export const resources = {
  fr: {
    translation: {
      language: {
        label: "Langue",
        fr: "Français",
        en: "Anglais",
        es: "Espagnol",
      },
      theme: {
        label: "Thème",
        system: "Système",
        light: "Clair",
        dark: "Sombre",
      },
      common: {
        loading: "Chargement…",
        close: "Fermer",
        cancel: "Annuler",
        save: "Enregistrer",
        edit: "Éditer",
        delete: "Supprimer",
        remove: "Retirer",
        refresh: "Rafraîchir",
        apply: "Appliquer",
        reject: "Rejeter",
        test: "Tester",
        publish: "Publier",
        openFull: "Ouvrir en grand",
        noDescription: "Aucune description fournie.",
        unknown: "Inconnu",
        valid: "Valide",
        invalid: "Invalide",
        yes: "Oui",
        no: "Non",
        search: "Rechercher",
        select: "Sélectionner",
        preview: "Aperçu",
        show: "Afficher",
        hide: "Masquer",
        open: "Ouvrir",
        download: "Télécharger",
        context: "Contexte",
        focus: "Focus",
        full: "Complet",
        connected: "Connecté",
        connecting: "Connexion…",
        notifications: "Notifications",
        active: "actif",
        error: "Erreur",
        copy: "Copier",
        run: "Exécution",
        studio: "Studio",
        build: "Configuration",
      },
      integrations: {
        badge: "Connecteurs",
        title: "Intégrations",
        description:
          "Ajoutez les connecteurs utiles à l’Agent courant, configurez leurs accès et exposez leurs tools au runtime AgentMaurice.",
        usageTitle: "Crédits intégrations",
        usageValue: "{{consumed}} / {{budget}} crédits ce mois-ci",
        addedTitle: "Connecteurs ajoutés",
        addedDescription:
          "Seuls les connecteurs ajoutés à l’Agent courant apparaissent ici.",
        addConnector: "Ajouter un connecteur",
        emptyTitle: "Aucun connecteur ajouté",
        emptyDescription:
          "Recherchez un connecteur dans le catalogue pour l’ajouter à l’Agent courant.",
        connectSuccess: "Connecteur connecté.",
        connectError: "Connexion impossible.",
        addSuccess: "Connecteur ajouté.",
        addError: "Ajout impossible.",
        removeSuccess: "Connecteur retiré.",
        removeError: "Retrait impossible.",
        disconnectSuccess: "Connecteur déconnecté.",
        disconnectError: "Déconnexion impossible.",
        settingsSuccess: "Configuration enregistrée.",
        settingsError: "Configuration impossible.",
        testSuccess: "Statut connecteur : {{status}}.",
        testError: "Test impossible.",
        catalogError: "Impossible de charger les connecteurs.",
        catalogHTTPError: "Console {{status}} sur {{path}} : {{message}}",
        authMode: "Mode",
        configurationRequiredHelp:
          "Renseignez la configuration du connecteur avant de créer une connexion utilisateur.",
        manualSupportHelp:
          "Ce connecteur nécessite une configuration accompagnée par le support.",
        editSettings: "Modifier",
        configure: "Configurer",
        reconnect: "Reconnecter",
        connect: "Connecter",
        test: "Tester",
        tools: "Tools",
        disconnect: "Déconnecter",
        remove: "Retirer",
        maintainedPack: "Pack maintenu",
        actionsAvailable: "Actions disponibles",
        noActionsEnabled: "Aucune action activée",
        directoryTitle: "Ajouter un connecteur",
        directoryDescription:
          "Le catalogue est global, mais l’ajout rend le connecteur disponible uniquement pour l’Agent courant.",
        searchPlaceholder: "Rechercher Gmail, Slack, CRM…",
        allCategories: "Toutes catégories",
        allAuthModes: "Tous modes",
        directoryError: "Impossible de charger le catalogue.",
        noDirectoryResults: "Aucun connecteur ne correspond à cette recherche.",
        toolPack: "Pack tools",
        noToolPack: "Sans pack",
        add: "Ajouter",
        loadMoreConnectors: "Afficher plus",
        toolsTitle: "Tools du connecteur",
        toolsDescription: "Tools projetés sur l’Agent courant pour {{connector}}.",
        toolsError: "Impossible de charger les tools du connecteur.",
        noActionsHelp:
          "Aucun tool n’est projeté tant que le connecteur n’est pas configuré et connecté sur cet Agent.",
        managedAction: "Action disponible",
        customTool: "Tool custom",
        editSettingsTitle: "Modifier la configuration",
        configureTitle: "Configurer le connecteur",
        configureDescription: "Les valeurs secrètes ne sont jamais réaffichées.",
        connectionCredentialsHelp:
          "Les identifiants sont saisis au moment de connecter le compte utilisateur.",
        setupGuide: "Guide de configuration",
        callbackUrl: "URL de callback",
        disabled: "Désactivé",
        manualSupport: "Support requis",
        configurationRequired: "Configuration requise",
        connected: "Connecté",
        revoked: "Révoqué",
        notConnected: "Non connecté",
      },
      desktopUpdate: {
        availableTitle: "Nouvelle version disponible",
        availableDescription: "JusteMaurice {{version}} peut être installé.",
        genericVersion: "la plus récente",
        installAction: "Mettre à jour",
        installing: "Installation de la mise à jour…",
        installError: "Impossible d’installer la mise à jour.",
      },
      auth: {
        checking: "Vérification de l’authentification…",
        required:
          "Une authentification est requise avant de charger les organisations, les Agents et les espaces.",
        desktopModeEnabled:
          "Le mode desktop est activé. La connexion passe par l’application locale.",
        localModeEnabled:
          "Le mode développement local est activé. L’authentification est gérée par `chatserver`.",
        localAccount: "Compte local",
        localSignIn: "Connexion locale",
        signIn: "Se connecter",
        createAccount: "Créer un compte",
        loadingApp: "Chargement de l’Agent OS…",
        accessModeLabel: "Mode d’accès",
        accessModeHosted: "LLM AgentMaurice",
        accessModeHostedDescription:
          "Utilisez les modèles fournis par AgentMaurice sans saisir de clé API personnelle.",
        accessModeByok: "BYOK",
        accessModeByokDescription:
          "Connectez vos propres providers après connexion.",
        hostedIntro:
          "Connectez-vous pour utiliser les modèles AgentMaurice ou configurer vos propres providers.",
        byokIntro:
          "Connectez-vous pour rattacher vos propres providers et garder le contrôle de vos clés.",
        accessModeChooseIntro:
          "Connectez-vous puis choisissez, dans l’accueil, entre les modèles AgentMaurice et vos propres clés.",
        registerIntro: "Créez votre compte pour accéder à l’application.",
        createAccountOnConsoleHint:
          "La création de compte se fait sur console.agentmaurice.app.",
        confirmationEmailSent:
          "Un email de confirmation a été envoyé. Vérifiez votre boîte de réception.",
        signInError: "Erreur de connexion",
        oauthError: "Erreur OAuth",
        noAccountYet: "Pas encore de compte ?",
        alreadyHaveAccount: "Déjà un compte ?",
      },
      enrollment: {
        title: "Compléter votre profil AgentMaurice",
        subtitle:
          "Renseignez votre profil et créez votre première organisation avant d’entrer dans AgentMaurice OS.",
        subtitleProfileOnly:
          "Renseignez votre profil Console avant d’entrer dans AgentMaurice OS.",
        roleHint:
          "Votre premier rôle sera `orga-admin` pour cette organisation.",
        roleHintProfileOnly:
          "Ce profil sera enregistré dans la Console et synchronisé automatiquement ici.",
        email: "Email",
        username: "Nom d’utilisateur",
        usernamePlaceholder: "mikaelmorvan",
        firstName: "Prénom",
        firstNamePlaceholder: "Votre prénom",
        lastName: "Nom",
        lastNamePlaceholder: "Votre nom",
        language: "Langue favorite",
        personalOrganization: "C’est une organisation personnelle",
        personalOrganizationHint:
          "Laissez le nom vide si vous voulez utiliser votre identité comme nom d’organisation.",
        organizationName: "Nom de l’organisation",
        organizationNamePlaceholder: "AgentMaurice",
        organizationNamePersonalPlaceholder:
          "Optionnel pour une organisation personnelle",
        submit: "Enregistrer le profil",
        error: "Impossible d’enregistrer le profil.",
        validation: {
          username: "Le nom d’utilisateur est requis.",
          firstName: "Le prénom est requis.",
          lastName: "Le nom est requis.",
          language: "La langue favorite est requise.",
          organizationName: "Le nom de l’organisation est requis.",
        },
      },
      welcome: {
        badge: "Configuration express",
        title: "Préparez AgentMaurice OS pour un premier run utile.",
        subtitle:
          "Nous récupérons le contexte d’organisation, créons l’Agent par défaut si nécessaire, puis nous verrouillons l’accès LLM avant d’ouvrir le chat et Build.",
        organizationTitle: "Organisation",
        organizationReady: "Organisation disponible",
        organizationPending: "En attente du bootstrap local",
        deploymentTitle: "Agent",
        deploymentReady: "Agent par défaut prêt",
        deploymentPending: "Agent à créer ou rattacher",
        providerTitle: "LLM",
        providerChoicePending: "Choix LLM non défini",
        providerHosted: "LLM AgentMaurice",
        providerHostedPending: "LLM AgentMaurice à initialiser",
        providerReady: "Provider configuré",
        providerPending: "Aucun provider actif",
        nextStepTitle: "Étape suivante",
        nextStepModeChoice:
          "Choisissez d’abord comment vous voulez utiliser les LLM : modèles AgentMaurice ou clés API personnelles.",
        nextStepContext:
          "Nous finalisons encore le contexte local. Relancez le bootstrap pour récupérer l’organisation console et créer le workspace par défaut.",
        nextStepDeployment:
          "L’organisation est prête, mais il manque encore l’Agent utilisateur par défaut. Rafraîchissez le contexte pour le créer.",
        nextStepProvider:
          "Le contexte est prêt. Configurez maintenant vos clés API pour débloquer le chat et Build.",
        nextStepHostedPending:
          "Le contexte est prêt. Initialisez le profil LLM AgentMaurice pour créer le provider, le modèle et la sélection de l’Agent.",
        nextStepHosted:
          "Le contexte est prêt. Les modèles AgentMaurice sont disponibles sans clé supplémentaire sur cette instance.",
        nextStepReady:
          "Tout est prêt sur cette machine. Vous pouvez aller dans le chat ou passer en Build sans configuration supplémentaire.",
        stepConsoleTitle: "Contexte",
        stepConsoleDescription:
          "AgentMaurice OS recharge d’abord votre organisation puis prépare le workspace actif.",
        stepProviderTitle: "Provider",
        stepProviderDescription:
          "Choisissez le mode LLM adapté à votre usage puis, en mode clés utilisateur, testez la configuration avant enregistrement.",
        stepLaunchTitle: "Lancement",
        stepLaunchDescription:
          "Une fois le mode validé, le chat et Build deviennent directement exploitables depuis cette machine.",
        modeTitle: "Choisir l’accès LLM",
        modeDescription:
          "Vous devez choisir entre les modèles proposés par AgentMaurice et vos propres clés API avant d’utiliser l’instance.",
        modeLabel: "Mode LLM",
        modeHostedTitle: "LLM AgentMaurice",
        modeHostedDescription:
          "Utilisez les modèles fournis par AgentMaurice. Aucune clé personnelle n’est requise sur ce poste.",
        modeByokTitle: "Mes propres clés",
        modeByokDescription:
          "Utilisez vos propres providers. Tant que les clés ne sont pas configurées, le chat et Build restent bloqués.",
        modeChoiceRequiredTitle: "Choix requis",
        modeChoiceRequiredDescription:
          "Tant que vous n’avez pas choisi un mode LLM, l’instance reste en configuration et les parcours principaux restent verrouillés.",
        modeLockedTitle: "Configuration LLM déjà définie",
        modeLockedHostedDescription:
          "Cette organisation utilise les modèles AgentMaurice. Les autres utilisateurs de cette VM n’ont pas à refaire l’onboarding LLM.",
        modeLockedByokDescription:
          "Cette organisation utilise déjà un provider BYOK. Les autres utilisateurs de cette VM n’ont pas à ressaisir de clés.",
        hostedTitle: "Utiliser les LLM AgentMaurice",
        hostedDescription:
          "Cette instance peut utiliser directement les modèles AgentMaurice. Vous n’avez rien à saisir côté clés API.",
        hostedPanelTitle: "LLM AgentMaurice actif",
        hostedPanelDescription:
          "L’Agent utilise un profil LLM organisationnel AgentMaurice. Aucun secret utilisateur n’est nécessaire dans AgentMaurice OS.",
        hostedPanelPendingTitle: "Initialiser le profil AgentMaurice",
        hostedPanelPendingDescription:
          "AgentMaurice OS va créer ou réutiliser le provider AgentMaurice de l’organisation, ajouter un modèle par défaut, créer un profil et le sélectionner pour cet Agent.",
        hostedNoKeyRequired: "Aucune clé utilisateur requise",
        hostedPendingNoKey: "Aucune clé utilisateur requise",
        hostedActivateButton: "Initialiser AgentMaurice",
        hostedActivating: "Initialisation…",
        hostedActivateSuccess: "Profil LLM AgentMaurice initialisé.",
        hostedActivateError: "Impossible d’initialiser le profil LLM AgentMaurice.",
        byokPanelTitle: "Provider BYOK actif",
        byokPanelDescription:
          "L’organisation possède déjà une configuration LLM. Pour la modifier, utilisez Build > LLM avec les droits nécessaires.",
        formTitle: "Connecter votre LLM",
        formDescription:
          "Un seul setup suffit. Les secrets sont stockés côté backend local et le provider est rattaché à l’Agent par défaut.",
        readyBadge: "Prêt",
        setupBadge: "Setup requis",
        providerNameLabel: "Nom affiché",
        modelLabel: "Modèle",
        apiKeyLabel: "Clé API",
        apiKeyOptionalLabel: "Clé API (optionnelle)",
        apiKeyPlaceholder: "sk-...",
        urlRequiredLabel: "URL / endpoint",
        urlOptionalLabel: "URL / endpoint (optionnel)",
        urlPlaceholder: "https://...",
        advancedTitle: "Paramètres avancés",
        hideAdvanced: "Masquer",
        showAdvanced: "Afficher",
        systemPromptLabel: "System prompt",
        systemPromptPlaceholder:
          "Optionnel. Utilisez le prompt par défaut si vous laissez ce champ vide.",
        maxCompletionTokensLabel: "Max completion tokens",
        diagnosticOk: "Connexion validée",
        diagnosticError: "Le test a échoué",
        testing: "Test…",
        testButton: "Tester",
        saving: "Configuration…",
        primaryButton: "Tester et démarrer",
        refreshing: "Rafraîchissement…",
        refreshButton: "Rafraîchir le contexte",
        continueChat: "Continuer vers le chat",
        openBuild: "Ouvrir Studio",
        readyHint:
          "Le contexte est prêt. Vous pouvez entrer dans le chat ou ouvrir Build pour commencer à construire.",
        readyHintHosted:
          "Le contexte est prêt et les modèles AgentMaurice sont disponibles. Vous pouvez entrer directement dans le chat ou Build.",
        pendingHint:
          "Choisissez d’abord un mode LLM, puis vérifiez que l’organisation et l’Agent sont bien prêts avant de continuer.",
        pendingHintByok:
          "Tant que vos clés API ne sont pas testées et enregistrées, le chat et Build restent verrouillés.",
        pendingHintHosted:
          "Initialisez le profil AgentMaurice pour débloquer le chat et Build sans saisir de clé API.",
        testSuccess: "Connexion au provider validée.",
        testError: "Impossible de valider la connexion au provider.",
        saveSuccess: "Configuration enregistrée.",
        saveError: "Impossible d’enregistrer la configuration.",
        contextRefreshed: "Contexte local rechargé.",
        contextRefreshError: "Impossible de recharger le contexte local.",
        statusError: "Impossible de lire le statut du setup.",
        agentDiscoveryTitle: "Connecter un agent de code",
        agentDiscoveryDescription:
          "Choisissez un prompt sans installation ou une commande MauriceCLI pour le rail Git-native Agent Spec V2. Dans les deux cas, l’accès External Inception reste guidé, temporaire et auditable.",
        agentDiscoveryBadge: "External Inception",
        codeAgentPromptMode: "Connexion MCP sans installation (`amb_`)",
        codeAgentCLIMode: "Connexion MauriceCLI (`amc_`)",
        codeAgentPromptModeHint:
          "Copiez un prompt de connexion MCP. Son URL `amb_` ne doit jamais être transmise à `maurice agent connect`.",
        codeAgentCLIModeHint:
          "Copiez la commande `maurice agent connect`. Elle configure le client puis engage le rail Agent Spec V2 dans le projet Git local.",
        agentDiscoveryReadyHint:
          "Le prompt ne contient pas la clé finale. L’agent devra appeler l’URL bootstrap pour recevoir le contrat `agentmaurice.agent_connection/v2`.",
        agentDiscoveryUnavailableHint:
          "Vous n’avez pas les droits suffisants pour générer ce prompt.",
        agentDiscoveryHumanApprovalHint:
          "L’agent de code prépare le plan, mais ne peut pas l’approuver. L’approbation du hash exact reste une action humaine distincte dans AgentMaurice OS.",
        agentDiscoveryGenerate: "Générer le prompt",
        agentDiscoveryGenerating: "Génération…",
        agentDiscoveryCopy: "Copier le prompt",
        agentDiscoveryGenerated: "Prompt agent généré.",
        agentDiscoveryGenerateError: "Impossible de générer le prompt agent.",
        agentDiscoveryInvalidBootstrap: "Le serveur n’a pas retourné une connexion MCP `amb_` valide.",
        agentDiscoveryCopied: "Prompt agent copié.",
        agentDiscoveryCopyError: "Impossible de copier le prompt agent.",
        agentDiscoveryPrompt:
          "Tu vas connecter cet agent de code à une instance AgentMaurice.\n\nIMPORTANT — connexion MCP uniquement (`amb_`) : ne transmets jamais cette URL à `maurice agent connect`. Cette commande exige un bootstrap MauriceCLI `amc_` généré par AgentMaurice OS.\n\n1. Appelle cette URL bootstrap une seule fois :\n{{url}}\n\n2. Vérifie que le JSON retourné porte `$schema: agentmaurice.agent_connection/v2`, `schema_version: 2`, `bootstrap_kind: external_inception_mcp` et `intended_consumer: mcp_client_setup`. Utilise uniquement `organization`, `agent`, `agent_scopes`, `credential`, `mcp`, `commands`, `tools`, `policies`, `warnings`, `next_command` et `client_setup`.\n\n3. Configure le MCP avec `client_setup`. Commence par `inception_agent_scopes_list`, puis appelle `inception_agent_doctor` sans argument : sa réponse est compacte par défaut ; utilise `full:true` seulement pour un diagnostic expert explicite. Appelle ensuite `inception_mcp_capabilities`. Ne cible jamais un Agent par inférence de nom : utilise `agent_alias` ou `agent_id` depuis `agent_scopes`.\n\n4. Pour toute modification, suis exclusivement ce rail : `inception_agent_spec_init` si nécessaire → `inception_agent_spec_pull` → édition des fichiers Git-native → `inception_agent_spec_check` → `inception_agent_spec_plan`. Présente le plan immuable et son `plan_hash`, puis arrête-toi.\n\n5. L’approbation doit être enregistrée par un humain authentifié dans AgentMaurice OS ou dans une session humaine distincte. En tant qu’agent ou service, n’appelle pas `inception_agent_spec_approve` et ne tente jamais de t’auto-approuver. Après confirmation que l’approbation humaine est enregistrée, appelle `inception_agent_spec_apply` avec le plan approuvé, puis `inception_agent_spec_verify`.\n\n6. Ne demande, n’affiche et n’écris jamais de secret brut ; utilise uniquement des références de secrets.",
        cliBootstrapTitle: "Connecter MauriceCLI",
        cliBootstrapDescription:
          "Générez une commande `maurice agent connect` à coller dans un terminal. Le lien amc_ est à usage unique, expire en 15 minutes et n’écrit aucun secret dans le projet.",
        cliBootstrapBadge: "MauriceCLI",
        cliBootstrapReadyHint:
          "La commande configure le client et le projet local ; les changements suivent ensuite init/pull/check/plan, approbation humaine, apply et verify.",
        cliBootstrapUnavailableHint:
          "Vous n’avez pas les droits suffisants pour générer cette commande.",
        cliBootstrapEnvLabel: "Environnement",
        cliBootstrapKindLabel: "Type",
        cliBootstrapClientLabel: "Client agent",
        cliBootstrapAliasLabel: "Alias technique de l’Agent (`agent_alias`)",
        cliBootstrapDirLabel: "Dossier",
        cliBootstrapJoinExistingLabel: "Me reconnecter à un projet existant",
        cliBootstrapJoinExistingDescription:
          "Ajoute `--join-existing` pour renouveler les accès locaux sans réécrire ni exporter les fichiers Agent Spec du projet.",
        bootstrapScopesTitle: "Agents liés",
        bootstrapScopesDescription:
          "Ajoutez seulement les Agents que cet agent ou cette CLI doit pouvoir cibler explicitement.",
        bootstrapScopesNone:
          "Aucun autre Agent disponible dans ce contexte.",
        bootstrapScopeAlias: "Alias",
        bootstrapScopeRole: "Rôle",
        bootstrapScopeRuntimeDependency: "Dépendance runtime",
        bootstrapScopeManaged: "Géré",
        cliBootstrapGenerate: "Générer la commande",
        cliBootstrapGenerating: "Génération…",
        cliBootstrapCopy: "Copier la commande",
        cliBootstrapGenerated: "Commande MauriceCLI générée.",
        cliBootstrapGenerateError: "Impossible de générer la commande MauriceCLI.",
        cliBootstrapInvalidCommand: "Le serveur n’a pas retourné une commande `maurice agent connect` V2 valide.",
        cliBootstrapCopied: "Commande MauriceCLI copiée.",
        cliBootstrapCopyError: "Impossible de copier la commande MauriceCLI.",
        cliBootstrapKind: {
          development: "Développement",
          preproduction: "Préproduction",
          production: "Production",
          sandbox: "Sandbox",
          integration_test: "Test d’intégration",
        },
        cliBootstrapClient: {
          "claude-code": "Claude Code",
          codex: "Codex",
          cursor: "Cursor",
          windsurf: "Windsurf",
          generic: "Generic MCP",
        },
      },
      operateSetup: {
        missingOrganizationTitle: "Organisation requise",
        missingOrganizationDescription:
          "Cette vue a besoin d’une organisation active avant de pouvoir charger le contenu d’exécution.",
        missingDeploymentTitle: "Agent requis",
        missingDeploymentDescription:
          "Sélectionnez ou créez d’abord un Agent actif pour ouvrir les écrans d’exécution.",
        missingSpaceTitle: "Espace requis",
        missingSpaceDescription:
          "L’Agent est prêt, mais aucun espace n’est encore actif dans cette session. Revenez à l’accueil pour terminer la mise en route.",
        noSpaceTitle: "Aucun espace prêt pour cet Agent",
        noSpaceDescription:
          "Cette instance n’a pas encore d’espace exploitable pour l’Agent courant. Finalisez la configuration depuis l’accueil avant d’ouvrir le chat.",
        loadingSpacesTitle: "Chargement des espaces…",
        loadingSpacesDescription:
          "Vérification des espaces disponibles pour l’Agent courant avant d’ouvrir le chat.",
        openWelcome: "Ouvrir l’accueil",
        openCatalog: "Ouvrir le catalogue",
        openHistory: "Ouvrir l’historique",
        completeSetupToStart:
          "Terminez l’accueil pour débloquer le chat et les écrans d’exécution",
      },
      shell: {
        toggleCenterFocus: "Basculer le focus central",
        focusCenterContent:
          "Mettre le contenu central en focus (Ctrl/Cmd+Shift+.)",
        toggleContextPanel: "Basculer le panneau de contexte",
        toggleRightPanel: "Basculer le panneau de droite (Ctrl/Cmd+Shift+\\)",
        resizeNavigationPanel: "Redimensionner le panneau de navigation",
        resizeContextPanel: "Redimensionner le panneau de contexte",
        inspectTitle: "Inspecter",
        inspectDescription: "Configurer le nœud sélectionné.",
        executionDetailTitle: "Détail d’exécution",
        executionDetailDescription: "Contexte pour l’exécution sélectionnée.",
        emptyContextTitle: "Le contexte détaillé apparaîtra ici",
        emptyContextDescription:
          "Le shell garde cette zone prête pour l’inspection, les détails d’exécution et les aperçus contextuels.",
        emptyContextBuildTitle: "Le contexte de build apparaîtra ici",
        emptyContextBuildDescription:
          "Le shell garde cette zone prête pour l’inspection des Workflows, des plans, des runs et des aperçus de build.",
        emptyContextRunTitle: "Les détails d’exécution apparaîtront ici",
        emptyContextRunDescription:
          "Le shell garde cette zone prête pour les étapes en cours, les fichiers liés et les aperçus utiles à l’exécution.",
        emptyContextRunActionsTitle: "Actions utiles",
        emptyContextRunActionsDescription:
          "Quand aucune exécution n’est encore sélectionnée, utilisez ce panneau pour repartir vers le bon point d’entrée.",
        emptyContextRunCatalogDescription:
          "Parcourez les Workflows prêts à lancer et ouvrez une session depuis le bon blueprint.",
        emptyContextRunHistoryDescription:
          "Reprenez une exécution récente, inspectez ses sorties et relancez-la dans le chat.",
        emptyContextRunOpenBuild: "Ouvrir Studio",
        emptyContextRunBuildDescription:
          "Passez dans Agent Spec pour finaliser un Workflow, inspecter son blueprint ou préparer un apply.",
        emptyContextHistoryTitle: "Le détail de l’exécution apparaîtra ici",
        emptyContextHistoryDescription:
          "Le shell affiche ici le détail d’un run sélectionné, avec ses sorties, ses artefacts et son état final.",
        emptyContextBuildHint:
          "En mode build, sélectionnez un nœud ou lancez une inspection pour ouvrir ce panneau.",
        emptyContextRunHint:
          "En mode exécution, ouvrez un fichier, une exécution ou un historique pour enrichir ce panneau.",
        emptyContextHistoryHint:
          "Sélectionnez une exécution dans l’historique pour afficher ses détails ici.",
        emptyContextShortcutHint:
          "Le raccourci Ctrl/Cmd+Shift+\\ réaffiche instantanément le panneau contextuel quand du contenu est disponible.",
      },
      sidebar: {
        calisto: "Calisto",
        recipes: "Recettes",
        metaRecette: "Meta-recette",
        capabilities: "Capacités",
        miniAppPreview: "Preview mini-app",
        data: "Données",
        deployments: "Agents",
        llm: "LLM",
        mcp: "MCP",
        skills: "Skills",
        schedules: "Schedules",
        observability: "Observabilité",
        externalControl: "Clés de l’Agent",
        apiKeys: "Clés d'API",
        agentControl: "Contrôle agent",
        importExport: "Import / Export",
        messaging: "Messagerie",
        mailCatcher: "Mail Catcher",
        spaces: "Espaces",
        chat: "Chat",
        catalog: "Catalogue",
        history: "Historique",
        spacesSessions: "Espaces et sessions",
        noSpaceForDeployment: "Aucun espace disponible pour cet Agent.",
        newSession: "Nouvelle session",
        sessionActions: "Actions de session",
        renameSession: "Renommer",
        renameSessionTitle: "Renommer la session",
        renameSessionDescription:
          "Modifiez le nom affiché dans la liste des sessions.",
        renameSessionNameRequired: "Le nom de session est obligatoire.",
        renameSessionSuccess: "Session renommée.",
        renameSessionError: "Impossible de renommer la session.",
        deleteSession: "Supprimer",
        deleteSessionTitle: "Supprimer la session",
        deleteSessionDescription:
          "La session {{name}} sera supprimée définitivement.",
        deleteSessionSuccess: "Session supprimée.",
        deleteSessionError: "Impossible de supprimer la session.",
        sessionName: "Nom de la session",
        unnamedSession: "Session",
        noSessionYet: "Aucune session pour le moment.",
        sessionCount: "{{count}} session(s)",
        lastActivity: "Activité {{value}}",
        showMoreSessions: "Afficher {{count}} session(s) de plus",
        showFewerSessions: "Afficher moins de sessions",
        localProfile: "Profil local",
        userProfile: "Profil utilisateur",
        account: "Compte",
        access: "Accès",
        organizations: "Organisations",
        currentWorkspace: "Espace courant",
        noWorkspaceSelected: "Aucun espace sélectionné",
        memberships_one: "{{count}} accès",
        memberships_other: "{{count}} accès",
        localAuthentication: "Authentification locale",
        hankoAuthentication: "Authentification sécurisée",
        hankoProfile: "Sécurité du compte",
        hankoProfileDescription:
          "Gérez l’identité, les méthodes de connexion et le contexte AgentMaurice de cette session.",
        hankoProfileLoadError: "Impossible de charger la sécurité du compte.",
        desktopAuthentication: "Authentification desktop",
        localSignOutHint:
          "La déconnexion vous ramène au sélecteur de comptes locaux.",
        hankoSignOutHint:
          "La déconnexion termine la session locale sur cet appareil.",
        desktopSignOutHint:
          "La déconnexion termine la session desktop sur cet appareil.",
        confirmSignOutTitle: "Confirmer la déconnexion",
        confirmSignOutDescription:
          "Vous allez fermer la session courante sur cet appareil.",
        confirmSwitchUserDescription:
          "Vous allez quitter ce profil local et revenir au sélecteur de comptes.",
        switchUser: "Changer d’utilisateur",
        signOut: "Se déconnecter",
        consoleBinding: "Rattachement console",
        consoleBindingDescription:
          "Rattachez cette installation à une instance console sans changer le backend local ni la base SQLite.",
        consoleBound: "Rattaché",
        consoleUnbound: "Non rattaché",
        consoleUrl: "Console",
        consoleInstance: "Instance",
        consoleOrganization: "Organisation",
        consoleUser: "Utilisateur console",
        consoleLastSync: "Dernière mise à jour {{value}}",
        consolePair: "Rattacher",
        consoleReconnect: "Rattacher à nouveau",
        consoleDetach: "Détacher",
        consoleDetachConfirm:
          "Détacher cette installation de la console et recharger l’application ?",
        consoleDetached:
          "Le rattachement console a été supprimé. Rechargement…",
        consolePairingIntro:
          "Entrez l’URL de la console puis lancez le device flow de rattachement.",
        consolePairingStart: "Démarrer le rattachement",
        consolePairingCancel: "Annuler",
        consolePairingUrlPlaceholder: "https://console.agentmaurice.app",
        consolePairingPending:
          "Ouvrez cette URL dans votre navigateur et saisissez le code suivant.",
        consoleVerificationUrl: "URL de validation",
        consoleUserCode: "Code",
        consoleCheckingStatus: "En attente de validation…",
        consolePairingExpires: "Expire dans {{count}} s",
        consolePairingExpired:
          "Le code de rattachement a expiré. Relancez le pairing.",
        consolePaired: "Installation rattachée à {{instance}}. Rechargement…",
        consolePairingFailed: "Le rattachement console a échoué.",
        consoleReloadHint:
          "Le contexte d’organisation sera rechargé automatiquement après rattachement ou détachement.",
      },
      wallet: {
        title: "Crédits organisation",
        referenceTokens: "~ {{count}} tokens",
        lowBalance: "Solde faible. Recharge recommandée.",
        suspended: "Wallet suspendu. Les consommations hosted sont bloquées.",
        portal: "Factures",
        recentActivity: "Activité récente",
        activityTopup: "Recharge",
        activityUsage: "Consommation",
        topupError: "Impossible de lancer la recharge.",
        portalError: "Impossible d’ouvrir le portail client.",
        checkoutSuccess: "Recharge confirmée.",
        checkoutCanceled: "Recharge annulée.",
        chatTopupTitle: "Crédits insuffisants",
        chatTopupDescription:
          "Cette conversation a atteint la limite de crédits de votre organisation. Rechargez pour reprendre sans perdre le contexte.",
        chatTopupCta: "Recharger",
        chatTopupPending: "Ouverture…",
        chatSuspendedTitle: "Wallet suspendu",
        chatSuspendedDescription:
          "Le wallet de votre organisation est suspendu. La consommation hosted est temporairement bloquée jusqu’à intervention d’un opérateur.",
      },
      contextSwitcher: {
        selectOrganization: "Sélectionner une organisation",
        selectDeployment: "Sélectionner un Agent",
        organization: "Organisation",
        deployment: "Agent",
        orgId: "ID organisation",
        environment: "Environnement",
        notSelected: "Non sélectionné",
        loadingContext: "Chargement du contexte…",
        createDeployment: "Nouveau",
        createDeploymentTitle: "Créer un Agent",
        createDeploymentDescription:
          "Créez un nouvel Agent vide classé sandbox, adapté aux previews Studio. Initialisez ensuite son projet avec maurice spec init, sans créer de ressource runtime managed.",
        createDeploymentNameLabel: "Nom de l’Agent",
        createDeploymentNamePlaceholder: "Assistant support",
        createDeploymentNotesLabel: "Notes initiales",
        createDeploymentNotesPlaceholder:
          "Décrivez brièvement le périmètre ou l’objectif initial de cet Agent.",
        createDeploymentConfirm: "Créer l’Agent",
        createDeploymentSubmitting: "Création…",
        createDeploymentSuccess: "Agent {{name}} créé.",
        createDeploymentFailed: "Impossible de créer l’Agent.",
        createDeploymentConflict:
          "Un Agent avec ce nom existe déjà. Choisissez un autre nom.",
        createDeploymentNoOrganization:
          "Sélectionnez d’abord une organisation.",
        createDeploymentNameRequired: "Le nom de l’Agent est requis.",
        deploymentKindLabel: "Type d’Agent",
        deploymentKindHint:
          "Le type pilote la gouvernance Studio (preview, approbation). Un changement demande confirmation.",
        deploymentKindConfirmTitle: "Changer le type d’Agent ?",
        deploymentKindConfirmDescription:
          "Vous allez passer « {{name}} » de {{from}} à {{to}}. Cela modifie immédiatement les règles de gouvernance (preview, approbation, contraintes). Confirmez seulement si c’est intentionnel.",
        deploymentKindConfirmAction: "Changer le type",
        deploymentKindUpdating: "Mise à jour…",
        deploymentKindUpdated: "Type de {{name}} : {{kind}}.",
        deploymentKindUpdateFailed: "Impossible de changer le type d’Agent.",
        deploymentKind: {
          sandbox: "Sandbox",
          development: "Development",
          integration_test: "Integration test",
          staging: "Staging",
          production: "Production",
          unknown: "Inconnu",
        },
      },
      chat: {
        headerTitle: "Discuter avec Maurice",
        freeConversation: "Conversation libre",
        recipeLabel: "Workflow : {{name}}",
        deploymentBadge: "Agent",
        sessionBadge: "Session",
        recipeBadge: "Contexte",
        newSessionBadge: "Nouvelle",
        freeConversationBadge: "Libre",
        freeConversationDescription:
          "Utilisez ce chat pour explorer, lancer un Workflow ou reprendre une exécution sans contexte imposé au départ.",
        recipeFocusDescription:
          "Cette conversation garde le Workflow actif au centre pour le lancer, l’affiner et le relire plus vite.",
        chooseRecipe: "Choisir un Workflow",
        openCatalog: "Voir le catalogue",
        openHistory: "Voir l’historique",
        skillsButton: "Skills",
        debugMessages: "Debug",
        showTechnicalMessages: "Afficher les appels tools et résultats bruts",
        hideTechnicalMessages: "Masquer les appels tools et résultats bruts",
        skillsSessionLabel: "Skills de session",
        skillsPanelTitle: "Skills de session",
        skillsPanelDescription:
          "Sélectionnez des skills de l’Agent pour enrichir la session courante.",
        skillsLoading: "Chargement des skills…",
        skillsLoadingError: "Impossible de charger les skills de l’Agent.",
        noSelectedSkills: "Aucune skill sélectionnée pour cette session.",
        noDeploymentSkills: "Aucune skill installée sur cet Agent.",
        useSkill: "Utiliser",
        skillSelected: "Sélectionnée",
        clearSkills: "Vider les skills",
        skillsCleared: "Sélection de skills vidée.",
        skillNotFound: "Skill introuvable : {{skill}}",
        skillAdded: "{{skill}} ajoutée à la session.",
        skillRemoved: "{{skill}} retirée de la session.",
        noSkillPreview: "Aucun aperçu disponible pour cette skill.",
        execution: "Exécution",
        missingContext:
          "Sélectionnez une organisation, un Agent et un espace avant d’ouvrir le chat.",
        connectionErrorTitle: "Erreur de connexion",
        sessionPausedTitle: "Session en veille",
        sessionPausedDescription: "La session a été mise en veille après une période d'inactivité.",
        resumeConversation: "Reprendre la conversation",
        messageFeed: "Fil des messages du chat",
        loadingHistory: "Chargement de l’historique…",
        loadingOlderMessages: "Chargement des messages plus anciens…",
        startConversation: "Démarrer une conversation",
        readyForMessage: "À vous de jouer",
        askAboutRecipe:
          "Posez n’importe quelle question à Maurice sur ce Workflow",
        askAboutWorkspace:
          "Posez n’importe quelle question à Maurice sur cet espace",
        latest: "Derniers messages",
        selectWorkspaceToStart:
          "Sélectionnez un espace pour commencer à discuter",
        createSessionToStart:
          "Créez ou sélectionnez une session pour commencer.",
        askMaurice: "Demandez à Maurice…",
        noExecutionContext:
          "Aucun contexte d’exécution disponible pour le moment",
        noActiveSessionToClear: "Aucune session active à vider",
        sessionHistoryCleared: "Historique de session vidé",
        failedToClearSession: "Impossible de vider la session",
        clearSessionTitle: "Vider la session",
        clearSessionDescription:
          "Cela supprimera tout l’historique de la session de chat courante.",
        clearHistory: "Vider l’historique",
        helpMessage: [
          "Commandes disponibles :",
          "",
          "- `/status` ouvrir le contexte d’exécution",
          "- `/workflow` ouvrir le sélecteur de Workflows",
          "- `/tools` demander à Maurice les outils disponibles dans ce contexte",
          "- `/skills` ouvrir le panneau skills",
          "- `/use-skill <id>` sélectionner une skill pour la session",
          "- `/clear-skills` vider la sélection de skills",
          "- `/help` afficher cette aide",
          "- `/clear` supprimer l’historique de la session courante",
        ].join("\n"),
        recipeContextHint:
          "Les messages seront envoyés avec ce blueprint dans le contexte.",
        llmActivityThinking: "Maurice réfléchit…",
        llmActivityTool: "Maurice utilise un outil…",
        llmActivitySkill: "Maurice applique une skill…",
        llmActivityProject: "Maurice travaille sur le projet…",
      },
      chatInput: {
        openStatusContext: "Ouvrir le contexte de statut",
        openStatusContextDescription:
          "Demander le statut courant d’une exécution ou d’un Agent",
        launchRecipe: "Lancer un Workflow",
        launchRecipeDescription:
          "Ouvrir le sélecteur de Workflows ou cibler une commande de Workflow",
        showHelp: "Afficher l’aide",
        showHelpDescription: "Afficher les slash commands disponibles",
        showTools: "Afficher les outils",
        showToolsDescription:
          "Demander à Maurice les outils disponibles dans ce contexte",
        openSkills: "Ouvrir les skills",
        openSkillsDescription:
          "Afficher les skills de l’Agent et la sélection active de la session",
        useSkill: "Utiliser une skill",
        useSkillDescription:
          "Sélectionner une skill pour enrichir les prochains messages",
        clearSkills: "Vider les skills",
        clearSkillsDescription:
          "Retirer toutes les skills sélectionnées pour la session courante",
        clearSession: "Vider la session",
        clearSessionDescription:
          "Supprimer l’historique de la session courante",
        changeRecipe: "Changer",
        messageLabel: "Votre message",
        quickActions: "Actions rapides",
        shortcutHint:
          "Utilisez les slash commands ou le sélecteur de Workflows pour cadrer rapidement la session.",
      },
      files: {
        attach: "Joindre un fichier",
        attached: "{{filename}} ajouté au message",
        uploadFailed: "Échec de l’envoi du fichier",
        uploadProgress: "Envoi {{progress}}%",
        attachedFile: "Fichier joint",
      },
      recipePicker: {
        title: "Sélectionner un blueprint",
        description:
          "Lancez la conversation avec un contexte de Workflow spécifique, ou gardez le chat générique.",
        searchPlaceholder: "Rechercher des Workflows…",
        loading: "Chargement des Workflows…",
        noMatch: "Aucun Workflow ne correspond à cette recherche.",
        noDescription: "Aucune description fournie.",
      },
      recipeForm: {
        fallbackTitle: "Formulaire de Workflow",
        fallbackDescription:
          "Le Workflow en cours a besoin d’informations supplémentaires pour continuer.",
        selectOption: "Sélectionner…",
        submit: "Envoyer le formulaire",
        submitting: "Envoi…",
        fieldRequired: "{{field}} est obligatoire.",
      },
      chatMessage: {
        resourcePreview: "Aperçu de ressource",
        previewTruncated: "Aperçu tronqué.",
        result: "Résultat",
        logs: "Logs",
        userMessage: "Message utilisateur",
        assistantMessage: "Message assistant",
        technicalMessage: "Message technique",
      },
      executionPanel: {
        title: "Statut d’exécution",
        completedCount: "{{done}}/{{total}} terminées",
        running: "En cours…",
        progress: "Progression",
        overallProgress: "Progression globale",
        stepProgress: "Progression de {{step}}",
        empty: "Aucune étape active pour le moment",
        summary:
          "Les étapes d’exécution apparaîtront ici dès qu’un Workflow ou une tâche de session démarre.",
      },
      executionResult: {
        title: "Résultat",
        refresh: "Rafraîchir le résultat",
        copy: "Copier le résultat",
        loading: "Chargement du résultat…",
        empty: "Aucun résultat disponible.",
      },
      executionLogs: {
        title: "Logs",
        refresh: "Rafraîchir les logs",
        copy: "Copier les logs",
        loading: "Chargement des logs…",
        empty: "Aucun log disponible pour cette exécution.",
      },
      historyDetail: {
        rerun: "Relancer dans le chat",
        timeline: "Chronologie",
        created: "Créé",
        started: "Démarré",
        completed: "Terminé",
        duration: "Durée",
        blueprint: "Blueprint",
        loadingBlueprint: "Chargement de l’aperçu du Workflow…",
        noBlueprintPreview:
          "Aucun aperçu de blueprint n’est disponible pour cette exécution.",
        noDescription: "Aucune description fournie.",
        noRecipe: "Aucun Workflow n’est associé à cette exécution.",
        error: "Erreur",
        notAvailable: "N/A",
        pending: "En attente",
        running: "En cours",
        completedStatus: "Terminé",
        failed: "Échec",
        usageTitle: "Bilan d’usage",
        usageSourceTrace: "Estimé",
        usageSourceMetering: "Metering",
        usageDuration: "Durée",
        usageTokens: "Tokens",
        usageEstimatedCost: "Coût estimé",
        usageActions: "Actions",
        usageFailures: "échecs",
        usageLLMCalls: "Appels LLM",
        usageMonetaryUnavailable: "Coût monétaire final indisponible",
        usageNoData: "Aucun bilan d’usage disponible.",
        usageModelBreakdown: "Modèles",
      },
      catalog: {
        title: "Catalogue d’actions",
        description:
          "Choisissez un Workflow pour démarrer une conversation avec Maurice",
        searchPlaceholder: "Rechercher des Workflows...",
        all: "Toutes",
        metricsAvailable: "Workflows",
        metricsAvailableHint: "Disponibles sur cet Agent",
        metricsVisible: "Visibles",
        metricsVisibleHint: "Correspondent aux filtres courants",
        surfaceHint:
          "Parcourez les Workflows depuis une surface faite pour rester lisible avant même le lancement.",
        quickLaunchEyebrow: "Point de départ",
        quickLaunchTitle: "Lancer rapidement",
        quickLaunchDescription:
          "Ces Workflows sont les meilleurs points de départ pour ouvrir une nouvelle session utile sans parcourir toute la liste.",
        quickLaunchHint:
          "Privilégiez un lancement direct quand vous savez déjà quel workflow vous voulez exécuter.",
        quickBuildTitle: "Préparer dans Studio",
        quickBuildDescription:
          "Aucun Workflow n’est encore prêt à être lancé ici. Commencez par terminer les plus prometteurs dans Agent Spec.",
        quickBuildHint:
          "Quand tout est encore en brouillon, ouvrez directement le Workflow dans Agent Spec.",
        openInChat: "Ouvrir dans le chat",
        resultsTitle: "Tous les Workflows",
        resultsDescription:
          "{{count}} Workflow(s) visible(s) dans cet Agent.",
        resultsFilteredBy: "Filtré par {{category}}",
        resultsAllVisible: "Vue complète",
        launchableTitle: "Prêtes à lancer",
        launchableDescription:
          "Ces Workflows sont déjà utilisables et peuvent ouvrir une nouvelle session immédiatement.",
        launchableCount: "{{count}} prête(s)",
        buildRequiredTitle: "À finaliser dans Studio",
        buildRequiredDescription:
          "Ces Workflows existent déjà, mais demandent encore une passe Agent Spec avant d’être lancés.",
        buildRequiredCount: "{{count}} à finaliser",
        buildRequiredTruncated: "{{shown}} affichée(s) sur {{total}}",
        showMoreBuild: "Afficher {{count}} de plus",
        showLessBuild: "Afficher moins",
        loading: "Chargement des Workflows…",
        error: "Erreur",
        noRecipes: "Aucun Workflow disponible",
        noRecipesHint:
          "Créez et appliquez un Workflow avec Agent Spec pour démarrer",
        noSearchMatch: "Aucun Workflow ne correspond à votre recherche",
        clearFilters: "Effacer les filtres",
      },
      history: {
        title: "Historique des exécutions",
        description: "Consultez les exécutions passées et leurs résultats",
        searchPlaceholder: "Rechercher par Workflow ou ID d’exécution...",
        all: "Toutes",
        metricsTotal: "Total",
        metricsTotalHint: "Exécutions chargées",
        metricsSuccess: "Réussies",
        metricsSuccessHint: "Terminées sans blocage",
        metricsAttention: "À corriger",
        metricsAttentionHint: "Demandent une intervention",
        metricsRerunnable: "Relançables",
        metricsRerunnableHint: "Peuvent repartir dans le chat",
        surfaceHint:
          "Relisez les derniers runs et ouvrez leurs détails sans dépendre d’un panneau déjà rempli.",
        loading: "Chargement de l’historique…",
        error: "Erreur",
        noExecutions: "Aucune exécution trouvée",
        noExecutionsHint: "Démarrez une conversation pour voir l’historique",
        loadMore: "Charger plus",
        pending: "En attente",
        running: "En cours",
        completed: "Terminée",
        failed: "Échec",
        openDetails: "Ouvrir les détails",
        rerun: "Relancer dans le chat",
        executionLabel: "Exécution",
        startedLabel: "Démarrée",
        durationLabel: "Durée",
        usageLabel: "Usage",
        signalLabel: "Signal",
        readinessReview: "À relire",
        readinessFix: "À corriger",
        readinessRerunnable: "Relançable",
        readinessRunning: "Suivi actif",
        readinessQueued: "En file",
        nextStepLabel: "Prochaine action",
        nextStepRerun:
          "Ouvrir les détails puis relancer rapidement si vous voulez comparer ou repartir.",
        nextStepFix:
          "Inspecter l’erreur, corriger le Workflow puis relancer depuis le chat.",
        nextStepWatch:
          "Suivre la progression en détail ou attendre la fin du run.",
        nextStepQueue:
          "Attendre le démarrage complet avant de relancer ou d’intervenir.",
        groupAttentionTitle: "À corriger",
        groupAttentionDescription:
          "Ces runs ont échoué ou se sont bloqués et demandent une action avant relance.",
        groupActiveTitle: "En cours",
        groupActiveDescription:
          "Ces runs progressent encore dans le runtime et méritent surtout du suivi.",
        groupQueuedTitle: "En attente",
        groupQueuedDescription:
          "Ces runs existent déjà, mais n’ont pas encore démarré complètement.",
        groupSuccessTitle: "Réussies",
        groupSuccessDescription:
          "Ces runs sont terminés, relisibles et souvent prêts à être relancés.",
        pendingSummary: "Cette exécution attend encore son démarrage complet.",
        runningSummary: "Cette exécution progresse encore dans le runtime.",
        completedSummary: "Le run est terminé et prêt à être relu.",
        failedSummary: "Le run a échoué et demande une relecture ciblée.",
      },
      recipeCard: {
        active: "Active",
        draft: "Brouillon",
        noDescription: "Aucune description fournie",
        steps: "{{count}} étapes",
        launch: "Lancer",
        launchNow: "Lancer maintenant",
        openInBuild: "Ouvrir dans Studio",
        inspectBlueprint: "Inspecter le blueprint",
        readiness: "Prêt à faire",
        structure: "Structure",
        readyToLaunch: "Prête à être lancée",
        finishInBuild: "À finaliser dans Studio",
        launchHint: "Ouvre directement une nouvelle session d’exécution.",
        buildHint: "Passez par Agent Spec pour terminer ou appliquer ce Workflow.",
        workflow: "Workflow",
        miniapp: "MiniApp",
        moreTags: "+{{count}}",
      },
      runContext: {
        title: "Contexte de session",
        description:
          "Mémoire de session, artefacts récents et Workflow lié à cette conversation.",
        loadingContext: "Chargement du contexte de session…",
        activeRecipe: "Workflow actif",
        activeRecipeDescription:
          "Aperçu en lecture seule du Workflow actuellement lié à cette session.",
        loadingRecipe: "Chargement de l’aperçu du Workflow…",
        notLinked:
          "Cette conversation n’est pas encore liée à un Workflow spécifique.",
        openTasks: "Tâches ouvertes",
        timeline: "Chronologie",
        artifacts: "Artefacts",
        sourceGraph: "Sources",
        noOpenTasks: "Aucune tâche ouverte n’est visible pour cette session.",
        noTimeline:
          "Aucun événement récent n’est disponible pour cette session.",
        noArtifacts:
          "Aucun artefact récent n’est disponible pour cette session.",
        noSources: "Aucune source liée n’est disponible pour cette session.",
        previewTitle: "Aperçu d’artefact",
        previewDescription:
          "Prévisualisation rapide d’un artefact produit pendant cette session.",
        openFile: "Ouvrir le fichier",
        noPreview: "Aucun aperçu intégré disponible.",
      },
      filePreview: {
        image: "Image",
        document: "Document",
        file: "Fichier",
        noPreviewUrl: "Aucune URL d’aperçu disponible pour ce fichier.",
        loadingPreview: "Chargement de l’aperçu…",
        noInlinePreview: "Aucun aperçu intégré disponible pour ce fichier.",
      },
      commandPalette: {
        button: "Commande…",
        title: "Palette de commandes",
        description:
          "Rechercher des commandes de l’application ou demander à Calisto d’agir sur l’Agent courant.",
        placeholder: "Rechercher des commandes ou interroger Calisto…",
        noCommands: "Aucune commande trouvée.",
        startTyping: "Commencez à taper pour rechercher…",
        navigation: "Navigation",
        recipes: "Recettes",
        deployment: "Agent",
        home: "Accueil",
        homeDescription: "Aller au tableau de bord",
        recipesView: "Recettes",
        recipesViewDescription: "Voir toutes les recettes",
        capabilities: "Capacités",
        capabilitiesDescription: "Parcourir les capacités",
        deploy: "Déployer",
        deployDescription: "Pipeline Agent",
        catalog: "Catalogue",
        catalogDescription: "Voir le catalogue de recettes",
        chat: "Chat",
        chatDescription: "Aller au chat",
        newRecipe: "Nouvelle recette",
        newRecipeDescription: "Créer une nouvelle recette",
        compileRecipe: "Compiler la recette",
        compileRecipeDescription: "Compiler la recette courante",
        testRecipe: "Tester la recette",
        testRecipeDescription: "Lancer les tests de la recette courante",
        promoteRecipe: "Promouvoir la recette",
        promoteRecipeDescription: "Promouvoir vers l’environnement suivant",
        rollback: "Rollback",
        rollbackDescription: "Revenir à la version précédente",
        askCalisto: "Demander à Calisto",
      },
      calisto: {
        adminMode: "Calisto Admin",
        adminTitle: "Administration conversationnelle globale",
        adminDescription:
          "Calisto agit au niveau de l’organisation pour créer, modifier et diagnostiquer les Agents, MCP, utilisateurs, skills et méta-recettes.",
        adminRuntime: "Runtime admin",
        adminLoadError: "Runtime admin indisponible",
        adminTargetScope: "Portée de travail",
        allDeployments: "Tous les Agents",
        businessDeployments: "Agents métier",
        targetingAllDeployments:
          "Calisto travaille en vue globale cross-Agent.",
        targetingDeployment: "Calisto cible {{name}}.",
        contextRailTitle: "Contexte utile",
        contextRailDescription:
          "Repères et raccourcis pour administrer sans quitter la conversation.",
        activeScope: "Portée active",
        conversation: "Conversation",
        messages: "messages",
        capabilities: "Capacités disponibles",
        capabilityDeployments: "Agents",
        capabilityMcp: "MCP et connecteurs",
        capabilityUsers: "Utilisateurs et rôles",
        capabilityMetaRecipes: "Méta-recettes",
        capabilityRuntime: "Paramètres runtime",
        quickActions: "Actions rapides",
        quickActionsDescription:
          "Préremplit le message. Rien n’est exécuté sans envoi explicite.",
        quickActionListDeployments: "Auditer les Agents",
        quickActionCreateDeployment: "Créer un Agent",
        quickActionConfigureMcp: "Configurer les MCP",
        quickActionInviteUser: "Inviter un utilisateur",
        quickActionMetaRecipe: "Créer une méta-recette",
        quickPromptListDeployments:
          "Liste les agents métier dans la portée {{scope}}, résume leur état, leurs MCP, leurs skills et les points d’attention.",
        quickPromptCreateDeployment:
          "Aide-moi à créer un nouvel Agent métier. Commence par me poser les questions nécessaires sur le nom, l’objectif, les utilisateurs, les MCP, les skills et les paramètres LLM avant de proposer un plan.",
        quickPromptConfigureMcp:
          "Aide-moi à configurer les MCP pour la portée {{scope}}. Commence par auditer l’existant, puis propose les changements nécessaires sans les appliquer tant que je n’ai pas validé.",
        quickPromptInviteUser:
          "Aide-moi à inviter ou mettre à jour un utilisateur pour la portée {{scope}}. Demande l’email, le rôle et les accès avant toute action.",
        quickPromptMetaRecipe:
          "Aide-moi à créer ou mettre à jour une méta-recette pour la portée {{scope}}. Commence par comprendre l’objectif métier, puis propose la structure et les étapes de validation.",
        guardrails: "Garde-fous",
        guardrailConfirmation:
          "Les suppressions doivent être confirmées avec le nom exact.",
        guardrailLastDeployment:
          "Le dernier Agent métier ne doit pas être supprimé sans remplacement validé.",
        guardrailAdminHidden:
          "Le runtime admin Calisto reste caché des sélecteurs métier.",
        connectedContext: "Connecté au contexte de l’Agent",
        connectingContext: "Connexion au contexte de l’Agent",
        minimize: "Réduire",
        clearConversation: "Vider la conversation",
        clearConversationTitle: "Vider la conversation Calisto",
        clearConversationDescription:
          "Cela supprimera l’historique de cette conversation Calisto. Le contexte de travail reste disponible, mais Calisto repartira sans les messages précédents.",
        clearConversationConfirm: "Vider",
        conversationCleared: "Conversation Calisto vidée",
        conversationClearFailed: "Impossible de vider la conversation Calisto",
        noActiveConversationToClear: "Aucune conversation Calisto active à vider",
        startConversation: "Démarrez une conversation avec Calisto",
        describeChange:
          "Décrivez le changement souhaité sur le blueprint ou l’Agent.",
        you: "Vous",
        thinking: "Calisto réfléchit",
        proposedChanges: "Changements proposés ({{count}})",
        addNode: "Ajouter un nœud",
        updateNode: "Mettre à jour le nœud",
        deleteNode: "Supprimer le nœud",
        addConnection: "Ajouter une connexion",
        deleteConnection: "Supprimer la connexion",
        yes: "Oui",
        no: "Non",
        firstBuildWelcome:
          "Bonjour, je suis Calisto. Je vais vous aider a construire votre premier agent. Qu’est-ce que vous voulez construire ? Decrivez le resultat attendu, les outils ou integrations a brancher, et les donnees que vous voulez utiliser.",
        askPlaceholder: "Demander à Calisto…",
        sendHint: "Entrée pour envoyer. Maj+Entrée pour une nouvelle ligne.",
        guidedConverge: "Convergence guidée",
        executionPlanTitle: "Plan d’exécution",
        executionPlanDescription:
          "Préparez, appliquez et suivez la convergence sans exposer les détails techniques par défaut.",
        executionStatePreparing: "Préparation en cours",
        executionStateApplying: "Apply en cours",
        executionStatePlanReady: "Plan prêt",
        executionStateAttention: "Attention requise",
        executionStateNeedsPlan: "Plan à préparer",
        executionPrepareInProgress:
          "Calisto prépare le plan d’exécution à partir de la spec et de l’Agent cible.",
        executionApplyInProgress:
          "Calisto applique le plan préparé et suit les retours de l’Agent.",
        executionNeedsReviewDescription:
          "Le contexte de convergence demande encore une validation avant l’apply.",
        executionNeedsPlanDescription:
          "Préparez un plan pour transformer les signaux de drift en actions concrètes.",
        executionReadyToApply: "Prêt à appliquer",
        executionSignals: "Signaux",
        executionPlan: "Plan",
        executionApply: "Apply",
        executionStageReady: "Prêt",
        executionStagePending: "En attente",
        executionStageInProgress: "En cours",
        executionStageDone: "Terminé",
        executionWarningsCount: "{{count}} avertissement(s) à relire",
        executionDetailsTitle: "Détails d’exécution",
        executionDetailsDescription:
          "Retrouvez ici le plan préparé, les raccourcis utiles et les étapes détaillées.",
        executionShowDetails: "Voir les détails",
        executionHideDetails: "Masquer les détails",
        executionShortcutsTitle: "Raccourcis utiles",
        targetDeployment: "Agent cible",
        activeBlueprint: "Blueprint actif",
        refresh: "Rafraîchir",
        preparedPlanReady: "Plan préparé prêt",
        hash: "Hash",
        recommendedActions: "Actions recommandées",
        preparePlan: "Préparer le plan",
        applyPlan: "Appliquer le plan",
        apply: "Appliquer",
        everythingSynced: "Tout est synchronisé",
        workflow: "Workflow",
        streaming: "streaming…",
        arguments: "Arguments :",
        result: "Résultat :",
        error: "Erreur :",
        slashMenuTitle: "Outils Calisto",
        slashHelpLabel: "Afficher l’aide Calisto",
        slashHelpDescription:
          "Afficher les slash commands disponibles pour Calisto",
        slashToolsLabel: "Lister les outils",
        slashToolsDescription:
          "Demander à Calisto quels outils sont utiles maintenant",
        slashContextLabel: "Inspecter le contexte",
        slashContextDescription:
          "Résumer le contexte courant de l’Agent et du blueprint",
        slashHealthLabel: "Inspecter la santé",
        slashHealthDescription:
          "Diagnostiquer l’état du contexte et de la mémoire Calisto",
        slashDriftLabel: "Expliquer le drift",
        slashDriftDescription:
          "Comparer la meta-recette active et l’Agent cible",
        slashPlanLabel: "Préparer le plan",
        slashPlanDescription: "Lancer la préparation guidée de convergence",
        slashRefreshLabel: "Rafraîchir la convergence",
        slashRefreshDescription:
          "Recharger les signaux de convergence guidée et le contexte",
        slashSpecLabel: "Analyser les specs jointes",
        slashSpecDescription:
          "Envoyer les fichiers joints actuels comme contexte de specs à Calisto",
        slashClearLabel: "Vider la conversation",
        slashClearDescription:
          "Supprimer l’historique de la conversation Calisto courante",
        slashHelpMessage: [
          "Commandes Calisto disponibles :",
          "",
          "- `/tools` liste les outils utiles dans le contexte courant",
          "- `/context` résume le contexte actuel de l’Agent",
          "- `/health` inspecte l’état de Calisto et de sa mémoire",
          "- `/drift` explique l’écart entre la spec et l’Agent",
          "- `/plan` prépare le plan guidé de convergence",
          "- `/refresh` recharge le contexte Calisto et l’état de convergence",
          "- `/spec` analyse les fichiers actuellement joints au composeur",
          "- `/clear` supprime l’historique de la conversation courante après confirmation",
          "",
          "Vous pouvez aussi joindre des fichiers comme des specs avant d’envoyer un message.",
        ].join("\n"),
        specNeedsFiles: "Joignez au moins un fichier avant d’utiliser /spec.",
      },
      build: {
        llmEnableProvider: "Activer",
        llmDisableProvider: "Désactiver",
        llmProviderEnabled: "Provider activé",
        llmProviderDisabled: "Provider désactivé",
        accessPrimaryCta: "Ouvrir une vue Configuration disponible",
        accessBackToRun: "Revenir à Run",
        accessRecipesTitle: "Accès Studio limité",
        accessRecipesDescription:
          "Cette zone Studio demande des droits d’édition sur les recettes. Votre rôle actuel ne permet pas d’ouvrir les écrans d’authoring.",
        accessDeployTitle: "Agent réservé",
        accessDeployDescription:
          "La page Deploy demande une capacité Agent explicite. Ouvrez une autre vue Configuration ou revenez à Run.",
        accessObserveTitle: "Observabilité non disponible",
        accessObserveDescription:
          "La page Observe demande l’accès aux logs de l’Agent courant. Ouvrez une autre vue Configuration disponible ou revenez à Run.",
        accessExternalControlTitle: "Clés de l’Agent réservées",
        accessExternalControlDescription:
          "Cette zone Configuration demande une capacité Agent explicite.",
        recipesTitle: "Mes Recettes",
        recipesDescription: "Gérez vos méta-recettes d’IA.",
        recipesSelectOrg:
          "Sélectionnez une organisation dans le sélecteur de contexte pour charger les recettes.",
        recipesCountLabel: "Recettes",
        recipesSpecSourceSummaryLabel: "{{count}} meta-recette source",
        recipesSpecSourceSummaryLabel_other: "{{count}} meta-recettes sources",
        recipesNodeCountSummaryLabel: "{{count}} nœuds décrits au total",
        recipesRuntimeActiveLabel: "Actives runtime",
        recipesRuntimeActiveHint:
          "Recettes de la spec retrouvées dans le runtime actif.",
        recipesPublishedLabel: "Synchronisées",
        recipesPublishedHint:
          "Recettes déjà alignées avec l’Agent cible.",
        recipesPendingLabel: "À traiter",
        recipesPendingHint:
          "Recettes en attente, en dérive ou à relire avant apply.",
        recipesLatestUpdatedLabel: "Dernière mise à jour",
        recipesLatestUpdatedHint:
          "Dernière recette modifiée dans cet Agent.",
        recipesNodeCountLabel: "{{count}} nœud",
        recipesNodeCountLabel_other: "{{count}} nœuds",
        recipesDeploymentScopeLabel: "Agent",
        recipesUpdatedLabel: "Mis à jour",
        recipesCreatedLabel: "Créé",
        recipesOpenMetaRecette: "Ouvrir la meta-recette",
        recipesRuntimeActiveStatus: "Runtime actif",
        recipesSpecOnlyStatus: "Spec uniquement",
        recipesNoSpecDefinitionsTitle: "Aucune recette déclarée dans la spec",
        recipesNoSpecDefinitionsDescription:
          "La meta-recette existe, mais sa structured_spec ne contient pas encore de recipes_definitions.",
        recipesDefaultModeLabel: "workflow",
        recipesRecipeIdLabel: "ID",
        recipesSourceMetaRecetteLabel: "Source",
        recipesFormsLabel: "Forms",
        recipesFormsCount: "{{count}} form",
        recipesFormsCount_other: "{{count}} forms",
        recipesEditFullSpec: "Éditer la spec complète",
        recipesDriftTitle: "Drift spec/runtime",
        recipesDriftDescription:
          "{{specMissing}} recette(s) de la spec manquent dans le runtime, {{runtimeOrphans}} recette(s) runtime ne sont pas déclarées dans la spec.",
        recipesSpecMissingRuntimeHint:
          "Déclarée dans la spec, mais absente du runtime actif.",
        recipesRuntimeOrphanHint:
          "Active au runtime, mais absente de la spec canonique.",
        recipesSpecConsistentTitle: "Spec et runtime alignés",
        recipesSpecConsistentDescription:
          "Toutes les recettes déclarées dans la spec sont actives dans le runtime.",
        recipesPrimarySyncedDescription:
          "Cette recette est alignée. Vous pouvez revoir la meta-recette ou repartir d’un nouveau changement.",
        recipesPrimaryPendingDescription:
          "Cette recette a encore besoin d’un plan ou d’un apply avant d’être vraiment utilisable.",
        recipesPrimaryDraftDescription:
          "Continuez l’édition avant de lancer un plan ou de demander une convergence à Calisto.",
        recipesWorkflowTitle: "Comment travailler ici",
        recipesWorkflowDescription:
          "La page Recipes sert à éditer le blueprint. La meta-recette et Calisto prennent le relais pour préparer, appliquer et vérifier les changements.",
        recipesWorkflowStepEditLabel: "Éditez le blueprint",
        recipesWorkflowStepEditDescription:
          "Travaillez la structure de la recette dans le canvas ou dans le YAML synchronisé.",
        recipesWorkflowStepMetaLabel: "Validez dans la meta-recette",
        recipesWorkflowStepMetaDescription:
          "Ouvrez la meta-recette pour comparer la spec, préparer un plan et demander une convergence.",
        recipesWorkflowStepShipLabel: "Testez puis publiez",
        recipesWorkflowStepShipDescription:
          "Quand la recette est prête, lancez les tests ou le publish depuis le workflow de build.",
        contextUnavailable: "Contexte indisponible",
        noRecipe: "Aucune recette",
        createFirstRecipe: "Créez votre première recette pour commencer.",
        newRecipe: "Nouvelle Recette",
        createRecipeCta: "Créer une Recette",
        backToList: "Retour à la liste",
        blueprintEditing: "Édition de blueprint",
        blueprintEditingDescription:
          "Alternez entre le canvas visuel et la représentation YAML synchronisée.",
        canvasView: "Canvas",
        yamlView: "YAML",
        reloadFromCanvas: "Recharger depuis le canvas",
        applyToCanvas: "Appliquer au canvas",
        structuredSpecYaml: "YAML Structured Spec",
        yamlValidated:
          "Les modifications sont validées avant d’être reflétées dans le canvas.",
        localDraft: "Brouillon local",
        synchronized: "Synchronisé",
        yamlSaveHint:
          "Le YAML décrit la recette complète. Sauvegarder applique d’abord le YAML au canvas.",
        calistoCommandTitle: "Calisto Command",
        calistoCommandDescription:
          "Décrivez le blueprint voulu, puis laissez Calisto proposer les changements.",
        closeCalisto: "Fermer Calisto",
        openCalisto: "Ouvrir Calisto",
        noNodeSelected: "Aucun nœud sélectionné",
        noNodeSelectedDescription:
          "Sélectionnez un bloc sur le canvas pour afficher sa configuration et les suggestions de Calisto.",
        essential: "Essentiel",
        advanced: "Avancé",
        expert: "Expert",
        pending: "En attente",
        applyAction: "Appliquer",
        rejectAction: "Rejeter",
        untitledNode: "Nœud sans titre",
        calistoAssistTitle: "Calisto Assist",
        calistoAssistDescription:
          "Suggestions contextuelles pour enrichir ou corriger ce nœud sans quitter le panneau.",
        suggestionLabel: "Suggestion {{index}}",
        lastCalistoResponse: "Dernière réponse Calisto",
        targetedHelp: "Demander une aide ciblée",
        guidedConvergeDescription:
          "Résumé du plan guidé Calisto pour l’Agent actif et actions de convergence.",
        planReady: "Plan prêt",
        activeBlueprintName: "Blueprint actif : {{name}}",
        openCalistoForWorkflow:
          "Ouvrez Calisto sur un Agent actif pour charger le workflow de convergence.",
        configurationTitle: "Configuration",
        configurationDescription:
          "Le niveau affiché dépend de la profondeur demandée : rapide, avancée ou brute.",
        nodeName: "Nom du nœud",
        nodeType: "Type",
        model: "Modèle",
        selectModel: "Choisir un modèle",
        mainPrompt: "Prompt principal",
        mcpServer: "Serveur MCP",
        tools: "Outils",
        commaSeparatedList: "Liste séparée par des virgules",
        sourceType: "Type de source",
        selectSourceType: "Sélectionner",
        source: "Source",
        conditionalExpression: "Expression conditionnelle",
        direction: "Direction",
        format: "Format",
        input: "Entrée",
        output: "Sortie",
        temperature: "Température",
        temperatureHint: "Réglage surtout utile pour les nœuds LLM",
        maxTokens: "Max tokens",
        timeoutMs: "Timeout (ms)",
        rawJsonConfig: "Configuration JSON brute",
        rawJsonConfigHint:
          "Utile pour les réglages avancés ou les copier-coller de configuration.",
        saveJson: "Enregistrer le JSON",
        revert: "Réinitialiser",
        database: "Base de données",
        file: "Fichier",
        api: "API",
        json: "JSON",
        inputLabel: "Entrée",
        outputLabel: "Sortie",
        deleteNode: "Supprimer le nœud",
        noConditionSet: "Aucune condition définie",
        trueLabel: "Vrai",
        falseLabel: "Faux",
        noPromptConfigured: "Aucun prompt configuré",
        noToolsConfigured: "Aucun outil configuré",
        moreTools: "+ {{count}} de plus",
        toolsCount: "{{count}} outils",
        recordsCount: "{{count}} enregistrements",
        templateEmptyName: "Recette vide",
        templateEmptyDescription: "Démarrer avec un canvas vide",
        templateRagName: "Pipeline RAG",
        templateRagDescription:
          "Workflow de génération augmentée par recherche",
        templateChainName: "Chaîne de prompts",
        templateChainDescription: "Séquence multi-étapes de prompts",
        templateAgentName: "Agent avec outils",
        templateAgentDescription: "Agent IA avec outils MCP",
        capabilitiesTitle: "Capacités",
        capabilitiesDescription:
          "Surfaces de capacité actuellement exposées par l’OS, groupées par fonction produit plutôt que par type de provider.",
        capabilitiesCoverageLabel: "Couverture",
        capabilitiesCoverageHint: "Surfaces de capacité visibles dans Build.",
        capabilitiesOperationalLabel: "Prêtes",
        capabilitiesOperationalHint:
          "Utilisables sans passer par des contournements.",
        capabilitiesEvolvingLabel: "À compléter",
        capabilitiesEvolvingHint:
          "Parties encore partielles ou en cours de finition.",
        capabilityStatusOperational: "Opérationnel",
        capabilityStatusPartial: "Partiel",
        capabilityStatusInProgress: "En cours",
        capabilitySurfaceLabel: "Surface",
        capabilityActionLabel: "Action",
        openSurfaceAction: "Ouvrir {{surface}}",
        capabilitiesJourneyDesignTitle: "Concevoir",
        capabilitiesJourneyDesignDescription:
          "Concevoir un agent, structurer une spec et raisonner sur le workflow.",
        capabilitiesJourneyConnectTitle: "Connecter",
        capabilitiesJourneyConnectDescription:
          "Brancher des outils, des données et des actions réutilisables dans le build.",
        capabilitiesJourneyShipTitle: "Publier",
        capabilitiesJourneyShipDescription:
          "Valider, planifier puis appliquer avec les garde-fous visibles dans le produit.",
        capabilitiesReadyTitle: "Prêt maintenant",
        capabilitiesReadyDescription:
          "Ce que les builders peuvent utiliser immédiatement au quotidien.",
        capabilitiesEvolvingTitle: "Encore en évolution",
        capabilitiesEvolvingDescription:
          "Zones utiles, mais encore incomplètes ou moins stables que le reste du workflow.",
        capabilitiesUseNowTitle: "Comment s’en servir",
        capabilitiesUseNowDescription:
          "Lecture rapide de la page pour savoir où travailler selon votre intention.",
        capabilitiesUseNowStep1:
          "Commencez par Conception & raisonnement et Outils & MCP pour cadrer la recette et les intégrations.",
        capabilitiesUseNowStep2:
          "Utilisez Garde-fous et Automatisation pour préparer un plan, le relire puis appliquer sans perdre le contexte.",
        capabilitiesUseNowStep3:
          "Gardez Données & récupération et Assistance contextuelle comme surfaces utiles mais encore moins mûres que le cœur du Build.",
        capabilitiesNextStepDescription:
          "Les prochains investissements produit les plus rentables pour cette zone.",
        capabilitiesNextStepData:
          "Rendre la couche Data plus concrète avec ingestion, exploration et liens directs vers l’Agent.",
        capabilitiesNextStepAssist:
          "Rendre Assist plus actionnable avec suggestions contextuelles et transitions plus claires vers Calisto.",
        capabilityReasoningTitle: "Conception & raisonnement",
        capabilityReasoningDescription:
          "Modèles de fondation et surfaces d’orchestration de prompts.",
        capabilityReasoningItem1: "Nœuds LLM",
        capabilityReasoningItem2: "Agents pilotés par prompt",
        capabilityReasoningItem3: "Réponses en streaming",
        capabilityToolsTitle: "Outils & MCP",
        capabilityToolsDescription:
          "Outils externes exposés via MCP ou intégrations directes.",
        capabilityToolsItem1: "Nœuds MCP",
        capabilityToolsItem2: "Rendu des appels outil",
        capabilityToolsItem3: "Entrées du command palette",
        capabilityDataTitle: "Données & récupération",
        capabilityDataDescription:
          "Sources et surfaces de récupération pour les contextes Build et Run.",
        capabilityDataItem1: "Nœuds de données",
        capabilityDataItem2: "Scoping workspace",
        capabilityDataItem3: "Plan d’ingestion encore à renforcer",
        capabilityGuardrailsTitle: "Garde-fous",
        capabilityGuardrailsDescription:
          "Validation, revue et contrôles de publication avant apply.",
        capabilityGuardrailsItem1: "Validation de spec",
        capabilityGuardrailsItem2: "Génération de plan et diff",
        capabilityGuardrailsItem3: "Approbations avant apply",
        capabilityAutomationTitle: "Automatisation",
        capabilityAutomationDescription:
          "Flows réutilisables et mutations de blueprint initiés par Calisto.",
        capabilityAutomationItem1: "Actions canvas",
        capabilityAutomationItem2: "Flux apply / reject",
        capabilityAutomationItem3: "Workflow de commande embarqué",
        capabilityAssistTitle: "Assistance contextuelle",
        capabilityAssistDescription:
          "Guidage contextuel embarqué dans Build et bientôt Run.",
        capabilityAssistItem1: "Suggestions d’inspection",
        capabilityAssistItem2: "Prompts focalisés sur le nœud",
        capabilityAssistItem3: "Résumés d’actions",
        dataPlaneTitle: "Plan de données",
        dataPlaneDescription:
          "Organisez les surfaces de données, la mémoire workspace et les points de récupération autour de l’Agent courant.",
        dataCoverageLabel: "Couverture",
        dataCoverageHint: "Surfaces de données cartographiées dans Build.",
        dataAvailableLabel: "Disponibles",
        dataAvailableHint: "Surfaces déjà exploitables dans le produit.",
        dataNeedsSetupLabel: "À brancher",
        dataNeedsSetupHint:
          "Surfaces qui demandent encore ingestion ou intégration.",
        dataStatusReady: "Prêt",
        dataStatusRuntime: "Runtime",
        dataStatusPartial: "Partiel",
        dataStatusNeedsIngestion: "Ingestion requise",
        dataJourneyScopeTitle: "Scope",
        dataJourneyScopeDescription:
          "Commencez par comprendre quelle organisation, quel Agent et quel workspace bornent le contexte de données.",
        dataJourneyConnectTitle: "Connect",
        dataJourneyConnectDescription:
          "Reliez ensuite les sources structurées, les APIs et la mémoire utile au build.",
        dataJourneyRetrieveTitle: "Retrieve",
        dataJourneyRetrieveDescription:
          "Préparez enfin des chemins de récupération lisibles pour Calisto et pour les recettes.",
        dataAvailableNowTitle: "Disponible maintenant",
        dataAvailableNowDescription:
          "Surfaces déjà visibles ou directement actionnables dans le workflow actuel.",
        dataNeedsSetupTitle: "Encore à brancher",
        dataNeedsSetupDescription:
          "Surfaces importantes, mais qui demandent encore ingestion, inventaire ou binding produit.",
        dataScopeTitle: "Scope courant",
        dataScopeDescription:
          "La donnée utile dépend toujours du tenant, de l’Agent et du workspace actifs.",
        dataScopeOrganization: "Organisation : {{value}}",
        dataScopeDeployment: "Agent : {{value}}",
        dataScopeWorkspace: "Workspace : {{value}}",
        dataNextStepDescription:
          "Ce qui rendrait cette page immédiatement plus utile aux builders.",
        dataNextStepInventory:
          "Exposer un vrai inventaire des sources connectées, pas seulement des catégories théoriques.",
        dataNextStepBindings:
          "Montrer les bindings réels entre recettes, workspace memory et surfaces de récupération.",
        dataSurfaceStructuredTitle: "Structured sources",
        dataSurfaceStructuredDescription:
          "Bases de données, entrepôts et systèmes métier tabulaires.",
        dataSurfaceStructuredDetail1: "Sources relationnelles et tabulaires",
        dataSurfaceStructuredDetail2:
          "Bon candidat pour des nœuds data explicites",
        dataSurfaceStructuredDetail3:
          "À connecter directement à l’Agent cible",
        dataSurfaceDocumentsTitle: "Document knowledge",
        dataSurfaceDocumentsDescription:
          "Fichiers, manuels, contrats et connaissance interne longue.",
        dataSurfaceDocumentsDetail1: "Demande des workflows d’ingestion clairs",
        dataSurfaceDocumentsDetail2:
          "Doit exposer une indexation et une fraîcheur lisibles",
        dataSurfaceDocumentsDetail3:
          "Encore moins concret que les surfaces structurées",
        dataSurfaceApisTitle: "Operational APIs",
        dataSurfaceApisDescription:
          "Systèmes externes exposés via APIs ou serveurs MCP.",
        dataSurfaceApisDetail1: "Déjà partiellement présents via MCP",
        dataSurfaceApisDetail2:
          "Nécessite encore un inventaire et des bindings plus visibles",
        dataSurfaceApisDetail3:
          "Surface utile pour les recettes orientées action",
        dataSurfaceWorkspaceTitle: "Workspace memory",
        dataSurfaceWorkspaceDescription:
          "Contexte court terme borné par le workspace et l’Agent.",
        dataSurfaceWorkspaceDetail1:
          "Disponible pendant l’exécution et les échanges assistés",
        dataSurfaceWorkspaceDetail2:
          "Utile pour garder des artefacts et un contexte local",
        dataSurfaceWorkspaceDetail3:
          "Doit mieux se relier aux recettes et aux runs",
        implementationNextStep: "Prochaine étape d’implémentation",
        observeTitle: "Observe",
        clearFocus: "Effacer le focus",
        noEnv: "Sans environnement",
        observeDescription:
          "Signaux opérationnels de l’Agent courant, avec inspection ciblée quand Calisto vous dirige vers un run précis.",
        observeRuntimeStatus: "Statut runtime : {{value}}",
        observeTotalTracked: "Total suivi : {{count}}",
        observeLastCheck: "Dernier contrôle : {{value}}",
        observeRunId: "Run ID : {{value}}",
        observeSuggestedActions: "Actions suggérées",
        observeStableBaseline: "Baseline stable",
        observeCandidate: "Candidat",
        observeRegressionDiff: "Diff de régression",
        observeNoFocusedRun:
          "Aucun run focalisé pour l’instant. Ouvrez le dernier apply ou le dernier test, ou repartez dans Calisto pour demander une nouvelle inspection.",
        observeOpenLatestApply: "Ouvrir le dernier apply",
        observeOpenLatestTest: "Ouvrir le dernier test",
        observeNoRuns: "Aucun run disponible pour le moment.",
        selectOrgDeployment:
          "Sélectionnez une organisation et un Agent pour inspecter les signaux d’observabilité.",
        blueprintFocus: "Focus blueprint",
        focusedInspection: "Inspection ciblée",
        currentMetaRecette:
          "Meta-recette courante et activité apply/test récente",
        detailsForRun: "Détails du run que Calisto vous a demandé d’inspecter",
        openBlueprint: "Ouvrir le blueprint",
        openPublishFlow: "Ouvrir le flux de publication",
        openInCalisto: "Ouvrir dans Calisto",
        runInChat: "Exécuter dans le chat",
        noMetaRecette: "Aucune meta-recette résolue pour cet Agent.",
        recentApplyRuns: "Applies récents",
        recentTestRuns: "Tests récents",
        components: "Composants",
        searchComponents: "Rechercher...",
        dragOrClick:
          "Glissez un composant sur le canvas ou cliquez pour ajouter",
        createRecipe: "Créer une recette",
        createRecipeDescription:
          "Créez une nouvelle meta-recette à partir d’un template ou démarrez avec un canvas vide.",
        recipeName: "Nom de la recette",
        recipeDescriptionOptional: "Description (optionnelle)",
        chooseTemplate: "Choisir un template",
        cancel: "Annuler",
        creating: "Création...",
        createRecipeAction: "Créer la recette",
        deployHealth: "Santé",
        deployUptime: "Disponibilité",
        deployActiveExecutions: "Exécutions actives",
        deployTotalExecutions: "Exécutions totales",
        deployLastCheck: "Dernier contrôle de santé",
        restart: "Redémarrer",
        deployRedeploy: "Redéployer",
        deployRedeployInProgress: "ReAgent…",
        deployRedeployConfirm:
          "Redéployer cet Agent ? Il sera temporairement indisponible et la configuration runtime sera rechargée.",
        deployRedeploySuccess: "ReAgent lancé.",
        deployRedeployError: "Impossible de redéployer.",
        deployDangerZoneTitle: "Zone de danger",
        deployDangerZoneDescription:
          "La suppression retire définitivement cet Agent, ses recettes, ses espaces et leurs conversations.",
        deployDeleteAction: "Supprimer cet Agent",
        deployDeleteConfirm:
          "Supprimer définitivement l’Agent « {{name}} » ? Cette action est irréversible.",
        deployDeleteSuccess: "Agent supprimé.",
        deployDeleteError: "Impossible de supprimer cet Agent.",
        stop: "Arrêter",
        promoteTo: "Promouvoir {{recipe}} vers {{target}} ?",
        promoteDescription:
          "Vous allez promouvoir cette recette de {{source}} vers {{target}}.",
        version: "Version",
        addedNodes: "Nœuds ajoutés",
        removedNodes: "Nœuds supprimés",
        modifiedNodes: "Nœuds modifiés",
        noChangesDetected: "Aucun changement détecté",
        dryRunMode: "Mode simulation (ne pas appliquer les changements)",
        promoting: "Promotion en cours...",
        simulate: "Simuler",
        promote: "Promouvoir",
        pipelineTitle: "Pipeline Agent",
        deployWorkspaceTitle: "Runtime de l’Agent",
        deployWorkspaceDescription:
          "Configurez les couches runtime de l’Agent: LLM, MCP, services internes et variables.",
        deployTabRelease: "Release",
        deployTabLlm: "LLM",
        deployTabMcp: "MCP",
        deployTabSkills: "Skills",
        deployTabInternal: "Interne",
        deployTabAccess: "Accès",
        deployTabVariables: "Variables",
        deployRuntimeLoading: "Chargement de la configuration runtime…",
        deployRuntimeSummaryTitle: "Configuration runtime",
        deployRuntimeSummaryDescription:
          "Pilotez ici les surfaces runtime de l’Agent sans quitter le workflow Build.",
        deployRuntimeManagedMode: "Modèle managé",
        deployRuntimeCustomMode: "Providers personnalisés",
        deployRuntimeNotConfigured: "Non configuré",
        deployRuntimeProvidersCount: "Providers LLM",
        deployRuntimeProvidersSummary: "{{count}} provider configuré",
        deployRuntimeProvidersSummary_other: "{{count}} providers configurés",
        deployRuntimeDefaultModel: "Modèle actif",
        deployRuntimeHostedBadge: "AgentMaurice",
        deployRuntimeHostedCreditsHint:
          "Indicatif: ~{{count}} crédits par 1k tokens.",
        deployRuntimeCreditsUnit: "crédits",
        deployRuntimeHostedPricingHint:
          "Indicatif: entrée {{input}} / sortie {{output}} {{currency}} par 1k tokens.",
        deployRuntimeSystemPrompt: "Prompt système",
        deployRuntimeSystemPromptSet:
          "Un prompt système est déjà défini pour cet Agent.",
        deployRuntimeSystemPromptMissing: "Aucun prompt système défini.",
        deployRuntimeMcpDescription:
          "Prépare la configuration des serveurs MCP manuels, du registry et des sidecars de cet Agent.",
        deployRuntimeMcpServers: "serveurs",
        deployRuntimeManualServers: "Serveurs manuels",
        deployRuntimeRegistryServers: "Sidecars du registry",
        deployRuntimeSkillsAttached: "skills attachés à l’Agent",
        deployRuntimeSkillsPanelDescription:
          "Pilotez les skills réellement installées sur l’Agent et le catalogue de skills disponibles.",
        deployRuntimeSkillsCatalogTitle: "Catalogue skills",
        deployRuntimeSkillsCatalogDescription:
          "Installez des skills depuis le catalogue réel exposé par chatserver.",
        deployRuntimeSkillsRegistryTitle: "Catalogue skills",
        deployRuntimeSkillsRegistryDescription:
          "Installez les skills nécessaires à cet Agent depuis le catalogue.",
        deployRuntimeSkillsSaveSelection: "Enregistrer la sélection",
        deployRuntimeSkillsSearchPlaceholder:
          "Rechercher une skill par nom, dépôt ou tag",
        deployRuntimeSkillsNoSelection: "Aucune skill attachée",
        deployRuntimeSkillsNoSelectionDescription:
          "Sélectionnez des skills depuis le registry pour les rendre disponibles dans cet Agent.",
        deployRuntimeSkillsNoCatalog: "Aucune skill disponible",
        deployRuntimeSkillsNoCatalogDescription:
          "Ajoutez des skills au catalogue pour pouvoir les installer sur cet Agent.",
        deployRuntimeSkillsNoRegistry: "Aucune skill disponible",
        deployRuntimeSkillsNoRegistryDescription:
          "Ajoutez des skills au catalogue pour pouvoir les installer ici.",
        deployRuntimeSkillsConfigRequired: "Configuration requise",
        deployRuntimeSkillsInstall: "Installer",
        deployRuntimeSkillsUninstall: "Désinstaller",
        deployRuntimeSkillsInstalled: "Installées runtime",
        deployRuntimeSkillsFilesCount: "{{count}} fichier(s)",
        deployRuntimeSkillsToolsCount: "{{count}} outil(s) MCP",
        deployRuntimeSkillsInstallations: "Installations",
        deployRuntimeSkillsInstallationsTitle: "Installations catalogue",
        deployRuntimeSkillsInstallationsDescription:
          "Ces lignes viennent de SkillInstallation et indiquent les packages installés pour cet Agent.",
        deployRuntimeSkillsNoInstallations: "Aucune installation catalogue.",
        deployRuntimeSkillsNoInstallationsDescription:
          "Les installations apparaîtront ici après ajout depuis le catalogue réel.",
        deployRuntimeSkillsCatalogCount: "Catalogue",
        deployRuntimeSkillsInstalledTitle: "État réel du runtime",
        deployRuntimeSkillsInstalledDescription:
          "Cette liste vient de chatserver et reflète les skills effectivement disponibles sur l’Agent.",
        deployRuntimeSkillsNoInstalled: "Aucune skill installée dans le runtime.",
        deployRuntimeSkillsNoInstalledDescription:
          "Installez une skill depuis le catalogue réel ou importez un SKILL.md dans cet Agent.",
        deployRuntimeSkillsVerified: "Vérifiée",
        deployRuntimeSkillsInactive: "Inactive",
        deployRuntimeSkillsNotInstalled: "Non installée",
        deployRuntimeSkillsInstallSuccess:
          "Skill {{skillName}} installée sur l’Agent.",
        deployRuntimeSkillsInstallError:
          "Impossible d’installer la skill {{skillName}}.",
        deployRuntimeSkillsUninstallSuccess:
          "Skill {{skillName}} désinstallée de l’Agent.",
        deployRuntimeSkillsUninstallError:
          "Impossible de désinstaller la skill {{skillName}}.",
        deployRuntimeSkillsUninstallConfirm:
          "Désinstaller la skill {{skillName}} de cet Agent ?",
        deployRuntimeSkillsGitHubImportTitle: "Installer depuis GitHub",
        deployRuntimeSkillsGitHubImportDescription:
          "Collez l’URL d’un repository ou d’un dossier GitHub contenant un SKILL.md. Les fichiers Markdown du dossier sont importés dans cet Agent.",
        deployRuntimeSkillsGitHubUrlPlaceholder:
          "https://github.com/owner/repo/tree/main/skills/ma-skill",
        deployRuntimeSkillsGitHubBranchPlaceholder: "Branche (optionnel)",
        deployRuntimeSkillsGitHubPathPlaceholder: "Dossier (optionnel)",
        deployRuntimeSkillsGitHubIdPlaceholder: "ID skill (optionnel)",
        deployRuntimeSkillsGitHubOverwrite: "Remplacer si la skill existe déjà",
        deployRuntimeSkillsGitHubImport: "Importer",
        deployRuntimeSkillsGitHubImporting: "Import…",
        deployRuntimeSkillsGitHubUrlRequired:
          "Renseignez une URL GitHub contenant un SKILL.md.",
        deployRuntimeSkillsGitHubImportSuccess:
          "Skill {{skillName}} importée depuis GitHub.",
        deployRuntimeSkillsGitHubImportError:
          "Impossible d’importer cette skill depuis GitHub.",
        deployRuntimeSkillsSelectionUpdated:
          "Sélection des skills mise à jour.",
        deployRuntimeSkillsSelectionError:
          "Impossible de mettre à jour la sélection des skills.",
        deployRuntimeSkillsFootnoteTitle: "Quand utiliser des skills",
        deployRuntimeSkillsFootnoteDescription:
          "Utilisez des skills pour exposer des workflows spécialisés au build sans surcharger les recettes standards de l’Agent.",
        deployRuntimeAccessPanelDescription:
          "Gérez les accès de l’Agent: clés d’API et configuration du gateway d’authentification.",
        deployRuntimeApiKeysTitle: "Clés de l’Agent",
        deployRuntimeApiKeysDescription:
          "Créez, régénérez et organisez les clés sk_maurice_ utilisées par LocalMaurice, X-API-Key, les recettes HTTP et les runtimes.",
        agentControlTitle: "Contrôle agent-native",
        agentControlDescription: "Supervisez les accès des agents de code, les approbations humaines Agent Spec et les clés temporaires associées.",
        agentAccessKindAgent: "Agent de code",
        agentAccessKindCli: "MauriceCLI",
        agentAccessTitle: "Accès des agents de code",
        agentAccessDescription:
          "Liens bootstrap émis pour les agents de code et MauriceCLI. Révoquer un lien révoque aussi sa clé temporaire.",
        agentAccessNoActiveLinks: "Aucun lien bootstrap actif.",
        agentAccessRevokedLinks: "Liens révoqués",
        agentControlSeeAlso: "Vues associées",
        agentControlOpenAgentSpec: "Plan et approbation → Agent Spec",
        agentControlOpenObserve: "Apply et vérification → Agent Spec",
        agentDiscoverySupervisionTitle: "Contrôle agent-native guidé",
        agentDiscoverySupervisionDescription:
          "Suivez les liens bootstrap, les clés émises et les approbations humaines des plans Agent Spec immuables.",
        agentDiscoveryCurrentPlanTitle: "Plan Agent Spec courant",
        agentDiscoveryNoMetaRecette: "Aucun Agent Spec lié à cet Agent.",
        agentDiscoveryRecipeSpecDriftTitle: "Drift entre Agent Spec et runtime",
        agentDiscoveryRecipeSpecDriftDescription:
          "L’Agent Spec reste la source de vérité. Les Workflows et MiniApps runtime non gérés doivent être adoptés explicitement.",
        agentDiscoveryPlanActions: "Actions",
        agentDiscoveryApproval: "Approbation",
        agentDiscoveryPlanHash: "Hash du plan",
        agentDiscoveryApprovePlan: "Approuver le plan",
        agentDiscoveryRejectPlan: "Refuser",
        agentDiscoveryApproveDialogTitle: "Approuver ce plan ?",
        agentDiscoveryApproveDialogDescription:
          "Le mode guidé pourra appliquer uniquement ce plan avec le hash approuvé.",
        agentDiscoveryRejectDialogTitle: "Refuser ce plan ?",
        agentDiscoveryRejectDialogDescription:
          "Le plan courant sera marqué comme refusé et ne pourra pas être appliqué en mode guidé.",
        agentDiscoveryDecisionCommentLabel: "Commentaire optionnel",
        agentDiscoveryDecisionCommentPlaceholder:
          "Contexte de la décision, risque accepté ou raison du refus",
        agentDiscoveryNoCurrentPlan: "Aucun plan courant à approuver.",
        agentDiscoveryApprovalsTitle: "Approbations récentes",
        agentDiscoveryApprovalsDescription:
          "Historique compact des approbations humaines portant sur le hash exact d’un plan Agent Spec immuable.",
        agentDiscoveryUnknownApprover: "Utilisateur",
        agentDiscoveryNoApprovals: "Aucune approbation récente.",
        agentDiscoveryBootstrapLinksTitle: "Liens bootstrap agent",
        agentDiscoveryBootstrapLinksDescription:
          "Les liens consommés peuvent aussi révoquer la clé temporaire issue du bootstrap.",
        agentDiscoveryNoBootstrapLinks: "Aucun lien bootstrap généré.",
        agentDiscoveryPlanApproved: "Plan approuvé",
        agentDiscoveryPlanApproveError: "Impossible d’approuver le plan",
        agentDiscoveryPlanRejected: "Plan refusé",
        agentDiscoveryPlanRejectError: "Impossible de refuser le plan",
        agentDiscoveryBootstrapRevoked: "Accès agent révoqué",
        agentDiscoveryBootstrapRevokeError: "Impossible de révoquer cet accès",
        cliBootstrapLinksTitle: "Liens bootstrap MauriceCLI",
        cliBootstrapLinksDescription:
          "Ces liens connectent MauriceCLI à un projet local et peuvent révoquer la clé temporaire issue du bootstrap.",
        cliBootstrapNoLinks: "Aucun lien bootstrap MauriceCLI généré.",
        cliBootstrapRevoked: "Accès MauriceCLI révoqué",
        cliBootstrapRevokeError: "Impossible de révoquer cet accès MauriceCLI",
        agentDiscoveryRecentRunsTitle: "Derniers apply/test/reconcile",
        agentDiscoveryRecentRunsDescription:
          "Vue compacte des apply, tests et vérifications Agent Spec liés au contrôle agent-native.",
        agentDiscoveryApplyRuns: "Apply / reconcile",
        agentDiscoveryTestRuns: "Tests",
        agentDiscoveryNoApplyRuns: "Aucun apply/reconcile récent.",
        agentDiscoveryNoTestRuns: "Aucun test récent.",
        agentDiscoveryRunSync: "Sync",
        agentDiscoveryStableBaseline: "Baseline stable",
        agentDiscoveryTestCases: "Cas",
        agentDiscoveryTestFailed: "échoué(s)",
        agentDiscoveryTestSkipped: "ignoré(s)",
        agentDiscoveryTestDuration: "Durée",
        agentDiscoveryTestTokens: "Tokens",
        agentDiscoveryTestCost: "Coût estimé",
        agentDiscoveryTestExecutions: "Exécutions",
        agentDiscoveryTestTraces: "Traces",
        agentDiscoveryTestErrors: "Erreurs",
        agentDiscoveryIntegrationSurfacesTitle: "Inventaire intégrations agent-native",
        agentDiscoveryIntegrationSurfacesDescription:
          "Résumé des surfaces que l’agent peut découvrir via External Inception et des frontières OS/HTTP-only.",
        agentDiscoveryNoIntegrationSurfaces: "Aucun inventaire d’intégration disponible.",
        deployRuntimeApiKeysCount: "Clés actives",
        deployRuntimeApiKeysExpiringSoon: "Expiration proche",
        deployRuntimeApiKeysNeverExpire: "Sans expiration",
        deployRuntimeApiKeyCreate: "Créer une clé",
        deployRuntimeApiKeyCreateDescription:
          "Définissez un nom, une description et une durée de vie pour cette nouvelle clé.",
        deployRuntimeApiKeyEdit: "Modifier la clé",
        deployRuntimeApiKeyEditDescription:
          "Ajustez le nom et la description de cette clé sans changer sa portée technique.",
        deployRuntimeApiKeyDelete: "Supprimer la clé",
        deployRuntimeApiKeyDeleteDescription:
          "La clé {{name}} sera supprimée immédiatement. Les clients qui l’utilisent perdront l’accès.",
        deployRuntimeApiKeyName: "Nom",
        deployRuntimeApiKeyNamePlaceholder: "CLI intégration",
        deployRuntimeApiKeyDescriptionLabel: "Description",
        deployRuntimeApiKeyDescriptionPlaceholder:
          "Expliquez qui utilise cette clé et dans quel contexte.",
        deployRuntimeApiKeyExpiration: "Expiration",
        deployRuntimeApiKeyExpiration30Days: "30 jours",
        deployRuntimeApiKeyExpiration90Days: "90 jours",
        deployRuntimeApiKeyExpiration1Year: "1 an",
        deployRuntimeApiKeyExpirationNever: "Jamais",
        deployRuntimeApiKeyExpirationCustom: "Date personnalisée",
        deployRuntimeApiKeyCustomExpiration: "Date d’expiration",
        deployRuntimeApiKeyCreated: "Clé créée.",
        deployRuntimeApiKeyCreateError: "Impossible de créer la clé.",
        deployRuntimeApiKeyUpdated: "Clé mise à jour.",
        deployRuntimeApiKeyUpdateError: "Impossible de mettre à jour la clé.",
        deployRuntimeApiKeyDeleted: "Clé supprimée.",
        deployRuntimeApiKeyDeleteError: "Impossible de supprimer la clé.",
        deployRuntimeApiKeyRegenerated: "Clé régénérée.",
        deployRuntimeApiKeyRegenerate: "Régénérer",
        deployRuntimeApiKeyRegenerateError: "Impossible de régénérer la clé.",
        deployRuntimeApiKeyCopied: "Clé copiée.",
        deployRuntimeApiKeyCopyError: "Impossible de copier la clé.",
        deployRuntimeApiKeyNoKeys: "Aucune clé supplémentaire",
        deployRuntimeApiKeyNoKeysDescription:
          "Créez des clés dédiées pour les intégrations au lieu de partager une clé primaire entre plusieurs usages.",
        deployRuntimeDeploymentMembersTitle: "Utilisateurs de l’Agent",
        deployRuntimeDeploymentMembersDescription:
          "Affectez les membres de l’organisation qui peuvent utiliser cet Agent.",
        deployRuntimeDeploymentMemberSelect: "Choisir un membre",
        deployRuntimeDeploymentMemberAssign: "Affecter",
        deployRuntimeDeploymentMemberAssigned: "Utilisateur affecté à l’Agent.",
        deployRuntimeDeploymentMemberAssignError:
          "Impossible d’affecter cet utilisateur à l’Agent.",
        deployRuntimeDeploymentMemberRemoved: "Affectation supprimée.",
        deployRuntimeDeploymentMemberRemoveError:
          "Impossible de supprimer cette affectation.",
        deployRuntimeDeploymentMembersEmpty:
          "Aucun utilisateur affecté. L’Agent reste accessible aux membres de l’organisation tant qu’aucune affectation explicite n’existe.",
        deployRuntimeDeploymentMemberOperator: "Opérateur",
        deployRuntimeDeploymentMemberViewer: "Lecture seule",
        deployRuntimeDeploymentMemberUser: "Utilisateur",
        deployRuntimeDeploymentMemberRole: "Rôle",
        deployRuntimeApiKeyRevealTitle: "Conservez cette clé maintenant",
        deployRuntimeApiKeyRevealDescription:
          "La valeur complète n’est montrée qu’après création ou régénération. Copiez-la tout de suite si nécessaire.",
        deployRuntimeApiKeyCopy: "Copier la clé",
        deployRuntimeApiKeyCreatedAt: "Créée le",
        deployRuntimeApiKeyExpiresAt: "Expire le",
        deployRuntimeApiKeyNeverExpiresLabel: "N’expire jamais",
        deployRuntimeApiKeyExpired: "Expirée",
        deployRuntimeApiKeyExpiringSoon: "Expire bientôt",
        deployRuntimeApiKeyActive: "Active",
        deployRuntimeAuthConnectorTitle: "Auth connector",
        deployRuntimeAuthConnectorDescription:
          "Configurez le gateway d’authentification de cet Agent à partir d’une spec JSON validable.",
        deployRuntimeAuthConnectorStatus: "Statut",
        deployRuntimeAuthConnectorConfigured: "Configuré",
        deployRuntimeAuthConnectorNotConfigured: "Non configuré",
        deployRuntimeAuthConnectorVersion: "Version",
        deployRuntimeAuthConnectorPresets: "Presets",
        deployRuntimeAuthConnectorSelectPreset: "Choisir un preset",
        deployRuntimeAuthConnectorApplyPreset: "Appliquer le preset",
        deployRuntimeAuthConnectorSpec: "Spec JSON",
        deployRuntimeAuthConnectorValid: "Spec valide",
        deployRuntimeAuthConnectorInvalid: "Spec invalide",
        deployRuntimeAuthConnectorErrors: "Erreurs",
        deployRuntimeAuthConnectorWarnings: "Avertissements",
        deployRuntimeAuthConnectorPresetApplied: "Preset appliqué.",
        deployRuntimeAuthConnectorSaved: "Auth connector enregistré.",
        deployRuntimeAuthConnectorSaveError:
          "Impossible d’enregistrer l’auth connector.",
        deployRuntimeAuthConnectorDeleted: "Auth connector supprimé.",
        deployRuntimeAuthConnectorDeleteError:
          "Impossible de supprimer l’auth connector.",
        deployRuntimeAuthConnectorValidateError:
          "Impossible de valider la spec de l’auth connector.",
        deployRuntimeAuthConnectorMappingTitle: "Lookup mappings",
        deployRuntimeAuthConnectorMappingDescription:
          "Associez des identités externes à des organisations et agents résolus pour ce gateway.",
        deployRuntimeAuthConnectorFieldIssuer: "Issuer",
        deployRuntimeAuthConnectorFieldExternalUserId: "External user ID",
        deployRuntimeAuthConnectorFieldEmail: "Email",
        deployRuntimeAuthConnectorFieldRoles:
          "Roles (séparés par des virgules)",
        deployRuntimeAuthConnectorFieldResolvedOrg: "Organisation résolue",
        deployRuntimeAuthConnectorFieldResolvedDeployment: "Agent résolu",
        deployRuntimeAuthConnectorFieldMetadata: "Metadata JSON",
        deployRuntimeAuthConnectorMappingResolvedTarget: "Cible résolue",
        deployRuntimeAuthConnectorSaveMapping: "Enregistrer le mapping",
        deployRuntimeAuthConnectorMappingSaved: "Mapping enregistré.",
        deployRuntimeAuthConnectorMappingSaveError:
          "Impossible d’enregistrer le mapping.",
        deployRuntimeAuthConnectorMappingDeleted: "Mapping supprimé.",
        deployRuntimeAuthConnectorMappingDeleteError:
          "Impossible de supprimer le mapping.",
        deployRuntimeAuthConnectorNoMappings: "Aucun mapping configuré",
        deployRuntimeAuthConnectorBulkTitle: "Import bulk mappings",
        deployRuntimeAuthConnectorBulkDescription:
          "Importez une liste JSON de mappings pour accélérer le bootstrap du gateway.",
        deployRuntimeAuthConnectorBulkImport: "Importer les mappings",
        deployRuntimeAuthConnectorBulkSuccess: "Mappings importés.",
        deployRuntimeAuthConnectorBulkError:
          "Impossible d’importer les mappings bulk.",
        deployRuntimeAuthConnectorGatewayTitle: "Gateway Next.js",
        deployRuntimeAuthConnectorGatewayDescription:
          "Générez une archive prête à intégrer côté frontend à partir de la spec actuelle.",
        deployRuntimeAuthConnectorGatewayHint:
          "Téléchargez le ZIP uniquement quand la spec et les mappings sont cohérents.",
        deployRuntimeAuthConnectorDownloadGateway: "Télécharger le ZIP",
        deployRuntimeAuthConnectorGatewayDownloaded: "Gateway téléchargé.",
        deployRuntimeAuthConnectorGatewayDownloadError:
          "Impossible de télécharger le gateway.",
        deployRuntimeActions: "Actions",
        deployRuntimeOAuth: "OAuth & diagnostic",
        deployRuntimeOAuthDescription:
          "Les connexions OAuth et le doctor SSE seront branchés ici avec les mêmes flux que le dashboard.",
        deployRuntimeInternalDescription:
          "Prépare les services internes de l’Agent : stockage des artefacts, recherche documentaire, mémoire métier, multimodal, messagerie et contrôle expert.",
        deployRuntimeUnsavedChanges: "Modifications non enregistrées",
        deployRuntimeSavedState: "Enregistré",
        deployRuntimeResetDraft: "Annuler les changements",
        deployRuntimeSaving: "Enregistrement…",
        deployRuntimeStorage: "Storage",
        deployRuntimeCompanyMemory: "Company memory",
        deployRuntimeEnabled: "Activé",
        deployRuntimeDisabled: "Désactivé",
        deployRuntimeLlmPanelDescription:
          "Choisissez un modèle managé, configurez les providers personnalisés et ajustez le prompt système de l’Agent.",
        deployRuntimeAddProvider: "Ajouter un provider",
        deployRuntimeProvidersList: "Providers configurés",
        deployRuntimeProvidersListDescription:
          "Gérez ici les endpoints LLM utilisés par cet Agent quand vous sortez du mode managé.",
        deployRuntimeNoProviders: "Aucun provider personnalisé configuré.",
        deployRuntimeDefault: "Par défaut",
        deployRuntimeModelMissing: "Aucun modèle renseigné",
        deployRuntimeSetDefault: "Définir par défaut",
        deployRuntimeCreateProvider: "Créer un provider",
        deployRuntimeEditProvider: "Modifier le provider",
        deployRuntimeProviderDialogDescription:
          "Renseignez le provider, son endpoint et son modèle pour l’utiliser dans cet Agent.",
        deployRuntimeProviderName: "Nom du provider",
        deployRuntimeProviderType: "Type de provider",
        deployRuntimeProviderModel: "Modèle",
        deployRuntimeProviderUrl: "URL",
        deployRuntimeProviderApiKey: "Clé API",
        deployRuntimeProviderApiKeyOptional:
          "Laisser vide pour conserver la clé existante",
        deployRuntimeProviderDescription: "Décrivez brièvement ce provider",
        deployRuntimeMakeDefault: "Utiliser ce provider par défaut",
        deployRuntimeProviderNameRequired: "Le nom du provider est requis.",
        deployRuntimeProviderCreated: "Provider créé.",
        deployRuntimeProviderCreateError: "Impossible de créer le provider.",
        deployRuntimeProviderUpdated: "Provider mis à jour.",
        deployRuntimeProviderUpdateError:
          "Impossible de mettre à jour le provider.",
        deployRuntimeProviderDeleted: "Provider supprimé.",
        deployRuntimeProviderDeleteError:
          "Impossible de supprimer le provider.",
        deployRuntimeProviderDefaultUpdated: "Provider par défaut mis à jour.",
        deployRuntimeProviderDefaultError:
          "Impossible de définir ce provider comme valeur par défaut.",
        deployRuntimeRegistryHint:
          "Utilisez un modèle managé ou ajoutez un provider personnalisé.",
        deployRuntimeLlmProfileBadge: "Profil LLM",
        deployRuntimeDeploymentProfile: "Profil LLM de l’Agent",
        deployRuntimeSelectModel: "Sélectionner un modèle managé",
        deployRuntimeNoManagedModel: "Aucun modèle managé",
        deployRuntimeSaveModel: "Enregistrer le modèle",
        deployRuntimeModelSaved: "Modèle enregistré.",
        deployRuntimeModelSaveError: "Impossible d’enregistrer le modèle.",
        deployRuntimeSystemPromptPlaceholder:
          "Définissez ici les instructions système appliquées à cet Agent.",
        deployRuntimeSystemPromptSaved: "Prompt système enregistré.",
        deployRuntimeSystemPromptSaveError:
          "Impossible d’enregistrer le prompt système.",
        deployRuntimeEmbeddingTitle: "Embeddings",
        deployRuntimeEmbeddingDescription:
          "Configurez les providers d’embeddings utilisés pour la recherche, la mémoire et les index vectoriels.",
        deployRuntimeAddEmbedding: "Ajouter un embedding",
        deployRuntimeNoEmbeddings: "Aucun provider d’embeddings configuré.",
        deployRuntimeCreateEmbedding: "Créer un provider d’embeddings",
        deployRuntimeEditEmbedding: "Modifier le provider d’embeddings",
        deployRuntimeEmbeddingDialogDescription:
          "Définissez le provider, le modèle et l’endpoint utilisés pour les embeddings de l’Agent.",
        deployRuntimeEmbeddingName: "Nom",
        deployRuntimeEmbeddingProvider: "Provider",
        deployRuntimeEmbeddingModel: "Modèle",
        deployRuntimeEmbeddingUrl: "URL",
        deployRuntimeEmbeddingApiKey: "Clé API",
        deployRuntimeEmbeddingApiKeyOptional:
          "Laisser vide pour conserver la clé existante",
        deployRuntimeEmbeddingDescriptionLabel: "Description",
        deployRuntimeEmbeddingDescriptionPlaceholder:
          "Décrivez brièvement ce provider d’embeddings.",
        deployRuntimeEmbeddingNameRequired:
          "Le nom du provider d’embeddings est requis.",
        deployRuntimeEmbeddingCreated: "Provider d’embeddings créé.",
        deployRuntimeEmbeddingCreateError:
          "Impossible de créer le provider d’embeddings.",
        deployRuntimeEmbeddingUpdated: "Provider d’embeddings mis à jour.",
        deployRuntimeEmbeddingUpdateError:
          "Impossible de mettre à jour le provider d’embeddings.",
        deployRuntimeEmbeddingDeleted: "Provider d’embeddings supprimé.",
        deployRuntimeEmbeddingDeleteError:
          "Impossible de supprimer le provider d’embeddings.",
        deployRuntimeProxyTitle: "Proxy réseau",
        deployRuntimeProxyDescription:
          "Routez les appels LLM vers un proxy d’entreprise ou un outil d’inspection.",
        deployRuntimeProxyConfigured: "Configuré",
        deployRuntimeProxyNotConfigured: "Non configuré",
        deployRuntimeProxyHttps: "HTTPS proxy",
        deployRuntimeProxyHttp: "HTTP proxy",
        deployRuntimeProxyNoProxy: "No proxy",
        deployRuntimeProxySecretPlaceholder:
          "••••••••  (laisser vide pour conserver la valeur actuelle)",
        deployRuntimeProxyEnvTitle: "Variables injectées",
        deployRuntimeProxyTlsTitle: "Note TLS",
        deployRuntimeProxyTlsDescription:
          "Pour l’inspection HTTPS, ajoutez le certificat CA du proxy dans le trust store système ou l’image cible.",
        deployRuntimeProxySave: "Enregistrer le proxy",
        deployRuntimeProxySaved:
          "Configuration proxy enregistrée. Un redémarrage peut être nécessaire.",
        deployRuntimeProxySaveError:
          "Impossible d’enregistrer la configuration proxy.",
        deployRuntimeProxyVariableDescription:
          "Configuration proxy réseau pour les appels API LLM.",
        deployRuntimeStorageCardDescription:
          "Choisit où le runtime conserve les fichiers produits, imports, exports et artefacts longs. Laissez désactivé si l’Agent ne manipule pas de fichiers persistants.",
        deployRuntimeStorageDisabled: "Désactivé",
        deployRuntimeStorageLocalS3: "Stockage S3 local",
        deployRuntimeStorageS3Compatible: "S3 compatible",
        deployRuntimeStorageAgentMauriceCdn: "AgentMaurice CDN",
        deployRuntimeStorageUnavailable: "indisponible",
        deployRuntimeStorageUnavailableMessage:
          "Ce provider n’est pas disponible sur ce runtime. Sélectionnez un stockage local/S3 compatible pour enregistrer.",
        deployRuntimeConfigureS3: "Configurer S3",
        deployRuntimeDocstoreCardDescription:
          "Ajoute une couche documentaire interne pour déposer, indexer et retrouver des fichiers dans les workflows qui travaillent sur des contrats, manuels ou bases de connaissance.",
        deployRuntimeCompanyMemoryCardDescription:
          "Expose une mémoire métier structurée aux recettes et outils pour conserver faits, décisions et contexte d’organisation entre les sessions.",
        deployRuntimeBrain: "Brain",
        deployRuntimeBrainCardDescription:
          "Active le MCP Brain local pour interroger une base DuckDB dédiée quand un Agent doit raisonner sur des données locales sans passer par un service externe.",
        deployRuntimeMemory: "Memory",
        deployRuntimeMemoryCardDescription:
          "Active le MCP Memory local pour stocker des notes, états et souvenirs opérationnels propres à ce poste ou à cet Agent.",
        deployRuntimeCompanyMemoryReadyDocker:
          "Company Memory est actif via le sidecar Docker de cet Agent.",
        deployRuntimeMultimodalCardDescription:
          "Permet aux recettes et au chat d’utiliser des profils spécialisés pour analyser des images, lire des PDF, extraire de l’OCR, transcrire de l’audio ou produire des médias.",
        deployRuntimeMessagingCardDescription:
          "Ouvre l’Agent aux canaux de conversation externes comme Slack, Telegram, WhatsApp, Discord, Google Chat ou Signal, avec des comptes liés à des clés API.",
        accessPageTitle: "Accès de l’Agent",
        accessPageDescription:
          "Gérez les clés API, les affectations utilisateur, l’auth connector et les mappings d’identité de cet Agent.",
        openAccessPage: "Ouvrir Accès",
        snapshotTitle: "Import / Export de l’Agent",
        snapshotDescription:
          "Transférez la configuration d’un Agent entre instances via un snapshot chiffré.",
        snapshotSummaryValue: "Snapshot chiffré",
        openImportExportPage: "Ouvrir Import / Export",
        snapshotExportTitle: "Exporter un snapshot",
        snapshotExportDescription:
          "Générez une archive JSON chiffrée contenant la configuration de l’Agent.",
        snapshotImportTitle: "Importer un snapshot",
        snapshotImportDescription:
          "Importez un snapshot JSON en création ou en écrasement contrôlé.",
        snapshotPassphrase: "Phrase secrète",
        snapshotPassphrasePlaceholder: "Saisir une phrase secrète forte",
        snapshotIncludeRegistryDefinitions:
          "Inclure les définitions de registry pour l’auto-création à l’import",
        snapshotExportAction: "Exporter le snapshot",
        snapshotExportSuccess: "Snapshot de l’Agent exporté.",
        snapshotExportError: "Impossible d’exporter le snapshot.",
        snapshotImportFromFile: "Depuis un fichier",
        snapshotImportFromJson: "Depuis JSON",
        snapshotSelectedFile: "Fichier sélectionné",
        snapshotJson: "Snapshot JSON",
        snapshotJsonPlaceholder: "Collez ici l’enveloppe JSON exportée.",
        snapshotImportMode: "Mode d’import",
        snapshotImportCreate: "Créer un nouvel Agent",
        snapshotImportOverwrite: "Écraser un Agent existant",
        snapshotTargetDeployment: "Agent cible",
        snapshotDryRun: "Dry-run sans appliquer",
        snapshotLaunchAfterImport: "Lancer après import",
        snapshotRedeployAfterImport: "Redéployer après import",
        snapshotAllowRegistryAutoCreate:
          "Autoriser l’auto-création des entrées registry",
        snapshotDryRunAction: "Tester l’import",
        snapshotImportAction: "Importer le snapshot",
        snapshotImportResult: "Résultat d’import",
        snapshotImportDryRunSuccess: "Dry-run terminé.",
        snapshotImportSuccess: "Snapshot importé.",
        snapshotImportError: "Impossible d’importer le snapshot.",
        mailCatcherTitle: "Routes email",
        mailCatcherDescription:
          "Associez des adresses inbound à des recettes pour déclencher automatiquement des workflows par email.",
        mailCatcherSummaryValue: "Email inbound",
        mailCatcherDisabledBadge: "Non disponible",
        mailCatcherDisabledTitle: "Email inbound désactivé",
        mailCatcherDisabledDescription:
          "Mail Catcher dépend d’EmailConnect et restera désactivé tant que le service payant, les quotas, la sécurité webhook et le dispatch vers les VMs ne sont pas prêts en production.",
        openMailCatcherPage: "Ouvrir Mail Catcher",
        mailCatcherAddRoute: "Ajouter une route",
        mailCatcherRoutesCount: "Routes",
        mailCatcherEnabledCount: "Actives",
        mailCatcherDomain: "Domaine inbound",
        mailCatcherNoRoutes: "Aucune route email",
        mailCatcherNoRoutesDescription:
          "Créez une route pour générer une adresse email unique liée à une recette.",
        mailCatcherEmailAddress: "Adresse email",
        mailCatcherRecipe: "Recette",
        mailCatcherCreatedAt: "Créée",
        mailCatcherCreateRoute: "Créer une route email",
        mailCatcherEditRoute: "Modifier la route email",
        mailCatcherDialogDescription:
          "Sélectionnez la recette déclenchée par cette adresse inbound.",
        mailCatcherRecipePlaceholder: "Choisir une recette",
        mailCatcherEnabled: "Route active",
        mailCatcherDeleteRoute: "Supprimer la route email",
        mailCatcherDeleteRouteDescription:
          "Cette adresse inbound ne déclenchera plus la recette associée.",
        mailCatcherRecipeRequired: "La recette est requise.",
        mailCatcherEmailCopied: "Adresse email copiée.",
        mailCatcherEmailCopyError: "Impossible de copier l’adresse email.",
        mailCatcherCreateSuccess: "Route email créée.",
        mailCatcherCreateError: "Impossible de créer la route email.",
        mailCatcherUpdateSuccess: "Route email mise à jour.",
        mailCatcherUpdateError: "Impossible de mettre à jour la route email.",
        mailCatcherDeleteSuccess: "Route email supprimée.",
        mailCatcherDeleteError: "Impossible de supprimer la route email.",
        spacesTitle: "Espaces collaboratifs",
        spacesDescription:
          "Gérez les espaces rattachés à l’Agent, leurs sessions et leur usage collaboratif.",
        spacesSummaryValue: "Workspaces",
        openSpacesPage: "Ouvrir Espaces",
        spacesCreate: "Créer un espace",
        spacesCount: "Espaces",
        spacesMembersCount: "Membres",
        spacesSessionsCount: "Sessions",
        spacesNoSpaces: "Aucun espace",
        spacesNoSpacesDescription:
          "Créez un espace pour organiser les sessions et collaborations de l’Agent.",
        spacesMembersLabel: "membre(s)",
        spacesSessionsLabel: "session(s)",
        spacesCreatedAt: "Créé",
        spacesCreateTitle: "Créer un espace",
        spacesCreateDescription:
          "L’espace sera rattaché à l’Agent courant.",
        spacesName: "Nom",
        spacesDescriptionLabel: "Description",
        spacesDeleteTitle: "Supprimer l’espace",
        spacesDeleteDescription:
          "L’espace {{name}} et ses sessions associées seront supprimés.",
        spacesCreateSuccess: "Espace créé.",
        spacesCreateError: "Impossible de créer l’espace.",
        spacesDeleteSuccess: "Espace supprimé.",
        spacesDeleteError: "Impossible de supprimer l’espace.",
        deploySummaryMessagingDescription:
          "Comptes Slack, Telegram, WhatsApp, Discord, Google Chat et Signal liés au gateway messaging.",
        openMessagingPage: "Ouvrir Messagerie",
        deployRuntimeMessagingTitle: "Comptes messaging",
        deployRuntimeMessagingDescription:
          "Connectez des canaux externes à l’Agent et associez-les à une clé d’API dédiée.",
        deployRuntimeMessagingAddAccount: "Ajouter un compte",
        deployRuntimeMessagingAccountsCount: "Comptes",
        deployRuntimeMessagingApiKeysAvailable: "Clés API disponibles",
        deployRuntimeMessagingWebhookChannels: "Canaux webhook",
        deployRuntimeMessagingNoAccounts: "Aucun compte messaging",
        deployRuntimeMessagingNoAccountsDescription:
          "Ajoutez au moins un canal si cet Agent doit recevoir ou émettre des messages métier.",
        deployRuntimeMessagingCopyWebhook: "Copier le webhook",
        deployRuntimeMessagingWebhookCopied: "Webhook copié.",
        deployRuntimeMessagingWebhookCopyError:
          "Impossible de copier le webhook.",
        deployRuntimeMessagingEditAccount: "Modifier le compte",
        deployRuntimeMessagingCreateAccount: "Créer un compte",
        deployRuntimeMessagingDialogDescription:
          "Configurez le canal, le compte et les secrets nécessaires pour ce transport.",
        deployRuntimeMessagingChannel: "Canal",
        deployRuntimeMessagingSelectChannel: "Choisir un canal",
        deployRuntimeMessagingStatus: "Statut",
        deployRuntimeMessagingStatusActive: "Actif",
        deployRuntimeMessagingStatusDisabled: "Désactivé",
        deployRuntimeMessagingStatusInvalid: "Invalide",
        deployRuntimeMessagingAccountId: "Identifiant de compte",
        deployRuntimeMessagingDisplayName: "Nom affiché",
        deployRuntimeMessagingDisplayNamePlaceholder: "Bot principal",
        deployRuntimeMessagingExternalId: "Identifiant externe",
        deployRuntimeMessagingExternalIdPlaceholder: "Optionnel",
        deployRuntimeMessagingApiKeyLabel: "Clé API",
        deployRuntimeMessagingApiKeyPlaceholder: "Sélectionner une clé API",
        deployRuntimeMessagingApiKeyPlaceholderEdit:
          "Laisser vide pour conserver la clé actuelle",
        deployRuntimeMessagingApiKeyHelperEdit:
          "Ne sélectionnez une nouvelle clé API que si vous souhaitez remplacer celle déjà liée.",
        deployRuntimeMessagingNoExpiration: "Sans expiration",
        deployRuntimeMessagingConfigSection: "Configuration du canal",
        deployRuntimeMessagingSecretInfo:
          "Les secrets existants ne sont jamais préremplis.",
        deployRuntimeMessagingSecretPlaceholder:
          "Laisser vide pour conserver la valeur actuelle",
        deployRuntimeMessagingSecretHelperEdit:
          "Laissez vide pour conserver le secret déjà stocké.",
        deployRuntimeMessagingDeleteAccount: "Supprimer le compte",
        deployRuntimeMessagingDeleteAccountDescription:
          "Le compte {{name}} sera supprimé du gateway messaging.",
        deployRuntimeMessagingChannelRequired: "Le canal est requis.",
        deployRuntimeMessagingAccountIdRequired:
          "L’identifiant du compte est requis.",
        deployRuntimeMessagingFieldRequired: "Le champ {{field}} est requis.",
        deployRuntimeMessagingApiKeyRequired:
          "Une clé API est requise pour créer un compte messaging.",
        deployRuntimeMessagingCreateSuccess: "Compte messaging créé.",
        deployRuntimeMessagingCreateError:
          "Impossible de créer le compte messaging.",
        deployRuntimeMessagingUpdateSuccess: "Compte messaging mis à jour.",
        deployRuntimeMessagingUpdateError:
          "Impossible de mettre à jour le compte messaging.",
        deployRuntimeMessagingDeleteSuccess: "Compte messaging supprimé.",
        deployRuntimeMessagingDeleteError:
          "Impossible de supprimer le compte messaging.",
        deployRuntimeMessagingConnectionWebhook: "Webhook",
        deployRuntimeMessagingConnectionPolling: "Polling",
        deployRuntimeMessagingConnectionWebsocket: "WebSocket",
        deployRuntimeMessagingConfigKeys: "Clés de configuration",
        deployRuntimeMessagingChannelTelegram: "Telegram",
        deployRuntimeMessagingChannelSlack: "Slack",
        deployRuntimeMessagingChannelWhatsapp: "WhatsApp",
        deployRuntimeMessagingChannelDiscord: "Discord",
        deployRuntimeMessagingChannelGooglechat: "Google Chat",
        deployRuntimeMessagingChannelSignal: "Signal",
        deployRuntimeMessagingChannelUnknown: "Canal inconnu",
        deployRuntimeMessagingFieldBotToken: "Bot token",
        deployRuntimeMessagingFieldPollInterval: "Intervalle de poll (s)",
        deployRuntimeMessagingFieldAllowedUpdates: "Allowed updates",
        deployRuntimeMessagingFieldSigningSecret: "Signing secret",
        deployRuntimeMessagingFieldBotUserId: "Bot user ID",
        deployRuntimeMessagingFieldAccessToken: "Access token",
        deployRuntimeMessagingFieldPhoneNumberId: "Phone number ID",
        deployRuntimeMessagingFieldAppSecret: "App secret",
        deployRuntimeMessagingFieldVerifyToken: "Verify token",
        deployRuntimeMessagingFieldApiBaseUrl: "API base URL",
        deployRuntimeMessagingFieldApiVersion: "API version",
        deployRuntimeMessagingFieldIntents: "Intents",
        deployRuntimeMessagingFieldVerificationToken: "Verification token",
        deployRuntimeMessagingFieldBaseUrl: "Base URL",
        deployRuntimeMessagingFieldNumber: "Numéro",
        deployRuntimeMqttCardDescription:
          "Expose un pont MQTT pour recevoir ou publier des événements temps réel, utile pour IoT, supervision, automations terrain et systèmes qui parlent déjà MQTT.",
        deployRuntimeExternalInceptionCardDescription:
          "Branche l’Agent sur une instance Inception externe afin de piloter des opérations expertes, d’inspecter le runtime et de déléguer des actions d’administration contrôlées.",
        deployRuntimeShellCardDescription:
          "Expose les capacités shell pour les flows locaux et les outils experts.",
        deployRuntimeInternalSaved: "Configuration interne enregistrée.",
        deployRuntimeInternalSaveError:
          "Impossible d’enregistrer la configuration interne.",
        deployRuntimeS3DialogDescription:
          "Renseignez la connexion S3 utilisée comme stockage par cet Agent.",
        deployRuntimeS3Endpoint: "Endpoint",
        deployRuntimeS3Region: "Région",
        deployRuntimeS3Bucket: "Bucket",
        deployRuntimeS3AccessKey: "Access key",
        deployRuntimeS3SecretKey: "Secret key",
        deployRuntimeS3Cdn: "URL CDN publique",
        deployRuntimeS3UseSsl: "Utiliser SSL",
        deployRuntimeS3Required: "L’endpoint et l’access key S3 sont requis.",
        deployRuntimeS3Created: "Configuration S3 créée.",
        deployRuntimeS3CreateError: "Impossible de créer la configuration S3.",
        deployRuntimeS3Updated: "Configuration S3 mise à jour.",
        deployRuntimeS3UpdateError:
          "Impossible de mettre à jour la configuration S3.",
        deployRuntimeS3Deleted: "Configuration S3 supprimée.",
        deployRuntimeS3DeleteError:
          "Impossible de supprimer la configuration S3.",
        deployRuntimeMultimodalSaved: "Configuration multimodale enregistrée.",
        deployRuntimeMultimodalSaveError:
          "Impossible d’enregistrer la configuration multimodale.",
        deployRuntimeMultimodalDeleted: "Configuration multimodale supprimée.",
        deployRuntimeMultimodalDeleteError:
          "Impossible de supprimer la configuration multimodale.",
        deployRuntimeMultimodalDefaultsSaved:
          "Multimodal AgentMaurice activé.",
        deployRuntimeMultimodalDefaultsError:
          "Impossible d’activer le multimodal AgentMaurice.",
        deployRuntimeConfigureMultimodal: "Configurer le multimodal",
        deployRuntimeMultimodalDialogDescription:
          "Activez le mode AgentMaurice géré ou configurez une clé personnelle.",
        deployRuntimeMultimodalManagedMode: "AgentMaurice géré",
        deployRuntimeMultimodalByokMode: "Clé personnelle",
        deployRuntimeMultimodalManagedTitle: "Multimodal AgentMaurice",
        deployRuntimeMultimodalManagedDescription:
          "Active les capacités vision, document, audio et vidéo sans clé personnelle. La consommation est facturée en crédits AgentMaurice.",
        deployRuntimeMultimodalManagedCapabilities:
          "Vision, documents, transcription audio et vidéo",
        deployRuntimeMultimodalManagedActivate: "Activer le multimodal",
        deployRuntimeMultimodalManagedActivating: "Activation…",
        deployRuntimeMultimodalHostedBadge: "AgentMaurice géré",
        deployRuntimeMultimodalByokBadge: "Clé personnelle",
        deployRuntimeMultimodalBaseUrlInvalid:
          "L’URL de base doit être une URL http(s) valide.",
        deployRuntimeMultimodalExistingConfigs: "Configurations existantes",
        deployRuntimeMultimodalAddConfig: "Ajouter une configuration",
        deployRuntimeMultimodalEditConfig: "Modifier la configuration",
        deployRuntimeMultimodalFormDescription:
          "Définissez une capacité, un provider et un modèle pour ce profil.",
        deployRuntimeMultimodalCapability: "Capacité",
        deployRuntimeMultimodalProfile: "Profil",
        deployRuntimeMultimodalProvider: "Provider",
        deployRuntimeMultimodalModel: "Modèle",
        deployRuntimeMultimodalSelectModel: "Sélectionner un modèle",
        deployRuntimeMultimodalNoCompatibleModels:
          "Aucun modèle compatible trouvé pour ce provider.",
        deployRuntimeMultimodalBaseUrl: "URL de base",
        deployRuntimeMultimodalApiKey: "Clé API",
        deployRuntimeMultimodalApiKeyOptional:
          "Laisser vide pour conserver la clé existante",
        deployRuntimeMultimodalOrgProvider: "Provider LLM organisation",
        deployRuntimeMultimodalSelectOrgProvider: "Sélectionner un provider",
        deployRuntimeMultimodalNoOrgProviders:
          "Aucun provider organisation compatible avec credential. Déclarez-en un dans Build → LLM.",
        deployRuntimeMultimodalOrgProviderRequired:
          "Un provider LLM organisation est requis pour le multimodal BYOK.",
        deployRuntimeMultimodalModelRequired:
          "Le modèle multimodal est requis.",
        deployRuntimeMultimodalNoConfigs:
          "Aucune configuration multimodale enregistrée.",
        deployRuntimeMultimodalDeleteConfig:
          "Supprimer la configuration multimodale",
        deployRuntimeMultimodalDeleteDescription:
          "La configuration {{capability}} / {{profile}} sera supprimée.",
        deployRuntimeMcpManualDescription:
          "Liste les serveurs MCP ajoutés manuellement pour cet Agent.",
        deployRuntimeMcpSidecarsDescription:
          "Affiche les sidecars et assets du registry actuellement rattachés à cet Agent.",
        deployRuntimeSidecarRunning: "Conteneur actif",
        deployRuntimeNoMcpServers: "Aucun serveur MCP manuel configuré.",
        deployRuntimeNoSidecars: "Aucun sidecar ou asset registry détecté.",
        deployRuntimeMcpServerCreated: "Serveur MCP créé.",
        deployRuntimeMcpServerCreateError:
          "Impossible de créer le serveur MCP.",
        deployRuntimeMcpServerUpdated: "Serveur MCP mis à jour.",
        deployRuntimeMcpServerUpdateError:
          "Impossible de mettre à jour le serveur MCP.",
        deployRuntimeMcpServerDeleted: "Serveur MCP supprimé.",
        deployRuntimeMcpServerDeleteError:
          "Impossible de supprimer le serveur MCP.",
        deployRuntimeAddStdio: "Ajouter STDIO",
        deployRuntimeAddSse: "Ajouter SSE",
        deployRuntimeCreateStdio: "Créer un serveur STDIO",
        deployRuntimeEditStdio: "Modifier le serveur STDIO",
        deployRuntimeCreateSse: "Créer un serveur SSE",
        deployRuntimeEditSse: "Modifier le serveur SSE",
        deployRuntimeStdioDialogDescription:
          "Configurez la commande locale, ses arguments et ses variables d’environnement.",
        deployRuntimeSseDialogDescription:
          "Configurez l’endpoint distant et les headers HTTP utilisés par ce serveur SSE.",
        deployRuntimeMcpName: "Nom du serveur",
        deployRuntimeMcpCommand: "Commande",
        deployRuntimeMcpUrl: "URL du serveur",
        deployRuntimeMcpArguments: "Arguments",
        deployRuntimeMcpEnv: "Variables d’environnement",
        deployRuntimeMcpHeaders: "Headers HTTP",
        deployRuntimeMcpAddArgument: "Ajouter un argument",
        deployRuntimeMcpAddEnv: "Ajouter une variable",
        deployRuntimeMcpAddHeader: "Ajouter un header",
        deployRuntimeMcpCommandPreview: "Prévisualisation de la commande",
        deployRuntimeMcpRemotePreview:
          "Prévisualisation de la connexion distante",
        deployRuntimeMcpNameRequired: "Le nom du serveur MCP est requis.",
        deployRuntimeMcpCommandRequired: "La commande STDIO est requise.",
        deployRuntimeMcpUrlRequired: "L’URL du serveur SSE est requise.",
        deployRuntimeMcpInvalidUrl: "L’URL du serveur SSE est invalide.",
        deployRuntimeMcpArgumentsCount: "{{count}} argument(s)",
        deployRuntimeMcpEnvCount: "{{count}} variable(s) d’environnement",
        deployRuntimeMcpHeadersCount: "{{count}} header(s)",
        deployRuntimeDeleteMcpServer: "Supprimer le serveur MCP",
        deployRuntimeDeleteMcpServerDescription:
          "Le serveur {{name}} sera retiré de l’Agent.",
        deployRuntimeMcpOAuthConnect: "Connecter OAuth",
        deployRuntimeMcpOAuthDisconnect: "Déconnecter OAuth",
        deployRuntimeMcpOAuthConnected: "Connecté",
        deployRuntimeMcpOAuthDisconnected: "OAuth déconnecté.",
        deployRuntimeMcpOAuthExpired: "Expiré",
        deployRuntimeMcpOAuthNotConnected: "Non connecté",
        deployRuntimeMcpOAuthStartError:
          "Impossible de démarrer le flux OAuth.",
        deployRuntimeMcpOAuthDisconnectError:
          "Impossible de déconnecter OAuth.",
        deployRuntimeMcpRunDoctor: "Lancer le doctor",
        deployRuntimeMcpDoctorTitle: "Diagnostic SSE",
        deployRuntimeMcpDoctorDescription: "Résultat du doctor pour {{name}}.",
        deployRuntimeMcpDoctorDetails: "Détails du diagnostic",
        deployRuntimeMcpDoctorEmpty: "Aucun résultat de diagnostic disponible.",
        deployRuntimeMcpDoctorError: "Impossible d’exécuter le diagnostic SSE.",
        deployRuntimeVariablesPanelDescription:
          "Gérez les variables et secrets injectés automatiquement pendant l’exécution des recettes.",
        deployRuntimeVariablesCount: "Variables",
        deployRuntimeVariableSecretCount: "Secrets",
        deployRuntimeVariableScopedCount: "Scopées",
        deployRuntimeVariableSharedCount: "Globales",
        deployRuntimeVariablesList: "Variables de l’Agent",
        deployRuntimeVariablesListDescription:
          "Ajoutez ici les clés API, identifiants et constantes nécessaires à cet Agent.",
        deployRuntimeAddVariable: "Ajouter une variable",
        deployRuntimeNoVariables: "Aucune variable configurée.",
        deployRuntimeNoVariablesDescription:
          "Les variables permettent de stocker des secrets et constantes injectés automatiquement dans les recettes.",
        deployRuntimeCreateVariable: "Créer une variable",
        deployRuntimeEditVariable: "Modifier la variable",
        deployRuntimeDeleteVariable: "Supprimer la variable",
        deployRuntimeDeleteVariableDescription:
          "La variable {{name}} sera retirée de l’Agent. Cette action est immédiate.",
        deployRuntimeVariableDialogDescription:
          "Définissez le nom, la valeur et le scope de cette variable pour l’Agent.",
        deployRuntimeVariableName: "Nom",
        deployRuntimeVariableValue: "Valeur",
        deployRuntimeVariableValueOptional:
          "Laisser vide pour conserver la valeur existante",
        deployRuntimeVariableSecret: "Masquer la valeur comme secret",
        deployRuntimeVariableDescriptionLabel: "Description",
        deployRuntimeVariableRecipeScope: "Scope recettes",
        deployRuntimeVariableRecipeScopeDescription:
          "Laissez vide pour partager la variable avec toutes les recettes, ou sélectionnez seulement celles qui en ont besoin.",
        deployRuntimeVariableAvailableRecipes: "Recettes disponibles",
        deployRuntimeVariableRecipeScopeAll: "Toutes les recettes",
        deployRuntimeVariableRecipeScopeEmpty:
          "Aucune recette déployée pour le moment. La variable restera partagée à l’échelle de l’Agent.",
        deployRuntimeVariableRecipeScopePlaceholder:
          "recipe_a, recipe_b, recipe_c",
        deployRuntimeVariableNameRequired: "Le nom de la variable est requis.",
        deployRuntimeVariableValueRequired:
          "La valeur de la variable est requise.",
        deployRuntimeVariableCreated: "Variable créée.",
        deployRuntimeVariableCreateError: "Impossible de créer la variable.",
        deployRuntimeVariableUpdated: "Variable mise à jour.",
        deployRuntimeVariableUpdateError:
          "Impossible de mettre à jour la variable.",
        deployRuntimeVariableDeleted: "Variable supprimée.",
        deployRuntimeVariableDeleteError:
          "Impossible de supprimer la variable.",
        deployRuntimeVariableAllRecipes: "Toutes les recettes",
        deployRuntimeVariableAllRecipesDescription:
          "Disponible pour toutes les recettes de cet Agent.",
        deployRuntimeVariableScopedRecipes: "Scope limité",
        deployRuntimeVariableShow: "Afficher",
        deployRuntimeVariableHide: "Masquer",
        deployRuntimeVariableSecretBadge: "Secret",
        deployRuntimeVariableDescription:
          "Expliquez brièvement à quoi sert cette variable.",
        deployRuntimeVariablesUsageTitle: "Bonnes pratiques",
        deployRuntimeVariablesUsage1:
          "Réservez les secrets aux valeurs sensibles comme les clés API et mots de passe.",
        deployRuntimeVariablesUsage2:
          "Utilisez le scope recettes pour limiter les variables à certains workflows.",
        deployRuntimeVariablesUsage3:
          "Préférez des noms explicites et stables pour faciliter la maintenance.",
        deployRuntimeVariablesInjectedDescription:
          "Ces variables seront injectées automatiquement dans les exécutions de l’Agent.",
        deployRuntimeVariablesSummary: "{{count}} variable(s) configurée(s)",
        deployRuntimeAccessSummary:
          "{{keys}} clé(s) · {{accounts}} compte(s) messaging",
        deployRuntimeVariablesDescription:
          "Les variables et secrets de l’Agent apparaîtront ici pour piloter les providers LLM, MCP et sidecars.",
        deployRuntimeVariablesPlaceholder:
          "Le socle API est prêt. L’éditeur de variables sera branché dans la prochaine passe UI.",
        deployRuntimeVariablesPending: "Éditeur à brancher",
        deployRuntimeNextStep: "État courant",
        deployRuntimeCurrentState: "État courant",
        deployRuntimeNextStepDescription:
          "Ce panneau met en avant les actions les plus utiles pour rendre ce runtime réellement exploitable.",
        deployRuntimeLlmNextStep1:
          "Gérer les profils LLM organisationnels et les providers associés.",
        deployRuntimeLlmNextStep2:
          "Brancher ensuite les embedding providers et le proxy réseau.",
        deployRuntimeLlmNextStep3:
          "Conserver Candle et les options expertes dans un panneau avancé.",
        deployRuntimeMcpNextStep1:
          "Ajouter les listes STDIO/SSE, les formulaires et les cartes serveur.",
        deployRuntimeMcpNextStep2:
          "Brancher OAuth connect/disconnect et le doctor SSE.",
        deployRuntimeMcpNextStep3:
          "Séparer ensuite registry sidecars et serveurs manuels dans l’interface Build.",
        deployRuntimeInternalNextStep1:
          "Afficher les cartes toggle storage, docstore, company memory et multimodal.",
        deployRuntimeInternalNextStep2:
          "Brancher les dialogs S3 et multimodal quand ces cartes sont activées.",
        deployRuntimeInternalNextStep3:
          "Garder shell et inception dans un mode expert sécurisé.",
        deployRuntimeSkillsNextStep1:
          "Attacher uniquement les skills utiles à l’Agent courant.",
        deployRuntimeSkillsNextStep2:
          "Vérifier les skills qui demandent encore une configuration avant apply.",
        deployRuntimeSkillsNextStep3:
          "Garder un catalogue ciblé pour éviter de surcharger les builders et Calisto.",
        deployRuntimeAccessNextStep1:
          "Créer des clés dédiées par intégration au lieu de partager une clé unique.",
        deployRuntimeAccessNextStep2:
          "Ajouter les comptes messaging avant de brancher des webhooks ou bots externes.",
        deployRuntimeAccessNextStep3:
          "Valider l’auth connector avant d’exporter le gateway Next.js.",
        deployRuntimeVariablesNextStep1:
          "Porter la gestion des variables de l’Agent depuis le dashboard.",
        deployRuntimeVariablesNextStep2:
          "Relier ensuite ces variables aux providers LLM et MCP.",
        deployRuntimeVariablesNextStep3:
          "Prévoir une séparation claire entre variables ordinaires et secrets.",
        pipelineDescription:
          "Gérez le plan, les tests et la promotion pour l’Agent sélectionné.",
        deployRecipeCoverageDescription:
          "{{synced}} synchronisée(s), {{pending}} encore à préparer ou relire.",
        deployRecipeListDescription:
          "Choisissez la meta-recette à pousser, puis utilisez cette page pour valider, tester et appliquer.",
        deployPrimaryValidateDescription:
          "Corrigez d’abord la spec locale pour repartir sur une base valide avant plan ou apply.",
        deployPrimaryPlanDescription:
          "Préparez un plan exécutable pour voir clairement ce qui sera appliqué sur l’Agent cible.",
        deployPrimaryTestDescription:
          "Lancez les tests maintenant pour vérifier que la recette reste cohérente avant publish.",
        deployPrimaryPublishDescription:
          "Le plan et les tests sont prêts. Vous pouvez maintenant appliquer les changements sur l’Agent.",
        deployPrimaryObserveDescription:
          "Les derniers runs sont disponibles. Ouvrez Observe pour vérifier le détail de l’exécution.",
        selectOrgDeploymentToPublish:
          "Sélectionnez une organisation et un Agent pour gérer la publication.",
        readyToTest: "Prêt à tester {{name}}.",
        readyToPromote: "Prêt à promouvoir {{name}}.",
        currentStage: "Étape actuelle",
        nextTarget: "Cible suivante",
        readiness: "État de préparation",
        health: "Santé",
        environmentLabel: "Environnement : {{environment}}",
        alreadyHighestStage: "Déjà au plus haut niveau de promotion déclaré.",
        inferredNextStage:
          "Cible de promotion suivante déduite de l’Agent sélectionné.",
        activeExecutionsLabel: "Exécutions actives : {{count}}",
        metaRecettesTitle: "Meta recettes",
        loadingRecipes: "Chargement des recettes…",
        noMetaRecetteForDeployment:
          "Aucune meta recette liée à cet Agent pour le moment.",
        targetLabel: "Cible : {{target}}",
        targetDeploymentLabel: "Agent cible",
        deploymentTarget: "Agent cible : {{target}}",
        publicationStages: "Étapes de publication",
        validate: "Valider",
        planning: "Planification…",
        plan: "Plan",
        testing: "Test…",
        dryRun: "Dry-run",
        validation: "Validation",
        latestTest: "Dernier test",
        lastApply: "Dernier apply",
        issuesCount: "{{count}} problème(s)",
        noIssue: "Aucun problème",
        notRun: "Jamais lancé",
        neverApplied: "Jamais appliqué",
        planAndDiff: "Plan et diff",
        inspectChangesBeforePromotion:
          "Générez un plan pour inspecter les changements exploitables avant promotion.",
        planId: "ID du plan : {{value}}",
        planHash: "Hash du plan : {{value}}",
        generatedAt: "Généré : {{value}}",
        signals: "Signaux",
        signalsDescription: "Sorties de validation, test et reconcile",
        reconciling: "Réconciliation…",
        reconcile: "Réconcilier",
        validationIssues: "Problèmes de validation",
        noLocalValidationIssue: "Aucun problème de validation locale détecté.",
        latestTestExecution: "Dernière exécution de test",
        statusLabel: "Statut : {{status}}",
        testRunLabel: "Test run : {{id}}",
        executionIdsLabel: "IDs d’exécution : {{ids}}",
        inspectInSidePanel: "Inspecter dans le panneau latéral",
        openFullObserve: "Ouvrir Observe complet",
        lastDryRun: "Dernier dry-run",
        lastPromotion: "Dernière promotion",
        syncStatusLabel: "Statut de synchro : {{status}}",
        inspectApplyInSidePanel: "Inspecter l’apply dans le panneau latéral",
        inspectTestInSidePanel: "Inspecter le test dans le panneau latéral",
        reconcilePayload: "Payload de reconcile",
        observeFocused: "Focus",
        selectMetaRecette:
          "Sélectionnez une meta recette pour voir les détails de publication.",
        deploymentHealthTitle: "Santé de l’Agent",
        readyToPromoteLabel: "Prêt à promouvoir",
        readyToPromoteDescription:
          "Le plan, les tests et la santé de l’Agent sont alignés.",
        partiallyReady: "Partiellement prêt",
        partiallyReadyDescription:
          "Un ou plusieurs signaux manquent encore avant la promotion.",
        notPrepared: "Non préparé",
        notPreparedDescription:
          "Générez un plan et lancez les tests avant de promouvoir.",
        needsFixes: "Corrections requises",
        needsFixesDescription:
          "Résolvez les problèmes de validation avant la promotion.",
        stagePending: "En attente",
        stageDeploying: "Agent",
        stageActive: "Actif",
        stageError: "Erreur",
        removedNodesSection: "Nœuds supprimés",
        addedNodesSection: "Nœuds ajoutés",
        modifiedNodesSection: "Nœuds modifiés",
        removed: "Supprimé",
        added: "Ajouté",
        modified: "Modifié",
        configCount: "Config ({{count}})",
        noChangesDetectedShort: "Aucun changement détecté",
        openTasks: "Tâches ouvertes",
        timeline: "Chronologie",
        artifacts: "Artefacts",
        sourceGraph: "Graphe de sources",
        workspaceContextTitle: "Contexte workspace",
        workspaceContextDescription:
          "Mémoire de session et artefacts pour l’exécution courante.",
        degraded: "Dégradé",
        loadingContext: "Chargement du contexte…",
        activeBlueprint: "Blueprint actif",
        activeBlueprintDescription:
          "Vue lecture seule de la recette actuellement utilisée.",
        loadingRecipePreview: "Chargement de l’aperçu de recette…",
        recipeNotLinked:
          "Cette conversation n’est pas encore liée à une recette spécifique.",
        noOpenWorkspaceTask:
          "Aucune tâche workspace ouverte n’est visible pour cette session.",
        noTimelineEvent:
          "Aucun événement de chronologie disponible pour le moment.",
        noWorkspaceArtifact:
          "Aucun artefact workspace n’est disponible pour le moment.",
        artifactPreview: "Aperçu d’artefact",
        artifactPreviewDescription:
          "Aperçu intégré d’un artefact workspace récent.",
        openFile: "Ouvrir le fichier",
        noInlinePreviewAvailable: "Aucun aperçu intégré disponible.",
        observeContextTitle: "Contexte Observe",
        observeContextDescription:
          "Exécution de blueprint ciblée, routée depuis Calisto.",
        clear: "Effacer",
        loadingFocusedContext: "Chargement du contexte ciblé…",
        openBlueprintAction: "Ouvrir le blueprint",
        publishAction: "Publier",
        runAction: "Exécuter",
        calistoAction: "Calisto",
        applyRun: "Apply run",
        testRun: "Test run",
        started: "Démarré : {{value}}",
        completed: "Terminé : {{value}}",
        recommendation: "Recommandation",
        inspectLinkedTest: "Inspecter le test lié",
        regressionDetected: "Régression détectée",
        regressionDescription:
          "Ce run contient une charge de régression dans la vue Observe détaillée.",
        metaRecettePanelAction: "Meta-recette",
        metaRecettePageDescription:
          "La meta-recette formalise les spécifications de l’Agent et sert de point de dialogue avec Calisto.",
        metaRecetteStatusTitle: "Statut",
        metaRecettePrimaryActionBadge: "Action principale",
        metaRecettePrimaryPlanLabel: "Préparer un plan",
        metaRecettePrimaryPlanDescription:
          "Générez un plan frais pour voir exactement ce qui doit changer avant l’apply.",
        metaRecettePrimaryAttentionLabel: "Relire les points critiques",
        metaRecettePrimaryAttentionDescription:
          "Le plan contient encore des changements qui demandent de l’attention avant apply.",
        metaRecettePrimaryReviewLabel: "Relire les changements",
        metaRecettePrimaryReviewDescription:
          "Le plan est exploitable, mais certains changements méritent une validation rapide.",
        metaRecettePrimaryApplyLabel: "Ouvrir Calisto pour appliquer",
        metaRecettePrimaryApplyDescription:
          "Le plan semble prêt. Ouvrez Calisto pour lancer la convergence ou guider l’apply.",
        metaRecettePrimaryObserveLabel: "Vérifier les derniers runs",
        metaRecettePrimaryObserveDescription:
          "L’Agent est synchronisé. Ouvrez Observe pour vérifier les derniers apply et tests.",
        metaRecetteSecondaryActions: "Accès rapides",
        metaRecetteNextStep: "Prochaine étape recommandée",
        metaRecetteExecutionTitle: "Exécution",
        metaRecetteArtifactsTitle: "Artefacts",
        metaRecettePipelineTitle: "Workflow de build",
        metaRecettePipelineDescription:
          "Suivez la progression de la spec jusqu’au dernier apply et aux tests les plus récents.",
        metaRecetteDriftTitle: "Snapshot de drift",
        metaRecetteDriftDescription:
          "Visualisez l’impact attendu des changements entre la spec courante et l’Agent cible.",
        metaRecetteDriftLoading: "Préparation du snapshot de drift…",
        metaRecetteNoDriftDescription:
          "L’Agent semble aligné avec la spec active. Aucun drift exploitable n’a été détecté.",
        metaRecetteDriftNeedsPlanDescription:
          "La spec n’est pas encore alignée. Préparez un plan pour inspecter les changements exacts à appliquer.",
        metaRecetteActionsToApply: "Actions à appliquer",
        metaRecetteWarningsDetected:
          "Des avertissements ont été détectés dans le plan.",
        metaRecetteDiscoveryTitle: "Discovery",
        metaRecetteDiscoveryFresh: "Discovery fraîche",
        metaRecetteDiscoveryStale: "Discovery ancienne",
        metaRecetteDiscoveryTargetOk: "Cible validée",
        metaRecetteDiscoveryTargetMismatch: "Cible à vérifier",
        metaRecetteDriftRecommendationFallback:
          "Préparez un plan pour confirmer précisément les changements à appliquer.",
        metaRecetteTopChangesTitle: "Changements principaux",
        metaRecetteTopChangesDescription:
          "Résumé des premières actions proposées par le plan.",
        metaRecetteChecklistTitle: "Checklist d’apply",
        metaRecetteChecklistDescription:
          "Priorisez les changements à appliquer, à relire ou à traiter avant l’apply.",
        metaRecetteChecklistReadyTitle: "Prêt à appliquer",
        metaRecetteChecklistReadyDescription:
          "Changements à faible risque, directement exploitables dans le plan courant.",
        metaRecetteChecklistReviewTitle: "À relire",
        metaRecetteChecklistReviewDescription:
          "Changements valides mais qui méritent une vérification rapide avant apply.",
        metaRecetteChecklistAttentionTitle: "Attention",
        metaRecetteChecklistAttentionDescription:
          "Changements potentiellement bloquants, support incomplet ou impact élevé.",
        metaRecetteChecklistReadinessTitle: "Lecture d’apply",
        metaRecetteChecklistReadyReadiness:
          "Le plan semble prêt à être appliqué. Les changements identifiés sont principalement à faible risque.",
        metaRecetteChecklistReviewReadiness:
          "Le plan est exploitable, mais certains changements méritent une relecture avant apply.",
        metaRecetteChecklistAttentionReadiness:
          "Des changements demandent encore de l’attention avant apply.",
        metaRecetteChecklistReadyBadge: "Prêt",
        metaRecetteChecklistReviewBadge: "Revue",
        metaRecetteChecklistAttentionBadge: "Attention",
        metaRecetteChecklistUnsupported: "Non supporté",
        metaRecetteChecklistHumanReview: "Revue humaine",
        metaRecetteChecklistFilterAll: "Tous",
        metaRecetteChecklistEmptyFilter:
          "Aucun changement ne correspond à ce filtre pour le moment.",
        metaRecetteChecklistMoreCount:
          "{{count}} changement(s) supplémentaire(s) existent dans le plan complet.",
        metaRecetteImpactedSectionsTitle: "Sections impactées",
        metaRecetteImpactedSectionsDescription:
          "Navigation rapide vers les sections du markdown probablement concernées par le plan.",
        metaRecetteQuickNavTitle: "Navigation rapide",
        metaRecetteQuickNavDescription:
          "Passez rapidement entre les grandes sections de la spec et les zones impactées.",
        metaRecetteImpactedBadge: "Impacté",
        metaRecetteInspectChange: "Inspecter",
        metaRecetteOpenInSpecs: "Voir dans la spec",
        metaRecetteFieldColumn: "Champ",
        metaRecetteBeforeColumn: "Avant",
        metaRecetteAfterColumn: "Après",
        metaRecetteContextColumn: "Contexte",
        metaRecetteChangeSummaryFallback:
          "Aucun résumé détaillé n’est encore disponible pour ce changement.",
        metaRecetteNoChangeDetails:
          "Le plan ne contient pas encore de détails suffisants pour résumer les changements.",
        metaRecetteOpenObserve: "Ouvrir Observe",
        metaRecetteAdvancedTitle: "Outils experts",
        metaRecetteAdvancedDescription:
          "Outils de diagnostic et actions avancées à utiliser quand le flux principal ne suffit pas.",
        metaRecetteExpertPlanDescription:
          "Régénère un plan détaillé et le diff associé sans appliquer de changement.",
        metaRecetteExpertReconcileDescription:
          "Force une réconciliation orientée validation pour comparer la spec et la cible.",
        metaRecetteExpertDryRunDescription:
          "Simule l’apply sans déployer, pour inspecter le résultat attendu.",
        metaRecetteExpertLatestOutputTitle: "Dernière sortie experte",
        metaRecetteExpertLatestOutputDescription:
          "Afficher la sortie brute produite par {{label}}.",
        metaRecettePreferredView: "Vue recommandée",
        metaRecetteSpecUnavailable:
          "Cette vue n’est pas encore disponible pour cette meta-recette.",
        metaRecetteCanvasReady:
          "Le canvas est disponible pour visualiser la structure.",
        metaRecetteMarkdownReady:
          "Le markdown est la meilleure vue disponible pour éditer la spec.",
        metaRecetteStructuredFallback:
          "Le JSON structuré reste disponible tant que la vue canvas n’est pas exploitable.",
        metaRecetteNoPreparedPlan: "Aucun plan préparé pour le moment.",
        metaRecetteStageSync: "Synchro",
        metaRecetteContextTitle: "Contexte meta-recette",
        metaRecetteContextDescription:
          "Conversation Calisto, spec fonctionnelle et signaux de synchronisation autour de la meta-recette active.",
        metaRecetteOverviewTab: "Vue d’ensemble",
        metaRecetteSpecTab: "Specs",
        metaRecetteConversationTab: "Calisto",
        metaRecetteLoading: "Chargement de la meta-recette…",
        metaRecetteNoSelection: "Aucune meta-recette ciblée.",
        metaRecetteNoSelectionDescription:
          "Ouvrez ce panneau depuis Recipes, Deploy ou Observe pour charger la meta-recette courante.",
        metaRecetteOpenConversation: "Discuter avec Calisto",
        metaRecetteCanvasTab: "Canvas",
        metaRecetteMarkdownTab: "Markdown",
        metaRecetteStructuredTab: "Spec structurée",
        metaRecetteNoStructuredSpec:
          "Aucune spec structurée n’est disponible pour cette meta-recette.",
        metaRecetteNoMarkdownSpec:
          "Aucune description fonctionnelle markdown n’est disponible pour cette meta-recette.",
        metaRecetteCalistoSyncing:
          "Synchronisation du contexte Calisto avec la meta-recette active…",
        metaRecetteCalistoReady:
          "Calisto est prêt à discuter des changements, écarts et intentions autour de cette meta-recette.",
        metaRecetteCalistoTitle: "Calisto Meta-recette",
        metaRecetteCalistoDescription:
          "Discussion guidée autour de {{name}} et de sa spec actuelle.",
        metaRecetteCalistoContextDescription:
          "Discussion contextuelle avec Calisto autour des spécifications de l’Agent.",
        metaRecetteVariablesLabel: "Variables",
        metaRecetteLastSynced: "Dernière synchro : {{value}}",
        metaRecetteEdgesCount: "{{count}} liaison(s)",
        metaRecetteLoadError: "Impossible de charger la meta-recette.",
        metaRecettePlanError:
          "Impossible de générer le plan de la meta-recette.",
        metaRecetteReconcileError: "Impossible de réconcilier la meta-recette.",
        metaRecetteDryRunError:
          "Impossible d’exécuter le dry-run de la meta-recette.",
        metaRecetteMiniAppPreviewTitle: "Preview mini-app OpenUI",
        metaRecetteMiniAppPreviewDescription:
          "Ce panneau rend la mini-app réellement générée dans structured_spec à partir des recipes_definitions compilées par la meta-recette.",
        metaRecetteMiniAppPreviewRecipeLabel: "Mini-app générée",
        metaRecetteMiniAppPreviewRefresh: "Rafraîchir le rendu",
        metaRecetteMiniAppPreviewError:
          "Impossible de générer le preview mini-app de la meta-recette.",
        metaRecetteMiniAppPreviewRuntimeTitle: "Runtime généré",
        metaRecetteMiniAppPreviewFormatLabel: "Format UI",
        metaRecetteMiniAppPreviewViewLabel: "Vue",
        metaRecetteMiniAppPreviewStateLabel: "Version d’état",
        metaRecetteMiniAppPreviewActionsLabel: "Actions détectées",
        metaRecetteMiniAppPreviewFormsLabel: "Formulaires",
        metaRecetteMiniAppPreviewInteractionsTitle: "Interactions capturées",
        metaRecetteMiniAppPreviewInteractionsEmpty:
          "Clique dans la mini-app pour voir les événements et ouvertures de formulaires capturés localement.",
        metaRecetteMiniAppPreviewEmpty:
          "Aucune mini-app générée n’a encore pu être prévisualisée pour cette meta-recette.",
        metaRecetteMiniAppPreviewEventError:
          "Impossible d’exécuter cet événement de preview mini-app.",
      },
    },
  },
  en: {
    translation: {
      language: {
        label: "Language",
        fr: "French",
        en: "English",
        es: "Spanish",
      },
      theme: {
        label: "Theme",
        system: "System",
        light: "Light",
        dark: "Dark",
      },
      common: {
        loading: "Loading…",
        close: "Close",
        cancel: "Cancel",
        save: "Save",
        edit: "Edit",
        delete: "Delete",
        remove: "Remove",
        refresh: "Refresh",
        apply: "Apply",
        reject: "Reject",
        test: "Test",
        publish: "Publish",
        openFull: "Open full view",
        noDescription: "No description provided.",
        unknown: "Unknown",
        valid: "Valid",
        invalid: "Invalid",
        yes: "Yes",
        no: "No",
        search: "Search",
        select: "Select",
        preview: "Preview",
        show: "Show",
        hide: "Hide",
        open: "Open",
        download: "Download",
        context: "Context",
        focus: "Focus",
        full: "Full",
        connected: "Connected",
        connecting: "Connecting…",
        notifications: "Notifications",
        active: "active",
        error: "Error",
        copy: "Copy",
        run: "Run",
        studio: "Studio",
        build: "Configuration",
      },
      integrations: {
        badge: "Connectors",
        title: "Integrations",
        description:
          "Add useful connectors to the current agent, configure access and expose their tools to the AgentMaurice runtime.",
        usageTitle: "Integration credits",
        usageValue: "{{consumed}} / {{budget}} credits this month",
        addedTitle: "Added connectors",
        addedDescription:
          "Only connectors added to the current agent appear here.",
        addConnector: "Add connector",
        emptyTitle: "No connector added",
        emptyDescription:
          "Search the catalog to add a connector to the current agent.",
        connectSuccess: "Connector connected.",
        connectError: "Unable to connect.",
        addSuccess: "Connector added.",
        addError: "Unable to add connector.",
        removeSuccess: "Connector removed.",
        removeError: "Unable to remove connector.",
        disconnectSuccess: "Connector disconnected.",
        disconnectError: "Unable to disconnect.",
        settingsSuccess: "Configuration saved.",
        settingsError: "Unable to configure connector.",
        testSuccess: "Connector status: {{status}}.",
        testError: "Unable to test connector.",
        catalogError: "Unable to load connectors.",
        catalogHTTPError: "Console {{status}} on {{path}}: {{message}}",
        authMode: "Mode",
        configurationRequiredHelp:
          "Configure the connector before creating a user connection.",
        manualSupportHelp:
          "This connector requires support-assisted configuration.",
        editSettings: "Edit",
        configure: "Configure",
        reconnect: "Reconnect",
        connect: "Connect",
        test: "Test",
        tools: "Tools",
        disconnect: "Disconnect",
        remove: "Remove",
        maintainedPack: "Maintained pack",
        actionsAvailable: "Available actions",
        noActionsEnabled: "No action enabled",
        directoryTitle: "Add connector",
        directoryDescription:
          "The catalog is global, but adding a connector only enables it for the current agent.",
        searchPlaceholder: "Search Gmail, Slack, CRM…",
        allCategories: "All categories",
        allAuthModes: "All modes",
        directoryError: "Unable to load the catalog.",
        noDirectoryResults: "No connector matches this search.",
        toolPack: "Tool pack",
        noToolPack: "No pack",
        add: "Add",
        loadMoreConnectors: "Show more",
        toolsTitle: "Connector tools",
        toolsDescription: "Tools projected on the current agent for {{connector}}.",
        toolsError: "Unable to load connector tools.",
        noActionsHelp:
          "No tool is projected until the connector is configured and connected on this agent.",
        managedAction: "Available action",
        customTool: "Custom tool",
        editSettingsTitle: "Edit configuration",
        configureTitle: "Configure connector",
        configureDescription: "Secret values are never shown again.",
        connectionCredentialsHelp:
          "Credentials are entered when connecting the user account.",
        setupGuide: "Setup guide",
        callbackUrl: "Callback URL",
        disabled: "Disabled",
        manualSupport: "Support required",
        configurationRequired: "Configuration required",
        connected: "Connected",
        revoked: "Revoked",
        notConnected: "Not connected",
      },
      desktopUpdate: {
        availableTitle: "New version available",
        availableDescription: "JusteMaurice {{version}} can be installed.",
        genericVersion: "latest",
        installAction: "Update",
        installing: "Installing update…",
        installError: "Unable to install the update.",
      },
      auth: {
        checking: "Checking authentication…",
        required:
          "Authentication is required before loading organizations, agents and workspaces.",
        desktopModeEnabled:
          "Desktop mode is enabled. Sign-in is handled by the local application.",
        localModeEnabled:
          "Local development mode is enabled. Authentication is handled by `chatserver`.",
        localAccount: "Local account",
        localSignIn: "Local sign in",
        signIn: "Sign in",
        createAccount: "Create account",
        loadingApp: "Loading Agent OS…",
        accessModeLabel: "Access mode",
        accessModeHosted: "AgentMaurice LLM",
        accessModeHostedDescription:
          "Use models provided by AgentMaurice without entering a personal API key.",
        accessModeByok: "BYOK",
        accessModeByokDescription: "Connect your own providers after sign-in.",
        hostedIntro:
          "Sign in to use AgentMaurice models or configure your own providers.",
        byokIntro:
          "Sign in to connect your own providers and keep your keys under your control.",
        accessModeChooseIntro:
          "Sign in, then choose on the welcome screen between AgentMaurice models and your own keys.",
        registerIntro: "Create your account to access the application.",
        createAccountOnConsoleHint:
          "Account creation happens on console.agentmaurice.app.",
        confirmationEmailSent:
          "A confirmation email has been sent. Check your inbox.",
        signInError: "Sign-in error",
        oauthError: "OAuth error",
        noAccountYet: "No account yet?",
        alreadyHaveAccount: "Already have an account?",
      },
      enrollment: {
        title: "Complete your AgentMaurice profile",
        subtitle:
          "Complete your profile and create your first organization before entering AgentMaurice OS.",
        subtitleProfileOnly:
          "Complete your Console profile before entering AgentMaurice OS.",
        roleHint: "Your first role in this organization will be `orga-admin`.",
        roleHintProfileOnly:
          "This profile is saved in the Console and synchronized here automatically.",
        email: "Email",
        username: "Username",
        usernamePlaceholder: "mikaelmorvan",
        firstName: "First name",
        firstNamePlaceholder: "Your first name",
        lastName: "Last name",
        lastNamePlaceholder: "Your last name",
        language: "Preferred language",
        personalOrganization: "This is a personal organization",
        personalOrganizationHint:
          "Leave the name empty if you want to use your identity as the organization name.",
        organizationName: "Organization name",
        organizationNamePlaceholder: "AgentMaurice",
        organizationNamePersonalPlaceholder:
          "Optional for a personal organization",
        submit: "Save profile",
        error: "Could not save profile.",
        validation: {
          username: "Username is required.",
          firstName: "First name is required.",
          lastName: "Last name is required.",
          language: "Preferred language is required.",
          organizationName: "Organization name is required.",
        },
      },
      welcome: {
        badge: "Express setup",
        title: "Prepare AgentMaurice OS for a first useful run.",
        subtitle:
          "We restore the organization context, create the default agent when needed, then lock the LLM access path before opening chat and Build.",
        organizationTitle: "Organization",
        organizationReady: "Organization available",
        organizationPending: "Waiting for local bootstrap",
        deploymentTitle: "Agent",
        deploymentReady: "Default agent ready",
        deploymentPending: "Agent still needs bootstrap",
        providerTitle: "LLM",
        providerChoicePending: "LLM choice missing",
        providerHosted: "AgentMaurice hosted models",
        providerHostedPending: "AgentMaurice models to initialize",
        providerReady: "Provider configured",
        providerPending: "No active provider yet",
        nextStepTitle: "Next step",
        nextStepModeChoice:
          "Choose first how you want to use LLMs: AgentMaurice models or your own API keys.",
        nextStepContext:
          "The local context is still being finalized. Rerun bootstrap to pull the console organization and create the default workspace.",
        nextStepDeployment:
          "The organization is ready, but the default user agent is still missing. Refresh the context to create it.",
        nextStepProvider:
          "The context is ready. Configure your API keys now to unlock chat and Build.",
        nextStepHostedPending:
          "The context is ready. Initialize the AgentMaurice LLM profile to create the provider, model, and agent selection.",
        nextStepHosted:
          "The context is ready. AgentMaurice models are available on this instance without any additional key setup.",
        nextStepReady:
          "Everything is ready on this machine. You can enter chat or switch to Build without any extra setup.",
        stepConsoleTitle: "Context",
        stepConsoleDescription:
          "AgentMaurice OS first restores your organization context and prepares the active workspace.",
        stepProviderTitle: "Provider",
        stepProviderDescription:
          "Choose the LLM mode that fits your usage, then, in user-key mode, test the configuration before saving it.",
        stepLaunchTitle: "Launch",
        stepLaunchDescription:
          "Once the mode is ready, chat and Build become usable on this machine.",
        modeTitle: "Choose your LLM access",
        modeDescription:
          "You must choose between AgentMaurice models and your own API keys before using the instance.",
        modeLabel: "LLM mode",
        modeHostedTitle: "AgentMaurice models",
        modeHostedDescription:
          "Use the models provided by AgentMaurice. No personal key is required on this machine.",
        modeByokTitle: "My own keys",
        modeByokDescription:
          "Use your own providers. Until the keys are configured, chat and Build stay locked.",
        modeChoiceRequiredTitle: "Choice required",
        modeChoiceRequiredDescription:
          "Until you choose an LLM mode, the instance stays in setup and the main flows remain locked.",
        modeLockedTitle: "LLM configuration already defined",
        modeLockedHostedDescription:
          "This organization uses AgentMaurice models. Other users on this VM do not need to repeat LLM onboarding.",
        modeLockedByokDescription:
          "This organization already uses a BYOK provider. Other users on this VM do not need to enter keys again.",
        hostedTitle: "Use AgentMaurice models",
        hostedDescription:
          "This instance can use AgentMaurice models directly. You do not need to enter any API key.",
        hostedPanelTitle: "AgentMaurice LLM is active",
        hostedPanelDescription:
          "The agent uses an organization-scoped AgentMaurice LLM profile. No user secret is required inside AgentMaurice OS.",
        hostedPanelPendingTitle: "Initialize the AgentMaurice profile",
        hostedPanelPendingDescription:
          "AgentMaurice OS will create or reuse the organization AgentMaurice provider, add a default model, create a profile, and select it for this agent.",
        hostedNoKeyRequired: "No user key required",
        hostedPendingNoKey: "No user key required",
        hostedActivateButton: "Initialize AgentMaurice",
        hostedActivating: "Initializing…",
        hostedActivateSuccess: "AgentMaurice LLM profile initialized.",
        hostedActivateError: "Could not initialize the AgentMaurice LLM profile.",
        byokPanelTitle: "BYOK provider active",
        byokPanelDescription:
          "The organization already has an LLM configuration. To change it, use Build > LLM with the required permissions.",
        formTitle: "Connect your LLM",
        formDescription:
          "One setup is enough. Secrets stay in the local backend and the provider is attached to the default agent.",
        readyBadge: "Ready",
        setupBadge: "Setup required",
        providerNameLabel: "Display name",
        modelLabel: "Model",
        apiKeyLabel: "API key",
        apiKeyOptionalLabel: "API key (optional)",
        apiKeyPlaceholder: "sk-...",
        urlRequiredLabel: "URL / endpoint",
        urlOptionalLabel: "URL / endpoint (optional)",
        urlPlaceholder: "https://...",
        advancedTitle: "Advanced settings",
        hideAdvanced: "Hide",
        showAdvanced: "Show",
        systemPromptLabel: "System prompt",
        systemPromptPlaceholder:
          "Optional. Leave empty to keep the default prompt.",
        maxCompletionTokensLabel: "Max completion tokens",
        diagnosticOk: "Connection validated",
        diagnosticError: "The test failed",
        testing: "Testing…",
        testButton: "Test",
        saving: "Saving…",
        primaryButton: "Test and start",
        refreshing: "Refreshing…",
        refreshButton: "Refresh context",
        continueChat: "Continue to chat",
        openBuild: "Open Studio",
        readyHint:
          "The workspace is ready. You can enter chat now or open Build to start shaping the agent.",
        readyHintHosted:
          "The workspace is ready and AgentMaurice models are available. You can go straight to chat or Build.",
        pendingHint:
          "Choose an LLM mode first, then make sure the organization and agent are ready before continuing.",
        pendingHintByok:
          "Until your API keys are tested and saved, chat and Build remain locked.",
        pendingHintHosted:
          "Initialize the AgentMaurice profile to unlock chat and Build without entering an API key.",
        testSuccess: "Provider connection validated.",
        testError: "Could not validate the provider connection.",
        saveSuccess: "Configuration saved.",
        saveError: "Could not save the configuration.",
        contextRefreshed: "Local context refreshed.",
        contextRefreshError: "Could not refresh the local context.",
        statusError: "Could not load setup status.",
        agentDiscoveryTitle: "Connect a code agent",
        agentDiscoveryDescription:
          "Choose a no-install prompt or a MauriceCLI command for the Git-native Agent Spec V2 rail. Both paths keep External Inception guided, temporary, and auditable.",
        agentDiscoveryBadge: "External Inception",
        codeAgentPromptMode: "MCP connection without installation (`amb_`)",
        codeAgentCLIMode: "MauriceCLI connection (`amc_`)",
        codeAgentPromptModeHint:
          "Copy an MCP setup prompt. Its `amb_` URL must never be passed to `maurice agent connect`.",
        codeAgentCLIModeHint:
          "Copy the `maurice agent connect` command. It configures the client and starts the Agent Spec V2 rail in the local Git project.",
        agentDiscoveryReadyHint:
          "The prompt does not contain the final key. The agent must call the bootstrap URL to receive the `agentmaurice.agent_connection/v2` contract.",
        agentDiscoveryUnavailableHint:
          "You do not have sufficient permissions to generate this prompt.",
        agentDiscoveryHumanApprovalHint:
          "The code agent prepares the plan but cannot approve it. Approval of the exact hash remains a separate human action in AgentMaurice OS.",
        agentDiscoveryGenerate: "Generate prompt",
        agentDiscoveryGenerating: "Generating…",
        agentDiscoveryCopy: "Copy prompt",
        agentDiscoveryGenerated: "Agent prompt generated.",
        agentDiscoveryGenerateError: "Could not generate the agent prompt.",
        agentDiscoveryInvalidBootstrap: "The server did not return a valid `amb_` MCP connection.",
        agentDiscoveryCopied: "Agent prompt copied.",
        agentDiscoveryCopyError: "Could not copy the agent prompt.",
        agentDiscoveryPrompt:
          "You are going to connect this code agent to an AgentMaurice instance.\n\nIMPORTANT — MCP setup only (`amb_`): never pass this URL to `maurice agent connect`. That command requires an `amc_` MauriceCLI bootstrap generated by AgentMaurice OS.\n\n1. Call this bootstrap URL exactly once:\n{{url}}\n\n2. Verify that the returned JSON has `$schema: agentmaurice.agent_connection/v2`, `schema_version: 2`, `bootstrap_kind: external_inception_mcp`, and `intended_consumer: mcp_client_setup`. Use only `organization`, `agent`, `agent_scopes`, `credential`, `mcp`, `commands`, `tools`, `policies`, `warnings`, `next_command`, and `client_setup`.\n\n3. Configure MCP with `client_setup`. Start with `inception_agent_scopes_list`, then call `inception_agent_doctor` with no arguments: its response is compact by default; use `full:true` only for an explicitly requested expert diagnostic. Then call `inception_mcp_capabilities`. Never infer an Agent target from its human name: use `agent_alias` or `agent_id` from `agent_scopes`.\n\n4. For every change, use only this rail: `inception_agent_spec_init` when needed → `inception_agent_spec_pull` → edit the Git-native files → `inception_agent_spec_check` → `inception_agent_spec_plan`. Present the immutable plan and its `plan_hash`, then stop.\n\n5. Approval must be recorded by an authenticated human in AgentMaurice OS or in a separate human session. As an agent or service, do not call `inception_agent_spec_approve` and never attempt to self-approve. After confirmation that human approval has been recorded, call `inception_agent_spec_apply` with the approved plan, then `inception_agent_spec_verify`.\n\n6. Never request, display, or write raw secrets; use secret references only.",
        cliBootstrapTitle: "Connect MauriceCLI",
        cliBootstrapDescription:
          "Generate a `maurice agent connect` command to paste into a terminal. The amc_ link is one-time, expires in 15 minutes, and writes no secret to the project.",
        cliBootstrapBadge: "MauriceCLI",
        cliBootstrapReadyHint:
          "The command configures the client and local project; changes then follow init/pull/check/plan, human approval, apply, and verify.",
        cliBootstrapUnavailableHint:
          "You do not have sufficient permissions to generate this command.",
        cliBootstrapEnvLabel: "Environment",
        cliBootstrapKindLabel: "Kind",
        cliBootstrapClientLabel: "Agent client",
        cliBootstrapAliasLabel: "Agent alias",
        cliBootstrapDirLabel: "Directory",
        cliBootstrapJoinExistingLabel: "Reconnect to an existing project",
        cliBootstrapJoinExistingDescription:
          "Adds `--join-existing` to renew local access without rewriting or exporting the project's Agent Spec files.",
        bootstrapScopesTitle: "Linked agents",
        bootstrapScopesDescription:
          "Add only the agents this agent or CLI should be allowed to target explicitly.",
        bootstrapScopesNone:
          "No other agent is available in this context.",
        bootstrapScopeAlias: "Alias",
        bootstrapScopeRole: "Role",
        bootstrapScopeRuntimeDependency: "Runtime dependency",
        bootstrapScopeManaged: "Managed",
        cliBootstrapGenerate: "Generate command",
        cliBootstrapGenerating: "Generating…",
        cliBootstrapCopy: "Copy command",
        cliBootstrapGenerated: "MauriceCLI command generated.",
        cliBootstrapGenerateError: "Could not generate the MauriceCLI command.",
        cliBootstrapInvalidCommand: "The server did not return a valid V2 `maurice agent connect` command.",
        cliBootstrapCopied: "MauriceCLI command copied.",
        cliBootstrapCopyError: "Could not copy the MauriceCLI command.",
        cliBootstrapKind: {
          development: "Development",
          preproduction: "Preproduction",
          production: "Production",
          sandbox: "Sandbox",
          integration_test: "Integration test",
        },
        cliBootstrapClient: {
          "claude-code": "Claude Code",
          codex: "Codex",
          cursor: "Cursor",
          windsurf: "Windsurf",
          generic: "Generic MCP",
        },
      },
      operateSetup: {
        missingOrganizationTitle: "Organization required",
        missingOrganizationDescription:
          "This view needs an active organization before it can load runtime content.",
        missingDeploymentTitle: "Agent required",
        missingDeploymentDescription:
          "Select or create an active agent before opening runtime screens.",
        missingSpaceTitle: "Workspace required",
        missingSpaceDescription:
          "The agent is ready, but no workspace is active in this session yet. Go back to the welcome screen to finish the setup.",
        noSpaceTitle: "No workspace is ready for this agent",
        noSpaceDescription:
          "This instance does not yet have a usable workspace for the current agent. Finish the welcome flow before opening chat.",
        loadingSpacesTitle: "Loading workspaces…",
        loadingSpacesDescription:
          "Checking available workspaces for the current agent before opening chat.",
        openWelcome: "Open welcome",
        openCatalog: "Open catalog",
        openHistory: "Open history",
        completeSetupToStart:
          "Finish the welcome flow to unlock chat and runtime screens",
      },
      shell: {
        toggleCenterFocus: "Toggle center focus mode",
        focusCenterContent: "Focus center content (Ctrl/Cmd+Shift+.)",
        toggleContextPanel: "Toggle context panel",
        toggleRightPanel: "Toggle right panel (Ctrl/Cmd+Shift+\\)",
        resizeNavigationPanel: "Resize navigation panel",
        resizeContextPanel: "Resize context panel",
        inspectTitle: "Inspect",
        inspectDescription: "Configure the selected node.",
        executionDetailTitle: "Execution detail",
        executionDetailDescription: "Context for the selected run.",
        emptyContextTitle: "Detailed context will appear here",
        emptyContextDescription:
          "The shell keeps this area ready for inspection, execution details and contextual previews.",
        emptyContextBuildTitle: "Build context will appear here",
        emptyContextBuildDescription:
          "The shell keeps this area ready for Workflow inspection, plans, runs and build previews.",
        emptyContextRunTitle: "Execution details will appear here",
        emptyContextRunDescription:
          "The shell keeps this area ready for active steps, linked files and execution-focused previews.",
        emptyContextRunActionsTitle: "Useful actions",
        emptyContextRunActionsDescription:
          "When no execution is selected yet, use this panel to jump back to the right starting point.",
        emptyContextRunCatalogDescription:
          "Browse launchable Workflows and start a session from the right blueprint.",
        emptyContextRunHistoryDescription:
          "Resume a recent execution, inspect its outputs, and relaunch it in chat.",
        emptyContextRunOpenBuild: "Open Studio",
        emptyContextRunBuildDescription:
          "Move to Agent Spec to finish a Workflow, inspect its blueprint, or prepare an apply.",
        emptyContextHistoryTitle: "Execution detail will appear here",
        emptyContextHistoryDescription:
          "The shell shows the selected run here, including outputs, artifacts and final status.",
        emptyContextBuildHint:
          "In build mode, select a node or start an inspection to open this panel.",
        emptyContextRunHint:
          "In run mode, open a file, an execution or history details to populate this panel.",
        emptyContextHistoryHint:
          "Select a history entry to display its details here.",
        emptyContextShortcutHint:
          "Use Ctrl/Cmd+Shift+\\ to reopen the context panel instantly when content is available.",
      },
      sidebar: {
        calisto: "Calisto",
        recipes: "Recipes",
        metaRecette: "Meta recipe",
        capabilities: "Capabilities",
        miniAppPreview: "Mini-app preview",
        data: "Data",
        deployments: "Agents",
        llm: "LLM",
        mcp: "MCP",
        skills: "Skills",
        schedules: "Schedules",
        observability: "Observe",
        externalControl: "Agent keys",
        apiKeys: "API keys",
        agentControl: "Agent control",
        importExport: "Import / Export",
        messaging: "Messaging",
        mailCatcher: "Mail Catcher",
        spaces: "Spaces",
        chat: "Chat",
        catalog: "Catalog",
        history: "History",
        spacesSessions: "Spaces & sessions",
        noSpaceForDeployment: "No space available for this agent.",
        newSession: "New session",
        sessionActions: "Session actions",
        renameSession: "Rename",
        renameSessionTitle: "Rename session",
        renameSessionDescription:
          "Change the name shown in the session list.",
        renameSessionNameRequired: "Session name is required.",
        renameSessionSuccess: "Session renamed.",
        renameSessionError: "Unable to rename the session.",
        deleteSession: "Delete",
        deleteSessionTitle: "Delete session",
        deleteSessionDescription:
          "Session {{name}} will be permanently deleted.",
        deleteSessionSuccess: "Session deleted.",
        deleteSessionError: "Unable to delete the session.",
        sessionName: "Session name",
        unnamedSession: "Session",
        noSessionYet: "No session yet.",
        sessionCount: "{{count}} session(s)",
        lastActivity: "Activity {{value}}",
        showMoreSessions: "Show {{count}} more session(s)",
        showFewerSessions: "Show fewer sessions",
        localProfile: "Local profile",
        userProfile: "User profile",
        account: "Account",
        access: "Access",
        organizations: "Organizations",
        currentWorkspace: "Current workspace",
        noWorkspaceSelected: "No workspace selected",
        memberships_one: "{{count}} membership",
        memberships_other: "{{count}} memberships",
        localAuthentication: "Local authentication",
        hankoAuthentication: "Secure authentication",
        hankoProfile: "Account security",
        hankoProfileDescription:
          "Manage the identity, sign-in methods, and AgentMaurice context for this session.",
        hankoProfileLoadError: "Unable to load account security.",
        desktopAuthentication: "Desktop authentication",
        localSignOutHint:
          "Signing out returns you to the local account picker.",
        hankoSignOutHint:
          "Signing out ends the local session on this device.",
        desktopSignOutHint:
          "Signing out ends the desktop session on this device.",
        confirmSignOutTitle: "Confirm sign out",
        confirmSignOutDescription:
          "You are about to end the current session on this device.",
        confirmSwitchUserDescription:
          "You are about to leave this local profile and return to the account picker.",
        switchUser: "Switch user",
        signOut: "Sign out",
        consoleBinding: "Console binding",
        consoleBindingDescription:
          "Bind this installation to a console instance without changing the local backend or SQLite database.",
        consoleBound: "Bound",
        consoleUnbound: "Unbound",
        consoleUrl: "Console",
        consoleInstance: "Instance",
        consoleOrganization: "Organization",
        consoleUser: "Console user",
        consoleLastSync: "Last update {{value}}",
        consolePair: "Bind",
        consoleReconnect: "Bind again",
        consoleDetach: "Detach",
        consoleDetachConfirm:
          "Detach this installation from the console and reload the application?",
        consoleDetached: "Console binding removed. Reloading…",
        consolePairingIntro:
          "Enter the console URL, then start the device flow binding.",
        consolePairingStart: "Start binding",
        consolePairingCancel: "Cancel",
        consolePairingUrlPlaceholder: "https://console.agentmaurice.app",
        consolePairingPending:
          "Open this URL in your browser and enter the following code.",
        consoleVerificationUrl: "Verification URL",
        consoleUserCode: "Code",
        consoleCheckingStatus: "Waiting for approval…",
        consolePairingExpires: "Expires in {{count}} s",
        consolePairingExpired: "The binding code expired. Start pairing again.",
        consolePaired: "Installation bound to {{instance}}. Reloading…",
        consolePairingFailed: "Console binding failed.",
        consoleReloadHint:
          "The organization context will reload automatically after bind or detach.",
      },
      wallet: {
        title: "Organization credits",
        referenceTokens: "~ {{count}} tokens",
        lowBalance: "Low balance. Top up recommended.",
        suspended: "Wallet suspended. Hosted usage is blocked.",
        portal: "Invoices",
        recentActivity: "Recent activity",
        activityTopup: "Top-up",
        activityUsage: "Usage",
        topupError: "Unable to start checkout.",
        portalError: "Unable to open the customer portal.",
        checkoutSuccess: "Top-up confirmed.",
        checkoutCanceled: "Top-up canceled.",
        chatTopupTitle: "Not enough credits",
        chatTopupDescription:
          "This conversation hit your organization credit limit. Top up to continue without losing context.",
        chatTopupCta: "Top up",
        chatTopupPending: "Opening…",
        chatSuspendedTitle: "Wallet suspended",
        chatSuspendedDescription:
          "Your organization wallet is suspended. Hosted usage is temporarily blocked until an operator re-enables it.",
      },
      contextSwitcher: {
        selectOrganization: "Select organization",
        selectDeployment: "Select agent",
        organization: "Organization",
        deployment: "Agent",
        orgId: "Org ID",
        environment: "Environment",
        notSelected: "Not selected",
        loadingContext: "Loading context…",
        createDeployment: "New",
        createDeploymentTitle: "Create agent",
        createDeploymentDescription:
          "Create an empty sandbox Agent suited for Studio previews. Then initialize its project with maurice spec init without creating a managed runtime resource.",
        createDeploymentNameLabel: "Agent name",
        createDeploymentNamePlaceholder: "Support assistant",
        createDeploymentNotesLabel: "Initial notes",
        createDeploymentNotesPlaceholder:
          "Briefly describe the initial scope or goal of this agent.",
        createDeploymentConfirm: "Create agent",
        createDeploymentSubmitting: "Creating…",
        createDeploymentSuccess: "Agent {{name}} created.",
        createDeploymentFailed: "Failed to create agent.",
        createDeploymentConflict:
          "A agent with this name already exists. Please choose a different name.",
        createDeploymentNoOrganization: "Select an organization first.",
        createDeploymentNameRequired: "Agent name is required.",
        deploymentKindLabel: "Agent type",
        deploymentKindHint:
          "The type drives Studio governance (preview, approval). Changing it always asks for confirmation.",
        deploymentKindConfirmTitle: "Change Agent type?",
        deploymentKindConfirmDescription:
          "You are about to change “{{name}}” from {{from}} to {{to}}. This immediately updates governance rules (preview, approval, constraints). Confirm only if intentional.",
        deploymentKindConfirmAction: "Change type",
        deploymentKindUpdating: "Updating…",
        deploymentKindUpdated: "{{name}} type: {{kind}}.",
        deploymentKindUpdateFailed: "Unable to change the Agent type.",
        deploymentKind: {
          sandbox: "Sandbox",
          development: "Development",
          integration_test: "Integration test",
          staging: "Staging",
          production: "Production",
          unknown: "Unknown",
        },
      },
      chat: {
        headerTitle: "Chat with Maurice",
        freeConversation: "Free conversation",
        recipeLabel: "Workflow: {{name}}",
        deploymentBadge: "Agent",
        sessionBadge: "Session",
        recipeBadge: "Context",
        newSessionBadge: "New",
        freeConversationBadge: "Free",
        freeConversationDescription:
          "Use this chat to explore, launch a Workflow, or resume an execution without locking the context too early.",
        recipeFocusDescription:
          "This conversation keeps the active Workflow in focus so you can launch, refine, and review it faster.",
        chooseRecipe: "Choose a Workflow",
        openCatalog: "Open catalog",
        openHistory: "Open history",
        skillsButton: "Skills",
        debugMessages: "Debug",
        showTechnicalMessages: "Show tool calls and raw results",
        hideTechnicalMessages: "Hide tool calls and raw results",
        skillsSessionLabel: "Session skills",
        skillsPanelTitle: "Session skills",
        skillsPanelDescription:
          "Select agent skills to enrich the current session.",
        skillsLoading: "Loading skills…",
        skillsLoadingError: "Failed to load agent skills.",
        noSelectedSkills: "No skill selected for this session.",
        noDeploymentSkills: "No skill is installed on this agent.",
        useSkill: "Use",
        skillSelected: "Selected",
        clearSkills: "Clear skills",
        skillsCleared: "Session skills cleared.",
        skillNotFound: "Skill not found: {{skill}}",
        skillAdded: "{{skill}} added to the session.",
        skillRemoved: "{{skill}} removed from the session.",
        noSkillPreview: "No preview available for this skill.",
        execution: "Execution",
        connectionErrorTitle: "Connection error",
        sessionPausedTitle: "Session paused",
        sessionPausedDescription: "The session was paused after a period of inactivity.",
        resumeConversation: "Resume conversation",
        messageFeed: "Chat message feed",
        loadingHistory: "Loading history…",
        loadingOlderMessages: "Loading older messages…",
        startConversation: "Start a conversation",
        readyForMessage: "Ready when you are",
        askAboutRecipe: "Ask Maurice anything about this Workflow",
        askAboutWorkspace: "Ask Maurice anything about this workspace",
        latest: "Latest",
        selectWorkspaceToStart: "Select a workspace to start chatting",
        createSessionToStart: "Create or select a session to start.",
        askMaurice: "Ask Maurice…",
        noExecutionContext: "No execution context available yet",
        noActiveSessionToClear: "No active session to clear",
        sessionHistoryCleared: "Session history cleared",
        failedToClearSession: "Failed to clear session",
        clearSessionTitle: "Clear session",
        clearSessionDescription:
          "This will remove the full history of the current chat session.",
        clearHistory: "Clear history",
        helpMessage: [
          "Available commands:",
          "",
          "- `/status` open the execution context",
          "- `/workflow` open the Workflow picker",
          "- `/tools` ask Maurice for the tools available in this context",
          "- `/skills` open the skills panel",
          "- `/use-skill <id>` select a skill for the session",
          "- `/clear-skills` clear the selected skills",
          "- `/help` show this help",
          "- `/clear` delete the current session history",
        ].join("\n"),
        recipeContextHint:
          "Messages will be sent with this blueprint in context.",
        llmActivityThinking: "Maurice is thinking...",
        llmActivityTool: "Maurice is using a tool...",
        llmActivitySkill: "Maurice is applying a skill...",
        llmActivityProject: "Maurice is working on the project...",
      },
      chatInput: {
        openStatusContext: "Open status context",
        openStatusContextDescription:
          "Ask for the current execution or agent status",
        launchRecipe: "Launch a Workflow",
        launchRecipeDescription:
          "Open the Workflow picker or target a Workflow command",
        showHelp: "Show help",
        showHelpDescription: "Display available slash commands",
        showTools: "Show tools",
        showToolsDescription:
          "Ask Maurice for the tools available in this context",
        openSkills: "Open skills",
        openSkillsDescription:
          "Display agent skills and the current session selection",
        useSkill: "Use a skill",
        useSkillDescription: "Select a skill to enrich the next messages",
        clearSkills: "Clear skills",
        clearSkillsDescription:
          "Remove all selected skills from the current session",
        clearSession: "Clear session",
        clearSessionDescription: "Delete the current session history",
        changeRecipe: "Change",
        messageLabel: "Your message",
        quickActions: "Quick actions",
        shortcutHint:
          "Use slash commands or the Workflow picker to frame the session quickly.",
      },
      files: {
        attach: "Attach a file",
        attached: "{{filename}} added to the message",
        uploadFailed: "File upload failed",
        uploadProgress: "Upload {{progress}}%",
        attachedFile: "Attached file",
      },
      recipePicker: {
        title: "Select a blueprint",
        description:
          "Launch the conversation with a specific Workflow context, or keep the chat generic.",
        searchPlaceholder: "Search Workflows...",
        loading: "Loading Workflows…",
        noMatch: "No Workflow matches this search.",
        noDescription: "No description provided.",
      },
      recipeForm: {
        fallbackTitle: "Workflow form",
        fallbackDescription:
          "The running Workflow needs additional input before it can continue.",
        selectOption: "Select…",
        submit: "Submit form",
        submitting: "Submitting…",
        fieldRequired: "{{field}} is required.",
      },
      chatMessage: {
        resourcePreview: "Resource preview",
        previewTruncated: "Preview truncated.",
        result: "Result",
        logs: "Logs",
        userMessage: "User message",
        assistantMessage: "Assistant message",
        technicalMessage: "Technical message",
      },
      executionPanel: {
        title: "Execution status",
        completedCount: "{{done}}/{{total}} completed",
        running: "Running...",
        progress: "Progress",
        overallProgress: "Overall progress",
        stepProgress: "{{step}} progress",
      },
      executionResult: {
        title: "Result",
        refresh: "Refresh result",
        copy: "Copy result",
        loading: "Loading result…",
        empty: "No result available.",
      },
      executionLogs: {
        title: "Logs",
        refresh: "Refresh logs",
        copy: "Copy logs",
        loading: "Loading logs…",
        empty: "No log available for this execution.",
      },
      historyDetail: {
        rerun: "Re-run in chat",
        timeline: "Timeline",
        created: "Created",
        started: "Started",
        completed: "Completed",
        duration: "Duration",
        blueprint: "Blueprint",
        loadingBlueprint: "Loading Workflow preview…",
        noBlueprintPreview:
          "No blueprint preview is available for this execution.",
        noDescription: "No description provided.",
        noRecipe: "No Workflow is associated with this execution.",
        error: "Error",
        notAvailable: "N/A",
        pending: "Pending",
        running: "Running",
        completedStatus: "Completed",
        failed: "Failed",
        usageTitle: "Usage summary",
        usageSourceTrace: "Estimated",
        usageSourceMetering: "Metering",
        usageDuration: "Duration",
        usageTokens: "Tokens",
        usageEstimatedCost: "Estimated cost",
        usageActions: "Actions",
        usageFailures: "failures",
        usageLLMCalls: "LLM calls",
        usageMonetaryUnavailable: "Final monetary cost unavailable",
        usageNoData: "No usage summary available.",
        usageModelBreakdown: "Models",
      },
      catalog: {
        title: "Actions catalog",
        description: "Choose a Workflow to start a conversation with Maurice",
        searchPlaceholder: "Search Workflows...",
        all: "All",
        quickLaunchEyebrow: "Starting point",
        quickLaunchTitle: "Quick launch",
        quickLaunchDescription:
          "These Workflows are the best starting points to open a useful new session without scanning the whole list first.",
        quickLaunchHint:
          "Use direct launch when you already know which workflow you want to run.",
        quickBuildTitle: "Prepare in Studio",
        quickBuildDescription:
          "No Workflow is ready to launch here yet. Start by finishing the most promising ones in Agent Spec.",
        quickBuildHint:
          "When everything is still draft, open the Workflow directly in Agent Spec.",
        openInChat: "Open in chat",
        resultsTitle: "All Workflows",
        resultsDescription: "{{count}} Workflow(s) visible in this agent.",
        resultsFilteredBy: "Filtered by {{category}}",
        resultsAllVisible: "Full view",
        launchableTitle: "Ready to launch",
        launchableDescription:
          "These Workflows are ready and can open a new session immediately.",
        launchableCount: "{{count}} ready",
        buildRequiredTitle: "Needs Studio review",
        buildRequiredDescription:
          "These Workflows already exist, but still need an Agent Spec pass before they should be launched.",
        buildRequiredCount: "{{count}} to finish",
        buildRequiredTruncated: "{{shown}} shown out of {{total}}",
        showMoreBuild: "Show {{count}} more",
        showLessBuild: "Show less",
        loading: "Loading Workflows...",
        error: "Error",
        noRecipes: "No Workflows available",
        noRecipesHint:
          "Create and apply a Workflow with Agent Spec to get started",
        noSearchMatch: "No Workflows match your search",
        clearFilters: "Clear filters",
      },
      history: {
        title: "Execution history",
        description: "View past Workflow executions and results",
        searchPlaceholder: "Search by Workflow or execution ID...",
        all: "All",
        metricsTotal: "Total",
        metricsTotalHint: "Loaded executions",
        metricsSuccess: "Successful",
        metricsSuccessHint: "Finished without blockers",
        metricsAttention: "Needs fixes",
        metricsAttentionHint: "Require intervention",
        metricsRerunnable: "Rerunnable",
        metricsRerunnableHint: "Can restart in chat",
        surfaceHint:
          "Review recent runs and open their details without depending on a pre-filled context panel.",
        loading: "Loading history...",
        error: "Error",
        noExecutions: "No executions found",
        noExecutionsHint: "Start a conversation to see execution history",
        loadMore: "Load more",
        pending: "Pending",
        running: "Running",
        completed: "Completed",
        failed: "Failed",
        openDetails: "Open details",
        rerun: "Run again in chat",
        executionLabel: "Execution",
        startedLabel: "Started",
        durationLabel: "Duration",
        usageLabel: "Usage",
        signalLabel: "Signal",
        readinessReview: "Ready for review",
        readinessFix: "Needs fixes",
        readinessRerunnable: "Rerunnable",
        readinessRunning: "Active tracking",
        readinessQueued: "Queued",
        nextStepLabel: "Next step",
        nextStepRerun:
          "Open the details, then relaunch quickly if you want to compare or start over.",
        nextStepFix:
          "Inspect the error, fix the Workflow, then relaunch it from chat.",
        nextStepWatch:
          "Follow the progress in detail or wait until the run finishes.",
        nextStepQueue:
          "Wait for the full start before relaunching or intervening.",
        groupAttentionTitle: "Needs fixes",
        groupAttentionDescription:
          "These runs failed or stalled and need action before you relaunch them.",
        groupActiveTitle: "In progress",
        groupActiveDescription:
          "These runs are still progressing in the runtime and mainly need monitoring.",
        groupQueuedTitle: "Queued",
        groupQueuedDescription:
          "These runs already exist but have not fully started yet.",
        groupSuccessTitle: "Successful",
        groupSuccessDescription:
          "These runs are complete, reviewable, and often ready to rerun.",
        pendingSummary: "This execution is still waiting for a full start.",
        runningSummary: "This execution is still progressing in the runtime.",
        completedSummary: "This run is complete and ready for review.",
        failedSummary: "This run failed and needs a targeted review.",
      },
      recipeCard: {
        active: "Active",
        draft: "Draft",
        noDescription: "No description provided",
        steps: "{{count}} steps",
        launch: "Launch",
        launchNow: "Launch now",
        openInBuild: "Open in Studio",
        inspectBlueprint: "Inspect blueprint",
        readiness: "Next step",
        structure: "Structure",
        readyToLaunch: "Ready to launch",
        finishInBuild: "Finish in Studio",
        launchHint: "Opens a new execution session directly.",
        buildHint: "Use Agent Spec to finish or apply this Workflow.",
        workflow: "Workflow",
        miniapp: "MiniApp",
        moreTags: "+{{count}}",
      },
      filePreview: {
        image: "Image",
        document: "Document",
        file: "File",
        noPreviewUrl: "No preview URL available for this file.",
        loadingPreview: "Loading preview…",
        noInlinePreview: "No inline preview available for this file.",
      },
      commandPalette: {
        button: "Command...",
        title: "Command palette",
        description:
          "Search application commands or ask Calisto to act on the current agent.",
        placeholder: "Search commands or ask Calisto...",
        noCommands: "No commands found.",
        startTyping: "Start typing to search...",
        navigation: "Navigation",
        recipes: "Recipes",
        deployment: "Agent",
        home: "Home",
        homeDescription: "Go to dashboard",
        recipesView: "Recipes",
        recipesViewDescription: "View all recipes",
        capabilities: "Capabilities",
        capabilitiesDescription: "Browse capabilities",
        deploy: "Deploy",
        deployDescription: "Agent pipeline",
        catalog: "Catalog",
        catalogDescription: "View recipe catalog",
        chat: "Chat",
        chatDescription: "Go to chat",
        newRecipe: "New recipe",
        newRecipeDescription: "Create a new recipe",
        compileRecipe: "Compile recipe",
        compileRecipeDescription: "Compile current recipe",
        testRecipe: "Test recipe",
        testRecipeDescription: "Run tests on current recipe",
        promoteRecipe: "Promote recipe",
        promoteRecipeDescription: "Promote to the next environment",
        rollback: "Rollback",
        rollbackDescription: "Rollback to previous version",
        askCalisto: "Ask Calisto",
      },
      calisto: {
        adminMode: "Calisto Admin",
        adminTitle: "Global conversational administration",
        adminDescription:
          "Calisto operates at organization level to create, update, and diagnose agents, MCP, users, skills, and meta-recipes.",
        adminRuntime: "Admin runtime",
        adminLoadError: "Admin runtime unavailable",
        adminTargetScope: "Work scope",
        allDeployments: "All agents",
        businessDeployments: "Business agents",
        targetingAllDeployments:
          "Calisto is working in a global cross-agent view.",
        targetingDeployment: "Calisto targets {{name}}.",
        contextRailTitle: "Useful context",
        contextRailDescription:
          "Signals and shortcuts for administration without leaving the conversation.",
        activeScope: "Active scope",
        conversation: "Conversation",
        messages: "messages",
        capabilities: "Available capabilities",
        capabilityDeployments: "Agents",
        capabilityMcp: "MCP and connectors",
        capabilityUsers: "Users and roles",
        capabilityMetaRecipes: "Meta-recipes",
        capabilityRuntime: "Runtime settings",
        quickActions: "Quick actions",
        quickActionsDescription:
          "Prefills the message. Nothing runs until you explicitly send it.",
        quickActionListDeployments: "Audit agents",
        quickActionCreateDeployment: "Create agent",
        quickActionConfigureMcp: "Configure MCP",
        quickActionInviteUser: "Invite user",
        quickActionMetaRecipe: "Create meta-recipe",
        quickPromptListDeployments:
          "List the business agents in scope {{scope}}, summarize their state, MCP, skills, and attention points.",
        quickPromptCreateDeployment:
          "Help me create a new business agent. Start by asking the required questions about name, goal, users, MCP, skills, and LLM settings before proposing a plan.",
        quickPromptConfigureMcp:
          "Help me configure MCP for scope {{scope}}. Start by auditing the current setup, then propose needed changes without applying them until I confirm.",
        quickPromptInviteUser:
          "Help me invite or update a user for scope {{scope}}. Ask for email, role, and access before taking any action.",
        quickPromptMetaRecipe:
          "Help me create or update a meta-recipe for scope {{scope}}. Start by understanding the business goal, then propose the structure and validation steps.",
        guardrails: "Guardrails",
        guardrailConfirmation:
          "Deletions must be confirmed with the exact name.",
        guardrailLastDeployment:
          "The last business agent must not be deleted without a validated replacement.",
        guardrailAdminHidden:
          "The Calisto admin runtime stays hidden from business selectors.",
        connectedContext: "Connected to agent context",
        connectingContext: "Connecting to agent context",
        minimize: "Minimize",
        clearConversation: "Clear conversation",
        clearConversationTitle: "Clear Calisto conversation",
        clearConversationDescription:
          "This will delete the history of this Calisto conversation. The work context stays available, but Calisto will restart without previous messages.",
        clearConversationConfirm: "Clear",
        conversationCleared: "Calisto conversation cleared",
        conversationClearFailed: "Failed to clear Calisto conversation",
        noActiveConversationToClear: "No active Calisto conversation to clear",
        startConversation: "Start a conversation with Calisto",
        describeChange:
          "Describe the change you want on the blueprint or agent.",
        you: "You",
        thinking: "Calisto is thinking",
        proposedChanges: "Proposed changes ({{count}})",
        addNode: "Add node",
        updateNode: "Update node",
        deleteNode: "Delete node",
        addConnection: "Add connection",
        deleteConnection: "Delete connection",
        yes: "Yes",
        no: "No",
        firstBuildWelcome:
          "Hello, I am Calisto. I will help you build your first agent. What do you want to build? Describe the outcome you want, the tools or integrations to connect, and the data you want to use.",
        askPlaceholder: "Ask Calisto...",
        sendHint: "Press Enter to send. Shift+Enter for a new line.",
        guidedConverge: "Guided Converge",
        executionPlanTitle: "Execution plan",
        executionPlanDescription:
          "Prepare, apply, and monitor convergence without exposing technical details by default.",
        executionStatePreparing: "Preparing plan",
        executionStateApplying: "Applying plan",
        executionStatePlanReady: "Plan ready",
        executionStateAttention: "Needs attention",
        executionStateNeedsPlan: "Plan required",
        executionPrepareInProgress:
          "Calisto is preparing the execution plan from the spec and the target agent.",
        executionApplyInProgress:
          "Calisto is applying the prepared plan and tracking agent feedback.",
        executionNeedsReviewDescription:
          "The convergence context still needs review before apply.",
        executionNeedsPlanDescription:
          "Prepare a plan to turn drift signals into concrete actions.",
        executionReadyToApply: "Ready to apply",
        executionSignals: "Signals",
        executionPlan: "Plan",
        executionApply: "Apply",
        executionStageReady: "Ready",
        executionStagePending: "Pending",
        executionStageInProgress: "In progress",
        executionStageDone: "Completed",
        executionWarningsCount: "{{count}} warning(s) to review",
        executionDetailsTitle: "Execution details",
        executionDetailsDescription:
          "Find the prepared plan, useful shortcuts, and detailed steps here.",
        executionShowDetails: "Show details",
        executionHideDetails: "Hide details",
        executionShortcutsTitle: "Useful shortcuts",
        targetDeployment: "Target agent",
        activeBlueprint: "Active blueprint",
        refresh: "Refresh",
        preparedPlanReady: "Prepared plan ready",
        hash: "Hash",
        recommendedActions: "Recommended actions",
        preparePlan: "Prepare plan",
        applyPlan: "Apply plan",
        apply: "Apply",
        everythingSynced: "Everything is synced",
        workflow: "Workflow",
        streaming: "streaming...",
        arguments: "Arguments:",
        result: "Result:",
        error: "Error:",
        slashMenuTitle: "Calisto tools",
        slashHelpLabel: "Show Calisto help",
        slashHelpDescription: "Display available slash commands for Calisto",
        slashToolsLabel: "List tools",
        slashToolsDescription: "Ask Calisto which tools are useful right now",
        slashContextLabel: "Inspect context",
        slashContextDescription:
          "Summarize the current agent and blueprint context",
        slashHealthLabel: "Inspect health",
        slashHealthDescription: "Diagnose Calisto context and memory health",
        slashDriftLabel: "Explain drift",
        slashDriftDescription:
          "Compare the active meta-recette and the target agent",
        slashPlanLabel: "Prepare plan",
        slashPlanDescription: "Launch the guided convergence preparation flow",
        slashRefreshLabel: "Refresh converge state",
        slashRefreshDescription:
          "Reload guided convergence signals and context summary",
        slashSpecLabel: "Analyze attached specs",
        slashSpecDescription:
          "Send the currently attached files as spec context to Calisto",
        slashClearLabel: "Clear conversation",
        slashClearDescription:
          "Delete the current Calisto conversation history",
        slashHelpMessage: [
          "Available Calisto commands:",
          "",
          "- `/tools` list the useful tools in the current context",
          "- `/context` summarize the current agent context",
          "- `/health` inspect Calisto health and memory status",
          "- `/drift` explain the gap between spec and agent",
          "- `/plan` prepare the guided convergence plan",
          "- `/refresh` reload Calisto context and converge state",
          "- `/spec` analyze the files currently attached to the composer",
          "- `/clear` delete the current conversation history after confirmation",
          "",
          "You can also attach files such as specs before sending a message.",
        ].join("\n"),
        specNeedsFiles: "Attach at least one file before using /spec.",
      },
      build: {
        llmEnableProvider: "Enable",
        llmDisableProvider: "Disable",
        llmProviderEnabled: "Provider enabled",
        llmProviderDisabled: "Provider disabled",
        accessPrimaryCta: "Open an available Configuration view",
        accessBackToRun: "Back to Run",
        accessRecipesTitle: "Limited Studio access",
        accessRecipesDescription:
          "This Studio area requires recipe authoring permissions. Your current role cannot open the authoring screens.",
        accessDeployTitle: "Deploy access required",
        accessDeployDescription:
          "The Deploy page requires explicit agent rights. Open another available Configuration view or go back to Run.",
        accessObserveTitle: "Observe is not available",
        accessObserveDescription:
          "The Observe page requires access to the current agent logs. Open another available Configuration view or go back to Run.",
        accessExternalControlTitle: "Agent keys are restricted",
        accessExternalControlDescription:
          "This Configuration area requires explicit agent rights.",
        recipesTitle: "My Recipes",
        recipesDescription: "Manage your AI meta-recipes.",
        recipesSelectOrg:
          "Select an organization in the context switcher to load recipes.",
        recipesCountLabel: "Recipes",
        recipesSpecSourceSummaryLabel: "{{count}} source meta-recette",
        recipesSpecSourceSummaryLabel_other: "{{count}} source meta-recettes",
        recipesNodeCountSummaryLabel: "{{count}} nodes described in total",
        recipesRuntimeActiveLabel: "Runtime active",
        recipesRuntimeActiveHint:
          "Spec recipes found in the active runtime.",
        recipesPublishedLabel: "Synced",
        recipesPublishedHint:
          "Recipes already aligned with the target agent.",
        recipesPendingLabel: "Needs work",
        recipesPendingHint:
          "Recipes still pending, drifting, or requiring review before apply.",
        recipesLatestUpdatedLabel: "Latest update",
        recipesLatestUpdatedHint:
          "Most recently edited recipe in this agent.",
        recipesNodeCountLabel: "{{count}} node",
        recipesNodeCountLabel_other: "{{count}} nodes",
        recipesDeploymentScopeLabel: "Agent",
        recipesUpdatedLabel: "Updated",
        recipesCreatedLabel: "Created",
        recipesOpenMetaRecette: "Open meta-recette",
        recipesRuntimeActiveStatus: "Runtime active",
        recipesSpecOnlyStatus: "Spec only",
        recipesNoSpecDefinitionsTitle: "No recipe declared in the spec",
        recipesNoSpecDefinitionsDescription:
          "The meta-recette exists, but its structured_spec does not contain recipes_definitions yet.",
        recipesDefaultModeLabel: "workflow",
        recipesRecipeIdLabel: "ID",
        recipesSourceMetaRecetteLabel: "Source",
        recipesFormsLabel: "Forms",
        recipesFormsCount: "{{count}} form",
        recipesFormsCount_other: "{{count}} forms",
        recipesEditFullSpec: "Edit full spec",
        recipesDriftTitle: "Spec/runtime drift",
        recipesDriftDescription:
          "{{specMissing}} spec recipe(s) are missing from runtime, {{runtimeOrphans}} runtime recipe(s) are not declared in the spec.",
        recipesSpecMissingRuntimeHint:
          "Declared in the spec, but missing from the active runtime.",
        recipesRuntimeOrphanHint:
          "Active in runtime, but missing from the canonical spec.",
        recipesSpecConsistentTitle: "Spec and runtime aligned",
        recipesSpecConsistentDescription:
          "Every recipe declared in the spec is active in the runtime.",
        recipesPrimarySyncedDescription:
          "This recipe is aligned. You can review the meta-recette or start a new change from there.",
        recipesPrimaryPendingDescription:
          "This recipe still needs planning or apply work before it is truly ready to use.",
        recipesPrimaryDraftDescription:
          "Keep editing before preparing a plan or asking Calisto for convergence.",
        recipesWorkflowTitle: "How to work here",
        recipesWorkflowDescription:
          "The Recipes page is for editing the blueprint. The meta-recette and Calisto then take over to plan, apply, and verify the changes.",
        recipesWorkflowStepEditLabel: "Edit the blueprint",
        recipesWorkflowStepEditDescription:
          "Work on the recipe structure in the visual canvas or in the synchronized YAML.",
        recipesWorkflowStepMetaLabel: "Review in meta-recette",
        recipesWorkflowStepMetaDescription:
          "Open the meta-recette to compare the spec, prepare a plan, and request convergence.",
        recipesWorkflowStepShipLabel: "Test and publish",
        recipesWorkflowStepShipDescription:
          "Once the recipe is ready, launch tests or publish from the build workflow.",
        contextUnavailable: "Context unavailable",
        noRecipe: "No recipe",
        createFirstRecipe: "Create your first recipe to get started.",
        newRecipe: "New Recipe",
        createRecipeCta: "Create Recipe",
        backToList: "Back to list",
        blueprintEditing: "Blueprint editing",
        blueprintEditingDescription:
          "Switch between the visual canvas and the synced YAML representation.",
        canvasView: "Canvas",
        yamlView: "YAML",
        reloadFromCanvas: "Reload from canvas",
        applyToCanvas: "Apply to canvas",
        structuredSpecYaml: "Structured Spec YAML",
        yamlValidated:
          "Changes are validated before they are reflected in the canvas.",
        localDraft: "Local draft",
        synchronized: "Synchronized",
        yamlSaveHint:
          "The YAML describes the full recipe. Saving first applies the YAML to the canvas.",
        calistoCommandTitle: "Calisto Command",
        calistoCommandDescription:
          "Describe the blueprint you want, then let Calisto propose changes.",
        closeCalisto: "Close Calisto",
        openCalisto: "Open Calisto",
        noNodeSelected: "No node selected",
        noNodeSelectedDescription:
          "Select a block on the canvas to display its configuration and Calisto suggestions.",
        essential: "Essential",
        advanced: "Advanced",
        expert: "Expert",
        pending: "Pending",
        applyAction: "Apply",
        rejectAction: "Reject",
        untitledNode: "Untitled Node",
        calistoAssistTitle: "Calisto Assist",
        calistoAssistDescription:
          "Contextual suggestions to enrich or fix this node without leaving the panel.",
        suggestionLabel: "Suggestion {{index}}",
        lastCalistoResponse: "Last Calisto response",
        targetedHelp: "Request targeted help",
        guidedConvergeDescription:
          "Summary of the guided Calisto plan for the active agent and convergence actions.",
        planReady: "Plan ready",
        activeBlueprintName: "Active blueprint: {{name}}",
        openCalistoForWorkflow:
          "Open Calisto on an active agent to load the convergence workflow.",
        configurationTitle: "Configuration",
        configurationDescription:
          "The displayed level depends on the requested depth: quick, advanced or raw.",
        nodeName: "Node name",
        nodeType: "Type",
        model: "Model",
        selectModel: "Choose a model",
        mainPrompt: "Main prompt",
        mcpServer: "MCP server",
        tools: "Tools",
        commaSeparatedList: "Comma-separated list",
        sourceType: "Source type",
        selectSourceType: "Select",
        source: "Source",
        conditionalExpression: "Conditional expression",
        direction: "Direction",
        format: "Format",
        input: "Input",
        output: "Output",
        temperature: "Temperature",
        temperatureHint: "Mostly useful for LLM nodes",
        maxTokens: "Max tokens",
        timeoutMs: "Timeout (ms)",
        rawJsonConfig: "Raw JSON configuration",
        rawJsonConfigHint:
          "Useful for advanced settings or copy-pasting configuration.",
        saveJson: "Save JSON",
        revert: "Revert",
        database: "Database",
        file: "File",
        api: "API",
        json: "JSON",
        inputLabel: "Input",
        outputLabel: "Output",
        deleteNode: "Delete node",
        noConditionSet: "No condition set",
        trueLabel: "True",
        falseLabel: "False",
        noPromptConfigured: "No prompt configured",
        noToolsConfigured: "No tools configured",
        moreTools: "+ {{count}} more",
        toolsCount: "{{count}} tools",
        recordsCount: "{{count}} records",
        templateEmptyName: "Empty Recipe",
        templateEmptyDescription: "Start with a blank canvas",
        templateRagName: "RAG Pipeline",
        templateRagDescription: "Retrieval augmented generation workflow",
        templateChainName: "Prompt Chain",
        templateChainDescription: "Multi-step prompt sequence",
        templateAgentName: "Agent with Tools",
        templateAgentDescription: "AI agent with MCP tools",
        capabilitiesTitle: "Capabilities",
        capabilitiesDescription:
          "Capability surfaces currently exposed by the OS, grouped by product function rather than raw provider type.",
        capabilitiesCoverageLabel: "Coverage",
        capabilitiesCoverageHint: "Capability surfaces visible in Build.",
        capabilitiesOperationalLabel: "Ready now",
        capabilitiesOperationalHint: "Usable without workarounds.",
        capabilitiesEvolvingLabel: "Evolving",
        capabilitiesEvolvingHint: "Areas still partial or being refined.",
        capabilityStatusOperational: "Operational",
        capabilityStatusPartial: "Partial",
        capabilityStatusInProgress: "In progress",
        capabilitySurfaceLabel: "Surface",
        capabilityActionLabel: "Action",
        openSurfaceAction: "Open {{surface}}",
        capabilitiesJourneyDesignTitle: "Design",
        capabilitiesJourneyDesignDescription:
          "Design an agent, structure a spec, and reason about the workflow.",
        capabilitiesJourneyConnectTitle: "Connect",
        capabilitiesJourneyConnectDescription:
          "Connect tools, data, and reusable actions into the build flow.",
        capabilitiesJourneyShipTitle: "Ship",
        capabilitiesJourneyShipDescription:
          "Validate, plan, and apply with guardrails that stay visible in the product.",
        capabilitiesReadyTitle: "Ready now",
        capabilitiesReadyDescription:
          "What builders can use immediately in day-to-day work.",
        capabilitiesEvolvingTitle: "Still evolving",
        capabilitiesEvolvingDescription:
          "Useful areas, but still less complete or less stable than the rest of the workflow.",
        capabilitiesUseNowTitle: "How to use this page",
        capabilitiesUseNowDescription:
          "A quick reading guide so you know where to work depending on your intent.",
        capabilitiesUseNowStep1:
          "Start with Reasoning and Tools & MCP to shape the recipe and its integrations.",
        capabilitiesUseNowStep2:
          "Use Guardrails and Automation to prepare a plan, review it, and apply without losing context.",
        capabilitiesUseNowStep3:
          "Treat Data and Assist as valuable but still less mature than the core Build flow.",
        capabilitiesNextStepDescription:
          "The next product investments with the best payoff for this area.",
        capabilitiesNextStepData:
          "Make the Data layer more concrete with ingestion, exploration, and direct agent links.",
        capabilitiesNextStepAssist:
          "Make Assist more actionable with contextual suggestions and clearer handoffs to Calisto.",
        capabilityReasoningTitle: "Reasoning",
        capabilityReasoningDescription:
          "Foundation models and prompt orchestration surfaces.",
        capabilityReasoningItem1: "LLM nodes",
        capabilityReasoningItem2: "Prompt-driven agents",
        capabilityReasoningItem3: "Streaming responses",
        capabilityToolsTitle: "Tools & MCP",
        capabilityToolsDescription:
          "External tools exposed through MCP or direct integrations.",
        capabilityToolsItem1: "MCP nodes",
        capabilityToolsItem2: "Tool call rendering",
        capabilityToolsItem3: "Command palette entry points",
        capabilityDataTitle: "Data",
        capabilityDataDescription:
          "Sources and retrieval surfaces for Build and Run contexts.",
        capabilityDataItem1: "Data nodes",
        capabilityDataItem2: "Workspace scoping",
        capabilityDataItem3: "Ingestion plane still to strengthen",
        capabilityGuardrailsTitle: "Guardrails",
        capabilityGuardrailsDescription:
          "Validation, review, and publication controls before apply.",
        capabilityGuardrailsItem1: "Spec validation",
        capabilityGuardrailsItem2: "Plan and diff generation",
        capabilityGuardrailsItem3: "Approvals before apply",
        capabilityAutomationTitle: "Automation",
        capabilityAutomationDescription:
          "Reusable flows and blueprint mutations initiated by Calisto.",
        capabilityAutomationItem1: "Canvas actions",
        capabilityAutomationItem2: "Apply / reject flow",
        capabilityAutomationItem3: "Embedded command workflow",
        capabilityAssistTitle: "Assist",
        capabilityAssistDescription:
          "Contextual guidance embedded in Build and eventually Run.",
        capabilityAssistItem1: "Inspection suggestions",
        capabilityAssistItem2: "Node-focused prompts",
        capabilityAssistItem3: "Action summaries",
        dataPlaneTitle: "Data plane",
        dataPlaneDescription:
          "Organize data surfaces, workspace memory, and retrieval entry points around the current agent.",
        dataCoverageLabel: "Coverage",
        dataCoverageHint: "Data surfaces mapped inside Build.",
        dataAvailableLabel: "Available",
        dataAvailableHint: "Surfaces already usable in the product.",
        dataNeedsSetupLabel: "Needs setup",
        dataNeedsSetupHint:
          "Surfaces still requiring ingestion or integration work.",
        dataStatusReady: "Ready",
        dataStatusRuntime: "Runtime",
        dataStatusPartial: "Partial",
        dataStatusNeedsIngestion: "Needs ingestion",
        dataJourneyScopeTitle: "Scope",
        dataJourneyScopeDescription:
          "Start by understanding which organization, agent, and workspace bound the data context.",
        dataJourneyConnectTitle: "Connect",
        dataJourneyConnectDescription:
          "Then connect structured sources, APIs, and the memory that matters to the build.",
        dataJourneyRetrieveTitle: "Retrieve",
        dataJourneyRetrieveDescription:
          "Finally shape retrieval paths that stay readable for Calisto and for recipes.",
        dataAvailableNowTitle: "Available now",
        dataAvailableNowDescription:
          "Surfaces already visible or directly actionable in the current workflow.",
        dataNeedsSetupTitle: "Still needs setup",
        dataNeedsSetupDescription:
          "Important surfaces, but still needing ingestion, inventory, or product-level binding.",
        dataScopeTitle: "Current scope",
        dataScopeDescription:
          "Useful data always depends on the active tenant, agent, and workspace.",
        dataScopeOrganization: "Organization: {{value}}",
        dataScopeDeployment: "Agent: {{value}}",
        dataScopeWorkspace: "Workspace: {{value}}",
        dataNextStepDescription:
          "What would make this page immediately more useful to builders.",
        dataNextStepInventory:
          "Expose a real inventory of connected sources instead of only theoretical categories.",
        dataNextStepBindings:
          "Show the real bindings between recipes, workspace memory, and retrieval surfaces.",
        dataSurfaceStructuredTitle: "Structured sources",
        dataSurfaceStructuredDescription:
          "Databases, warehouses, and tabular business systems.",
        dataSurfaceStructuredDetail1: "Relational and tabular sources",
        dataSurfaceStructuredDetail2: "Good fit for explicit data nodes",
        dataSurfaceStructuredDetail3:
          "Should connect directly to the target agent",
        dataSurfaceDocumentsTitle: "Document knowledge",
        dataSurfaceDocumentsDescription:
          "Files, manuals, contracts, and long-form internal knowledge.",
        dataSurfaceDocumentsDetail1: "Needs clear ingestion workflows",
        dataSurfaceDocumentsDetail2:
          "Should expose indexing and freshness clearly",
        dataSurfaceDocumentsDetail3:
          "Still less concrete than structured sources",
        dataSurfaceApisTitle: "Operational APIs",
        dataSurfaceApisDescription:
          "External systems exposed through APIs or MCP servers.",
        dataSurfaceApisDetail1: "Already partially present through MCP",
        dataSurfaceApisDetail2: "Still needs visible inventory and bindings",
        dataSurfaceApisDetail3: "Useful surface for action-oriented recipes",
        dataSurfaceWorkspaceTitle: "Workspace memory",
        dataSurfaceWorkspaceDescription:
          "Short-term context scoped to workspace and agent.",
        dataSurfaceWorkspaceDetail1:
          "Available during execution and assisted conversations",
        dataSurfaceWorkspaceDetail2:
          "Useful for keeping local artifacts and context",
        dataSurfaceWorkspaceDetail3:
          "Should connect more clearly to recipes and runs",
        implementationNextStep: "Implementation next step",
        observeTitle: "Observe",
        clearFocus: "Clear focus",
        noEnv: "No env",
        observeDescription:
          "Operational signals for the current agent, with focused inspection when Calisto routes you to a specific blueprint run.",
        observeRuntimeStatus: "Runtime status: {{value}}",
        observeTotalTracked: "Total tracked: {{count}}",
        observeLastCheck: "Last check: {{value}}",
        observeRunId: "Run ID: {{value}}",
        observeSuggestedActions: "Suggested actions",
        observeStableBaseline: "Stable baseline",
        observeCandidate: "Candidate",
        observeRegressionDiff: "Regression diff",
        observeNoFocusedRun:
          "No focused run yet. Open the latest apply or test run, or go back to Calisto to request a new inspection.",
        observeOpenLatestApply: "Open latest apply",
        observeOpenLatestTest: "Open latest test",
        observeNoRuns: "No runs available yet.",
        selectOrgDeployment:
          "Select an organization and agent to inspect observability signals.",
        blueprintFocus: "Blueprint focus",
        focusedInspection: "Focused inspection",
        currentMetaRecette:
          "Current meta-recette and recent apply/test activity",
        detailsForRun: "Details for the run Calisto asked you to inspect",
        openBlueprint: "Open blueprint",
        openPublishFlow: "Open publish flow",
        openInCalisto: "Open in Calisto",
        runInChat: "Run in chat",
        noMetaRecette:
          "No meta-recette resolved for the current agent yet.",
        recentApplyRuns: "Recent apply runs",
        recentTestRuns: "Recent test runs",
        components: "Components",
        searchComponents: "Search...",
        dragOrClick: "Drag a component onto the canvas or click to add it",
        createRecipe: "Create recipe",
        createRecipeDescription:
          "Create a new meta-recette from a template or start with a blank canvas.",
        recipeName: "Recipe name",
        recipeDescriptionOptional: "Description (optional)",
        chooseTemplate: "Choose a template",
        cancel: "Cancel",
        creating: "Creating...",
        createRecipeAction: "Create recipe",
        deployHealth: "Health",
        deployUptime: "Uptime",
        deployActiveExecutions: "Active executions",
        deployTotalExecutions: "Total executions",
        deployLastCheck: "Last health check",
        restart: "Restart",
        deployRedeploy: "Redeploy",
        deployRedeployInProgress: "Redeploying…",
        deployRedeployConfirm:
          "Redeploy this agent? It will be temporarily unavailable and the runtime configuration will be reloaded.",
        deployRedeploySuccess: "Reagent started.",
        deployRedeployError: "Unable to redeploy.",
        deployDangerZoneTitle: "Danger zone",
        deployDangerZoneDescription:
          "Deleting permanently removes this agent, its recipes, its spaces and their conversations.",
        deployDeleteAction: "Delete this agent",
        deployDeleteConfirm:
          "Permanently delete the agent “{{name}}”? This action cannot be undone.",
        deployDeleteSuccess: "Agent deleted.",
        deployDeleteError: "Unable to delete this agent.",
        stop: "Stop",
        promoteTo: "Promote {{recipe}} to {{target}}?",
        promoteDescription:
          "You are about to promote this recipe from {{source}} to {{target}}.",
        version: "Version",
        addedNodes: "Added nodes",
        removedNodes: "Removed nodes",
        modifiedNodes: "Modified nodes",
        noChangesDetected: "No changes detected",
        dryRunMode: "Simulation mode (do not apply changes)",
        promoting: "Promotion in progress...",
        simulate: "Simulate",
        promote: "Promote",
        pipelineTitle: "Agent Pipeline",
        deployWorkspaceTitle: "Agent runtime",
        deployWorkspaceDescription:
          "Configure the agent runtime layers: LLM, MCP, internal services, and variables.",
        deployTabRelease: "Release",
        deployTabLlm: "LLM",
        deployTabMcp: "MCP",
        deployTabSkills: "Skills",
        deployTabInternal: "Internal",
        deployTabAccess: "Access",
        deployTabVariables: "Variables",
        deployRuntimeLoading: "Loading runtime configuration…",
        deployRuntimeSummaryTitle: "Runtime configuration",
        deployRuntimeSummaryDescription:
          "Manage the agent runtime surfaces here without leaving the Build workflow.",
        deployRuntimeManagedMode: "Managed model",
        deployRuntimeCustomMode: "Custom providers",
        deployRuntimeNotConfigured: "Not configured",
        deployRuntimeProvidersCount: "LLM providers",
        deployRuntimeProvidersSummary: "{{count}} configured provider",
        deployRuntimeProvidersSummary_other: "{{count}} configured providers",
        deployRuntimeDefaultModel: "Active model",
        deployRuntimeHostedBadge: "AgentMaurice",
        deployRuntimeHostedCreditsHint:
          "Indicative: ~{{count}} credits per 1k tokens.",
        deployRuntimeCreditsUnit: "credits",
        deployRuntimeHostedPricingHint:
          "Indicative: input {{input}} / output {{output}} {{currency}} per 1k tokens.",
        deployRuntimeSystemPrompt: "System prompt",
        deployRuntimeSystemPromptSet:
          "A system prompt is already configured for this agent.",
        deployRuntimeSystemPromptMissing: "No system prompt configured.",
        deployRuntimeMcpDescription:
          "Prepares manual MCP, registry, and sidecar configuration for this agent.",
        deployRuntimeMcpServers: "servers",
        deployRuntimeManualServers: "Manual servers",
        deployRuntimeRegistryServers: "Registry sidecars",
        deployRuntimeSkillsAttached: "skills attached to this agent",
        deployRuntimeSkillsPanelDescription:
          "Manage the skills actually installed on this agent and the available skills catalog.",
        deployRuntimeSkillsCatalogTitle: "Skills catalog",
        deployRuntimeSkillsCatalogDescription:
          "Install skills from the real catalog exposed by chatserver.",
        deployRuntimeSkillsRegistryTitle: "Skills catalog",
        deployRuntimeSkillsRegistryDescription:
          "Install the skills this agent needs from the catalog.",
        deployRuntimeSkillsSaveSelection: "Save selection",
        deployRuntimeSkillsSearchPlaceholder:
          "Search skills by name, repository, or tag",
        deployRuntimeSkillsNoSelection: "No skills attached",
        deployRuntimeSkillsNoSelectionDescription:
          "Select skills from the registry to make them available in this agent.",
        deployRuntimeSkillsNoCatalog: "No skills available",
        deployRuntimeSkillsNoCatalogDescription:
          "Add skills to the catalog before installing them on this agent.",
        deployRuntimeSkillsNoRegistry: "No skills available",
        deployRuntimeSkillsNoRegistryDescription:
          "Add skills to the catalog before installing them here.",
        deployRuntimeSkillsConfigRequired: "Config required",
        deployRuntimeSkillsInstall: "Install",
        deployRuntimeSkillsUninstall: "Uninstall",
        deployRuntimeSkillsInstalled: "Runtime installed",
        deployRuntimeSkillsFilesCount: "{{count}} file(s)",
        deployRuntimeSkillsToolsCount: "{{count}} MCP tool(s)",
        deployRuntimeSkillsInstallations: "Installations",
        deployRuntimeSkillsInstallationsTitle: "Catalog installations",
        deployRuntimeSkillsInstallationsDescription:
          "These rows come from SkillInstallation and show packages installed for this agent.",
        deployRuntimeSkillsNoInstallations: "No catalog installation.",
        deployRuntimeSkillsNoInstallationsDescription:
          "Installations will appear here after adding a skill from the real catalog.",
        deployRuntimeSkillsCatalogCount: "Catalog",
        deployRuntimeSkillsInstalledTitle: "Real runtime state",
        deployRuntimeSkillsInstalledDescription:
          "This list comes from chatserver and reflects the skills effectively available on the agent.",
        deployRuntimeSkillsNoInstalled: "No skill installed in the runtime.",
        deployRuntimeSkillsNoInstalledDescription:
          "Install a skill from the real catalog or import a SKILL.md into this agent.",
        deployRuntimeSkillsVerified: "Verified",
        deployRuntimeSkillsInactive: "Inactive",
        deployRuntimeSkillsNotInstalled: "Not installed",
        deployRuntimeSkillsInstallSuccess:
          "Skill {{skillName}} installed on the agent.",
        deployRuntimeSkillsInstallError:
          "Failed to install skill {{skillName}}.",
        deployRuntimeSkillsUninstallSuccess:
          "Skill {{skillName}} uninstalled from the agent.",
        deployRuntimeSkillsUninstallError:
          "Failed to uninstall skill {{skillName}}.",
        deployRuntimeSkillsUninstallConfirm:
          "Uninstall skill {{skillName}} from this agent?",
        deployRuntimeSkillsGitHubImportTitle: "Install from GitHub",
        deployRuntimeSkillsGitHubImportDescription:
          "Paste a GitHub repository or folder URL containing SKILL.md. Markdown files from that folder are imported into this agent.",
        deployRuntimeSkillsGitHubUrlPlaceholder:
          "https://github.com/owner/repo/tree/main/skills/my-skill",
        deployRuntimeSkillsGitHubBranchPlaceholder: "Branch (optional)",
        deployRuntimeSkillsGitHubPathPlaceholder: "Folder (optional)",
        deployRuntimeSkillsGitHubIdPlaceholder: "Skill ID (optional)",
        deployRuntimeSkillsGitHubOverwrite: "Replace if the skill already exists",
        deployRuntimeSkillsGitHubImport: "Import",
        deployRuntimeSkillsGitHubImporting: "Importing…",
        deployRuntimeSkillsGitHubUrlRequired:
          "Enter a GitHub URL containing SKILL.md.",
        deployRuntimeSkillsGitHubImportSuccess:
          "Skill {{skillName}} imported from GitHub.",
        deployRuntimeSkillsGitHubImportError:
          "Failed to import this skill from GitHub.",
        deployRuntimeSkillsSelectionUpdated: "Skills selection updated.",
        deployRuntimeSkillsSelectionError: "Failed to update skills selection.",
        deployRuntimeSkillsFootnoteTitle: "When to use skills",
        deployRuntimeSkillsFootnoteDescription:
          "Use skills to expose specialized build workflows without overloading the agent standard recipes.",
        deployRuntimeAccessPanelDescription:
          "Manage agent access surfaces: API keys and authentication gateway configuration.",
        deployRuntimeApiKeysTitle: "Agent keys",
        deployRuntimeApiKeysDescription:
          "Create, regenerate, and organize sk_maurice_ keys used by LocalMaurice, X-API-Key, HTTP recipes, and runtimes.",
        agentControlTitle: "Agent-native control",
        agentControlDescription: "Supervise code-agent access, human Agent Spec approvals, and the associated temporary keys.",
        agentAccessKindAgent: "Code agent",
        agentAccessKindCli: "MauriceCLI",
        agentAccessTitle: "Code-agent access",
        agentAccessDescription:
          "Bootstrap links issued to code agents and MauriceCLI. Revoking a link also revokes its temporary key.",
        agentAccessNoActiveLinks: "No active bootstrap link.",
        agentAccessRevokedLinks: "Revoked links",
        agentControlSeeAlso: "Related views",
        agentControlOpenAgentSpec: "Plan and approval → Agent Spec",
        agentControlOpenObserve: "Apply and verification → Agent Spec",
        agentDiscoverySupervisionTitle: "Guided agent-native control",
        agentDiscoverySupervisionDescription:
          "Track bootstrap links, issued keys, and human approvals for immutable Agent Spec plans.",
        agentDiscoveryCurrentPlanTitle: "Current Agent Spec plan",
        agentDiscoveryNoMetaRecette: "No Agent Spec is linked to this agent.",
        agentDiscoveryRecipeSpecDriftTitle: "Agent Spec/runtime drift",
        agentDiscoveryRecipeSpecDriftDescription:
          "The Agent Spec remains the source of truth. Unmanaged runtime Workflows and MiniApps must be adopted explicitly.",
        agentDiscoveryPlanActions: "Actions",
        agentDiscoveryApproval: "Approval",
        agentDiscoveryPlanHash: "Plan hash",
        agentDiscoveryApprovePlan: "Approve plan",
        agentDiscoveryRejectPlan: "Reject",
        agentDiscoveryApproveDialogTitle: "Approve this plan?",
        agentDiscoveryApproveDialogDescription:
          "Guided mode will only be able to apply this plan with the approved hash.",
        agentDiscoveryRejectDialogTitle: "Reject this plan?",
        agentDiscoveryRejectDialogDescription:
          "The current plan will be marked as rejected and cannot be applied in guided mode.",
        agentDiscoveryDecisionCommentLabel: "Optional comment",
        agentDiscoveryDecisionCommentPlaceholder:
          "Decision context, accepted risk, or rejection reason",
        agentDiscoveryNoCurrentPlan: "No current plan to approve.",
        agentDiscoveryApprovalsTitle: "Recent approvals",
        agentDiscoveryApprovalsDescription:
          "Compact history of human approvals bound to the exact hash of an immutable Agent Spec plan.",
        agentDiscoveryUnknownApprover: "User",
        agentDiscoveryNoApprovals: "No recent approval.",
        agentDiscoveryBootstrapLinksTitle: "Agent bootstrap links",
        agentDiscoveryBootstrapLinksDescription:
          "Consumed links can also revoke the temporary key issued by bootstrap.",
        agentDiscoveryNoBootstrapLinks: "No bootstrap link generated.",
        agentDiscoveryPlanApproved: "Plan approved",
        agentDiscoveryPlanApproveError: "Could not approve the plan",
        agentDiscoveryPlanRejected: "Plan rejected",
        agentDiscoveryPlanRejectError: "Could not reject the plan",
        agentDiscoveryBootstrapRevoked: "Agent access revoked",
        agentDiscoveryBootstrapRevokeError: "Could not revoke this access",
        cliBootstrapLinksTitle: "MauriceCLI bootstrap links",
        cliBootstrapLinksDescription:
          "These links connect MauriceCLI to a local project and can revoke the temporary bootstrap key.",
        cliBootstrapNoLinks: "No MauriceCLI bootstrap link generated.",
        cliBootstrapRevoked: "MauriceCLI access revoked",
        cliBootstrapRevokeError: "Could not revoke this MauriceCLI access",
        agentDiscoveryRecentRunsTitle: "Latest apply/test/reconcile",
        agentDiscoveryRecentRunsDescription:
          "Compact view of Agent Spec apply, test, and verification runs linked to agent-native control.",
        agentDiscoveryApplyRuns: "Apply / reconcile",
        agentDiscoveryTestRuns: "Tests",
        agentDiscoveryNoApplyRuns: "No recent apply/reconcile run.",
        agentDiscoveryNoTestRuns: "No recent test run.",
        agentDiscoveryRunSync: "Sync",
        agentDiscoveryStableBaseline: "Stable baseline",
        agentDiscoveryTestCases: "Cases",
        agentDiscoveryTestFailed: "failed",
        agentDiscoveryTestSkipped: "skipped",
        agentDiscoveryTestDuration: "Duration",
        agentDiscoveryTestTokens: "Tokens",
        agentDiscoveryTestCost: "Estimated cost",
        agentDiscoveryTestExecutions: "Executions",
        agentDiscoveryTestTraces: "Traces",
        agentDiscoveryTestErrors: "Errors",
        agentDiscoveryIntegrationSurfacesTitle: "Agent-native integration inventory",
        agentDiscoveryIntegrationSurfacesDescription:
          "Summary of the surfaces the agent can discover through External Inception and the OS/HTTP-only boundaries.",
        agentDiscoveryNoIntegrationSurfaces: "No integration inventory available.",
        deployRuntimeApiKeysCount: "Active keys",
        deployRuntimeApiKeysExpiringSoon: "Expiring soon",
        deployRuntimeApiKeysNeverExpire: "No expiration",
        deployRuntimeApiKeyCreate: "Create key",
        deployRuntimeApiKeyCreateDescription:
          "Define a name, description, and lifetime for this new key.",
        deployRuntimeApiKeyEdit: "Edit key",
        deployRuntimeApiKeyEditDescription:
          "Adjust the name and description of this key without changing its technical scope.",
        deployRuntimeApiKeyDelete: "Delete key",
        deployRuntimeApiKeyDeleteDescription:
          "Key {{name}} will be removed immediately. Clients using it will lose access.",
        deployRuntimeApiKeyName: "Name",
        deployRuntimeApiKeyNamePlaceholder: "Integration CLI",
        deployRuntimeApiKeyDescriptionLabel: "Description",
        deployRuntimeApiKeyDescriptionPlaceholder:
          "Explain who uses this key and in which context.",
        deployRuntimeApiKeyExpiration: "Expiration",
        deployRuntimeApiKeyExpiration30Days: "30 days",
        deployRuntimeApiKeyExpiration90Days: "90 days",
        deployRuntimeApiKeyExpiration1Year: "1 year",
        deployRuntimeApiKeyExpirationNever: "Never",
        deployRuntimeApiKeyExpirationCustom: "Custom date",
        deployRuntimeApiKeyCustomExpiration: "Expiration date",
        deployRuntimeApiKeyCreated: "Key created.",
        deployRuntimeApiKeyCreateError: "Failed to create key.",
        deployRuntimeApiKeyUpdated: "Key updated.",
        deployRuntimeApiKeyUpdateError: "Failed to update key.",
        deployRuntimeApiKeyDeleted: "Key deleted.",
        deployRuntimeApiKeyDeleteError: "Failed to delete key.",
        deployRuntimeApiKeyRegenerated: "Key regenerated.",
        deployRuntimeApiKeyRegenerate: "Regenerate",
        deployRuntimeApiKeyRegenerateError: "Failed to regenerate key.",
        deployRuntimeApiKeyCopied: "Key copied.",
        deployRuntimeApiKeyCopyError: "Failed to copy key.",
        deployRuntimeApiKeyNoKeys: "No additional keys",
        deployRuntimeApiKeyNoKeysDescription:
          "Create dedicated keys for integrations instead of sharing one primary key across multiple uses.",
        deployRuntimeDeploymentMembersTitle: "Agent users",
        deployRuntimeDeploymentMembersDescription:
          "Assign organization members who can use this agent.",
        deployRuntimeDeploymentMemberSelect: "Choose a member",
        deployRuntimeDeploymentMemberAssign: "Assign",
        deployRuntimeDeploymentMemberAssigned: "User assigned to agent.",
        deployRuntimeDeploymentMemberAssignError:
          "Failed to assign this user to the agent.",
        deployRuntimeDeploymentMemberRemoved: "Assignment removed.",
        deployRuntimeDeploymentMemberRemoveError:
          "Failed to remove this assignment.",
        deployRuntimeDeploymentMembersEmpty:
          "No users assigned. The agent remains available to organization members until an explicit assignment exists.",
        deployRuntimeDeploymentMemberOperator: "Operator",
        deployRuntimeDeploymentMemberViewer: "Read-only",
        deployRuntimeDeploymentMemberUser: "User",
        deployRuntimeDeploymentMemberRole: "Role",
        deployRuntimeApiKeyRevealTitle: "Store this key now",
        deployRuntimeApiKeyRevealDescription:
          "The full value is only shown after creation or regeneration. Copy it now if you need it.",
        deployRuntimeApiKeyCopy: "Copy key",
        deployRuntimeApiKeyCreatedAt: "Created",
        deployRuntimeApiKeyExpiresAt: "Expires",
        deployRuntimeApiKeyNeverExpiresLabel: "Never expires",
        deployRuntimeApiKeyExpired: "Expired",
        deployRuntimeApiKeyExpiringSoon: "Expiring soon",
        deployRuntimeApiKeyActive: "Active",
        deployRuntimeAuthConnectorTitle: "Auth connector",
        deployRuntimeAuthConnectorDescription:
          "Configure the agent authentication gateway from a JSON spec you can validate before saving.",
        deployRuntimeAuthConnectorStatus: "Status",
        deployRuntimeAuthConnectorConfigured: "Configured",
        deployRuntimeAuthConnectorNotConfigured: "Not configured",
        deployRuntimeAuthConnectorVersion: "Version",
        deployRuntimeAuthConnectorPresets: "Presets",
        deployRuntimeAuthConnectorSelectPreset: "Choose a preset",
        deployRuntimeAuthConnectorApplyPreset: "Apply preset",
        deployRuntimeAuthConnectorSpec: "JSON spec",
        deployRuntimeAuthConnectorValid: "Spec is valid",
        deployRuntimeAuthConnectorInvalid: "Spec is invalid",
        deployRuntimeAuthConnectorErrors: "Errors",
        deployRuntimeAuthConnectorWarnings: "Warnings",
        deployRuntimeAuthConnectorPresetApplied: "Preset applied.",
        deployRuntimeAuthConnectorSaved: "Auth connector saved.",
        deployRuntimeAuthConnectorSaveError: "Failed to save auth connector.",
        deployRuntimeAuthConnectorDeleted: "Auth connector deleted.",
        deployRuntimeAuthConnectorDeleteError:
          "Failed to delete auth connector.",
        deployRuntimeAuthConnectorValidateError:
          "Failed to validate auth connector spec.",
        deployRuntimeAuthConnectorMappingTitle: "Lookup mappings",
        deployRuntimeAuthConnectorMappingDescription:
          "Map external identities to resolved organizations and agents for this gateway.",
        deployRuntimeAuthConnectorFieldIssuer: "Issuer",
        deployRuntimeAuthConnectorFieldExternalUserId: "External user ID",
        deployRuntimeAuthConnectorFieldEmail: "Email",
        deployRuntimeAuthConnectorFieldRoles: "Roles (comma separated)",
        deployRuntimeAuthConnectorFieldResolvedOrg: "Resolved organization",
        deployRuntimeAuthConnectorFieldResolvedDeployment:
          "Resolved agent",
        deployRuntimeAuthConnectorFieldMetadata: "Metadata JSON",
        deployRuntimeAuthConnectorMappingResolvedTarget: "Resolved target",
        deployRuntimeAuthConnectorSaveMapping: "Save mapping",
        deployRuntimeAuthConnectorMappingSaved: "Mapping saved.",
        deployRuntimeAuthConnectorMappingSaveError: "Failed to save mapping.",
        deployRuntimeAuthConnectorMappingDeleted: "Mapping deleted.",
        deployRuntimeAuthConnectorMappingDeleteError:
          "Failed to delete mapping.",
        deployRuntimeAuthConnectorNoMappings: "No mappings configured",
        deployRuntimeAuthConnectorBulkTitle: "Bulk import mappings",
        deployRuntimeAuthConnectorBulkDescription:
          "Import a JSON list of mappings to accelerate gateway bootstrap.",
        deployRuntimeAuthConnectorBulkImport: "Import mappings",
        deployRuntimeAuthConnectorBulkSuccess: "Mappings imported.",
        deployRuntimeAuthConnectorBulkError: "Failed to import bulk mappings.",
        deployRuntimeAuthConnectorGatewayTitle: "Next.js gateway",
        deployRuntimeAuthConnectorGatewayDescription:
          "Generate an archive ready to integrate on the frontend from the current spec.",
        deployRuntimeAuthConnectorGatewayHint:
          "Download the ZIP only when the spec and mappings are coherent.",
        deployRuntimeAuthConnectorDownloadGateway: "Download ZIP",
        deployRuntimeAuthConnectorGatewayDownloaded: "Gateway downloaded.",
        deployRuntimeAuthConnectorGatewayDownloadError:
          "Failed to download gateway.",
        deployRuntimeActions: "Actions",
        deployRuntimeOAuth: "OAuth & doctor",
        deployRuntimeOAuthDescription:
          "OAuth connect/disconnect and SSE doctor flows will be wired here with the same lifecycle as the dashboard.",
        deployRuntimeInternalDescription:
          "Prepares agent internal services: artifact storage, document search, business memory, multimodal processing, messaging, and expert control.",
        deployRuntimeUnsavedChanges: "Unsaved changes",
        deployRuntimeSavedState: "Saved",
        deployRuntimeResetDraft: "Discard changes",
        deployRuntimeSaving: "Saving…",
        deployRuntimeStorage: "Storage",
        deployRuntimeCompanyMemory: "Company memory",
        deployRuntimeEnabled: "Enabled",
        deployRuntimeDisabled: "Disabled",
        deployRuntimeLlmPanelDescription:
          "Choose an LLM profile, configure organization providers, and adjust the agent system prompt.",
        deployRuntimeAddProvider: "Add provider",
        deployRuntimeProvidersList: "Configured providers",
        deployRuntimeProvidersListDescription:
          "Manage the LLM endpoints used by this agent when you leave managed mode.",
        deployRuntimeNoProviders: "No organization provider configured.",
        deployRuntimeDefault: "Default",
        deployRuntimeModelMissing: "No model configured",
        deployRuntimeSetDefault: "Set agent profile",
        deployRuntimeCreateProvider: "Create provider",
        deployRuntimeEditProvider: "Edit provider",
        deployRuntimeProviderDialogDescription:
          "Provide the provider, endpoint, and model so it can be used by this agent.",
        deployRuntimeProviderName: "Provider name",
        deployRuntimeProviderType: "Provider type",
        deployRuntimeProviderModel: "Model",
        deployRuntimeProviderUrl: "URL",
        deployRuntimeProviderApiKey: "API key",
        deployRuntimeProviderApiKeyOptional:
          "Leave empty to keep the existing key",
        deployRuntimeProviderDescription:
          "Add a short description for this provider",
        deployRuntimeMakeDefault: "Use this provider by default",
        deployRuntimeProviderNameRequired: "Provider name is required.",
        deployRuntimeProviderCreated: "Provider created.",
        deployRuntimeProviderCreateError: "Failed to create provider.",
        deployRuntimeProviderUpdated: "Provider updated.",
        deployRuntimeProviderUpdateError: "Failed to update provider.",
        deployRuntimeProviderDeleted: "Provider deleted.",
        deployRuntimeProviderDeleteError: "Failed to delete provider.",
        deployRuntimeProviderDefaultUpdated: "Default provider updated.",
        deployRuntimeProviderDefaultError:
          "Failed to update the default provider.",
        deployRuntimeRegistryHint:
          "Use an organization profile or add a provider endpoint.",
        deployRuntimeLlmProfileBadge: "LLM profile",
        deployRuntimeDeploymentProfile: "Agent LLM profile",
        deployRuntimeSelectModel: "Select a profile model",
        deployRuntimeNoManagedModel: "No profile model",
        deployRuntimeSaveModel: "Save model",
        deployRuntimeModelSaved: "Model saved.",
        deployRuntimeModelSaveError: "Failed to save the model.",
        deployRuntimeSystemPromptPlaceholder:
          "Define the agent-level system instructions here.",
        deployRuntimeSystemPromptSaved: "System prompt saved.",
        deployRuntimeSystemPromptSaveError: "Failed to save the system prompt.",
        deployRuntimeEmbeddingTitle: "Embeddings",
        deployRuntimeEmbeddingDescription:
          "Configure the embedding providers used for search, memory, and vector indexes.",
        deployRuntimeAddEmbedding: "Add embedding",
        deployRuntimeNoEmbeddings: "No embedding provider configured.",
        deployRuntimeCreateEmbedding: "Create embedding provider",
        deployRuntimeEditEmbedding: "Edit embedding provider",
        deployRuntimeEmbeddingDialogDescription:
          "Define the provider, model, and endpoint used for agent embeddings.",
        deployRuntimeEmbeddingName: "Name",
        deployRuntimeEmbeddingProvider: "Provider",
        deployRuntimeEmbeddingModel: "Model",
        deployRuntimeEmbeddingUrl: "URL",
        deployRuntimeEmbeddingApiKey: "API key",
        deployRuntimeEmbeddingApiKeyOptional:
          "Leave empty to keep the existing key",
        deployRuntimeEmbeddingDescriptionLabel: "Description",
        deployRuntimeEmbeddingDescriptionPlaceholder:
          "Add a short description for this embedding provider.",
        deployRuntimeEmbeddingNameRequired:
          "Embedding provider name is required.",
        deployRuntimeEmbeddingCreated: "Embedding provider created.",
        deployRuntimeEmbeddingCreateError:
          "Failed to create embedding provider.",
        deployRuntimeEmbeddingUpdated: "Embedding provider updated.",
        deployRuntimeEmbeddingUpdateError:
          "Failed to update embedding provider.",
        deployRuntimeEmbeddingDeleted: "Embedding provider deleted.",
        deployRuntimeEmbeddingDeleteError:
          "Failed to delete embedding provider.",
        deployRuntimeProxyTitle: "Network proxy",
        deployRuntimeProxyDescription:
          "Route LLM API calls through a corporate proxy or an inspection tool.",
        deployRuntimeProxyConfigured: "Configured",
        deployRuntimeProxyNotConfigured: "Not configured",
        deployRuntimeProxyHttps: "HTTPS proxy",
        deployRuntimeProxyHttp: "HTTP proxy",
        deployRuntimeProxyNoProxy: "No proxy",
        deployRuntimeProxySecretPlaceholder:
          "••••••••  (leave empty to keep the current value)",
        deployRuntimeProxyEnvTitle: "Injected variables",
        deployRuntimeProxyTlsTitle: "TLS note",
        deployRuntimeProxyTlsDescription:
          "For HTTPS inspection, add the proxy CA certificate to the system trust store or target image.",
        deployRuntimeProxySave: "Save proxy",
        deployRuntimeProxySaved:
          "Proxy configuration saved. A restart may be required.",
        deployRuntimeProxySaveError: "Failed to save proxy configuration.",
        deployRuntimeProxyVariableDescription:
          "Network proxy configuration for LLM API calls.",
        deployRuntimeStorageCardDescription:
          "Selects where the runtime keeps generated files, imports, exports, and long-lived artifacts. Keep it disabled when the agent does not need persistent files.",
        deployRuntimeStorageDisabled: "Disabled",
        deployRuntimeStorageLocalS3: "Local S3 storage",
        deployRuntimeStorageS3Compatible: "S3 compatible",
        deployRuntimeStorageAgentMauriceCdn: "AgentMaurice CDN",
        deployRuntimeStorageUnavailable: "unavailable",
        deployRuntimeStorageUnavailableMessage:
          "This provider is not available on this runtime. Select local/S3-compatible storage to save.",
        deployRuntimeConfigureS3: "Configure S3",
        deployRuntimeDocstoreCardDescription:
          "Adds an internal document layer to upload, index, and retrieve files for workflows that work with contracts, manuals, or knowledge bases.",
        deployRuntimeCompanyMemoryCardDescription:
          "Exposes structured business memory to recipes and tools so facts, decisions, and organization context survive across sessions.",
        deployRuntimeBrain: "Brain",
        deployRuntimeBrainCardDescription:
          "Enables the local Brain MCP to query a dedicated DuckDB store when a agent needs to reason over local data without an external service.",
        deployRuntimeMemory: "Memory",
        deployRuntimeMemoryCardDescription:
          "Enables the local Memory MCP to keep notes, state, and operational memories scoped to this machine or agent.",
        deployRuntimeCompanyMemoryReadyDocker:
          "Company Memory is active through this agent Docker sidecar.",
        deployRuntimeMultimodalCardDescription:
          "Lets recipes and chat use specialized profiles for image analysis, PDF reading, OCR extraction, audio transcription, or media generation.",
        deployRuntimeMessagingCardDescription:
          "Opens the agent to external conversation channels such as Slack, Telegram, WhatsApp, Discord, Google Chat, or Signal, with accounts bound to API keys.",
        accessPageTitle: "Agent access",
        accessPageDescription:
          "Manage API keys, user assignments, auth connector, and identity mappings for this agent.",
        openAccessPage: "Open Access",
        snapshotTitle: "Agent Import / Export",
        snapshotDescription:
          "Transfer agent settings across instances using an encrypted snapshot.",
        snapshotSummaryValue: "Encrypted snapshot",
        openImportExportPage: "Open Import / Export",
        snapshotExportTitle: "Export snapshot",
        snapshotExportDescription:
          "Generate an encrypted JSON archive containing the agent configuration.",
        snapshotImportTitle: "Import snapshot",
        snapshotImportDescription:
          "Import a JSON snapshot by creating or overwriting a agent.",
        snapshotPassphrase: "Passphrase",
        snapshotPassphrasePlaceholder: "Enter a strong passphrase",
        snapshotIncludeRegistryDefinitions:
          "Include registry definitions for auto-create during import",
        snapshotExportAction: "Export snapshot",
        snapshotExportSuccess: "Agent snapshot exported.",
        snapshotExportError: "Failed to export agent snapshot.",
        snapshotImportFromFile: "From file",
        snapshotImportFromJson: "From JSON",
        snapshotSelectedFile: "Selected file",
        snapshotJson: "Snapshot JSON",
        snapshotJsonPlaceholder: "Paste the exported JSON envelope here.",
        snapshotImportMode: "Import mode",
        snapshotImportCreate: "Create a new agent",
        snapshotImportOverwrite: "Overwrite an existing agent",
        snapshotTargetDeployment: "Target agent",
        snapshotDryRun: "Dry-run without applying",
        snapshotLaunchAfterImport: "Launch after import",
        snapshotRedeployAfterImport: "Redeploy after import",
        snapshotAllowRegistryAutoCreate: "Allow registry auto-create",
        snapshotDryRunAction: "Test import",
        snapshotImportAction: "Import snapshot",
        snapshotImportResult: "Import result",
        snapshotImportDryRunSuccess: "Dry-run completed.",
        snapshotImportSuccess: "Snapshot imported.",
        snapshotImportError: "Failed to import snapshot.",
        mailCatcherTitle: "Email routes",
        mailCatcherDescription:
          "Bind inbound email addresses to recipes so emails can trigger workflows automatically.",
        mailCatcherSummaryValue: "Inbound email",
        mailCatcherDisabledBadge: "Unavailable",
        mailCatcherDisabledTitle: "Inbound email disabled",
        mailCatcherDisabledDescription:
          "Mail Catcher depends on EmailConnect and stays disabled until the paid service, quotas, webhook security, and VM dispatch are production-ready.",
        openMailCatcherPage: "Open Mail Catcher",
        mailCatcherAddRoute: "Add route",
        mailCatcherRoutesCount: "Routes",
        mailCatcherEnabledCount: "Active",
        mailCatcherDomain: "Inbound domain",
        mailCatcherNoRoutes: "No email routes",
        mailCatcherNoRoutesDescription:
          "Create a route to generate a unique email address bound to a recipe.",
        mailCatcherEmailAddress: "Email address",
        mailCatcherRecipe: "Recipe",
        mailCatcherCreatedAt: "Created",
        mailCatcherCreateRoute: "Create email route",
        mailCatcherEditRoute: "Edit email route",
        mailCatcherDialogDescription:
          "Select the recipe triggered by this inbound address.",
        mailCatcherRecipePlaceholder: "Choose a recipe",
        mailCatcherEnabled: "Route enabled",
        mailCatcherDeleteRoute: "Delete email route",
        mailCatcherDeleteRouteDescription:
          "This inbound address will no longer trigger its recipe.",
        mailCatcherRecipeRequired: "Recipe is required.",
        mailCatcherEmailCopied: "Email address copied.",
        mailCatcherEmailCopyError: "Failed to copy email address.",
        mailCatcherCreateSuccess: "Email route created.",
        mailCatcherCreateError: "Failed to create email route.",
        mailCatcherUpdateSuccess: "Email route updated.",
        mailCatcherUpdateError: "Failed to update email route.",
        mailCatcherDeleteSuccess: "Email route deleted.",
        mailCatcherDeleteError: "Failed to delete email route.",
        spacesTitle: "Collaborative spaces",
        spacesDescription:
          "Manage spaces attached to the agent, their sessions, and collaboration usage.",
        spacesSummaryValue: "Workspaces",
        openSpacesPage: "Open Spaces",
        spacesCreate: "Create space",
        spacesCount: "Spaces",
        spacesMembersCount: "Members",
        spacesSessionsCount: "Sessions",
        spacesNoSpaces: "No spaces",
        spacesNoSpacesDescription:
          "Create a space to organize agent sessions and collaboration.",
        spacesMembersLabel: "member(s)",
        spacesSessionsLabel: "session(s)",
        spacesCreatedAt: "Created",
        spacesCreateTitle: "Create space",
        spacesCreateDescription:
          "The space will be attached to the current agent.",
        spacesName: "Name",
        spacesDescriptionLabel: "Description",
        spacesDeleteTitle: "Delete space",
        spacesDeleteDescription:
          "Space {{name}} and its associated sessions will be deleted.",
        spacesCreateSuccess: "Space created.",
        spacesCreateError: "Failed to create space.",
        spacesDeleteSuccess: "Space deleted.",
        spacesDeleteError: "Failed to delete space.",
        deploySummaryMessagingDescription:
          "Slack, Telegram, WhatsApp, Discord, Google Chat, and Signal accounts bound to the messaging gateway.",
        openMessagingPage: "Open Messaging",
        deployRuntimeMessagingTitle: "Messaging accounts",
        deployRuntimeMessagingDescription:
          "Connect external channels to the agent and bind them to a dedicated API key.",
        deployRuntimeMessagingAddAccount: "Add account",
        deployRuntimeMessagingAccountsCount: "Accounts",
        deployRuntimeMessagingApiKeysAvailable: "Available API keys",
        deployRuntimeMessagingWebhookChannels: "Webhook channels",
        deployRuntimeMessagingNoAccounts: "No messaging accounts",
        deployRuntimeMessagingNoAccountsDescription:
          "Add at least one channel if this agent must receive or emit business messages.",
        deployRuntimeMessagingCopyWebhook: "Copy webhook",
        deployRuntimeMessagingWebhookCopied: "Webhook copied.",
        deployRuntimeMessagingWebhookCopyError: "Failed to copy webhook.",
        deployRuntimeMessagingEditAccount: "Edit account",
        deployRuntimeMessagingCreateAccount: "Create account",
        deployRuntimeMessagingDialogDescription:
          "Configure the channel, account, and required secrets for this transport.",
        deployRuntimeMessagingChannel: "Channel",
        deployRuntimeMessagingSelectChannel: "Choose a channel",
        deployRuntimeMessagingStatus: "Status",
        deployRuntimeMessagingStatusActive: "Active",
        deployRuntimeMessagingStatusDisabled: "Disabled",
        deployRuntimeMessagingStatusInvalid: "Invalid",
        deployRuntimeMessagingAccountId: "Account ID",
        deployRuntimeMessagingDisplayName: "Display name",
        deployRuntimeMessagingDisplayNamePlaceholder: "Primary bot",
        deployRuntimeMessagingExternalId: "External ID",
        deployRuntimeMessagingExternalIdPlaceholder: "Optional",
        deployRuntimeMessagingApiKeyLabel: "API key",
        deployRuntimeMessagingApiKeyPlaceholder: "Select an API key",
        deployRuntimeMessagingApiKeyPlaceholderEdit:
          "Leave empty to keep the current key",
        deployRuntimeMessagingApiKeyHelperEdit:
          "Only select a new API key if you want to replace the one already bound.",
        deployRuntimeMessagingNoExpiration: "No expiration",
        deployRuntimeMessagingConfigSection: "Channel configuration",
        deployRuntimeMessagingSecretInfo:
          "Existing secrets are never prefilled.",
        deployRuntimeMessagingSecretPlaceholder:
          "Leave empty to keep the current value",
        deployRuntimeMessagingSecretHelperEdit:
          "Leave empty to keep the secret already stored.",
        deployRuntimeMessagingDeleteAccount: "Delete account",
        deployRuntimeMessagingDeleteAccountDescription:
          "Account {{name}} will be removed from the messaging gateway.",
        deployRuntimeMessagingChannelRequired: "Channel is required.",
        deployRuntimeMessagingAccountIdRequired: "Account ID is required.",
        deployRuntimeMessagingFieldRequired: "Field {{field}} is required.",
        deployRuntimeMessagingApiKeyRequired:
          "An API key is required to create a messaging account.",
        deployRuntimeMessagingCreateSuccess: "Messaging account created.",
        deployRuntimeMessagingCreateError:
          "Failed to create messaging account.",
        deployRuntimeMessagingUpdateSuccess: "Messaging account updated.",
        deployRuntimeMessagingUpdateError:
          "Failed to update messaging account.",
        deployRuntimeMessagingDeleteSuccess: "Messaging account deleted.",
        deployRuntimeMessagingDeleteError:
          "Failed to delete messaging account.",
        deployRuntimeMessagingConnectionWebhook: "Webhook",
        deployRuntimeMessagingConnectionPolling: "Polling",
        deployRuntimeMessagingConnectionWebsocket: "WebSocket",
        deployRuntimeMessagingConfigKeys: "Config keys",
        deployRuntimeMessagingChannelTelegram: "Telegram",
        deployRuntimeMessagingChannelSlack: "Slack",
        deployRuntimeMessagingChannelWhatsapp: "WhatsApp",
        deployRuntimeMessagingChannelDiscord: "Discord",
        deployRuntimeMessagingChannelGooglechat: "Google Chat",
        deployRuntimeMessagingChannelSignal: "Signal",
        deployRuntimeMessagingChannelUnknown: "Unknown channel",
        deployRuntimeMessagingFieldBotToken: "Bot token",
        deployRuntimeMessagingFieldPollInterval: "Poll interval (s)",
        deployRuntimeMessagingFieldAllowedUpdates: "Allowed updates",
        deployRuntimeMessagingFieldSigningSecret: "Signing secret",
        deployRuntimeMessagingFieldBotUserId: "Bot user ID",
        deployRuntimeMessagingFieldAccessToken: "Access token",
        deployRuntimeMessagingFieldPhoneNumberId: "Phone number ID",
        deployRuntimeMessagingFieldAppSecret: "App secret",
        deployRuntimeMessagingFieldVerifyToken: "Verify token",
        deployRuntimeMessagingFieldApiBaseUrl: "API base URL",
        deployRuntimeMessagingFieldApiVersion: "API version",
        deployRuntimeMessagingFieldIntents: "Intents",
        deployRuntimeMessagingFieldVerificationToken: "Verification token",
        deployRuntimeMessagingFieldBaseUrl: "Base URL",
        deployRuntimeMessagingFieldNumber: "Number",
        deployRuntimeMqttCardDescription:
          "Exposes an MQTT bridge to receive or publish real-time events for IoT, monitoring, field automations, and systems that already speak MQTT.",
        deployRuntimeExternalInceptionCardDescription:
          "Connects the agent to an external Inception instance for expert operations, runtime inspection, and controlled administration actions.",
        deployRuntimeShellCardDescription:
          "Expose shell capabilities for local flows and expert tools.",
        deployRuntimeInternalSaved: "Internal configuration saved.",
        deployRuntimeInternalSaveError:
          "Failed to save internal configuration.",
        deployRuntimeS3DialogDescription:
          "Fill in the S3 connection used as storage for this agent.",
        deployRuntimeS3Endpoint: "Endpoint",
        deployRuntimeS3Region: "Region",
        deployRuntimeS3Bucket: "Bucket",
        deployRuntimeS3AccessKey: "Access key",
        deployRuntimeS3SecretKey: "Secret key",
        deployRuntimeS3Cdn: "Public CDN URL",
        deployRuntimeS3UseSsl: "Use SSL",
        deployRuntimeS3Required: "S3 endpoint and access key are required.",
        deployRuntimeS3Created: "S3 configuration created.",
        deployRuntimeS3CreateError: "Failed to create S3 configuration.",
        deployRuntimeS3Updated: "S3 configuration updated.",
        deployRuntimeS3UpdateError: "Failed to update S3 configuration.",
        deployRuntimeS3Deleted: "S3 configuration deleted.",
        deployRuntimeS3DeleteError: "Failed to delete S3 configuration.",
        deployRuntimeMultimodalSaved: "Multimodal configuration saved.",
        deployRuntimeMultimodalSaveError:
          "Failed to save multimodal configuration.",
        deployRuntimeMultimodalDeleted: "Multimodal configuration deleted.",
        deployRuntimeMultimodalDeleteError:
          "Failed to delete multimodal configuration.",
        deployRuntimeMultimodalDefaultsSaved:
          "AgentMaurice multimodal enabled.",
        deployRuntimeMultimodalDefaultsError:
          "Failed to enable AgentMaurice multimodal.",
        deployRuntimeConfigureMultimodal: "Configure multimodal",
        deployRuntimeMultimodalDialogDescription:
          "Enable AgentMaurice managed mode or configure a personal key.",
        deployRuntimeMultimodalManagedMode: "AgentMaurice managed",
        deployRuntimeMultimodalByokMode: "Personal key",
        deployRuntimeMultimodalManagedTitle: "AgentMaurice multimodal",
        deployRuntimeMultimodalManagedDescription:
          "Enables vision, document, audio, and video capabilities without a personal key. Usage is billed in AgentMaurice credits.",
        deployRuntimeMultimodalManagedCapabilities:
          "Vision, documents, audio transcription, and video",
        deployRuntimeMultimodalManagedActivate: "Enable multimodal",
        deployRuntimeMultimodalManagedActivating: "Enabling…",
        deployRuntimeMultimodalHostedBadge: "AgentMaurice managed",
        deployRuntimeMultimodalByokBadge: "Personal key",
        deployRuntimeMultimodalBaseUrlInvalid:
          "Base URL must be a valid http(s) URL.",
        deployRuntimeMultimodalExistingConfigs: "Existing configurations",
        deployRuntimeMultimodalAddConfig: "Add configuration",
        deployRuntimeMultimodalEditConfig: "Edit configuration",
        deployRuntimeMultimodalFormDescription:
          "Define a capability, provider, and model for this profile.",
        deployRuntimeMultimodalCapability: "Capability",
        deployRuntimeMultimodalProfile: "Profile",
        deployRuntimeMultimodalProvider: "Provider",
        deployRuntimeMultimodalModel: "Model",
        deployRuntimeMultimodalSelectModel: "Select a model",
        deployRuntimeMultimodalNoCompatibleModels:
          "No compatible models found for this provider.",
        deployRuntimeMultimodalBaseUrl: "Base URL",
        deployRuntimeMultimodalApiKey: "API key",
        deployRuntimeMultimodalApiKeyOptional:
          "Leave empty to keep the current key",
        deployRuntimeMultimodalOrgProvider: "Organization LLM provider",
        deployRuntimeMultimodalSelectOrgProvider: "Select a provider",
        deployRuntimeMultimodalNoOrgProviders:
          "No compatible organization provider with a credential. Declare one in Build → LLM.",
        deployRuntimeMultimodalOrgProviderRequired:
          "An organization LLM provider is required for multimodal BYOK.",
        deployRuntimeMultimodalModelRequired: "A multimodal model is required.",
        deployRuntimeMultimodalNoConfigs:
          "No multimodal configuration has been saved yet.",
        deployRuntimeMultimodalDeleteConfig: "Delete multimodal configuration",
        deployRuntimeMultimodalDeleteDescription:
          "Configuration {{capability}} / {{profile}} will be deleted.",
        deployRuntimeMcpManualDescription:
          "Lists the MCP servers manually attached to this agent.",
        deployRuntimeMcpSidecarsDescription:
          "Shows the sidecars and registry assets currently attached to this agent.",
        deployRuntimeSidecarRunning: "Container running",
        deployRuntimeNoMcpServers: "No manual MCP servers configured.",
        deployRuntimeNoSidecars: "No sidecars or registry assets detected.",
        deployRuntimeMcpServerCreated: "MCP server created.",
        deployRuntimeMcpServerCreateError: "Failed to create MCP server.",
        deployRuntimeMcpServerUpdated: "MCP server updated.",
        deployRuntimeMcpServerUpdateError: "Failed to update MCP server.",
        deployRuntimeMcpServerDeleted: "MCP server deleted.",
        deployRuntimeMcpServerDeleteError: "Failed to delete MCP server.",
        deployRuntimeAddStdio: "Add STDIO",
        deployRuntimeAddSse: "Add SSE",
        deployRuntimeCreateStdio: "Create STDIO server",
        deployRuntimeEditStdio: "Edit STDIO server",
        deployRuntimeCreateSse: "Create SSE server",
        deployRuntimeEditSse: "Edit SSE server",
        deployRuntimeStdioDialogDescription:
          "Configure the local command, its arguments, and its environment variables.",
        deployRuntimeSseDialogDescription:
          "Configure the remote endpoint and HTTP headers used by this SSE server.",
        deployRuntimeMcpName: "Server name",
        deployRuntimeMcpCommand: "Command",
        deployRuntimeMcpUrl: "Server URL",
        deployRuntimeMcpArguments: "Arguments",
        deployRuntimeMcpEnv: "Environment variables",
        deployRuntimeMcpHeaders: "HTTP headers",
        deployRuntimeMcpAddArgument: "Add argument",
        deployRuntimeMcpAddEnv: "Add variable",
        deployRuntimeMcpAddHeader: "Add header",
        deployRuntimeMcpCommandPreview: "Command preview",
        deployRuntimeMcpRemotePreview: "Remote connection preview",
        deployRuntimeMcpNameRequired: "MCP server name is required.",
        deployRuntimeMcpCommandRequired: "STDIO command is required.",
        deployRuntimeMcpUrlRequired: "SSE server URL is required.",
        deployRuntimeMcpInvalidUrl: "SSE server URL is invalid.",
        deployRuntimeMcpArgumentsCount: "{{count}} argument(s)",
        deployRuntimeMcpEnvCount: "{{count}} environment variable(s)",
        deployRuntimeMcpHeadersCount: "{{count}} header(s)",
        deployRuntimeDeleteMcpServer: "Delete MCP server",
        deployRuntimeDeleteMcpServerDescription:
          "Server {{name}} will be removed from the agent.",
        deployRuntimeMcpOAuthConnect: "Connect OAuth",
        deployRuntimeMcpOAuthDisconnect: "Disconnect OAuth",
        deployRuntimeMcpOAuthConnected: "Connected",
        deployRuntimeMcpOAuthDisconnected: "OAuth disconnected.",
        deployRuntimeMcpOAuthExpired: "Expired",
        deployRuntimeMcpOAuthNotConnected: "Not connected",
        deployRuntimeMcpOAuthStartError: "Failed to start the OAuth flow.",
        deployRuntimeMcpOAuthDisconnectError: "Failed to disconnect OAuth.",
        deployRuntimeMcpRunDoctor: "Run doctor",
        deployRuntimeMcpDoctorTitle: "SSE diagnostics",
        deployRuntimeMcpDoctorDescription: "Doctor result for {{name}}.",
        deployRuntimeMcpDoctorDetails: "Diagnostic details",
        deployRuntimeMcpDoctorEmpty: "No diagnostic result available.",
        deployRuntimeMcpDoctorError: "Failed to run SSE diagnostics.",
        deployRuntimeVariablesPanelDescription:
          "Manage the variables and secrets injected automatically during recipe execution.",
        deployRuntimeVariablesCount: "Variables",
        deployRuntimeVariableSecretCount: "Secrets",
        deployRuntimeVariableScopedCount: "Scoped",
        deployRuntimeVariableSharedCount: "Shared",
        deployRuntimeVariablesList: "Agent variables",
        deployRuntimeVariablesListDescription:
          "Add the API keys, credentials, and constants required by this agent here.",
        deployRuntimeAddVariable: "Add variable",
        deployRuntimeNoVariables: "No variables configured.",
        deployRuntimeNoVariablesDescription:
          "Variables let you store secrets and constants that are injected automatically into recipes.",
        deployRuntimeCreateVariable: "Create variable",
        deployRuntimeEditVariable: "Edit variable",
        deployRuntimeDeleteVariable: "Delete variable",
        deployRuntimeDeleteVariableDescription:
          "Variable {{name}} will be removed from the agent immediately.",
        deployRuntimeVariableDialogDescription:
          "Define the name, value, and scope of this variable for the agent.",
        deployRuntimeVariableName: "Name",
        deployRuntimeVariableValue: "Value",
        deployRuntimeVariableValueOptional:
          "Leave empty to keep the existing value",
        deployRuntimeVariableSecret: "Mask the value as a secret",
        deployRuntimeVariableDescriptionLabel: "Description",
        deployRuntimeVariableRecipeScope: "Recipe scope",
        deployRuntimeVariableRecipeScopeDescription:
          "Leave empty to share the variable with every recipe, or select only the recipes that need it.",
        deployRuntimeVariableAvailableRecipes: "Available recipes",
        deployRuntimeVariableRecipeScopeAll: "All recipes",
        deployRuntimeVariableRecipeScopeEmpty:
          "No deployed recipes yet. The variable will stay shared at agent level.",
        deployRuntimeVariableRecipeScopePlaceholder:
          "recipe_a, recipe_b, recipe_c",
        deployRuntimeVariableNameRequired: "Variable name is required.",
        deployRuntimeVariableValueRequired: "Variable value is required.",
        deployRuntimeVariableCreated: "Variable created.",
        deployRuntimeVariableCreateError: "Failed to create variable.",
        deployRuntimeVariableUpdated: "Variable updated.",
        deployRuntimeVariableUpdateError: "Failed to update variable.",
        deployRuntimeVariableDeleted: "Variable deleted.",
        deployRuntimeVariableDeleteError: "Failed to delete variable.",
        deployRuntimeVariableAllRecipes: "All recipes",
        deployRuntimeVariableAllRecipesDescription:
          "Available to every recipe in this agent.",
        deployRuntimeVariableScopedRecipes: "Scoped",
        deployRuntimeVariableShow: "Show",
        deployRuntimeVariableHide: "Hide",
        deployRuntimeVariableSecretBadge: "Secret",
        deployRuntimeVariableDescription:
          "Explain briefly what this variable is used for.",
        deployRuntimeVariablesUsageTitle: "Best practices",
        deployRuntimeVariablesUsage1:
          "Keep sensitive values such as API keys and passwords as secrets.",
        deployRuntimeVariablesUsage2:
          "Use recipe scope to limit variables to specific workflows.",
        deployRuntimeVariablesUsage3:
          "Prefer explicit and stable names to keep maintenance simple.",
        deployRuntimeVariablesInjectedDescription:
          "These variables will be injected automatically into agent executions.",
        deployRuntimeVariablesSummary: "{{count}} configured variable(s)",
        deployRuntimeAccessSummary:
          "{{keys}} key(s) · {{accounts}} messaging account(s)",
        deployRuntimeVariablesDescription:
          "Agent variables and secrets will appear here to drive LLM, MCP, and sidecar providers.",
        deployRuntimeVariablesPlaceholder:
          "The API foundation is ready. The variables editor will be wired in the next UI pass.",
        deployRuntimeVariablesPending: "Editor pending",
        deployRuntimeNextStep: "Current state",
        deployRuntimeCurrentState: "Current state",
        deployRuntimeNextStepDescription:
          "This panel highlights the most useful actions to make this runtime operational.",
        deployRuntimeLlmNextStep1:
          "Add SaaS model selection and on-prem provider management.",
        deployRuntimeLlmNextStep2:
          "Then wire embedding providers and network proxy.",
        deployRuntimeLlmNextStep3:
          "Keep Candle and advanced options inside an expert panel.",
        deployRuntimeMcpNextStep1:
          "Add STDIO/SSE lists, forms, and server cards.",
        deployRuntimeMcpNextStep2:
          "Wire OAuth connect/disconnect and SSE doctor.",
        deployRuntimeMcpNextStep3:
          "Then separate registry sidecars from manual servers inside Build.",
        deployRuntimeInternalNextStep1:
          "Show toggle cards for storage, docstore, company memory, and multimodal.",
        deployRuntimeInternalNextStep2:
          "Wire S3 and multimodal dialogs when those cards are enabled.",
        deployRuntimeInternalNextStep3:
          "Keep shell and inception inside a secured expert mode.",
        deployRuntimeSkillsNextStep1:
          "Attach only the skills that matter for the current agent.",
        deployRuntimeSkillsNextStep2:
          "Review the skills that still require configuration before apply.",
        deployRuntimeSkillsNextStep3:
          "Keep a focused catalog so builders and Calisto are not overloaded.",
        deployRuntimeAccessNextStep1:
          "Create dedicated keys per integration instead of sharing one global key.",
        deployRuntimeAccessNextStep2:
          "Add messaging accounts before wiring external webhooks or bots.",
        deployRuntimeAccessNextStep3:
          "Validate the auth connector before exporting the Next.js gateway.",
        deployRuntimeVariablesNextStep1:
          "Port agent variable management from the dashboard.",
        deployRuntimeVariablesNextStep2:
          "Then connect those variables to LLM and MCP providers.",
        deployRuntimeVariablesNextStep3:
          "Keep a clear split between standard variables and secrets.",
        pipelineDescription:
          "Manage plan, tests and promotion for the selected agent.",
        deployRecipeCoverageDescription:
          "{{synced}} synced, {{pending}} still needing planning or review.",
        deployRecipeListDescription:
          "Choose the meta-recette to push, then use this page to validate, test, and apply.",
        deployPrimaryValidateDescription:
          "Fix the local spec first so you can work from a valid base before planning or applying.",
        deployPrimaryPlanDescription:
          "Prepare an executable plan to see clearly what will be applied to the target agent.",
        deployPrimaryTestDescription:
          "Run tests now to confirm the recipe still behaves correctly before publish.",
        deployPrimaryPublishDescription:
          "The plan and tests are ready. You can now apply the changes to the agent.",
        deployPrimaryObserveDescription:
          "The latest runs are available. Open Observe to inspect the execution details.",
        selectOrgDeploymentToPublish:
          "Select an organization and agent to manage publication.",
        readyToTest: "Ready to test {{name}}.",
        readyToPromote: "Ready to promote {{name}}.",
        currentStage: "Current Stage",
        nextTarget: "Next Target",
        readiness: "Readiness",
        health: "Health",
        environmentLabel: "Environment: {{environment}}",
        alreadyHighestStage: "Already at the highest declared promotion stage.",
        inferredNextStage:
          "Next promotion target inferred from the selected agent.",
        activeExecutionsLabel: "Active executions: {{count}}",
        metaRecettesTitle: "Meta recipes",
        loadingRecipes: "Loading recipes…",
        noMetaRecetteForDeployment:
          "No meta recipe linked to this agent yet.",
        targetLabel: "Target: {{target}}",
        targetDeploymentLabel: "Target agent",
        deploymentTarget: "Agent target: {{target}}",
        publicationStages: "Publication stages",
        validate: "Validate",
        planning: "Planning…",
        plan: "Plan",
        testing: "Testing…",
        dryRun: "Dry-run",
        validation: "Validation",
        latestTest: "Latest Test",
        lastApply: "Last Apply",
        issuesCount: "{{count}} issue(s)",
        noIssue: "No issue",
        notRun: "Not run",
        neverApplied: "Never applied",
        planAndDiff: "Plan and diff",
        inspectChangesBeforePromotion:
          "Generate a plan to inspect actionable changes before promotion.",
        planId: "Plan ID: {{value}}",
        planHash: "Plan hash: {{value}}",
        generatedAt: "Generated: {{value}}",
        signals: "Signals",
        signalsDescription: "Validation, test and reconcile outputs",
        reconciling: "Reconciling…",
        reconcile: "Reconcile",
        validationIssues: "Validation issues",
        noLocalValidationIssue: "No local validation issue detected.",
        latestTestExecution: "Latest test execution",
        statusLabel: "Status: {{status}}",
        testRunLabel: "Test run: {{id}}",
        executionIdsLabel: "Execution IDs: {{ids}}",
        inspectInSidePanel: "Inspect in side panel",
        openFullObserve: "Open full Observe",
        lastDryRun: "Last dry-run",
        lastPromotion: "Last promotion",
        syncStatusLabel: "Sync status: {{status}}",
        inspectApplyInSidePanel: "Inspect apply in side panel",
        inspectTestInSidePanel: "Inspect test in side panel",
        reconcilePayload: "Reconcile payload",
        observeFocused: "Focused",
        selectMetaRecette: "Select a meta recipe to view publication details.",
        deploymentHealthTitle: "Agent health",
        readyToPromoteLabel: "Ready to promote",
        readyToPromoteDescription:
          "Plan, tests and agent health are aligned.",
        partiallyReady: "Partially ready",
        partiallyReadyDescription:
          "One or more signals are still missing before promotion.",
        notPrepared: "Not prepared",
        notPreparedDescription:
          "Generate a plan and run tests before promoting.",
        needsFixes: "Needs fixes",
        needsFixesDescription: "Resolve validation issues before promotion.",
        stagePending: "Pending",
        stageDeploying: "Deploying",
        stageActive: "Active",
        stageError: "Error",
        removedNodesSection: "Removed nodes",
        addedNodesSection: "Added nodes",
        modifiedNodesSection: "Modified nodes",
        removed: "Removed",
        added: "Added",
        modified: "Modified",
        configCount: "Config ({{count}})",
        noChangesDetectedShort: "No changes detected",
        openTasks: "Open tasks",
        timeline: "Timeline",
        artifacts: "Artifacts",
        sourceGraph: "Source graph",
        workspaceContextTitle: "Workspace context",
        workspaceContextDescription:
          "Session-backed memory and artifacts for the current run.",
        degraded: "Degraded",
        loadingContext: "Loading context…",
        activeBlueprint: "Active blueprint",
        activeBlueprintDescription:
          "Read-only view of the recipe currently in use.",
        loadingRecipePreview: "Loading recipe preview…",
        recipeNotLinked:
          "This conversation is not tied to a specific recipe yet.",
        noOpenWorkspaceTask:
          "No open workspace task is currently visible for this session.",
        noTimelineEvent: "No timeline event available yet.",
        noWorkspaceArtifact: "No workspace artifact available yet.",
        artifactPreview: "Artifact preview",
        artifactPreviewDescription:
          "Inline preview of a recent workspace artifact.",
        openFile: "Open file",
        noInlinePreviewAvailable: "No inline preview available.",
        observeContextTitle: "Observe context",
        observeContextDescription: "Focused blueprint run routed from Calisto.",
        clear: "Clear",
        loadingFocusedContext: "Loading focused context…",
        openBlueprintAction: "Open blueprint",
        publishAction: "Publish",
        runAction: "Run",
        calistoAction: "Calisto",
        applyRun: "Apply run",
        testRun: "Test run",
        started: "Started: {{value}}",
        completed: "Completed: {{value}}",
        recommendation: "Recommendation",
        inspectLinkedTest: "Inspect linked test",
        regressionDetected: "Regression detected",
        regressionDescription:
          "This run contains a regression payload in the detailed Observe view.",
        metaRecettePanelAction: "Meta recipe",
        metaRecettePageDescription:
          "The meta recipe captures agent specifications and acts as the main discussion surface with Calisto.",
        metaRecetteStatusTitle: "Status",
        metaRecettePrimaryActionBadge: "Primary action",
        metaRecettePrimaryPlanLabel: "Prepare plan",
        metaRecettePrimaryPlanDescription:
          "Generate a fresh plan to see exactly what must change before apply.",
        metaRecettePrimaryAttentionLabel: "Review critical changes",
        metaRecettePrimaryAttentionDescription:
          "The plan still contains changes that need attention before apply.",
        metaRecettePrimaryReviewLabel: "Review changes",
        metaRecettePrimaryReviewDescription:
          "The plan is usable, but some changes still deserve a quick validation.",
        metaRecettePrimaryApplyLabel: "Open Calisto to apply",
        metaRecettePrimaryApplyDescription:
          "The plan looks ready. Open Calisto to drive convergence or guide the apply.",
        metaRecettePrimaryObserveLabel: "Review latest runs",
        metaRecettePrimaryObserveDescription:
          "The agent is synced. Open Observe to inspect the latest apply and test runs.",
        metaRecetteSecondaryActions: "Quick access",
        metaRecetteNextStep: "Recommended next step",
        metaRecetteExecutionTitle: "Execution",
        metaRecetteArtifactsTitle: "Artifacts",
        metaRecettePipelineTitle: "Build workflow",
        metaRecettePipelineDescription:
          "Track progress from the spec to the latest apply and the most recent tests.",
        metaRecetteDriftTitle: "Drift snapshot",
        metaRecetteDriftDescription:
          "Inspect the expected impact of changes between the current spec and the target agent.",
        metaRecetteDriftLoading: "Preparing drift snapshot…",
        metaRecetteNoDriftDescription:
          "The agent appears aligned with the active spec. No actionable drift was detected.",
        metaRecetteDriftNeedsPlanDescription:
          "The spec is not aligned yet. Prepare a plan to inspect the exact changes to apply.",
        metaRecetteActionsToApply: "Actions to apply",
        metaRecetteWarningsDetected: "Warnings were detected in the plan.",
        metaRecetteDiscoveryTitle: "Discovery",
        metaRecetteDiscoveryFresh: "Fresh discovery",
        metaRecetteDiscoveryStale: "Stale discovery",
        metaRecetteDiscoveryTargetOk: "Target validated",
        metaRecetteDiscoveryTargetMismatch: "Target mismatch",
        metaRecetteDriftRecommendationFallback:
          "Prepare a plan to confirm the exact changes that should be applied.",
        metaRecetteTopChangesTitle: "Top changes",
        metaRecetteTopChangesDescription:
          "Summary of the first actions proposed by the plan.",
        metaRecetteChecklistTitle: "Apply checklist",
        metaRecetteChecklistDescription:
          "Prioritize the changes that are ready, need review, or require attention before apply.",
        metaRecetteChecklistReadyTitle: "Ready to apply",
        metaRecetteChecklistReadyDescription:
          "Low-risk changes that are directly usable in the current plan.",
        metaRecetteChecklistReviewTitle: "Review first",
        metaRecetteChecklistReviewDescription:
          "Valid changes that still deserve a quick review before apply.",
        metaRecetteChecklistAttentionTitle: "Needs attention",
        metaRecetteChecklistAttentionDescription:
          "Potential blockers, unsupported changes, or high-impact actions.",
        metaRecetteChecklistReadinessTitle: "Apply readiness",
        metaRecetteChecklistReadyReadiness:
          "The plan looks ready to apply. Most identified changes are low risk.",
        metaRecetteChecklistReviewReadiness:
          "The plan is usable, but some changes deserve a quick review before apply.",
        metaRecetteChecklistAttentionReadiness:
          "Some changes still need attention before apply.",
        metaRecetteChecklistReadyBadge: "Ready",
        metaRecetteChecklistReviewBadge: "Review",
        metaRecetteChecklistAttentionBadge: "Attention",
        metaRecetteChecklistUnsupported: "Unsupported",
        metaRecetteChecklistHumanReview: "Human review",
        metaRecetteChecklistFilterAll: "All",
        metaRecetteChecklistEmptyFilter: "No changes match this filter yet.",
        metaRecetteChecklistMoreCount:
          "{{count}} more change(s) exist in the full plan.",
        metaRecetteImpactedSectionsTitle: "Impacted sections",
        metaRecetteImpactedSectionsDescription:
          "Quick navigation to the markdown sections most likely affected by the plan.",
        metaRecetteQuickNavTitle: "Quick navigation",
        metaRecetteQuickNavDescription:
          "Jump quickly between the main spec sections and impacted areas.",
        metaRecetteImpactedBadge: "Impacted",
        metaRecetteInspectChange: "Inspect",
        metaRecetteOpenInSpecs: "Open in spec",
        metaRecetteFieldColumn: "Field",
        metaRecetteBeforeColumn: "Before",
        metaRecetteAfterColumn: "After",
        metaRecetteContextColumn: "Context",
        metaRecetteChangeSummaryFallback:
          "No detailed summary is available for this change yet.",
        metaRecetteNoChangeDetails:
          "The plan does not contain enough detail yet to summarize changes.",
        metaRecetteOpenObserve: "Open Observe",
        metaRecetteAdvancedTitle: "Expert tools",
        metaRecetteAdvancedDescription:
          "Diagnostic tools and advanced actions to use when the main flow is not enough.",
        metaRecetteExpertPlanDescription:
          "Regenerate a detailed plan and its diff without applying changes.",
        metaRecetteExpertReconcileDescription:
          "Force a validation-oriented reconcile to compare the spec and the target.",
        metaRecetteExpertDryRunDescription:
          "Simulate the apply without deploying, to inspect the expected result.",
        metaRecetteExpertLatestOutputTitle: "Latest expert output",
        metaRecetteExpertLatestOutputDescription:
          "Show the raw output produced by {{label}}.",
        metaRecettePreferredView: "Recommended view",
        metaRecetteSpecUnavailable:
          "This view is not available for this meta recipe yet.",
        metaRecetteCanvasReady: "Canvas is available to inspect the structure.",
        metaRecetteMarkdownReady:
          "Markdown is the best available view to edit the spec.",
        metaRecetteStructuredFallback:
          "Structured JSON remains available until the canvas view becomes usable.",
        metaRecetteNoPreparedPlan: "No prepared plan yet.",
        metaRecetteStageSync: "Sync",
        metaRecetteContextTitle: "Meta-recette context",
        metaRecetteContextDescription:
          "Calisto conversation, functional spec and sync signals around the active meta-recette.",
        metaRecetteOverviewTab: "Overview",
        metaRecetteSpecTab: "Specs",
        metaRecetteConversationTab: "Calisto",
        metaRecetteLoading: "Loading meta-recette…",
        metaRecetteNoSelection: "No meta-recette selected.",
        metaRecetteNoSelectionDescription:
          "Open this panel from Recipes, Deploy or Observe to load the current meta-recette.",
        metaRecetteOpenConversation: "Discuss with Calisto",
        metaRecetteCanvasTab: "Canvas",
        metaRecetteMarkdownTab: "Markdown",
        metaRecetteStructuredTab: "Structured spec",
        metaRecetteNoStructuredSpec:
          "No structured spec is available for this meta-recette.",
        metaRecetteNoMarkdownSpec:
          "No markdown functional specification is available for this meta-recette.",
        metaRecetteCalistoSyncing:
          "Syncing Calisto context with the active meta-recette…",
        metaRecetteCalistoReady:
          "Calisto is ready to discuss changes, gaps and intent around this meta-recette.",
        metaRecetteCalistoTitle: "Calisto Meta-recette",
        metaRecetteCalistoDescription:
          "Guided conversation around {{name}} and its current specification.",
        metaRecetteCalistoContextDescription:
          "Contextual discussion with Calisto around agent specifications.",
        metaRecetteVariablesLabel: "Variables",
        metaRecetteLastSynced: "Last sync: {{value}}",
        metaRecetteEdgesCount: "{{count}} edge(s)",
        metaRecetteLoadError: "Unable to load the meta-recette.",
        metaRecettePlanError: "Unable to generate the meta-recette plan.",
        metaRecetteReconcileError: "Unable to reconcile the meta-recette.",
        metaRecetteDryRunError: "Unable to run the meta-recette dry-run.",
        metaRecetteMiniAppPreviewTitle: "OpenUI mini-app preview",
        metaRecetteMiniAppPreviewDescription:
          "This panel renders the mini-app actually generated in structured_spec from the recipe definitions compiled by the meta-recette.",
        metaRecetteMiniAppPreviewRecipeLabel: "Generated mini-app",
        metaRecetteMiniAppPreviewRefresh: "Refresh preview",
        metaRecetteMiniAppPreviewError:
          "Unable to generate the meta-recette mini-app preview.",
        metaRecetteMiniAppPreviewRuntimeTitle: "Generated runtime",
        metaRecetteMiniAppPreviewFormatLabel: "UI format",
        metaRecetteMiniAppPreviewViewLabel: "View",
        metaRecetteMiniAppPreviewStateLabel: "State version",
        metaRecetteMiniAppPreviewActionsLabel: "Detected actions",
        metaRecetteMiniAppPreviewFormsLabel: "Forms",
        metaRecetteMiniAppPreviewInteractionsTitle: "Captured interactions",
        metaRecetteMiniAppPreviewInteractionsEmpty:
          "Click inside the mini-app to inspect locally captured events and form openings.",
        metaRecetteMiniAppPreviewEmpty:
          "No generated mini-app preview is available yet for this meta-recette.",
        metaRecetteMiniAppPreviewEventError:
          "Unable to execute this mini-app preview event.",
      },
    },
  },
  es: {
    translation: {
      language: {
        label: "Idioma",
        fr: "Francés",
        en: "Inglés",
        es: "Español",
      },
      theme: {
        label: "Tema",
        system: "Sistema",
        light: "Claro",
        dark: "Oscuro",
      },
      common: {
        loading: "Cargando…",
        close: "Cerrar",
        cancel: "Cancelar",
        save: "Guardar",
        edit: "Editar",
        delete: "Eliminar",
        remove: "Quitar",
        refresh: "Actualizar",
        apply: "Aplicar",
        reject: "Rechazar",
        test: "Probar",
        publish: "Publicar",
        openFull: "Abrir completo",
        noDescription: "No se proporcionó descripción.",
        unknown: "Desconocido",
        valid: "Válida",
        invalid: "Inválida",
        yes: "Sí",
        no: "No",
        search: "Buscar",
        select: "Seleccionar",
        preview: "Vista previa",
        show: "Mostrar",
        hide: "Ocultar",
        open: "Abrir",
        download: "Descargar",
        context: "Contexto",
        focus: "Foco",
        full: "Completo",
        connected: "Conectado",
        connecting: "Conectando…",
        notifications: "Notificaciones",
        active: "activo",
        error: "Error",
        copy: "Copiar",
        run: "Ejecución",
        studio: "Studio",
        build: "Configuración",
      },
      integrations: {
        badge: "Conectores",
        title: "Integraciones",
        description:
          "Añade conectores útiles al Agente actual, configura sus accesos y expone sus tools al runtime AgentMaurice.",
        usageTitle: "Créditos de integraciones",
        usageValue: "{{consumed}} / {{budget}} créditos este mes",
        addedTitle: "Conectores añadidos",
        addedDescription:
          "Solo aparecen aquí los conectores añadidos al Agente actual.",
        addConnector: "Añadir conector",
        emptyTitle: "No hay conectores añadidos",
        emptyDescription:
          "Busca un conector en el catálogo para añadirlo al Agente actual.",
        connectSuccess: "Conector conectado.",
        connectError: "No se pudo conectar.",
        addSuccess: "Conector añadido.",
        addError: "No se pudo añadir.",
        removeSuccess: "Conector retirado.",
        removeError: "No se pudo retirar.",
        disconnectSuccess: "Conector desconectado.",
        disconnectError: "No se pudo desconectar.",
        settingsSuccess: "Configuración guardada.",
        settingsError: "No se pudo configurar.",
        testSuccess: "Estado del conector: {{status}}.",
        testError: "No se pudo probar.",
        catalogError: "No se pudieron cargar los conectores.",
        catalogHTTPError: "Console {{status}} en {{path}}: {{message}}",
        authMode: "Modo",
        configurationRequiredHelp:
          "Configura el conector antes de crear una conexión de usuario.",
        manualSupportHelp:
          "Este conector requiere configuración asistida por soporte.",
        editSettings: "Editar",
        configure: "Configurar",
        reconnect: "Reconectar",
        connect: "Conectar",
        test: "Probar",
        tools: "Tools",
        disconnect: "Desconectar",
        remove: "Retirar",
        maintainedPack: "Pack mantenido",
        actionsAvailable: "Acciones disponibles",
        noActionsEnabled: "Ninguna acción activada",
        directoryTitle: "Añadir conector",
        directoryDescription:
          "El catálogo es global, pero añadir un conector lo habilita solo para el Agente actual.",
        searchPlaceholder: "Buscar Gmail, Slack, CRM…",
        allCategories: "Todas las categorías",
        allAuthModes: "Todos los modos",
        directoryError: "No se pudo cargar el catálogo.",
        noDirectoryResults: "Ningún conector coincide con esta búsqueda.",
        toolPack: "Pack tools",
        noToolPack: "Sin pack",
        add: "Añadir",
        loadMoreConnectors: "Mostrar más",
        toolsTitle: "Tools del conector",
        toolsDescription: "Tools proyectados en el Agente actual para {{connector}}.",
        toolsError: "No se pudieron cargar los tools del conector.",
        noActionsHelp:
          "No se proyecta ningún tool hasta que el conector esté configurado y conectado en este Agente.",
        managedAction: "Acción disponible",
        customTool: "Tool custom",
        editSettingsTitle: "Editar configuración",
        configureTitle: "Configurar conector",
        configureDescription: "Los valores secretos nunca se vuelven a mostrar.",
        connectionCredentialsHelp:
          "Las credenciales se introducen al conectar la cuenta de usuario.",
        setupGuide: "Guía de configuración",
        callbackUrl: "URL de callback",
        disabled: "Desactivado",
        manualSupport: "Soporte requerido",
        configurationRequired: "Configuración requerida",
        connected: "Conectado",
        revoked: "Revocado",
        notConnected: "No conectado",
      },
      desktopUpdate: {
        availableTitle: "Nueva versión disponible",
        availableDescription: "JusteMaurice {{version}} se puede instalar.",
        genericVersion: "más reciente",
        installAction: "Actualizar",
        installing: "Instalando actualización…",
        installError: "No se pudo instalar la actualización.",
      },
      auth: {
        checking: "Comprobando autenticación…",
        required:
          "La autenticación es necesaria antes de cargar organizaciones, agentes y espacios.",
        localModeEnabled:
          "El modo de desarrollo local está activado. La autenticación la gestiona `chatserver`.",
        localAccount: "Cuenta local",
        localSignIn: "Inicio local",
        signIn: "Iniciar sesión",
        createAccount: "Crear cuenta",
        loadingApp: "Cargando Agent OS…",
        accessModeLabel: "Modo de acceso",
        accessModeHosted: "LLM AgentMaurice",
        accessModeHostedDescription:
          "Usa modelos proporcionados por AgentMaurice sin introducir una clave API personal.",
        accessModeByok: "BYOK",
        accessModeByokDescription:
          "Conecta tus propios providers después de iniciar sesión.",
        hostedIntro:
          "Inicia sesión para usar modelos AgentMaurice o configurar tus propios providers.",
        byokIntro:
          "Inicia sesión para conectar tus propios providers y conservar el control de tus claves.",
        accessModeChooseIntro:
          "Inicia sesión y luego elige, en la pantalla de bienvenida, entre los modelos de AgentMaurice y tus propias claves.",
        registerIntro: "Crea tu cuenta para acceder a la aplicación.",
        createAccountOnConsoleHint:
          "La creación de cuenta se hace en console.agentmaurice.app.",
        confirmationEmailSent:
          "Se ha enviado un correo de confirmación. Revisa tu bandeja de entrada.",
        signInError: "Error de inicio de sesión",
        oauthError: "Error de OAuth",
        noAccountYet: "¿Aún no tienes cuenta?",
        alreadyHaveAccount: "¿Ya tienes cuenta?",
      },
      enrollment: {
        title: "Completa tu perfil AgentMaurice",
        subtitle:
          "Completa tu perfil y crea tu primera organización antes de entrar en AgentMaurice OS.",
        subtitleProfileOnly:
          "Completa tu perfil de Console antes de entrar en AgentMaurice OS.",
        roleHint: "Tu primer rol en esta organización será `orga-admin`.",
        roleHintProfileOnly:
          "Este perfil se guarda en Console y se sincroniza aquí automáticamente.",
        email: "Correo",
        username: "Nombre de usuario",
        usernamePlaceholder: "mikaelmorvan",
        firstName: "Nombre",
        firstNamePlaceholder: "Tu nombre",
        lastName: "Apellido",
        lastNamePlaceholder: "Tu apellido",
        language: "Idioma preferido",
        personalOrganization: "Es una organización personal",
        personalOrganizationHint:
          "Deja el nombre vacío si quieres usar tu identidad como nombre de la organización.",
        organizationName: "Nombre de la organización",
        organizationNamePlaceholder: "AgentMaurice",
        organizationNamePersonalPlaceholder:
          "Opcional para una organización personal",
        submit: "Guardar perfil",
        error: "No se pudo guardar el perfil.",
        validation: {
          username: "El nombre de usuario es obligatorio.",
          firstName: "El nombre es obligatorio.",
          lastName: "El apellido es obligatorio.",
          language: "El idioma preferido es obligatorio.",
          organizationName: "El nombre de la organización es obligatorio.",
        },
      },
      welcome: {
        badge: "Configuración exprés",
        title: "Prepara AgentMaurice OS para un primer uso útil.",
        subtitle:
          "Recuperamos el contexto de organización, creamos el Agente por defecto si hace falta y bloqueamos el acceso LLM hasta que esté listo.",
        organizationTitle: "Organización",
        organizationReady: "Organización disponible",
        organizationPending: "Esperando el bootstrap local",
        deploymentTitle: "Agente",
        deploymentReady: "Agente por defecto listo",
        deploymentPending: "Agente aún por crear",
        providerTitle: "LLM",
        providerChoicePending: "Falta elegir el modo LLM",
        providerHosted: "Modelos hosted de AgentMaurice",
        providerHostedPending: "Modelos AgentMaurice por inicializar",
        providerReady: "Provider configurado",
        providerPending: "Todavía no hay provider activo",
        nextStepTitle: "Siguiente paso",
        nextStepModeChoice:
          "Primero elige cómo quieres usar los LLM: modelos de AgentMaurice o tus propias claves API.",
        nextStepContext:
          "Todavía estamos terminando el contexto local. Vuelve a lanzar el bootstrap para recuperar la organización de consola y crear el workspace por defecto.",
        nextStepDeployment:
          "La organización ya está lista, pero aún falta el Agente de usuario por defecto. Actualiza el contexto para crearlo.",
        nextStepProvider:
          "El contexto ya está listo. Configura ahora tus claves API para desbloquear chat y Build.",
        nextStepHostedPending:
          "El contexto ya está listo. Inicializa el perfil LLM AgentMaurice para crear el provider, el modelo y la selección del Agente.",
        nextStepHosted:
          "El contexto ya está listo. Los modelos de AgentMaurice están disponibles en esta instancia sin claves adicionales.",
        nextStepReady:
          "Todo está listo en esta máquina. Ya puedes entrar en el chat o pasar a Build sin configuración adicional.",
        stepConsoleTitle: "Contexto",
        stepConsoleDescription:
          "AgentMaurice OS primero recupera el contexto de tu organización y prepara el workspace activo.",
        stepProviderTitle: "Provider",
        stepProviderDescription:
          "Elige el modo LLM que mejor te encaja y, en modo de claves propias, prueba la configuración antes de guardarla.",
        stepLaunchTitle: "Inicio",
        stepLaunchDescription:
          "Cuando el modo está listo, el chat y Build quedan listos para usarse en esta máquina.",
        modeTitle: "Elegir acceso LLM",
        modeDescription:
          "Debes elegir entre los modelos de AgentMaurice y tus propias claves API antes de usar la instancia.",
        modeLabel: "Modo LLM",
        modeHostedTitle: "Modelos de AgentMaurice",
        modeHostedDescription:
          "Usa los modelos proporcionados por AgentMaurice. No hace falta ninguna clave personal en esta máquina.",
        modeByokTitle: "Mis propias claves",
        modeByokDescription:
          "Usa tus propios providers. Mientras las claves no estén configuradas, chat y Build seguirán bloqueados.",
        modeChoiceRequiredTitle: "Elección obligatoria",
        modeChoiceRequiredDescription:
          "Mientras no elijas un modo LLM, la instancia se mantiene en configuración y los flujos principales siguen bloqueados.",
        modeLockedTitle: "Configuración LLM ya definida",
        modeLockedHostedDescription:
          "Esta organización usa los modelos de AgentMaurice. Los demás usuarios de esta VM no tienen que repetir el onboarding LLM.",
        modeLockedByokDescription:
          "Esta organización ya usa un provider BYOK. Los demás usuarios de esta VM no tienen que volver a introducir claves.",
        hostedTitle: "Usar los modelos de AgentMaurice",
        hostedDescription:
          "Esta instancia puede usar directamente los modelos de AgentMaurice. No necesitas introducir ninguna clave API.",
        hostedPanelTitle: "LLM AgentMaurice activo",
        hostedPanelDescription:
          "El Agente usa un perfil LLM AgentMaurice de la organización. No hace falta ningún secreto de usuario en AgentMaurice OS.",
        hostedPanelPendingTitle: "Inicializar el perfil AgentMaurice",
        hostedPanelPendingDescription:
          "AgentMaurice OS creará o reutilizará el provider AgentMaurice de la organización, añadirá un modelo por defecto, creará un perfil y lo seleccionará para este Agente.",
        hostedNoKeyRequired: "No se requiere clave del usuario",
        hostedPendingNoKey: "No se requiere clave del usuario",
        hostedActivateButton: "Inicializar AgentMaurice",
        hostedActivating: "Inicializando…",
        hostedActivateSuccess: "Perfil LLM AgentMaurice inicializado.",
        hostedActivateError: "No se pudo inicializar el perfil LLM AgentMaurice.",
        byokPanelTitle: "Provider BYOK activo",
        byokPanelDescription:
          "La organización ya tiene una configuración LLM. Para cambiarla, usa Build > LLM con los permisos necesarios.",
        formTitle: "Conectar tu LLM",
        formDescription:
          "Una sola configuración basta. Los secretos se guardan en el backend local y el provider se conecta al Agente por defecto.",
        readyBadge: "Listo",
        setupBadge: "Setup requerido",
        providerNameLabel: "Nombre visible",
        modelLabel: "Modelo",
        apiKeyLabel: "Clave API",
        apiKeyOptionalLabel: "Clave API (opcional)",
        apiKeyPlaceholder: "sk-...",
        urlRequiredLabel: "URL / endpoint",
        urlOptionalLabel: "URL / endpoint (opcional)",
        urlPlaceholder: "https://...",
        advancedTitle: "Parámetros avanzados",
        hideAdvanced: "Ocultar",
        showAdvanced: "Mostrar",
        systemPromptLabel: "System prompt",
        systemPromptPlaceholder:
          "Opcional. Déjalo vacío para usar el prompt por defecto.",
        maxCompletionTokensLabel: "Max completion tokens",
        diagnosticOk: "Conexión validada",
        diagnosticError: "La prueba falló",
        testing: "Probando…",
        testButton: "Probar",
        saving: "Guardando…",
        primaryButton: "Probar y empezar",
        refreshing: "Actualizando…",
        refreshButton: "Actualizar contexto",
        continueChat: "Continuar al chat",
        openBuild: "Abrir Studio",
        readyHint:
          "El workspace ya está listo. Puedes entrar en el chat o abrir Build para empezar a construir.",
        readyHintHosted:
          "El workspace ya está listo y los modelos de AgentMaurice están disponibles. Puedes ir directamente al chat o a Build.",
        pendingHint:
          "Elige primero un modo LLM y luego asegúrate de que la organización y el Agente estén listos antes de continuar.",
        pendingHintByok:
          "Mientras tus claves API no estén probadas y guardadas, chat y Build seguirán bloqueados.",
        pendingHintHosted:
          "Inicializa el perfil AgentMaurice para desbloquear chat y Build sin introducir una clave API.",
        testSuccess: "Conexión con el provider validada.",
        testError: "No se pudo validar la conexión con el provider.",
        saveSuccess: "Configuración guardada.",
        saveError: "No se pudo guardar la configuración.",
        contextRefreshed: "Contexto local actualizado.",
        contextRefreshError: "No se pudo actualizar el contexto local.",
        statusError: "No se pudo cargar el estado del setup.",
        agentDiscoveryTitle: "Conectar un agente de código",
        agentDiscoveryDescription:
          "Elige un prompt sin instalación o un comando MauriceCLI para el rail Git-native Agent Spec V2. Ambos caminos mantienen External Inception guiado, temporal y auditable.",
        agentDiscoveryBadge: "External Inception",
        codeAgentPromptMode: "Conexión MCP sin instalación (`amb_`)",
        codeAgentCLIMode: "Conexión MauriceCLI (`amc_`)",
        codeAgentPromptModeHint:
          "Copia un prompt de conexión MCP. Su URL `amb_` nunca debe pasarse a `maurice agent connect`.",
        codeAgentCLIModeHint:
          "Copia el comando `maurice agent connect`. Configura el cliente e inicia el rail Agent Spec V2 en el proyecto Git local.",
        agentDiscoveryReadyHint:
          "El prompt no contiene la clave final. El agente debe llamar a la URL bootstrap para recibir el contrato `agentmaurice.agent_connection/v2`.",
        agentDiscoveryUnavailableHint:
          "No tienes permisos suficientes para generar este prompt.",
        agentDiscoveryHumanApprovalHint:
          "El agente de código prepara el plan, pero no puede aprobarlo. La aprobación del hash exacto sigue siendo una acción humana separada en AgentMaurice OS.",
        agentDiscoveryGenerate: "Generar prompt",
        agentDiscoveryGenerating: "Generando…",
        agentDiscoveryCopy: "Copiar prompt",
        agentDiscoveryGenerated: "Prompt de agente generado.",
        agentDiscoveryGenerateError: "No se pudo generar el prompt de agente.",
        agentDiscoveryInvalidBootstrap: "El servidor no devolvió una conexión MCP `amb_` válida.",
        agentDiscoveryCopied: "Prompt de agente copiado.",
        agentDiscoveryCopyError: "No se pudo copiar el prompt de agente.",
        agentDiscoveryPrompt:
          "Vas a conectar este agente de código a una instancia AgentMaurice.\n\nIMPORTANTE — solo conexión MCP (`amb_`): no pases nunca esta URL a `maurice agent connect`. Ese comando requiere un bootstrap MauriceCLI `amc_` generado por AgentMaurice OS.\n\n1. Llama a esta URL bootstrap una sola vez:\n{{url}}\n\n2. Comprueba que el JSON devuelto tiene `$schema: agentmaurice.agent_connection/v2`, `schema_version: 2`, `bootstrap_kind: external_inception_mcp` e `intended_consumer: mcp_client_setup`. Usa únicamente `organization`, `agent`, `agent_scopes`, `credential`, `mcp`, `commands`, `tools`, `policies`, `warnings`, `next_command` y `client_setup`.\n\n3. Configura MCP con `client_setup`. Empieza con `inception_agent_scopes_list` y luego llama a `inception_agent_doctor` sin argumentos: la respuesta es compacta por defecto; usa `full:true` solo para un diagnóstico experto solicitado expresamente. Después llama a `inception_mcp_capabilities`. Nunca infieras un Agente por su nombre humano: usa `agent_alias` o `agent_id` de `agent_scopes`.\n\n4. Para cualquier cambio, usa exclusivamente este rail: `inception_agent_spec_init` si es necesario → `inception_agent_spec_pull` → edición de los archivos Git-native → `inception_agent_spec_check` → `inception_agent_spec_plan`. Presenta el plan inmutable y su `plan_hash` y detente.\n\n5. La aprobación debe registrarla una persona autenticada en AgentMaurice OS o en una sesión humana separada. Como agente o servicio, no llames a `inception_agent_spec_approve` ni intentes autoaprobarte. Tras confirmar que la aprobación humana está registrada, llama a `inception_agent_spec_apply` con el plan aprobado y luego a `inception_agent_spec_verify`.\n\n6. Nunca solicites, muestres ni escribas secretos en bruto; usa solo referencias de secretos.",
        cliBootstrapTitle: "Conectar MauriceCLI",
        cliBootstrapDescription:
          "Genera un comando `maurice agent connect` para pegar en una terminal. El enlace amc_ es de un solo uso, caduca en 15 minutos y no escribe secretos en el proyecto.",
        cliBootstrapBadge: "MauriceCLI",
        cliBootstrapReadyHint:
          "El comando configura el cliente y el proyecto local; los cambios siguen después init/pull/check/plan, aprobación humana, apply y verify.",
        cliBootstrapUnavailableHint:
          "No tienes permisos suficientes para generar este comando.",
        cliBootstrapEnvLabel: "Entorno",
        cliBootstrapKindLabel: "Tipo",
        cliBootstrapClientLabel: "Cliente agente",
        cliBootstrapAliasLabel: "Alias del Agente",
        cliBootstrapDirLabel: "Directorio",
        cliBootstrapJoinExistingLabel: "Reconectarme a un proyecto existente",
        cliBootstrapJoinExistingDescription:
          "Añade `--join-existing` para renovar el acceso local sin reescribir ni exportar los archivos Agent Spec del proyecto.",
        bootstrapScopesTitle: "Agentes vinculados",
        bootstrapScopesDescription:
          "Añade solo los agentes que este agente o esta CLI debe poder seleccionar explícitamente.",
        bootstrapScopesNone:
          "No hay otro Agente disponible en este contexto.",
        bootstrapScopeAlias: "Alias",
        bootstrapScopeRole: "Rol",
        bootstrapScopeRuntimeDependency: "Dependencia runtime",
        bootstrapScopeManaged: "Gestionado",
        cliBootstrapGenerate: "Generar comando",
        cliBootstrapGenerating: "Generando…",
        cliBootstrapCopy: "Copiar comando",
        cliBootstrapGenerated: "Comando MauriceCLI generado.",
        cliBootstrapGenerateError: "No se pudo generar el comando MauriceCLI.",
        cliBootstrapInvalidCommand: "El servidor no devolvió un comando V2 `maurice agent connect` válido.",
        cliBootstrapCopied: "Comando MauriceCLI copiado.",
        cliBootstrapCopyError: "No se pudo copiar el comando MauriceCLI.",
        cliBootstrapKind: {
          development: "Desarrollo",
          preproduction: "Preproducción",
          production: "Producción",
          sandbox: "Sandbox",
          integration_test: "Test de integración",
        },
        cliBootstrapClient: {
          "claude-code": "Claude Code",
          codex: "Codex",
          cursor: "Cursor",
          windsurf: "Windsurf",
          generic: "Generic MCP",
        },
      },
      operateSetup: {
        missingOrganizationTitle: "Se requiere una organización",
        missingOrganizationDescription:
          "Esta vista necesita una organización activa antes de poder cargar el contenido operativo.",
        missingDeploymentTitle: "Se requiere un Agente",
        missingDeploymentDescription:
          "Selecciona o crea primero un Agente activo antes de abrir las pantallas de operación.",
        missingSpaceTitle: "Se requiere un espacio",
        missingSpaceDescription:
          "El Agente está listo, pero todavía no hay un espacio activo en esta sesión. Vuelve a la bienvenida para terminar la puesta en marcha.",
        noSpaceTitle: "No hay un espacio listo para este Agente",
        noSpaceDescription:
          "Esta instancia todavía no tiene un espacio utilizable para el Agente actual. Termina la bienvenida antes de abrir el chat.",
        loadingSpacesTitle: "Cargando espacios…",
        loadingSpacesDescription:
          "Comprobando los espacios disponibles para el Agente actual antes de abrir el chat.",
        openWelcome: "Abrir bienvenida",
        openCatalog: "Abrir catálogo",
        openHistory: "Abrir historial",
        completeSetupToStart:
          "Termina la bienvenida para desbloquear el chat y las pantallas operativas",
      },
      shell: {
        toggleCenterFocus: "Alternar foco central",
        focusCenterContent: "Enfocar el contenido central (Ctrl/Cmd+Shift+.)",
        toggleContextPanel: "Alternar panel de contexto",
        toggleRightPanel: "Alternar panel derecho (Ctrl/Cmd+Shift+\\)",
        resizeNavigationPanel: "Redimensionar panel de navegación",
        resizeContextPanel: "Redimensionar panel de contexto",
        inspectTitle: "Inspeccionar",
        inspectDescription: "Configura el nodo seleccionado.",
        executionDetailTitle: "Detalle de ejecución",
        executionDetailDescription: "Contexto de la ejecución seleccionada.",
        emptyContextTitle: "El contexto detallado aparecerá aquí",
        emptyContextDescription:
          "El shell mantiene esta zona lista para inspección, detalles de ejecución y vistas previas contextuales.",
        emptyContextBuildTitle: "El contexto de build aparecerá aquí",
        emptyContextBuildDescription:
          "El shell mantiene esta zona lista para inspeccionar Workflows, planes, ejecuciones y vistas previas de build.",
        emptyContextRunTitle: "Los detalles de ejecución aparecerán aquí",
        emptyContextRunDescription:
          "El shell mantiene esta zona lista para pasos activos, archivos vinculados y vistas previas de ejecución.",
        emptyContextRunActionsTitle: "Acciones útiles",
        emptyContextRunActionsDescription:
          "Cuando todavía no hay una ejecución seleccionada, usa este panel para volver al punto de entrada correcto.",
        emptyContextRunCatalogDescription:
          "Recorre los Workflows listos para lanzar y abre una sesión desde el blueprint adecuado.",
        emptyContextRunHistoryDescription:
          "Retoma una ejecución reciente, inspecciona sus salidas y relánzala en el chat.",
        emptyContextRunOpenBuild: "Abrir Studio",
        emptyContextRunBuildDescription:
          "Pasa a Agent Spec para terminar un Workflow, inspeccionar su blueprint o preparar un apply.",
        emptyContextHistoryTitle: "El detalle de la ejecución aparecerá aquí",
        emptyContextHistoryDescription:
          "El shell muestra aquí la ejecución seleccionada, con sus salidas, artefactos y estado final.",
        emptyContextBuildHint:
          "En modo build, selecciona un nodo o inicia una inspección para abrir este panel.",
        emptyContextRunHint:
          "En modo ejecución, abre un archivo, una ejecución o un historial para alimentar este panel.",
        emptyContextHistoryHint:
          "Selecciona una entrada del historial para mostrar aquí sus detalles.",
        emptyContextShortcutHint:
          "Usa Ctrl/Cmd+Shift+\\ para reabrir al instante el panel contextual cuando haya contenido disponible.",
      },
      sidebar: {
        calisto: "Calisto",
        recipes: "Recetas",
        metaRecette: "Meta-receta",
        capabilities: "Capacidades",
        data: "Datos",
        deployments: "Agentes",
        llm: "LLM",
        mcp: "MCP",
        skills: "Skills",
        schedules: "Schedules",
        observability: "Observabilidad",
        externalControl: "Claves del Agente",
        apiKeys: "Claves de API",
        agentControl: "Control de agentes",
        importExport: "Import / Export",
        messaging: "Mensajería",
        mailCatcher: "Mail Catcher",
        spaces: "Espacios",
        chat: "Chat",
        catalog: "Catálogo",
        history: "Historial",
        spacesSessions: "Espacios y sesiones",
        noSpaceForDeployment:
          "No hay espacios disponibles para este Agente.",
        newSession: "Nueva sesión",
        sessionActions: "Acciones de sesión",
        renameSession: "Renombrar",
        renameSessionTitle: "Renombrar sesión",
        renameSessionDescription:
          "Cambia el nombre mostrado en la lista de sesiones.",
        renameSessionNameRequired: "El nombre de sesión es obligatorio.",
        renameSessionSuccess: "Sesión renombrada.",
        renameSessionError: "No se pudo renombrar la sesión.",
        deleteSession: "Eliminar",
        deleteSessionTitle: "Eliminar sesión",
        deleteSessionDescription:
          "La sesión {{name}} se eliminará definitivamente.",
        deleteSessionSuccess: "Sesión eliminada.",
        deleteSessionError: "No se pudo eliminar la sesión.",
        sessionName: "Nombre de la sesión",
        unnamedSession: "Sesión",
        noSessionYet: "Aún no hay sesiones.",
        sessionCount: "{{count}} sesión(es)",
        lastActivity: "Actividad {{value}}",
        showMoreSessions: "Mostrar {{count}} sesión(es) más",
        showFewerSessions: "Mostrar menos sesiones",
        localProfile: "Perfil local",
        userProfile: "Perfil de usuario",
        account: "Cuenta",
        access: "Acceso",
        organizations: "Organizaciones",
        currentWorkspace: "Espacio actual",
        noWorkspaceSelected: "Ningún espacio seleccionado",
        memberships_one: "{{count}} membresía",
        memberships_other: "{{count}} membresías",
        localAuthentication: "Autenticación local",
        hankoAuthentication: "Autenticación segura",
        hankoProfile: "Seguridad de la cuenta",
        hankoProfileDescription:
          "Gestiona la identidad, los métodos de inicio de sesión y el contexto AgentMaurice de esta sesión.",
        hankoProfileLoadError:
          "No se pudo cargar la seguridad de la cuenta.",
        desktopAuthentication: "Autenticación desktop",
        localSignOutHint:
          "Cerrar sesión te devuelve al selector de cuentas locales.",
        hankoSignOutHint:
          "Cerrar sesión termina la sesión local en este dispositivo.",
        desktopSignOutHint:
          "Cerrar sesión termina la sesión desktop en este dispositivo.",
        confirmSignOutTitle: "Confirmar cierre de sesión",
        confirmSignOutDescription:
          "Vas a cerrar la sesión actual en este dispositivo.",
        confirmSwitchUserDescription:
          "Vas a salir de este perfil local y volver al selector de cuentas.",
        switchUser: "Cambiar usuario",
        signOut: "Cerrar sesión",
      },
      wallet: {
        title: "Créditos de la organización",
        referenceTokens: "~ {{count}} tokens",
        lowBalance: "Saldo bajo. Se recomienda recargar.",
        suspended: "Wallet suspendido. El consumo hosted está bloqueado.",
        portal: "Facturas",
        recentActivity: "Actividad reciente",
        activityTopup: "Recarga",
        activityUsage: "Consumo",
        topupError: "No se pudo iniciar la recarga.",
        portalError: "No se pudo abrir el portal del cliente.",
        checkoutSuccess: "Recarga confirmada.",
        checkoutCanceled: "Recarga cancelada.",
        chatTopupTitle: "Créditos insuficientes",
        chatTopupDescription:
          "Esta conversación alcanzó el límite de créditos de tu organización. Recarga para continuar sin perder el contexto.",
        chatTopupCta: "Recargar",
        chatTopupPending: "Abriendo…",
        chatSuspendedTitle: "Wallet suspendido",
        chatSuspendedDescription:
          "El wallet de tu organización está suspendido. El uso hosted queda bloqueado temporalmente hasta que un operador lo reactive.",
      },
      contextSwitcher: {
        selectOrganization: "Seleccionar organización",
        selectDeployment: "Seleccionar Agente",
        organization: "Organización",
        deployment: "Agente",
        orgId: "ID organización",
        environment: "Entorno",
        notSelected: "No seleccionado",
        loadingContext: "Cargando contexto…",
        createDeployment: "Nuevo",
        createDeploymentTitle: "Crear Agente",
        createDeploymentDescription:
          "Crea un Agente vacío clasificado como sandbox, adecuado para previews de Studio. Luego inicializa su proyecto con maurice spec init, sin crear recursos runtime managed.",
        createDeploymentNameLabel: "Nombre del Agente",
        createDeploymentNamePlaceholder: "Asistente de soporte",
        createDeploymentNotesLabel: "Notas iniciales",
        createDeploymentNotesPlaceholder:
          "Describe brevemente el alcance o el objetivo inicial de este Agente.",
        createDeploymentConfirm: "Crear Agente",
        createDeploymentSubmitting: "Creando…",
        createDeploymentSuccess: "Agente {{name}} creado.",
        createDeploymentFailed: "No se pudo crear el Agente.",
        createDeploymentNoOrganization: "Selecciona primero una organización.",
        createDeploymentNameRequired:
          "El nombre del Agente es obligatorio.",
        deploymentKindLabel: "Tipo de Agente",
        deploymentKindHint:
          "El tipo controla la gobernanza de Studio (preview, aprobación). Un cambio siempre pide confirmación.",
        deploymentKindConfirmTitle: "¿Cambiar el tipo de Agente?",
        deploymentKindConfirmDescription:
          "Vas a pasar « {{name}} » de {{from}} a {{to}}. Esto actualiza de inmediato las reglas de gobernanza (preview, aprobación, restricciones). Confirma solo si es intencional.",
        deploymentKindConfirmAction: "Cambiar tipo",
        deploymentKindUpdating: "Actualizando…",
        deploymentKindUpdated: "Tipo de {{name}}: {{kind}}.",
        deploymentKindUpdateFailed: "No se pudo cambiar el tipo del Agente.",
        deploymentKind: {
          sandbox: "Sandbox",
          development: "Development",
          integration_test: "Integration test",
          staging: "Staging",
          production: "Production",
          unknown: "Desconocido",
        },
      },
      chat: {
        headerTitle: "Chat con Maurice",
        freeConversation: "Conversación libre",
        recipeLabel: "Workflow: {{name}}",
        deploymentBadge: "Agente",
        sessionBadge: "Sesión",
        recipeBadge: "Contexto",
        newSessionBadge: "Nueva",
        freeConversationBadge: "Libre",
        freeConversationDescription:
          "Usa este chat para explorar, lanzar un Workflow o retomar una ejecución sin fijar el contexto demasiado pronto.",
        recipeFocusDescription:
          "Esta conversación mantiene el Workflow activo en primer plano para lanzarlo, ajustarlo y revisarlo más rápido.",
        chooseRecipe: "Elegir un Workflow",
        openCatalog: "Abrir catálogo",
        openHistory: "Abrir historial",
        skillsButton: "Skills",
        debugMessages: "Debug",
        showTechnicalMessages:
          "Mostrar llamadas a herramientas y resultados sin procesar",
        hideTechnicalMessages:
          "Ocultar llamadas a herramientas y resultados sin procesar",
        skillsSessionLabel: "Skills de sesión",
        skillsPanelTitle: "Skills de sesión",
        skillsPanelDescription:
          "Selecciona skills del Agente para enriquecer la sesión actual.",
        skillsLoading: "Cargando skills…",
        skillsLoadingError: "No se pudieron cargar las skills del Agente.",
        noSelectedSkills: "No hay skills seleccionadas para esta sesión.",
        noDeploymentSkills: "No hay skills instaladas en este Agente.",
        useSkill: "Usar",
        skillSelected: "Seleccionada",
        clearSkills: "Vaciar skills",
        skillsCleared: "Selección de skills vaciada.",
        skillNotFound: "Skill no encontrada: {{skill}}",
        skillAdded: "{{skill}} añadida a la sesión.",
        skillRemoved: "{{skill}} retirada de la sesión.",
        noSkillPreview: "No hay vista previa disponible para esta skill.",
        execution: "Ejecución",
        connectionErrorTitle: "Error de conexión",
        sessionPausedTitle: "Sesión en pausa",
        sessionPausedDescription: "La sesión se pausó tras un período de inactividad.",
        resumeConversation: "Reanudar la conversación",
        messageFeed: "Flujo de mensajes del chat",
        loadingHistory: "Cargando historial…",
        loadingOlderMessages: "Cargando mensajes anteriores…",
        startConversation: "Iniciar una conversación",
        readyForMessage: "Cuando quieras",
        askAboutRecipe: "Pregunta a Maurice cualquier cosa sobre este Workflow",
        askAboutWorkspace:
          "Pregunta a Maurice cualquier cosa sobre este espacio",
        latest: "Últimos",
        selectWorkspaceToStart: "Selecciona un espacio para empezar a chatear",
        createSessionToStart: "Crea o selecciona una sesión para empezar.",
        askMaurice: "Pregúntale a Maurice…",
        noExecutionContext: "Todavía no hay contexto de ejecución disponible",
        noActiveSessionToClear: "No hay sesión activa para limpiar",
        sessionHistoryCleared: "Historial de sesión borrado",
        failedToClearSession: "No se pudo borrar la sesión",
        clearSessionTitle: "Borrar sesión",
        clearSessionDescription:
          "Esto eliminará todo el historial de la sesión de chat actual.",
        clearHistory: "Borrar historial",
        helpMessage: [
          "Comandos disponibles:",
          "",
          "- `/status` abrir el contexto de ejecución",
          "- `/workflow` abrir el selector de Workflows",
          "- `/tools` pedir a Maurice las herramientas disponibles en este contexto",
          "- `/skills` abrir el panel de skills",
          "- `/use-skill <id>` seleccionar una skill para la sesión",
          "- `/clear-skills` vaciar la selección de skills",
          "- `/help` mostrar esta ayuda",
          "- `/clear` borrar el historial de la sesión actual",
        ].join("\n"),
        recipeContextHint:
          "Los mensajes se enviarán con este blueprint en el contexto.",
        llmActivityThinking: "Maurice está pensando…",
        llmActivityTool: "Maurice está usando una herramienta…",
        llmActivitySkill: "Maurice está aplicando una skill…",
        llmActivityProject: "Maurice está trabajando en el proyecto…",
      },
      chatInput: {
        openStatusContext: "Abrir contexto de estado",
        openStatusContextDescription:
          "Pedir el estado actual de una ejecución o Agente",
        launchRecipe: "Lanzar un Workflow",
        launchRecipeDescription:
          "Abrir el selector de Workflows o apuntar a un comando de Workflow",
        showHelp: "Mostrar ayuda",
        showHelpDescription: "Mostrar los slash commands disponibles",
        showTools: "Mostrar herramientas",
        showToolsDescription:
          "Pedir a Maurice las herramientas disponibles en este contexto",
        openSkills: "Abrir skills",
        openSkillsDescription:
          "Mostrar las skills del Agente y la selección actual de la sesión",
        useSkill: "Usar una skill",
        useSkillDescription:
          "Seleccionar una skill para enriquecer los próximos mensajes",
        clearSkills: "Vaciar skills",
        clearSkillsDescription:
          "Quitar todas las skills seleccionadas de la sesión actual",
        clearSession: "Borrar sesión",
        clearSessionDescription: "Eliminar el historial de la sesión actual",
        changeRecipe: "Cambiar",
        messageLabel: "Tu mensaje",
        quickActions: "Acciones rápidas",
        shortcutHint:
          "Usa slash commands o el selector de Workflows para encuadrar la sesión rápidamente.",
      },
      files: {
        attach: "Adjuntar un archivo",
        attached: "{{filename}} añadido al mensaje",
        uploadFailed: "Error al subir el archivo",
        uploadProgress: "Subida {{progress}}%",
        attachedFile: "Archivo adjunto",
      },
      recipePicker: {
        title: "Seleccionar un blueprint",
        description:
          "Inicia la conversación con un contexto de Workflow específico, o mantén el chat genérico.",
        searchPlaceholder: "Buscar Workflows…",
        loading: "Cargando Workflows…",
        noMatch: "Ningún Workflow coincide con esta búsqueda.",
        noDescription: "No se proporcionó descripción.",
      },
      recipeForm: {
        fallbackTitle: "Formulario de Workflow",
        fallbackDescription:
          "El Workflow en curso necesita información adicional para continuar.",
        selectOption: "Seleccionar…",
        submit: "Enviar formulario",
        submitting: "Enviando…",
        fieldRequired: "{{field}} es obligatorio.",
      },
      chatMessage: {
        resourcePreview: "Vista previa del recurso",
        previewTruncated: "Vista previa truncada.",
        result: "Resultado",
        logs: "Logs",
        userMessage: "Mensaje del usuario",
        assistantMessage: "Mensaje del asistente",
        technicalMessage: "Mensaje técnico",
      },
      executionPanel: {
        title: "Estado de ejecución",
        completedCount: "{{done}}/{{total}} completadas",
        running: "En curso…",
        progress: "Progreso",
        overallProgress: "Progreso global",
        stepProgress: "Progreso de {{step}}",
      },
      executionResult: {
        title: "Resultado",
        refresh: "Actualizar resultado",
        copy: "Copiar resultado",
        loading: "Cargando resultado…",
        empty: "No hay resultado disponible.",
      },
      executionLogs: {
        title: "Logs",
        refresh: "Actualizar logs",
        copy: "Copiar logs",
        loading: "Cargando logs…",
        empty: "No hay logs disponibles para esta ejecución.",
      },
      historyDetail: {
        rerun: "Relanzar en el chat",
        timeline: "Cronología",
        created: "Creado",
        started: "Iniciado",
        completed: "Completado",
        duration: "Duración",
        blueprint: "Blueprint",
        loadingBlueprint: "Cargando vista previa del Workflow…",
        noBlueprintPreview:
          "No hay vista previa del blueprint disponible para esta ejecución.",
        noDescription: "No se proporcionó descripción.",
        noRecipe: "No hay ningún Workflow asociado a esta ejecución.",
        error: "Error",
        notAvailable: "N/D",
        pending: "Pendiente",
        running: "En curso",
        completedStatus: "Completado",
        failed: "Fallido",
        usageTitle: "Resumen de uso",
        usageSourceTrace: "Estimado",
        usageSourceMetering: "Metering",
        usageDuration: "Duración",
        usageTokens: "Tokens",
        usageEstimatedCost: "Coste estimado",
        usageActions: "Acciones",
        usageFailures: "fallos",
        usageLLMCalls: "Llamadas LLM",
        usageMonetaryUnavailable: "Coste monetario final no disponible",
        usageNoData: "No hay resumen de uso disponible.",
        usageModelBreakdown: "Modelos",
      },
      catalog: {
        title: "Catálogo de acciones",
        description:
          "Elige un Workflow para iniciar una conversación con Maurice",
        searchPlaceholder: "Buscar Workflows...",
        all: "Todas",
        quickLaunchEyebrow: "Punto de partida",
        quickLaunchTitle: "Lanzamiento rápido",
        quickLaunchDescription:
          "Estos Workflows son los mejores puntos de partida para abrir una sesión útil sin recorrer toda la lista.",
        quickLaunchHint:
          "Usa el lanzamiento directo cuando ya sabes qué flujo quieres ejecutar.",
        quickBuildTitle: "Preparar en Studio",
        quickBuildDescription:
          "Todavía no hay Workflows listos para lanzarse aquí. Empieza por terminar los más prometedores en Agent Spec.",
        quickBuildHint:
          "Cuando todo sigue en borrador, abre el Workflow directamente en Agent Spec.",
        openInChat: "Abrir en el chat",
        resultsTitle: "Todos los Workflows",
        resultsDescription: "{{count}} Workflow(s) visibles en este Agente.",
        resultsFilteredBy: "Filtrado por {{category}}",
        resultsAllVisible: "Vista completa",
        launchableTitle: "Listas para lanzar",
        launchableDescription:
          "Estos Workflows ya se pueden usar y pueden abrir una nueva sesión inmediatamente.",
        launchableCount: "{{count}} listas",
        buildRequiredTitle: "Para terminar en Studio",
        buildRequiredDescription:
          "Estos Workflows ya existen, pero todavía necesitan una pasada por Agent Spec antes de lanzarse.",
        buildRequiredCount: "{{count}} por terminar",
        buildRequiredTruncated: "{{shown}} mostradas de {{total}}",
        showMoreBuild: "Mostrar {{count}} más",
        showLessBuild: "Mostrar menos",
        loading: "Cargando Workflows…",
        error: "Error",
        noRecipes: "No hay Workflows disponibles",
        noRecipesHint:
          "Crea y aplica un Workflow con Agent Spec para empezar",
        noSearchMatch: "Ningún Workflow coincide con tu búsqueda",
        clearFilters: "Limpiar filtros",
      },
      history: {
        title: "Historial de ejecuciones",
        description: "Consulta ejecuciones pasadas y sus resultados",
        searchPlaceholder: "Buscar por Workflow o ID de ejecución...",
        all: "Todas",
        metricsTotal: "Total",
        metricsTotalHint: "Ejecuciones cargadas",
        metricsSuccess: "Correctas",
        metricsSuccessHint: "Terminadas sin bloqueo",
        metricsAttention: "Por corregir",
        metricsAttentionHint: "Requieren intervención",
        metricsRerunnable: "Relanzables",
        metricsRerunnableHint: "Pueden volver al chat",
        surfaceHint:
          "Revisa runs recientes y abre sus detalles sin depender de un panel contextual ya relleno.",
        loading: "Cargando historial...",
        error: "Error",
        noExecutions: "No se encontraron ejecuciones",
        noExecutionsHint: "Inicia una conversación para ver el historial",
        loadMore: "Cargar más",
        pending: "Pendiente",
        running: "En curso",
        completed: "Completado",
        failed: "Fallido",
        openDetails: "Abrir detalles",
        rerun: "Relanzar en el chat",
        executionLabel: "Ejecución",
        startedLabel: "Inicio",
        durationLabel: "Duración",
        usageLabel: "Uso",
        signalLabel: "Señal",
        readinessReview: "Lista para revisión",
        readinessFix: "Por corregir",
        readinessRerunnable: "Relanzable",
        readinessRunning: "Seguimiento activo",
        readinessQueued: "En cola",
        nextStepLabel: "Siguiente paso",
        nextStepRerun:
          "Abre los detalles y relanza rápido si quieres comparar o empezar de nuevo.",
        nextStepFix:
          "Inspecciona el error, corrige el Workflow y relánzalo desde el chat.",
        nextStepWatch:
          "Sigue el progreso en detalle o espera a que termine el run.",
        nextStepQueue:
          "Espera al arranque completo antes de relanzar o intervenir.",
        groupAttentionTitle: "Por corregir",
        groupAttentionDescription:
          "Estos runs fallaron o se bloquearon y necesitan acción antes de relanzarlos.",
        groupActiveTitle: "En curso",
        groupActiveDescription:
          "Estos runs siguen avanzando en el runtime y sobre todo requieren seguimiento.",
        groupQueuedTitle: "En espera",
        groupQueuedDescription:
          "Estos runs ya existen, pero todavía no han arrancado del todo.",
        groupSuccessTitle: "Correctas",
        groupSuccessDescription:
          "Estos runs terminaron, se pueden revisar y a menudo están listos para relanzar.",
        pendingSummary: "Esta ejecución todavía espera un arranque completo.",
        runningSummary: "Esta ejecución sigue avanzando en el runtime.",
        completedSummary: "Este run terminó y está listo para revisión.",
        failedSummary: "Este run falló y necesita una revisión específica.",
      },
      recipeCard: {
        active: "Activa",
        draft: "Borrador",
        noDescription: "No se proporcionó descripción",
        steps: "{{count}} pasos",
        launch: "Lanzar",
        launchNow: "Lanzar ahora",
        openInBuild: "Abrir en Studio",
        inspectBlueprint: "Inspeccionar blueprint",
        readiness: "Siguiente paso",
        structure: "Estructura",
        readyToLaunch: "Lista para lanzar",
        finishInBuild: "Terminar en Studio",
        launchHint: "Abre directamente una nueva sesión de ejecución.",
        buildHint: "Usa Agent Spec para terminar o aplicar este Workflow.",
        workflow: "Workflow",
        miniapp: "MiniApp",
        moreTags: "+{{count}}",
      },
      filePreview: {
        image: "Imagen",
        document: "Documento",
        file: "Archivo",
        noPreviewUrl:
          "No hay URL de vista previa disponible para este archivo.",
        loadingPreview: "Cargando vista previa…",
        noInlinePreview:
          "No hay vista previa integrada disponible para este archivo.",
      },
      commandPalette: {
        button: "Comando…",
        title: "Paleta de comandos",
        description:
          "Busca comandos de la aplicación o pide a Calisto que actúe sobre el Agente actual.",
        placeholder: "Buscar comandos o preguntar a Calisto…",
        noCommands: "No se encontró ningún comando.",
        startTyping: "Empieza a escribir para buscar…",
        navigation: "Navegación",
        recipes: "Recetas",
        deployment: "Agente",
        home: "Inicio",
        homeDescription: "Ir al tablero",
        recipesView: "Recetas",
        recipesViewDescription: "Ver todas las recetas",
        capabilities: "Capacidades",
        capabilitiesDescription: "Explorar capacidades",
        deploy: "Desplegar",
        deployDescription: "Pipeline Agente",
        catalog: "Catálogo",
        catalogDescription: "Ver el catálogo de recetas",
        chat: "Chat",
        chatDescription: "Ir al chat",
        newRecipe: "Nueva receta",
        newRecipeDescription: "Crear una nueva receta",
        compileRecipe: "Compilar receta",
        compileRecipeDescription: "Compilar la receta actual",
        testRecipe: "Probar receta",
        testRecipeDescription: "Ejecutar pruebas sobre la receta actual",
        promoteRecipe: "Promover receta",
        promoteRecipeDescription: "Promover al siguiente entorno",
        rollback: "Rollback",
        rollbackDescription: "Volver a la versión anterior",
        askCalisto: "Preguntar a Calisto",
      },
      calisto: {
        adminMode: "Calisto Admin",
        adminTitle: "Administración conversacional global",
        adminDescription:
          "Calisto actúa a nivel de organización para crear, modificar y diagnosticar agentes, MCP, usuarios, skills y meta-recetas.",
        adminRuntime: "Runtime admin",
        adminLoadError: "Runtime admin no disponible",
        adminTargetScope: "Alcance de trabajo",
        allDeployments: "Todos los Agentes",
        businessDeployments: "Agentes de negocio",
        targetingAllDeployments:
          "Calisto trabaja en una vista global cross-agent.",
        targetingDeployment: "Calisto apunta a {{name}}.",
        contextRailTitle: "Contexto útil",
        contextRailDescription:
          "Señales y atajos para administrar sin salir de la conversación.",
        activeScope: "Alcance activo",
        conversation: "Conversación",
        messages: "mensajes",
        capabilities: "Capacidades disponibles",
        capabilityDeployments: "Agentes",
        capabilityMcp: "MCP y conectores",
        capabilityUsers: "Usuarios y roles",
        capabilityMetaRecipes: "Meta-recetas",
        capabilityRuntime: "Parámetros runtime",
        quickActions: "Acciones rápidas",
        quickActionsDescription:
          "Rellena el mensaje. Nada se ejecuta sin envío explícito.",
        quickActionListDeployments: "Auditar agentes",
        quickActionCreateDeployment: "Crear Agente",
        quickActionConfigureMcp: "Configurar MCP",
        quickActionInviteUser: "Invitar usuario",
        quickActionMetaRecipe: "Crear meta-receta",
        quickPromptListDeployments:
          "Lista los agentes de negocio en el alcance {{scope}}, resume su estado, MCP, skills y puntos de atención.",
        quickPromptCreateDeployment:
          "Ayúdame a crear un nuevo Agente de negocio. Empieza preguntando lo necesario sobre nombre, objetivo, usuarios, MCP, skills y parámetros LLM antes de proponer un plan.",
        quickPromptConfigureMcp:
          "Ayúdame a configurar los MCP para el alcance {{scope}}. Empieza auditando lo existente y después propone los cambios sin aplicarlos hasta que yo valide.",
        quickPromptInviteUser:
          "Ayúdame a invitar o actualizar un usuario para el alcance {{scope}}. Pregunta email, rol y accesos antes de cualquier acción.",
        quickPromptMetaRecipe:
          "Ayúdame a crear o actualizar una meta-receta para el alcance {{scope}}. Empieza por entender el objetivo de negocio y luego propone la estructura y las etapas de validación.",
        guardrails: "Reglas de seguridad",
        guardrailConfirmation:
          "Las eliminaciones deben confirmarse con el nombre exacto.",
        guardrailLastDeployment:
          "El último Agente de negocio no debe eliminarse sin un reemplazo validado.",
        guardrailAdminHidden:
          "El runtime admin Calisto permanece oculto en los selectores de negocio.",
        connectedContext: "Conectado al contexto del Agente",
        connectingContext: "Conectando al contexto del Agente",
        minimize: "Minimizar",
        clearConversation: "Borrar conversación",
        clearConversationTitle: "Borrar conversación de Calisto",
        clearConversationDescription:
          "Esto eliminará el historial de esta conversación de Calisto. El contexto de trabajo seguirá disponible, pero Calisto empezará sin los mensajes anteriores.",
        clearConversationConfirm: "Borrar",
        conversationCleared: "Conversación de Calisto borrada",
        conversationClearFailed: "No se pudo borrar la conversación de Calisto",
        noActiveConversationToClear:
          "No hay una conversación de Calisto activa para borrar",
        startConversation: "Inicia una conversación con Calisto",
        describeChange:
          "Describe el cambio que quieres en el blueprint o el Agente.",
        you: "Tú",
        thinking: "Calisto está pensando",
        proposedChanges: "Cambios propuestos ({{count}})",
        addNode: "Añadir nodo",
        updateNode: "Actualizar nodo",
        deleteNode: "Eliminar nodo",
        addConnection: "Añadir conexión",
        deleteConnection: "Eliminar conexión",
        yes: "Sí",
        no: "No",
        firstBuildWelcome:
          "Hola, soy Calisto. Voy a ayudarte a construir tu primer agente. Que quieres construir? Describe el resultado esperado, las herramientas o integraciones que hay que conectar y los datos que quieres usar.",
        askPlaceholder: "Preguntar a Calisto…",
        sendHint: "Pulsa Enter para enviar. Shift+Enter para una nueva línea.",
        guidedConverge: "Convergencia guiada",
        executionPlanTitle: "Plan de ejecución",
        executionPlanDescription:
          "Prepara, aplica y sigue la convergencia sin exponer detalles técnicos por defecto.",
        executionStatePreparing: "Preparando plan",
        executionStateApplying: "Aplicando plan",
        executionStatePlanReady: "Plan listo",
        executionStateAttention: "Requiere atención",
        executionStateNeedsPlan: "Hace falta un plan",
        executionPrepareInProgress:
          "Calisto está preparando el plan de ejecución a partir de la spec y del Agente objetivo.",
        executionApplyInProgress:
          "Calisto está aplicando el plan preparado y siguiendo el retorno del Agente.",
        executionNeedsReviewDescription:
          "El contexto de convergencia todavía requiere validación antes del apply.",
        executionNeedsPlanDescription:
          "Prepara un plan para convertir las señales de drift en acciones concretas.",
        executionReadyToApply: "Listo para aplicar",
        executionSignals: "Señales",
        executionPlan: "Plan",
        executionApply: "Apply",
        executionStageReady: "Listo",
        executionStagePending: "Pendiente",
        executionStageInProgress: "En curso",
        executionStageDone: "Completado",
        executionWarningsCount: "{{count}} advertencia(s) para revisar",
        executionDetailsTitle: "Detalles de ejecución",
        executionDetailsDescription:
          "Aquí encontrarás el plan preparado, atajos útiles y pasos detallados.",
        executionShowDetails: "Ver detalles",
        executionHideDetails: "Ocultar detalles",
        executionShortcutsTitle: "Atajos útiles",
        targetDeployment: "Agente objetivo",
        activeBlueprint: "Blueprint activo",
        refresh: "Actualizar",
        preparedPlanReady: "Plan preparado listo",
        hash: "Hash",
        recommendedActions: "Acciones recomendadas",
        preparePlan: "Preparar plan",
        applyPlan: "Aplicar plan",
        apply: "Aplicar",
        everythingSynced: "Todo está sincronizado",
        workflow: "Workflow",
        streaming: "streaming…",
        arguments: "Argumentos:",
        result: "Resultado:",
        error: "Error:",
        slashMenuTitle: "Herramientas de Calisto",
        slashHelpLabel: "Mostrar ayuda de Calisto",
        slashHelpDescription:
          "Mostrar los slash commands disponibles para Calisto",
        slashToolsLabel: "Listar herramientas",
        slashToolsDescription:
          "Pedir a Calisto qué herramientas son útiles ahora",
        slashContextLabel: "Inspeccionar contexto",
        slashContextDescription:
          "Resumir el contexto actual del Agente y del blueprint",
        slashHealthLabel: "Inspeccionar salud",
        slashHealthDescription:
          "Diagnosticar la salud del contexto y la memoria de Calisto",
        slashDriftLabel: "Explicar drift",
        slashDriftDescription:
          "Comparar la meta-receta activa y el Agente objetivo",
        slashPlanLabel: "Preparar plan",
        slashPlanDescription:
          "Lanzar el flujo guiado de preparación de convergencia",
        slashRefreshLabel: "Actualizar convergencia",
        slashRefreshDescription:
          "Recargar las señales de convergencia guiada y el contexto",
        slashSpecLabel: "Analizar specs adjuntas",
        slashSpecDescription:
          "Enviar los archivos adjuntos actuales como contexto de specs a Calisto",
        slashClearLabel: "Borrar conversación",
        slashClearDescription:
          "Eliminar el historial de la conversación actual de Calisto",
        slashHelpMessage: [
          "Comandos disponibles de Calisto:",
          "",
          "- `/tools` lista las herramientas útiles en el contexto actual",
          "- `/context` resume el contexto actual del Agente",
          "- `/health` inspecciona la salud y la memoria de Calisto",
          "- `/drift` explica la diferencia entre la spec y el Agente",
          "- `/plan` prepara el plan guiado de convergencia",
          "- `/refresh` recarga el contexto de Calisto y el estado de convergencia",
          "- `/spec` analiza los archivos adjuntos actuales del composer",
          "- `/clear` elimina el historial de la conversación actual tras confirmación",
          "",
          "También puedes adjuntar archivos como specs antes de enviar un mensaje.",
        ].join("\n"),
        specNeedsFiles: "Adjunta al menos un archivo antes de usar /spec.",
      },
      build: {
        accessPrimaryCta: "Abrir una vista Configuración disponible",
        accessBackToRun: "Volver a Run",
        accessRecipesTitle: "Acceso Studio limitado",
        accessRecipesDescription:
          "Esta zona Studio requiere permisos de edición sobre las recetas. Tu rol actual no puede abrir las pantallas de authoring.",
        accessDeployTitle: "Se requiere acceso a Deploy",
        accessDeployDescription:
          "La página Deploy requiere permisos explícitos del Agente. Abre otra vista Configuración disponible o vuelve a Run.",
        accessObserveTitle: "Observe no está disponible",
        accessObserveDescription:
          "La página Observe requiere acceso a los logs del Agente actual. Abre otra vista Configuración disponible o vuelve a Run.",
        accessExternalControlTitle: "Claves del Agente restringidas",
        accessExternalControlDescription:
          "Esta zona Configuración requiere permisos explícitos del Agente.",
        recipesTitle: "Mis Recetas",
        recipesDescription: "Gestiona tus meta-recetas de IA.",
        recipesSelectOrg:
          "Selecciona una organización en el selector de contexto para cargar las recetas.",
        recipesCountLabel: "Recetas",
        recipesSpecSourceSummaryLabel: "{{count}} meta-receta fuente",
        recipesSpecSourceSummaryLabel_other: "{{count}} meta-recetas fuente",
        recipesNodeCountSummaryLabel: "{{count}} nodos descritos en total",
        recipesRuntimeActiveLabel: "Activas runtime",
        recipesRuntimeActiveHint:
          "Recetas de la spec encontradas en el runtime activo.",
        recipesPublishedLabel: "Sincronizadas",
        recipesPublishedHint:
          "Recetas ya alineadas con el Agente objetivo.",
        recipesPendingLabel: "Por revisar",
        recipesPendingHint:
          "Recetas pendientes, con deriva o que requieren revisión antes del apply.",
        recipesLatestUpdatedLabel: "Última actualización",
        recipesLatestUpdatedHint:
          "Receta modificada más recientemente en este Agente.",
        recipesNodeCountLabel: "{{count}} nodo",
        recipesNodeCountLabel_other: "{{count}} nodos",
        recipesDeploymentScopeLabel: "Agente",
        recipesUpdatedLabel: "Actualizada",
        recipesCreatedLabel: "Creada",
        recipesOpenMetaRecette: "Abrir meta-receta",
        recipesRuntimeActiveStatus: "Runtime activo",
        recipesSpecOnlyStatus: "Solo spec",
        recipesNoSpecDefinitionsTitle: "Ninguna receta declarada en la spec",
        recipesNoSpecDefinitionsDescription:
          "La meta-receta existe, pero su structured_spec todavía no contiene recipes_definitions.",
        recipesDefaultModeLabel: "workflow",
        recipesRecipeIdLabel: "ID",
        recipesSourceMetaRecetteLabel: "Fuente",
        recipesFormsLabel: "Forms",
        recipesFormsCount: "{{count}} form",
        recipesFormsCount_other: "{{count}} forms",
        recipesEditFullSpec: "Editar spec completa",
        recipesDriftTitle: "Drift spec/runtime",
        recipesDriftDescription:
          "{{specMissing}} receta(s) de la spec faltan en el runtime, {{runtimeOrphans}} receta(s) runtime no están declaradas en la spec.",
        recipesSpecMissingRuntimeHint:
          "Declarada en la spec, pero ausente del runtime activo.",
        recipesRuntimeOrphanHint:
          "Activa en runtime, pero ausente de la spec canónica.",
        recipesSpecConsistentTitle: "Spec y runtime alineados",
        recipesSpecConsistentDescription:
          "Todas las recetas declaradas en la spec están activas en el runtime.",
        recipesPrimarySyncedDescription:
          "Esta receta está alineada. Puedes revisar la meta-receta o iniciar un nuevo cambio desde allí.",
        recipesPrimaryPendingDescription:
          "Esta receta todavía necesita planificación o apply antes de ser realmente utilizable.",
        recipesPrimaryDraftDescription:
          "Sigue editando antes de preparar un plan o pedir convergencia a Calisto.",
        recipesWorkflowTitle: "Cómo trabajar aquí",
        recipesWorkflowDescription:
          "La página Recipes sirve para editar el blueprint. La meta-receta y Calisto toman el relevo para planificar, aplicar y verificar los cambios.",
        recipesWorkflowStepEditLabel: "Edita el blueprint",
        recipesWorkflowStepEditDescription:
          "Trabaja la estructura de la receta en el canvas visual o en el YAML sincronizado.",
        recipesWorkflowStepMetaLabel: "Revisa en la meta-receta",
        recipesWorkflowStepMetaDescription:
          "Abre la meta-receta para comparar la spec, preparar un plan y pedir convergencia.",
        recipesWorkflowStepShipLabel: "Prueba y publica",
        recipesWorkflowStepShipDescription:
          "Cuando la receta esté lista, lanza pruebas o publish desde el flujo de build.",
        contextUnavailable: "Contexto no disponible",
        noRecipe: "Sin receta",
        createFirstRecipe: "Crea tu primera receta para empezar.",
        newRecipe: "Nueva Receta",
        createRecipeCta: "Crear receta",
        backToList: "Volver a la lista",
        blueprintEditing: "Edición del blueprint",
        blueprintEditingDescription:
          "Alterna entre el canvas visual y la representación YAML sincronizada.",
        canvasView: "Canvas",
        yamlView: "YAML",
        reloadFromCanvas: "Recargar desde el canvas",
        applyToCanvas: "Aplicar al canvas",
        structuredSpecYaml: "YAML Structured Spec",
        yamlValidated:
          "Los cambios se validan antes de reflejarse en el canvas.",
        localDraft: "Borrador local",
        synchronized: "Sincronizado",
        yamlSaveHint:
          "El YAML describe la receta completa. Guardar aplica primero el YAML al canvas.",
        calistoCommandTitle: "Calisto Command",
        calistoCommandDescription:
          "Describe el blueprint deseado y deja que Calisto proponga cambios.",
        closeCalisto: "Cerrar Calisto",
        openCalisto: "Abrir Calisto",
        noNodeSelected: "Ningún nodo seleccionado",
        noNodeSelectedDescription:
          "Selecciona un bloque en el canvas para mostrar su configuración y las sugerencias de Calisto.",
        essential: "Esencial",
        advanced: "Avanzado",
        expert: "Experto",
        pending: "Pendiente",
        applyAction: "Aplicar",
        rejectAction: "Rechazar",
        untitledNode: "Nodo sin título",
        calistoAssistTitle: "Calisto Assist",
        calistoAssistDescription:
          "Sugerencias contextuales para enriquecer o corregir este nodo sin salir del panel.",
        suggestionLabel: "Sugerencia {{index}}",
        lastCalistoResponse: "Última respuesta de Calisto",
        targetedHelp: "Solicitar ayuda específica",
        guidedConvergeDescription:
          "Resumen del plan guiado de Calisto para el Agente activo y acciones de convergencia.",
        planReady: "Plan listo",
        activeBlueprintName: "Blueprint activo: {{name}}",
        openCalistoForWorkflow:
          "Abre Calisto en un Agente activo para cargar el flujo de convergencia.",
        configurationTitle: "Configuración",
        configurationDescription:
          "El nivel mostrado depende de la profundidad solicitada: rápida, avanzada o bruta.",
        nodeName: "Nombre del nodo",
        nodeType: "Tipo",
        model: "Modelo",
        selectModel: "Elegir un modelo",
        mainPrompt: "Prompt principal",
        mcpServer: "Servidor MCP",
        tools: "Herramientas",
        commaSeparatedList: "Lista separada por comas",
        sourceType: "Tipo de fuente",
        selectSourceType: "Seleccionar",
        source: "Fuente",
        conditionalExpression: "Expresión condicional",
        direction: "Dirección",
        format: "Formato",
        input: "Entrada",
        output: "Salida",
        temperature: "Temperatura",
        temperatureHint: "Útil sobre todo para nodos LLM",
        maxTokens: "Máx. tokens",
        timeoutMs: "Timeout (ms)",
        rawJsonConfig: "Configuración JSON cruda",
        rawJsonConfigHint:
          "Útil para ajustes avanzados o para pegar configuración.",
        saveJson: "Guardar JSON",
        revert: "Restablecer",
        database: "Base de datos",
        file: "Archivo",
        api: "API",
        json: "JSON",
        inputLabel: "Entrada",
        outputLabel: "Salida",
        deleteNode: "Eliminar nodo",
        noConditionSet: "Ninguna condición definida",
        trueLabel: "Verdadero",
        falseLabel: "Falso",
        noPromptConfigured: "Ningún prompt configurado",
        noToolsConfigured: "No hay herramientas configuradas",
        moreTools: "+ {{count}} más",
        toolsCount: "{{count}} herramientas",
        recordsCount: "{{count}} registros",
        templateEmptyName: "Receta vacía",
        templateEmptyDescription: "Empezar con un canvas vacío",
        templateRagName: "Pipeline RAG",
        templateRagDescription:
          "Flujo de generación aumentada por recuperación",
        templateChainName: "Cadena de prompts",
        templateChainDescription: "Secuencia de prompts de varios pasos",
        templateAgentName: "Agente con herramientas",
        templateAgentDescription: "Agente de IA con herramientas MCP",
        capabilitiesTitle: "Capacidades",
        capabilitiesDescription:
          "Superficies de capacidad expuestas actualmente por el OS, agrupadas por función de producto y no por tipo bruto de proveedor.",
        capabilitiesCoverageLabel: "Cobertura",
        capabilitiesCoverageHint: "Superficies de capacidad visibles en Build.",
        capabilitiesOperationalLabel: "Listo ahora",
        capabilitiesOperationalHint: "Utilizable sin rodeos.",
        capabilitiesEvolvingLabel: "En evolución",
        capabilitiesEvolvingHint:
          "Áreas todavía parciales o en proceso de afinado.",
        capabilityStatusOperational: "Operativo",
        capabilityStatusPartial: "Parcial",
        capabilityStatusInProgress: "En curso",
        capabilitySurfaceLabel: "Superficie",
        capabilityActionLabel: "Acción",
        openSurfaceAction: "Abrir {{surface}}",
        capabilitiesJourneyDesignTitle: "Diseñar",
        capabilitiesJourneyDesignDescription:
          "Diseñar un agente, estructurar una spec y razonar sobre el workflow.",
        capabilitiesJourneyConnectTitle: "Conectar",
        capabilitiesJourneyConnectDescription:
          "Conectar herramientas, datos y acciones reutilizables dentro del flujo de build.",
        capabilitiesJourneyShipTitle: "Publicar",
        capabilitiesJourneyShipDescription:
          "Validar, planificar y aplicar con guardrails visibles dentro del producto.",
        capabilitiesReadyTitle: "Listo ahora",
        capabilitiesReadyDescription:
          "Lo que los builders pueden usar inmediatamente en el trabajo diario.",
        capabilitiesEvolvingTitle: "Todavía en evolución",
        capabilitiesEvolvingDescription:
          "Áreas útiles, pero aún menos completas o menos estables que el resto del workflow.",
        capabilitiesUseNowTitle: "Cómo usar esta página",
        capabilitiesUseNowDescription:
          "Una guía de lectura rápida para saber dónde trabajar según tu intención.",
        capabilitiesUseNowStep1:
          "Empieza por Diseño y razonamiento y Herramientas & MCP para dar forma a la receta y sus integraciones.",
        capabilitiesUseNowStep2:
          "Usa Guardrails y Automatización para preparar un plan, revisarlo y aplicarlo sin perder el contexto.",
        capabilitiesUseNowStep3:
          "Trata Datos y recuperación y Asistencia contextual como superficies valiosas pero todavía menos maduras que el núcleo de Build.",
        capabilitiesNextStepDescription:
          "Las próximas inversiones de producto con mejor retorno para esta zona.",
        capabilitiesNextStepData:
          "Hacer la capa Data más concreta con ingestión, exploración y enlaces directos al Agente.",
        capabilitiesNextStepAssist:
          "Hacer Assist más accionable con sugerencias contextuales y transiciones más claras hacia Calisto.",
        capabilityReasoningTitle: "Reasoning",
        capabilityReasoningDescription:
          "Modelos fundacionales y superficies de orquestación de prompts.",
        capabilityReasoningItem1: "Nodos LLM",
        capabilityReasoningItem2: "Agentes guiados por prompt",
        capabilityReasoningItem3: "Respuestas en streaming",
        capabilityToolsTitle: "Tools & MCP",
        capabilityToolsDescription:
          "Herramientas externas expuestas mediante MCP o integraciones directas.",
        capabilityToolsItem1: "Nodos MCP",
        capabilityToolsItem2: "Renderizado de llamadas de herramienta",
        capabilityToolsItem3: "Entradas del command palette",
        capabilityDataTitle: "Datos y recuperación",
        capabilityDataDescription:
          "Fuentes y superficies de recuperación para los contextos de Build y Run.",
        capabilityDataItem1: "Nodos de datos",
        capabilityDataItem2: "Scoping de workspace",
        capabilityDataItem3: "Plano de ingestión aún por reforzar",
        capabilityGuardrailsTitle: "Guardrails",
        capabilityGuardrailsDescription:
          "Validación, revisión y controles de publicación antes del apply.",
        capabilityGuardrailsItem1: "Validación de spec",
        capabilityGuardrailsItem2: "Generación de plan y diff",
        capabilityGuardrailsItem3: "Aprobaciones antes del apply",
        capabilityAutomationTitle: "Automatización",
        capabilityAutomationDescription:
          "Flows reutilizables y mutaciones de blueprint iniciadas por Calisto.",
        capabilityAutomationItem1: "Acciones de canvas",
        capabilityAutomationItem2: "Flujo apply / reject",
        capabilityAutomationItem3: "Workflow de comandos embebido",
        capabilityAssistTitle: "Asistencia contextual",
        capabilityAssistDescription:
          "Guía contextual integrada en Build y más adelante en Run.",
        capabilityAssistItem1: "Sugerencias de inspección",
        capabilityAssistItem2: "Prompts centrados en nodos",
        capabilityAssistItem3: "Resúmenes de acciones",
        dataPlaneTitle: "Plano de datos",
        dataPlaneDescription:
          "Organiza las superficies de datos, la memoria de workspace y los puntos de recuperación alrededor del Agente actual.",
        dataCoverageLabel: "Cobertura",
        dataCoverageHint:
          "Superficies de datos cartografiadas dentro de Build.",
        dataAvailableLabel: "Disponibles",
        dataAvailableHint: "Superficies ya utilizables dentro del producto.",
        dataNeedsSetupLabel: "Por conectar",
        dataNeedsSetupHint:
          "Superficies que todavía requieren ingestión o integración.",
        dataStatusReady: "Listo",
        dataStatusRuntime: "Runtime",
        dataStatusPartial: "Parcial",
        dataStatusNeedsIngestion: "Requiere ingestión",
        dataJourneyScopeTitle: "Scope",
        dataJourneyScopeDescription:
          "Empieza por entender qué organización, Agente y workspace limitan el contexto de datos.",
        dataJourneyConnectTitle: "Connect",
        dataJourneyConnectDescription:
          "Después conecta fuentes estructuradas, APIs y la memoria útil para el build.",
        dataJourneyRetrieveTitle: "Retrieve",
        dataJourneyRetrieveDescription:
          "Finalmente prepara rutas de recuperación legibles para Calisto y para las recetas.",
        dataAvailableNowTitle: "Disponible ahora",
        dataAvailableNowDescription:
          "Superficies ya visibles o directamente accionables en el workflow actual.",
        dataNeedsSetupTitle: "Todavía por conectar",
        dataNeedsSetupDescription:
          "Superficies importantes, pero que todavía necesitan ingestión, inventario o binding de producto.",
        dataScopeTitle: "Scope actual",
        dataScopeDescription:
          "La data útil siempre depende del tenant, el Agente y el workspace activos.",
        dataScopeOrganization: "Organización: {{value}}",
        dataScopeDeployment: "Agente: {{value}}",
        dataScopeWorkspace: "Workspace: {{value}}",
        dataNextStepDescription:
          "Lo que haría esta página inmediatamente más útil para los builders.",
        dataNextStepInventory:
          "Exponer un inventario real de fuentes conectadas en lugar de solo categorías teóricas.",
        dataNextStepBindings:
          "Mostrar los bindings reales entre recetas, workspace memory y superficies de recuperación.",
        dataSurfaceStructuredTitle: "Structured sources",
        dataSurfaceStructuredDescription:
          "Bases de datos, almacenes y sistemas de negocio tabulares.",
        dataSurfaceStructuredDetail1: "Fuentes relacionales y tabulares",
        dataSurfaceStructuredDetail2:
          "Buen encaje para nodos de datos explícitos",
        dataSurfaceStructuredDetail3:
          "Deberían conectarse directamente al Agente objetivo",
        dataSurfaceDocumentsTitle: "Document knowledge",
        dataSurfaceDocumentsDescription:
          "Archivos, manuales, contratos y conocimiento interno de formato largo.",
        dataSurfaceDocumentsDetail1: "Necesita flujos de ingestión claros",
        dataSurfaceDocumentsDetail2:
          "Debe exponer la indexación y la frescura con claridad",
        dataSurfaceDocumentsDetail3:
          "Todavía es menos concreta que la superficie estructurada",
        dataSurfaceApisTitle: "Operational APIs",
        dataSurfaceApisDescription:
          "Sistemas externos expuestos mediante APIs o servidores MCP.",
        dataSurfaceApisDetail1: "Ya está parcialmente presente mediante MCP",
        dataSurfaceApisDetail2:
          "Todavía necesita inventario y bindings visibles",
        dataSurfaceApisDetail3:
          "Superficie útil para recetas orientadas a la acción",
        dataSurfaceWorkspaceTitle: "Workspace memory",
        dataSurfaceWorkspaceDescription:
          "Contexto de corto plazo limitado al workspace y al Agente.",
        dataSurfaceWorkspaceDetail1:
          "Disponible durante la ejecución y las conversaciones asistidas",
        dataSurfaceWorkspaceDetail2:
          "Útil para conservar artefactos y contexto local",
        dataSurfaceWorkspaceDetail3: "Debe conectarse mejor con recetas y runs",
        implementationNextStep: "Siguiente paso de implementación",
        observeTitle: "Observe",
        clearFocus: "Limpiar foco",
        noEnv: "Sin entorno",
        observeDescription:
          "Señales operativas del Agente actual, con inspección focalizada cuando Calisto te dirige a una ejecución concreta.",
        observeRuntimeStatus: "Estado runtime: {{value}}",
        observeTotalTracked: "Total seguido: {{count}}",
        observeLastCheck: "Último control: {{value}}",
        observeRunId: "Run ID: {{value}}",
        observeSuggestedActions: "Acciones sugeridas",
        observeStableBaseline: "Baseline estable",
        observeCandidate: "Candidato",
        observeRegressionDiff: "Diff de regresión",
        observeNoFocusedRun:
          "Todavía no hay un run focalizado. Abre el último apply o test, o vuelve a Calisto para pedir una nueva inspección.",
        observeOpenLatestApply: "Abrir el último apply",
        observeOpenLatestTest: "Abrir el último test",
        observeNoRuns: "Aún no hay runs disponibles.",
        selectOrgDeployment:
          "Selecciona una organización y un Agente para inspeccionar las señales de observabilidad.",
        blueprintFocus: "Foco blueprint",
        focusedInspection: "Inspección focalizada",
        currentMetaRecette:
          "Meta-receta actual y actividad reciente de apply/test",
        detailsForRun:
          "Detalles de la ejecución que Calisto te pidió inspeccionar",
        openBlueprint: "Abrir blueprint",
        openPublishFlow: "Abrir flujo de publicación",
        openInCalisto: "Abrir en Calisto",
        runInChat: "Ejecutar en el chat",
        noMetaRecette:
          "Todavía no hay meta-receta resuelta para este Agente.",
        recentApplyRuns: "Applies recientes",
        recentTestRuns: "Tests recientes",
        components: "Componentes",
        searchComponents: "Buscar...",
        dragOrClick:
          "Arrastra un componente al canvas o haz clic para añadirlo",
        createRecipe: "Crear receta",
        createRecipeDescription:
          "Crea una nueva meta-receta a partir de una plantilla o empieza con un canvas vacío.",
        recipeName: "Nombre de la receta",
        recipeDescriptionOptional: "Descripción (opcional)",
        chooseTemplate: "Elegir una plantilla",
        cancel: "Cancelar",
        creating: "Creando...",
        createRecipeAction: "Crear receta",
        deployHealth: "Salud",
        deployUptime: "Tiempo activo",
        deployActiveExecutions: "Ejecuciones activas",
        deployTotalExecutions: "Ejecuciones totales",
        deployLastCheck: "Última comprobación de salud",
        restart: "Reiniciar",
        deployRedeploy: "Redesplegar",
        deployRedeployInProgress: "ReAgente…",
        deployRedeployConfirm:
          "¿Redesplegar este Agente? No estará disponible temporalmente y se recargará la configuración runtime.",
        deployRedeploySuccess: "ReAgente iniciado.",
        deployRedeployError: "No se pudo redesplegar.",
        deployDangerZoneTitle: "Zona de peligro",
        deployDangerZoneDescription:
          "La eliminación elimina definitivamente este Agente, sus recetas, sus espacios y sus conversaciones.",
        deployDeleteAction: "Eliminar este Agente",
        deployDeleteConfirm:
          "¿Eliminar definitivamente el Agente «{{name}}»? Esta acción es irreversible.",
        deployDeleteSuccess: "Agente eliminado.",
        deployDeleteError: "No se pudo eliminar este Agente.",
        stop: "Detener",
        promoteTo: "¿Promover {{recipe}} a {{target}}?",
        promoteDescription:
          "Vas a promover esta receta de {{source}} a {{target}}.",
        version: "Versión",
        addedNodes: "Nodos añadidos",
        removedNodes: "Nodos eliminados",
        modifiedNodes: "Nodos modificados",
        noChangesDetected: "No se detectaron cambios",
        dryRunMode: "Modo simulación (no aplicar cambios)",
        promoting: "Promoción en curso...",
        simulate: "Simular",
        promote: "Promover",
        pipelineTitle: "Pipeline Agente",
        deployWorkspaceTitle: "Runtime del Agente",
        deployWorkspaceDescription:
          "Configura las capas runtime del Agente: LLM, MCP, servicios internos y variables.",
        deployTabRelease: "Release",
        deployTabLlm: "LLM",
        deployTabMcp: "MCP",
        deployTabSkills: "Skills",
        deployTabInternal: "Interno",
        deployTabAccess: "Acceso",
        deployTabVariables: "Variables",
        deployRuntimeLoading: "Cargando configuración runtime…",
        deployRuntimeSummaryTitle: "Configuración runtime",
        deployRuntimeSummaryDescription:
          "Gestiona aquí las superficies runtime del Agente sin salir del workflow Build.",
        deployRuntimeManagedMode: "Modelo gestionado",
        deployRuntimeCustomMode: "Providers personalizados",
        deployRuntimeNotConfigured: "No configurado",
        deployRuntimeProvidersCount: "Providers LLM",
        deployRuntimeProvidersSummary: "{{count}} provider configurado",
        deployRuntimeProvidersSummary_other: "{{count}} providers configurados",
        deployRuntimeDefaultModel: "Modelo activo",
        deployRuntimeHostedBadge: "AgentMaurice",
        deployRuntimeHostedCreditsHint:
          "Indicativo: ~{{count}} créditos por 1k tokens.",
        deployRuntimeCreditsUnit: "créditos",
        deployRuntimeHostedPricingHint:
          "Indicativo: entrada {{input}} / salida {{output}} {{currency}} por 1k tokens.",
        deployRuntimeSystemPrompt: "Prompt del sistema",
        deployRuntimeSystemPromptSet:
          "Ya existe un prompt del sistema para este Agente.",
        deployRuntimeSystemPromptMissing:
          "No hay prompt del sistema configurado.",
        deployRuntimeMcpDescription:
          "Prepara la configuración de servidores MCP manuales, del registry y de los sidecars del Agente.",
        deployRuntimeMcpServers: "servidores",
        deployRuntimeManualServers: "Servidores manuales",
        deployRuntimeRegistryServers: "Sidecars del registry",
        deployRuntimeSkillsAttached: "skills asociados al Agente",
        deployRuntimeSkillsPanelDescription:
          "Gestiona las skills realmente instaladas en el Agente y el catálogo disponible.",
        deployRuntimeSkillsCatalogTitle: "Catálogo de skills",
        deployRuntimeSkillsCatalogDescription:
          "Instala skills desde el catálogo real expuesto por chatserver.",
        deployRuntimeSkillsRegistryTitle: "Catálogo de skills",
        deployRuntimeSkillsRegistryDescription:
          "Instala desde el catálogo las skills que necesita este Agente.",
        deployRuntimeSkillsSaveSelection: "Guardar selección",
        deployRuntimeSkillsSearchPlaceholder:
          "Buscar skills por nombre, repositorio o tag",
        deployRuntimeSkillsNoSelection: "No hay skills asociadas",
        deployRuntimeSkillsNoSelectionDescription:
          "Selecciona skills del registry para ponerlas a disposición de este Agente.",
        deployRuntimeSkillsNoCatalog: "No hay skills disponibles",
        deployRuntimeSkillsNoCatalogDescription:
          "Añade skills al catálogo antes de instalarlas en este Agente.",
        deployRuntimeSkillsNoRegistry: "No hay skills disponibles",
        deployRuntimeSkillsNoRegistryDescription:
          "Añade skills al catálogo antes de instalarlas aquí.",
        deployRuntimeSkillsConfigRequired: "Configuración requerida",
        deployRuntimeSkillsInstall: "Instalar",
        deployRuntimeSkillsUninstall: "Desinstalar",
        deployRuntimeSkillsInstalled: "Instaladas runtime",
        deployRuntimeSkillsFilesCount: "{{count}} archivo(s)",
        deployRuntimeSkillsToolsCount: "{{count}} herramienta(s) MCP",
        deployRuntimeSkillsInstallations: "Instalaciones",
        deployRuntimeSkillsInstallationsTitle: "Instalaciones del catálogo",
        deployRuntimeSkillsInstallationsDescription:
          "Estas líneas vienen de SkillInstallation e indican los paquetes instalados para este Agente.",
        deployRuntimeSkillsNoInstallations: "No hay instalación del catálogo.",
        deployRuntimeSkillsNoInstallationsDescription:
          "Las instalaciones aparecerán aquí después de añadir una skill desde el catálogo real.",
        deployRuntimeSkillsCatalogCount: "Catálogo",
        deployRuntimeSkillsInstalledTitle: "Estado real del runtime",
        deployRuntimeSkillsInstalledDescription:
          "Esta lista viene de chatserver y refleja las skills efectivamente disponibles en el Agente.",
        deployRuntimeSkillsNoInstalled: "No hay skill instalada en el runtime.",
        deployRuntimeSkillsNoInstalledDescription:
          "Instala una skill desde el catálogo real o importa un SKILL.md en este Agente.",
        deployRuntimeSkillsVerified: "Verificada",
        deployRuntimeSkillsInactive: "Inactiva",
        deployRuntimeSkillsNotInstalled: "No instalada",
        deployRuntimeSkillsInstallSuccess:
          "Skill {{skillName}} instalada en el Agente.",
        deployRuntimeSkillsInstallError:
          "No se pudo instalar la skill {{skillName}}.",
        deployRuntimeSkillsUninstallSuccess:
          "Skill {{skillName}} desinstalada del Agente.",
        deployRuntimeSkillsUninstallError:
          "No se pudo desinstalar la skill {{skillName}}.",
        deployRuntimeSkillsUninstallConfirm:
          "¿Desinstalar la skill {{skillName}} de este Agente?",
        deployRuntimeSkillsGitHubImportTitle: "Instalar desde GitHub",
        deployRuntimeSkillsGitHubImportDescription:
          "Pega una URL de repositorio o carpeta GitHub que contenga SKILL.md. Los archivos Markdown de esa carpeta se importan en este Agente.",
        deployRuntimeSkillsGitHubUrlPlaceholder:
          "https://github.com/owner/repo/tree/main/skills/mi-skill",
        deployRuntimeSkillsGitHubBranchPlaceholder: "Rama (opcional)",
        deployRuntimeSkillsGitHubPathPlaceholder: "Carpeta (opcional)",
        deployRuntimeSkillsGitHubIdPlaceholder: "ID skill (opcional)",
        deployRuntimeSkillsGitHubOverwrite: "Reemplazar si la skill ya existe",
        deployRuntimeSkillsGitHubImport: "Importar",
        deployRuntimeSkillsGitHubImporting: "Importando…",
        deployRuntimeSkillsGitHubUrlRequired:
          "Introduce una URL GitHub que contenga SKILL.md.",
        deployRuntimeSkillsGitHubImportSuccess:
          "Skill {{skillName}} importada desde GitHub.",
        deployRuntimeSkillsGitHubImportError:
          "No se pudo importar esta skill desde GitHub.",
        deployRuntimeSkillsSelectionUpdated: "Selección de skills actualizada.",
        deployRuntimeSkillsSelectionError:
          "No se pudo actualizar la selección de skills.",
        deployRuntimeSkillsFootnoteTitle: "Cuándo usar skills",
        deployRuntimeSkillsFootnoteDescription:
          "Usa skills para exponer workflows de build especializados sin sobrecargar las recetas estándar del Agente.",
        deployRuntimeAccessPanelDescription:
          "Gestiona las superficies de acceso del Agente: claves API y configuración del gateway de autenticación.",
        deployRuntimeApiKeysTitle: "Claves del Agente",
        deployRuntimeApiKeysDescription:
          "Crea, regenera y organiza claves sk_maurice_ usadas por LocalMaurice, X-API-Key, recetas HTTP y runtimes.",
        agentControlTitle: "Control agent-native",
        agentControlDescription: "Supervisa los accesos de agentes de código, las aprobaciones humanas de Agent Spec y las claves temporales asociadas.",
        agentAccessKindAgent: "Agente de código",
        agentAccessKindCli: "MauriceCLI",
        agentAccessTitle: "Accesos de agentes de código",
        agentAccessDescription:
          "Enlaces bootstrap emitidos para agentes de código y MauriceCLI. Revocar un enlace también revoca su clave temporal.",
        agentAccessNoActiveLinks: "No hay ningún enlace bootstrap activo.",
        agentAccessRevokedLinks: "Enlaces revocados",
        agentControlSeeAlso: "Vistas relacionadas",
        agentControlOpenAgentSpec: "Plan y aprobación → Agent Spec",
        agentControlOpenObserve: "Apply y verificación → Agent Spec",
        agentDiscoverySupervisionTitle: "Control agent-native guiado",
        agentDiscoverySupervisionDescription:
          "Sigue los enlaces bootstrap, las claves emitidas y las aprobaciones humanas de planes Agent Spec inmutables.",
        agentDiscoveryCurrentPlanTitle: "Plan Agent Spec actual",
        agentDiscoveryNoMetaRecette: "No hay ningún Agent Spec vinculado a este Agente.",
        agentDiscoveryRecipeSpecDriftTitle: "Drift entre Agent Spec y runtime",
        agentDiscoveryRecipeSpecDriftDescription:
          "Agent Spec sigue siendo la fuente de verdad. Los Workflows y MiniApps runtime no gestionados deben adoptarse explícitamente.",
        agentDiscoveryPlanActions: "Acciones",
        agentDiscoveryApproval: "Aprobación",
        agentDiscoveryPlanHash: "Hash del plan",
        agentDiscoveryApprovePlan: "Aprobar plan",
        agentDiscoveryRejectPlan: "Rechazar",
        agentDiscoveryApproveDialogTitle: "¿Aprobar este plan?",
        agentDiscoveryApproveDialogDescription:
          "El modo guiado solo podrá aplicar este plan con el hash aprobado.",
        agentDiscoveryRejectDialogTitle: "¿Rechazar este plan?",
        agentDiscoveryRejectDialogDescription:
          "El plan actual se marcará como rechazado y no podrá aplicarse en modo guiado.",
        agentDiscoveryDecisionCommentLabel: "Comentario opcional",
        agentDiscoveryDecisionCommentPlaceholder:
          "Contexto de la decisión, riesgo aceptado o motivo del rechazo",
        agentDiscoveryNoCurrentPlan: "No hay un plan actual para aprobar.",
        agentDiscoveryApprovalsTitle: "Aprobaciones recientes",
        agentDiscoveryApprovalsDescription:
          "Historial compacto de aprobaciones humanas vinculadas al hash exacto de un plan Agent Spec inmutable.",
        agentDiscoveryUnknownApprover: "Usuario",
        agentDiscoveryNoApprovals: "No hay aprobaciones recientes.",
        agentDiscoveryBootstrapLinksTitle: "Enlaces bootstrap de agente",
        agentDiscoveryBootstrapLinksDescription:
          "Los enlaces consumidos también pueden revocar la clave temporal emitida por bootstrap.",
        agentDiscoveryNoBootstrapLinks: "No se ha generado ningún enlace bootstrap.",
        agentDiscoveryPlanApproved: "Plan aprobado",
        agentDiscoveryPlanApproveError: "No se pudo aprobar el plan",
        agentDiscoveryPlanRejected: "Plan rechazado",
        agentDiscoveryPlanRejectError: "No se pudo rechazar el plan",
        agentDiscoveryBootstrapRevoked: "Acceso del agente revocado",
        agentDiscoveryBootstrapRevokeError: "No se pudo revocar este acceso",
        cliBootstrapLinksTitle: "Enlaces bootstrap de MauriceCLI",
        cliBootstrapLinksDescription:
          "Estos enlaces conectan MauriceCLI a un proyecto local y pueden revocar la clave temporal del bootstrap.",
        cliBootstrapNoLinks: "No se ha generado ningún enlace bootstrap MauriceCLI.",
        cliBootstrapRevoked: "Acceso MauriceCLI revocado",
        cliBootstrapRevokeError: "No se pudo revocar este acceso MauriceCLI",
        agentDiscoveryRecentRunsTitle: "Últimos apply/test/reconcile",
        agentDiscoveryRecentRunsDescription:
          "Vista compacta de los apply, tests y verificaciones Agent Spec vinculados al control agent-native.",
        agentDiscoveryApplyRuns: "Apply / reconcile",
        agentDiscoveryTestRuns: "Tests",
        agentDiscoveryNoApplyRuns: "No hay apply/reconcile reciente.",
        agentDiscoveryNoTestRuns: "No hay test reciente.",
        agentDiscoveryRunSync: "Sync",
        agentDiscoveryStableBaseline: "Baseline estable",
        agentDiscoveryTestCases: "Casos",
        agentDiscoveryTestFailed: "fallido(s)",
        agentDiscoveryTestSkipped: "omitido(s)",
        agentDiscoveryTestDuration: "Duración",
        agentDiscoveryTestTokens: "Tokens",
        agentDiscoveryTestCost: "Coste estimado",
        agentDiscoveryTestExecutions: "Ejecuciones",
        agentDiscoveryTestTraces: "Trazas",
        agentDiscoveryTestErrors: "Errores",
        agentDiscoveryIntegrationSurfacesTitle: "Inventario de integraciones agent-native",
        agentDiscoveryIntegrationSurfacesDescription:
          "Resumen de las superficies que el agente puede descubrir mediante External Inception y de los límites OS/HTTP-only.",
        agentDiscoveryNoIntegrationSurfaces: "No hay inventario de integraciones disponible.",
        deployRuntimeApiKeysCount: "Claves activas",
        deployRuntimeApiKeysExpiringSoon: "Caducan pronto",
        deployRuntimeApiKeysNeverExpire: "Sin caducidad",
        deployRuntimeApiKeyCreate: "Crear clave",
        deployRuntimeApiKeyCreateDescription:
          "Define un nombre, una descripción y una duración para esta nueva clave.",
        deployRuntimeApiKeyEdit: "Editar clave",
        deployRuntimeApiKeyEditDescription:
          "Ajusta el nombre y la descripción de esta clave sin cambiar su alcance técnico.",
        deployRuntimeApiKeyDelete: "Eliminar clave",
        deployRuntimeApiKeyDeleteDescription:
          "La clave {{name}} se eliminará inmediatamente. Los clientes que la usan perderán acceso.",
        deployRuntimeApiKeyName: "Nombre",
        deployRuntimeApiKeyNamePlaceholder: "CLI de integración",
        deployRuntimeApiKeyDescriptionLabel: "Descripción",
        deployRuntimeApiKeyDescriptionPlaceholder:
          "Explica quién usa esta clave y en qué contexto.",
        deployRuntimeApiKeyExpiration: "Caducidad",
        deployRuntimeApiKeyExpiration30Days: "30 días",
        deployRuntimeApiKeyExpiration90Days: "90 días",
        deployRuntimeApiKeyExpiration1Year: "1 año",
        deployRuntimeApiKeyExpirationNever: "Nunca",
        deployRuntimeApiKeyExpirationCustom: "Fecha personalizada",
        deployRuntimeApiKeyCustomExpiration: "Fecha de caducidad",
        deployRuntimeApiKeyCreated: "Clave creada.",
        deployRuntimeApiKeyCreateError: "No se pudo crear la clave.",
        deployRuntimeApiKeyUpdated: "Clave actualizada.",
        deployRuntimeApiKeyUpdateError: "No se pudo actualizar la clave.",
        deployRuntimeApiKeyDeleted: "Clave eliminada.",
        deployRuntimeApiKeyDeleteError: "No se pudo eliminar la clave.",
        deployRuntimeApiKeyRegenerated: "Clave regenerada.",
        deployRuntimeApiKeyRegenerate: "Regenerar",
        deployRuntimeApiKeyRegenerateError: "No se pudo regenerar la clave.",
        deployRuntimeApiKeyCopied: "Clave copiada.",
        deployRuntimeApiKeyCopyError: "No se pudo copiar la clave.",
        deployRuntimeApiKeyNoKeys: "No hay claves adicionales",
        deployRuntimeApiKeyNoKeysDescription:
          "Crea claves dedicadas para las integraciones en lugar de compartir una clave primaria entre varios usos.",
        deployRuntimeDeploymentMembersTitle: "Usuarios del Agente",
        deployRuntimeDeploymentMembersDescription:
          "Asigna los miembros de la organización que pueden usar este Agente.",
        deployRuntimeDeploymentMemberSelect: "Elegir un miembro",
        deployRuntimeDeploymentMemberAssign: "Asignar",
        deployRuntimeDeploymentMemberAssigned: "Usuario asignado al Agente.",
        deployRuntimeDeploymentMemberAssignError:
          "No se pudo asignar este usuario al Agente.",
        deployRuntimeDeploymentMemberRemoved: "Asignación eliminada.",
        deployRuntimeDeploymentMemberRemoveError:
          "No se pudo eliminar esta asignación.",
        deployRuntimeDeploymentMembersEmpty:
          "No hay usuarios asignados. El Agente sigue disponible para los miembros de la organización hasta que exista una asignación explícita.",
        deployRuntimeDeploymentMemberOperator: "Operador",
        deployRuntimeDeploymentMemberViewer: "Solo lectura",
        deployRuntimeDeploymentMemberUser: "Usuario",
        deployRuntimeDeploymentMemberRole: "Rol",
        deployRuntimeApiKeyRevealTitle: "Guarda esta clave ahora",
        deployRuntimeApiKeyRevealDescription:
          "El valor completo solo se muestra tras crearla o regenerarla. Cópialo ahora si lo necesitas.",
        deployRuntimeApiKeyCopy: "Copiar clave",
        deployRuntimeApiKeyCreatedAt: "Creada",
        deployRuntimeApiKeyExpiresAt: "Caduca",
        deployRuntimeApiKeyNeverExpiresLabel: "No caduca",
        deployRuntimeApiKeyExpired: "Caducada",
        deployRuntimeApiKeyExpiringSoon: "Caduca pronto",
        deployRuntimeApiKeyActive: "Activa",
        deployRuntimeAuthConnectorTitle: "Auth connector",
        deployRuntimeAuthConnectorDescription:
          "Configura el gateway de autenticación del Agente desde una spec JSON que puedes validar antes de guardar.",
        deployRuntimeAuthConnectorStatus: "Estado",
        deployRuntimeAuthConnectorConfigured: "Configurado",
        deployRuntimeAuthConnectorNotConfigured: "No configurado",
        deployRuntimeAuthConnectorVersion: "Versión",
        deployRuntimeAuthConnectorPresets: "Presets",
        deployRuntimeAuthConnectorSelectPreset: "Elegir un preset",
        deployRuntimeAuthConnectorApplyPreset: "Aplicar preset",
        deployRuntimeAuthConnectorSpec: "Spec JSON",
        deployRuntimeAuthConnectorValid: "Spec válida",
        deployRuntimeAuthConnectorInvalid: "Spec inválida",
        deployRuntimeAuthConnectorErrors: "Errores",
        deployRuntimeAuthConnectorWarnings: "Advertencias",
        deployRuntimeAuthConnectorPresetApplied: "Preset aplicado.",
        deployRuntimeAuthConnectorSaved: "Auth connector guardado.",
        deployRuntimeAuthConnectorSaveError:
          "No se pudo guardar el auth connector.",
        deployRuntimeAuthConnectorDeleted: "Auth connector eliminado.",
        deployRuntimeAuthConnectorDeleteError:
          "No se pudo eliminar el auth connector.",
        deployRuntimeAuthConnectorValidateError:
          "No se pudo validar la spec del auth connector.",
        deployRuntimeAuthConnectorMappingTitle: "Lookup mappings",
        deployRuntimeAuthConnectorMappingDescription:
          "Asocia identidades externas con organizaciones y agentes resueltos para este gateway.",
        deployRuntimeAuthConnectorFieldIssuer: "Issuer",
        deployRuntimeAuthConnectorFieldExternalUserId: "External user ID",
        deployRuntimeAuthConnectorFieldEmail: "Email",
        deployRuntimeAuthConnectorFieldRoles: "Roles (separados por comas)",
        deployRuntimeAuthConnectorFieldResolvedOrg: "Organización resuelta",
        deployRuntimeAuthConnectorFieldResolvedDeployment:
          "Agente resuelto",
        deployRuntimeAuthConnectorFieldMetadata: "Metadata JSON",
        deployRuntimeAuthConnectorMappingResolvedTarget: "Destino resuelto",
        deployRuntimeAuthConnectorSaveMapping: "Guardar mapping",
        deployRuntimeAuthConnectorMappingSaved: "Mapping guardado.",
        deployRuntimeAuthConnectorMappingSaveError:
          "No se pudo guardar el mapping.",
        deployRuntimeAuthConnectorMappingDeleted: "Mapping eliminado.",
        deployRuntimeAuthConnectorMappingDeleteError:
          "No se pudo eliminar el mapping.",
        deployRuntimeAuthConnectorNoMappings: "No hay mappings configurados",
        deployRuntimeAuthConnectorBulkTitle: "Importar mappings en bloque",
        deployRuntimeAuthConnectorBulkDescription:
          "Importa una lista JSON de mappings para acelerar el bootstrap del gateway.",
        deployRuntimeAuthConnectorBulkImport: "Importar mappings",
        deployRuntimeAuthConnectorBulkSuccess: "Mappings importados.",
        deployRuntimeAuthConnectorBulkError:
          "No se pudieron importar los mappings en bloque.",
        deployRuntimeAuthConnectorGatewayTitle: "Gateway Next.js",
        deployRuntimeAuthConnectorGatewayDescription:
          "Genera un archivo listo para integrar en frontend a partir de la spec actual.",
        deployRuntimeAuthConnectorGatewayHint:
          "Descarga el ZIP solo cuando la spec y los mappings sean coherentes.",
        deployRuntimeAuthConnectorDownloadGateway: "Descargar ZIP",
        deployRuntimeAuthConnectorGatewayDownloaded: "Gateway descargado.",
        deployRuntimeAuthConnectorGatewayDownloadError:
          "No se pudo descargar el gateway.",
        deployRuntimeActions: "Acciones",
        deployRuntimeOAuth: "OAuth y doctor",
        deployRuntimeOAuthDescription:
          "Los flujos OAuth y el doctor SSE se conectarán aquí con el mismo ciclo de vida que en el dashboard.",
        deployRuntimeInternalDescription:
          "Prepara los servicios internos del Agente: almacenamiento de artefactos, búsqueda documental, memoria de negocio, multimodal, mensajería y control experto.",
        deployRuntimeUnsavedChanges: "Cambios sin guardar",
        deployRuntimeSavedState: "Guardado",
        deployRuntimeResetDraft: "Descartar cambios",
        deployRuntimeSaving: "Guardando…",
        deployRuntimeStorage: "Storage",
        deployRuntimeCompanyMemory: "Company memory",
        deployRuntimeEnabled: "Activado",
        deployRuntimeDisabled: "Desactivado",
        deployRuntimeLlmPanelDescription:
          "Elige un modelo gestionado, configura providers personalizados y ajusta el prompt del sistema del Agente.",
        deployRuntimeAddProvider: "Añadir provider",
        deployRuntimeProvidersList: "Providers configurados",
        deployRuntimeProvidersListDescription:
          "Gestiona aquí los endpoints LLM usados por este Agente cuando sales del modo gestionado.",
        deployRuntimeNoProviders:
          "No hay providers personalizados configurados.",
        deployRuntimeDefault: "Por defecto",
        deployRuntimeModelMissing: "Sin modelo configurado",
        deployRuntimeSetDefault: "Usar por defecto",
        deployRuntimeCreateProvider: "Crear provider",
        deployRuntimeEditProvider: "Editar provider",
        deployRuntimeProviderDialogDescription:
          "Indica el provider, su endpoint y el modelo para usarlo en este Agente.",
        deployRuntimeProviderName: "Nombre del provider",
        deployRuntimeProviderType: "Tipo de provider",
        deployRuntimeProviderModel: "Modelo",
        deployRuntimeProviderUrl: "URL",
        deployRuntimeProviderApiKey: "Clave API",
        deployRuntimeProviderApiKeyOptional:
          "Déjalo vacío para conservar la clave existente",
        deployRuntimeProviderDescription: "Describe brevemente este provider",
        deployRuntimeMakeDefault: "Usar este provider por defecto",
        deployRuntimeProviderNameRequired:
          "El nombre del provider es obligatorio.",
        deployRuntimeProviderCreated: "Provider creado.",
        deployRuntimeProviderCreateError: "No se pudo crear el provider.",
        deployRuntimeProviderUpdated: "Provider actualizado.",
        deployRuntimeProviderUpdateError: "No se pudo actualizar el provider.",
        deployRuntimeProviderDeleted: "Provider eliminado.",
        deployRuntimeProviderDeleteError: "No se pudo eliminar el provider.",
        deployRuntimeProviderDefaultUpdated:
          "Provider por defecto actualizado.",
        deployRuntimeProviderDefaultError:
          "No se pudo definir este provider como predeterminado.",
        deployRuntimeRegistryHint:
          "Usa un modelo gestionado o añade un endpoint personalizado.",
        deployRuntimeLlmProfileBadge: "Perfil LLM",
        deployRuntimeDeploymentProfile: "Perfil LLM del Agente",
        deployRuntimeSelectModel: "Seleccionar un modelo gestionado",
        deployRuntimeNoManagedModel: "Sin modelo gestionado",
        deployRuntimeSaveModel: "Guardar modelo",
        deployRuntimeModelSaved: "Modelo guardado.",
        deployRuntimeModelSaveError: "No se pudo guardar el modelo.",
        deployRuntimeSystemPromptPlaceholder:
          "Define aquí las instrucciones del sistema para este Agente.",
        deployRuntimeSystemPromptSaved: "Prompt del sistema guardado.",
        deployRuntimeSystemPromptSaveError:
          "No se pudo guardar el prompt del sistema.",
        deployRuntimeEmbeddingTitle: "Embeddings",
        deployRuntimeEmbeddingDescription:
          "Configura los providers de embeddings usados para búsqueda, memoria e índices vectoriales.",
        deployRuntimeAddEmbedding: "Añadir embedding",
        deployRuntimeNoEmbeddings: "No hay provider de embeddings configurado.",
        deployRuntimeCreateEmbedding: "Crear provider de embeddings",
        deployRuntimeEditEmbedding: "Editar provider de embeddings",
        deployRuntimeEmbeddingDialogDescription:
          "Define el provider, el modelo y el endpoint usados para los embeddings del Agente.",
        deployRuntimeEmbeddingName: "Nombre",
        deployRuntimeEmbeddingProvider: "Provider",
        deployRuntimeEmbeddingModel: "Modelo",
        deployRuntimeEmbeddingUrl: "URL",
        deployRuntimeEmbeddingApiKey: "Clave API",
        deployRuntimeEmbeddingApiKeyOptional:
          "Déjalo vacío para conservar la clave existente",
        deployRuntimeEmbeddingDescriptionLabel: "Descripción",
        deployRuntimeEmbeddingDescriptionPlaceholder:
          "Añade una breve descripción para este provider de embeddings.",
        deployRuntimeEmbeddingNameRequired:
          "El nombre del provider de embeddings es obligatorio.",
        deployRuntimeEmbeddingCreated: "Provider de embeddings creado.",
        deployRuntimeEmbeddingCreateError:
          "No se pudo crear el provider de embeddings.",
        deployRuntimeEmbeddingUpdated: "Provider de embeddings actualizado.",
        deployRuntimeEmbeddingUpdateError:
          "No se pudo actualizar el provider de embeddings.",
        deployRuntimeEmbeddingDeleted: "Provider de embeddings eliminado.",
        deployRuntimeEmbeddingDeleteError:
          "No se pudo eliminar el provider de embeddings.",
        deployRuntimeProxyTitle: "Proxy de red",
        deployRuntimeProxyDescription:
          "Enruta las llamadas LLM a través de un proxy corporativo o una herramienta de inspección.",
        deployRuntimeProxyConfigured: "Configurado",
        deployRuntimeProxyNotConfigured: "No configurado",
        deployRuntimeProxyHttps: "HTTPS proxy",
        deployRuntimeProxyHttp: "HTTP proxy",
        deployRuntimeProxyNoProxy: "No proxy",
        deployRuntimeProxySecretPlaceholder:
          "••••••••  (déjalo vacío para conservar el valor actual)",
        deployRuntimeProxyEnvTitle: "Variables inyectadas",
        deployRuntimeProxyTlsTitle: "Nota TLS",
        deployRuntimeProxyTlsDescription:
          "Para la inspección HTTPS, añade el certificado CA del proxy al trust store del sistema o la imagen destino.",
        deployRuntimeProxySave: "Guardar proxy",
        deployRuntimeProxySaved:
          "Configuración proxy guardada. Puede ser necesario reiniciar.",
        deployRuntimeProxySaveError:
          "No se pudo guardar la configuración proxy.",
        deployRuntimeProxyVariableDescription:
          "Configuración de proxy de red para las llamadas API LLM.",
        deployRuntimeStorageCardDescription:
          "Selecciona dónde el runtime conserva archivos generados, imports, exports y artefactos persistentes. Déjalo desactivado si el Agente no manipula archivos duraderos.",
        deployRuntimeStorageDisabled: "Desactivado",
        deployRuntimeStorageLocalS3: "Almacenamiento S3 local",
        deployRuntimeStorageS3Compatible: "S3 compatible",
        deployRuntimeStorageAgentMauriceCdn: "AgentMaurice CDN",
        deployRuntimeStorageUnavailable: "no disponible",
        deployRuntimeStorageUnavailableMessage:
          "Este proveedor no está disponible en este runtime. Selecciona almacenamiento local/S3 compatible para guardar.",
        deployRuntimeConfigureS3: "Configurar S3",
        deployRuntimeDocstoreCardDescription:
          "Añade una capa documental interna para subir, indexar y recuperar archivos en workflows sobre contratos, manuales o bases de conocimiento.",
        deployRuntimeCompanyMemoryCardDescription:
          "Expone memoria de negocio estructurada a recetas y herramientas para conservar hechos, decisiones y contexto de organización entre sesiones.",
        deployRuntimeBrain: "Brain",
        deployRuntimeBrainCardDescription:
          "Activa el MCP Brain local para consultar una base DuckDB dedicada cuando un Agente debe razonar sobre datos locales sin servicio externo.",
        deployRuntimeMemory: "Memory",
        deployRuntimeMemoryCardDescription:
          "Activa el MCP Memory local para guardar notas, estado y recuerdos operativos propios de esta máquina o Agente.",
        deployRuntimeCompanyMemoryReadyDocker:
          "Company Memory está activo mediante el sidecar Docker de este Agente.",
        deployRuntimeMultimodalCardDescription:
          "Permite que recetas y chat usen perfiles especializados para analizar imágenes, leer PDF, extraer OCR, transcribir audio o generar medios.",
        deployRuntimeMessagingCardDescription:
          "Abre el Agente a canales externos como Slack, Telegram, WhatsApp, Discord, Google Chat o Signal, con cuentas ligadas a claves API.",
        accessPageTitle: "Acceso del Agente",
        accessPageDescription:
          "Gestiona claves API, asignaciones de usuarios, auth connector y mappings de identidad de este Agente.",
        openAccessPage: "Abrir Acceso",
        snapshotTitle: "Import / Export de l’Agente",
        snapshotDescription:
          "Transfiere la configuración de un Agente entre instancias mediante un snapshot cifrado.",
        snapshotSummaryValue: "Snapshot cifrado",
        openImportExportPage: "Abrir Import / Export",
        snapshotExportTitle: "Exportar snapshot",
        snapshotExportDescription:
          "Genera un archivo JSON cifrado con la configuración del Agente.",
        snapshotImportTitle: "Importar snapshot",
        snapshotImportDescription:
          "Importa un snapshot JSON creando o sobrescribiendo un Agente.",
        snapshotPassphrase: "Frase secreta",
        snapshotPassphrasePlaceholder: "Introduce una frase secreta fuerte",
        snapshotIncludeRegistryDefinitions:
          "Incluir definiciones de registry para autocreación durante el import",
        snapshotExportAction: "Exportar snapshot",
        snapshotExportSuccess: "Snapshot exportado.",
        snapshotExportError: "No se pudo exportar el snapshot.",
        snapshotImportFromFile: "Desde archivo",
        snapshotImportFromJson: "Desde JSON",
        snapshotSelectedFile: "Archivo seleccionado",
        snapshotJson: "Snapshot JSON",
        snapshotJsonPlaceholder: "Pega aquí el JSON exportado.",
        snapshotImportMode: "Modo de import",
        snapshotImportCreate: "Crear un nuevo Agente",
        snapshotImportOverwrite: "Sobrescribir un Agente existente",
        snapshotTargetDeployment: "Agente destino",
        snapshotDryRun: "Dry-run sin aplicar",
        snapshotLaunchAfterImport: "Lanzar después del import",
        snapshotRedeployAfterImport: "Redesplegar después del import",
        snapshotAllowRegistryAutoCreate: "Permitir autocreación de registry",
        snapshotDryRunAction: "Probar import",
        snapshotImportAction: "Importar snapshot",
        snapshotImportResult: "Resultado del import",
        snapshotImportDryRunSuccess: "Dry-run terminado.",
        snapshotImportSuccess: "Snapshot importado.",
        snapshotImportError: "No se pudo importar el snapshot.",
        mailCatcherTitle: "Rutas email",
        mailCatcherDescription:
          "Asocia direcciones inbound a recetas para activar workflows automáticamente por email.",
        mailCatcherSummaryValue: "Email inbound",
        mailCatcherDisabledBadge: "No disponible",
        mailCatcherDisabledTitle: "Email inbound desactivado",
        mailCatcherDisabledDescription:
          "Mail Catcher depende de EmailConnect y permanecerá desactivado hasta que el servicio de pago, las cuotas, la seguridad webhook y el dispatch hacia las VMs estén listos en producción.",
        openMailCatcherPage: "Abrir Mail Catcher",
        mailCatcherAddRoute: "Añadir ruta",
        mailCatcherRoutesCount: "Rutas",
        mailCatcherEnabledCount: "Activas",
        mailCatcherDomain: "Dominio inbound",
        mailCatcherNoRoutes: "No hay rutas email",
        mailCatcherNoRoutesDescription:
          "Crea una ruta para generar una dirección email única ligada a una receta.",
        mailCatcherEmailAddress: "Dirección email",
        mailCatcherRecipe: "Receta",
        mailCatcherCreatedAt: "Creada",
        mailCatcherCreateRoute: "Crear ruta email",
        mailCatcherEditRoute: "Editar ruta email",
        mailCatcherDialogDescription:
          "Selecciona la receta activada por esta dirección inbound.",
        mailCatcherRecipePlaceholder: "Elegir una receta",
        mailCatcherEnabled: "Ruta activa",
        mailCatcherDeleteRoute: "Eliminar ruta email",
        mailCatcherDeleteRouteDescription:
          "Esta dirección inbound ya no activará su receta.",
        mailCatcherRecipeRequired: "La receta es obligatoria.",
        mailCatcherEmailCopied: "Dirección email copiada.",
        mailCatcherEmailCopyError: "No se pudo copiar la dirección email.",
        mailCatcherCreateSuccess: "Ruta email creada.",
        mailCatcherCreateError: "No se pudo crear la ruta email.",
        mailCatcherUpdateSuccess: "Ruta email actualizada.",
        mailCatcherUpdateError: "No se pudo actualizar la ruta email.",
        mailCatcherDeleteSuccess: "Ruta email eliminada.",
        mailCatcherDeleteError: "No se pudo eliminar la ruta email.",
        spacesTitle: "Espacios colaborativos",
        spacesDescription:
          "Gestiona los espacios ligados al Agente, sus sesiones y colaboración.",
        spacesSummaryValue: "Workspaces",
        openSpacesPage: "Abrir Espacios",
        spacesCreate: "Crear espacio",
        spacesCount: "Espacios",
        spacesMembersCount: "Miembros",
        spacesSessionsCount: "Sesiones",
        spacesNoSpaces: "No hay espacios",
        spacesNoSpacesDescription:
          "Crea un espacio para organizar sesiones y colaboración del Agente.",
        spacesMembersLabel: "miembro(s)",
        spacesSessionsLabel: "sesión(es)",
        spacesCreatedAt: "Creado",
        spacesCreateTitle: "Crear espacio",
        spacesCreateDescription:
          "El espacio se asociará al Agente actual.",
        spacesName: "Nombre",
        spacesDescriptionLabel: "Descripción",
        spacesDeleteTitle: "Eliminar espacio",
        spacesDeleteDescription:
          "El espacio {{name}} y sus sesiones asociadas se eliminarán.",
        spacesCreateSuccess: "Espacio creado.",
        spacesCreateError: "No se pudo crear el espacio.",
        spacesDeleteSuccess: "Espacio eliminado.",
        spacesDeleteError: "No se pudo eliminar el espacio.",
        deploySummaryMessagingDescription:
          "Cuentas de Slack, Telegram, WhatsApp, Discord, Google Chat y Signal vinculadas al gateway de mensajería.",
        openMessagingPage: "Abrir mensajería",
        deployRuntimeMessagingTitle: "Cuentas de mensajería",
        deployRuntimeMessagingDescription:
          "Conecta canales externos al Agente y asígnalos a una clave API dedicada.",
        deployRuntimeMessagingAddAccount: "Añadir cuenta",
        deployRuntimeMessagingAccountsCount: "Cuentas",
        deployRuntimeMessagingApiKeysAvailable: "Claves API disponibles",
        deployRuntimeMessagingWebhookChannels: "Canales webhook",
        deployRuntimeMessagingNoAccounts: "No hay cuentas de mensajería",
        deployRuntimeMessagingNoAccountsDescription:
          "Añade al menos un canal si este Agente debe recibir o emitir mensajes de negocio.",
        deployRuntimeMessagingCopyWebhook: "Copiar webhook",
        deployRuntimeMessagingWebhookCopied: "Webhook copiado.",
        deployRuntimeMessagingWebhookCopyError: "No se pudo copiar el webhook.",
        deployRuntimeMessagingEditAccount: "Editar cuenta",
        deployRuntimeMessagingCreateAccount: "Crear cuenta",
        deployRuntimeMessagingDialogDescription:
          "Configura el canal, la cuenta y los secretos necesarios para este transporte.",
        deployRuntimeMessagingChannel: "Canal",
        deployRuntimeMessagingSelectChannel: "Elegir un canal",
        deployRuntimeMessagingStatus: "Estado",
        deployRuntimeMessagingStatusActive: "Activa",
        deployRuntimeMessagingStatusDisabled: "Desactivada",
        deployRuntimeMessagingStatusInvalid: "Inválida",
        deployRuntimeMessagingAccountId: "ID de cuenta",
        deployRuntimeMessagingDisplayName: "Nombre visible",
        deployRuntimeMessagingDisplayNamePlaceholder: "Bot principal",
        deployRuntimeMessagingExternalId: "ID externo",
        deployRuntimeMessagingExternalIdPlaceholder: "Opcional",
        deployRuntimeMessagingApiKeyLabel: "Clave API",
        deployRuntimeMessagingApiKeyPlaceholder: "Selecciona una clave API",
        deployRuntimeMessagingApiKeyPlaceholderEdit:
          "Déjalo vacío para conservar la clave actual",
        deployRuntimeMessagingApiKeyHelperEdit:
          "Selecciona una nueva clave API solo si quieres reemplazar la ya asociada.",
        deployRuntimeMessagingNoExpiration: "Sin caducidad",
        deployRuntimeMessagingConfigSection: "Configuración del canal",
        deployRuntimeMessagingSecretInfo:
          "Los secretos existentes nunca se rellenan previamente.",
        deployRuntimeMessagingSecretPlaceholder:
          "Déjalo vacío para conservar el valor actual",
        deployRuntimeMessagingSecretHelperEdit:
          "Déjalo vacío para conservar el secreto ya almacenado.",
        deployRuntimeMessagingDeleteAccount: "Eliminar cuenta",
        deployRuntimeMessagingDeleteAccountDescription:
          "La cuenta {{name}} se eliminará del gateway de mensajería.",
        deployRuntimeMessagingChannelRequired: "El canal es obligatorio.",
        deployRuntimeMessagingAccountIdRequired:
          "El ID de cuenta es obligatorio.",
        deployRuntimeMessagingFieldRequired:
          "El campo {{field}} es obligatorio.",
        deployRuntimeMessagingApiKeyRequired:
          "Se requiere una clave API para crear una cuenta de mensajería.",
        deployRuntimeMessagingCreateSuccess: "Cuenta de mensajería creada.",
        deployRuntimeMessagingCreateError:
          "No se pudo crear la cuenta de mensajería.",
        deployRuntimeMessagingUpdateSuccess:
          "Cuenta de mensajería actualizada.",
        deployRuntimeMessagingUpdateError:
          "No se pudo actualizar la cuenta de mensajería.",
        deployRuntimeMessagingDeleteSuccess: "Cuenta de mensajería eliminada.",
        deployRuntimeMessagingDeleteError:
          "No se pudo eliminar la cuenta de mensajería.",
        deployRuntimeMessagingConnectionWebhook: "Webhook",
        deployRuntimeMessagingConnectionPolling: "Polling",
        deployRuntimeMessagingConnectionWebsocket: "WebSocket",
        deployRuntimeMessagingConfigKeys: "Claves de configuración",
        deployRuntimeMessagingChannelTelegram: "Telegram",
        deployRuntimeMessagingChannelSlack: "Slack",
        deployRuntimeMessagingChannelWhatsapp: "WhatsApp",
        deployRuntimeMessagingChannelDiscord: "Discord",
        deployRuntimeMessagingChannelGooglechat: "Google Chat",
        deployRuntimeMessagingChannelSignal: "Signal",
        deployRuntimeMessagingChannelUnknown: "Canal desconocido",
        deployRuntimeMessagingFieldBotToken: "Bot token",
        deployRuntimeMessagingFieldPollInterval: "Intervalo de polling (s)",
        deployRuntimeMessagingFieldAllowedUpdates: "Allowed updates",
        deployRuntimeMessagingFieldSigningSecret: "Signing secret",
        deployRuntimeMessagingFieldBotUserId: "Bot user ID",
        deployRuntimeMessagingFieldAccessToken: "Access token",
        deployRuntimeMessagingFieldPhoneNumberId: "Phone number ID",
        deployRuntimeMessagingFieldAppSecret: "App secret",
        deployRuntimeMessagingFieldVerifyToken: "Verify token",
        deployRuntimeMessagingFieldApiBaseUrl: "API base URL",
        deployRuntimeMessagingFieldApiVersion: "API version",
        deployRuntimeMessagingFieldIntents: "Intents",
        deployRuntimeMessagingFieldVerificationToken: "Verification token",
        deployRuntimeMessagingFieldBaseUrl: "Base URL",
        deployRuntimeMessagingFieldNumber: "Número",
        deployRuntimeMqttCardDescription:
          "Expone un puente MQTT para recibir o publicar eventos en tiempo real, útil para IoT, supervisión, automatizaciones de campo y sistemas que ya usan MQTT.",
        deployRuntimeExternalInceptionCardDescription:
          "Conecta el Agente a una instancia Inception externa para operaciones expertas, inspección del runtime y acciones de administración controladas.",
        deployRuntimeShellCardDescription:
          "Expone capacidades shell para flujos locales y herramientas expertas.",
        deployRuntimeInternalSaved: "Configuración interna guardada.",
        deployRuntimeInternalSaveError:
          "No se pudo guardar la configuración interna.",
        deployRuntimeS3DialogDescription:
          "Completa la conexión S3 usada como storage de este Agente.",
        deployRuntimeS3Endpoint: "Endpoint",
        deployRuntimeS3Region: "Región",
        deployRuntimeS3Bucket: "Bucket",
        deployRuntimeS3AccessKey: "Access key",
        deployRuntimeS3SecretKey: "Secret key",
        deployRuntimeS3Cdn: "URL CDN pública",
        deployRuntimeS3UseSsl: "Usar SSL",
        deployRuntimeS3Required:
          "El endpoint S3 y el access key son obligatorios.",
        deployRuntimeS3Created: "Configuración S3 creada.",
        deployRuntimeS3CreateError: "No se pudo crear la configuración S3.",
        deployRuntimeS3Updated: "Configuración S3 actualizada.",
        deployRuntimeS3UpdateError:
          "No se pudo actualizar la configuración S3.",
        deployRuntimeS3Deleted: "Configuración S3 eliminada.",
        deployRuntimeS3DeleteError: "No se pudo eliminar la configuración S3.",
        deployRuntimeMultimodalSaved: "Configuración multimodal guardada.",
        deployRuntimeMultimodalSaveError:
          "No se pudo guardar la configuración multimodal.",
        deployRuntimeMultimodalDeleted: "Configuración multimodal eliminada.",
        deployRuntimeMultimodalDeleteError:
          "No se pudo eliminar la configuración multimodal.",
        deployRuntimeMultimodalDefaultsSaved:
          "Multimodal AgentMaurice activado.",
        deployRuntimeMultimodalDefaultsError:
          "No se pudo activar el multimodal AgentMaurice.",
        deployRuntimeConfigureMultimodal: "Configurar multimodal",
        deployRuntimeMultimodalDialogDescription:
          "Activa el modo AgentMaurice gestionado o configura una clave personal.",
        deployRuntimeMultimodalManagedMode: "AgentMaurice gestionado",
        deployRuntimeMultimodalByokMode: "Clave personal",
        deployRuntimeMultimodalManagedTitle: "Multimodal AgentMaurice",
        deployRuntimeMultimodalManagedDescription:
          "Activa visión, documentos, audio y vídeo sin clave personal. El consumo se factura en créditos AgentMaurice.",
        deployRuntimeMultimodalManagedCapabilities:
          "Visión, documentos, transcripción de audio y vídeo",
        deployRuntimeMultimodalManagedActivate: "Activar multimodal",
        deployRuntimeMultimodalManagedActivating: "Activando…",
        deployRuntimeMultimodalHostedBadge: "AgentMaurice gestionado",
        deployRuntimeMultimodalByokBadge: "Clave personal",
        deployRuntimeMultimodalBaseUrlInvalid:
          "La URL base debe ser una URL http(s) válida.",
        deployRuntimeMultimodalExistingConfigs: "Configuraciones existentes",
        deployRuntimeMultimodalAddConfig: "Añadir configuración",
        deployRuntimeMultimodalEditConfig: "Editar configuración",
        deployRuntimeMultimodalFormDescription:
          "Define una capacidad, un provider y un modelo para este perfil.",
        deployRuntimeMultimodalCapability: "Capacidad",
        deployRuntimeMultimodalProfile: "Perfil",
        deployRuntimeMultimodalProvider: "Provider",
        deployRuntimeMultimodalModel: "Modelo",
        deployRuntimeMultimodalSelectModel: "Seleccionar un modelo",
        deployRuntimeMultimodalNoCompatibleModels:
          "No se encontraron modelos compatibles para este provider.",
        deployRuntimeMultimodalBaseUrl: "URL base",
        deployRuntimeMultimodalApiKey: "Clave API",
        deployRuntimeMultimodalApiKeyOptional:
          "Déjalo vacío para conservar la clave actual",
        deployRuntimeMultimodalOrgProvider: "Provider LLM de la organización",
        deployRuntimeMultimodalSelectOrgProvider: "Seleccionar un provider",
        deployRuntimeMultimodalNoOrgProviders:
          "No hay provider de organización compatible con credencial. Decláralo en Build → LLM.",
        deployRuntimeMultimodalOrgProviderRequired:
          "Se requiere un provider LLM de la organización para multimodal BYOK.",
        deployRuntimeMultimodalModelRequired:
          "El modelo multimodal es obligatorio.",
        deployRuntimeMultimodalNoConfigs:
          "Todavía no hay configuración multimodal guardada.",
        deployRuntimeMultimodalDeleteConfig:
          "Eliminar configuración multimodal",
        deployRuntimeMultimodalDeleteDescription:
          "La configuración {{capability}} / {{profile}} se eliminará.",
        deployRuntimeMcpManualDescription:
          "Lista los servidores MCP añadidos manualmente a este Agente.",
        deployRuntimeMcpSidecarsDescription:
          "Muestra los sidecars y assets del registry asociados a este Agente.",
        deployRuntimeSidecarRunning: "Contenedor activo",
        deployRuntimeNoMcpServers:
          "No hay servidores MCP manuales configurados.",
        deployRuntimeNoSidecars:
          "No se detectaron sidecars ni assets del registry.",
        deployRuntimeMcpServerCreated: "Servidor MCP creado.",
        deployRuntimeMcpServerCreateError: "No se pudo crear el servidor MCP.",
        deployRuntimeMcpServerUpdated: "Servidor MCP actualizado.",
        deployRuntimeMcpServerUpdateError:
          "No se pudo actualizar el servidor MCP.",
        deployRuntimeMcpServerDeleted: "Servidor MCP eliminado.",
        deployRuntimeMcpServerDeleteError:
          "No se pudo eliminar el servidor MCP.",
        deployRuntimeAddStdio: "Añadir STDIO",
        deployRuntimeAddSse: "Añadir SSE",
        deployRuntimeCreateStdio: "Crear servidor STDIO",
        deployRuntimeEditStdio: "Editar servidor STDIO",
        deployRuntimeCreateSse: "Crear servidor SSE",
        deployRuntimeEditSse: "Editar servidor SSE",
        deployRuntimeStdioDialogDescription:
          "Configura el comando local, sus argumentos y sus variables de entorno.",
        deployRuntimeSseDialogDescription:
          "Configura el endpoint remoto y los headers HTTP usados por este servidor SSE.",
        deployRuntimeMcpName: "Nombre del servidor",
        deployRuntimeMcpCommand: "Comando",
        deployRuntimeMcpUrl: "URL del servidor",
        deployRuntimeMcpArguments: "Argumentos",
        deployRuntimeMcpEnv: "Variables de entorno",
        deployRuntimeMcpHeaders: "Headers HTTP",
        deployRuntimeMcpAddArgument: "Añadir argumento",
        deployRuntimeMcpAddEnv: "Añadir variable",
        deployRuntimeMcpAddHeader: "Añadir header",
        deployRuntimeMcpCommandPreview: "Vista previa del comando",
        deployRuntimeMcpRemotePreview: "Vista previa de la conexión remota",
        deployRuntimeMcpNameRequired:
          "El nombre del servidor MCP es obligatorio.",
        deployRuntimeMcpCommandRequired: "El comando STDIO es obligatorio.",
        deployRuntimeMcpUrlRequired: "La URL del servidor SSE es obligatoria.",
        deployRuntimeMcpInvalidUrl: "La URL del servidor SSE no es válida.",
        deployRuntimeMcpArgumentsCount: "{{count}} argumento(s)",
        deployRuntimeMcpEnvCount: "{{count}} variable(s) de entorno",
        deployRuntimeMcpHeadersCount: "{{count}} header(s)",
        deployRuntimeDeleteMcpServer: "Eliminar servidor MCP",
        deployRuntimeDeleteMcpServerDescription:
          "El servidor {{name}} se eliminará del Agente.",
        deployRuntimeMcpOAuthConnect: "Conectar OAuth",
        deployRuntimeMcpOAuthDisconnect: "Desconectar OAuth",
        deployRuntimeMcpOAuthConnected: "Conectado",
        deployRuntimeMcpOAuthDisconnected: "OAuth desconectado.",
        deployRuntimeMcpOAuthExpired: "Expirado",
        deployRuntimeMcpOAuthNotConnected: "No conectado",
        deployRuntimeMcpOAuthStartError: "No se pudo iniciar el flujo OAuth.",
        deployRuntimeMcpOAuthDisconnectError: "No se pudo desconectar OAuth.",
        deployRuntimeMcpRunDoctor: "Ejecutar doctor",
        deployRuntimeMcpDoctorTitle: "Diagnóstico SSE",
        deployRuntimeMcpDoctorDescription:
          "Resultado del doctor para {{name}}.",
        deployRuntimeMcpDoctorDetails: "Detalles del diagnóstico",
        deployRuntimeMcpDoctorEmpty:
          "No hay resultado de diagnóstico disponible.",
        deployRuntimeMcpDoctorError: "No se pudo ejecutar el diagnóstico SSE.",
        deployRuntimeVariablesPanelDescription:
          "Gestiona las variables y secretos inyectados automáticamente durante la ejecución de recetas.",
        deployRuntimeVariablesCount: "Variables",
        deployRuntimeVariableSecretCount: "Secretos",
        deployRuntimeVariableScopedCount: "Con scope",
        deployRuntimeVariableSharedCount: "Globales",
        deployRuntimeVariablesList: "Variables del Agente",
        deployRuntimeVariablesListDescription:
          "Añade aquí las claves API, credenciales y constantes necesarias para este Agente.",
        deployRuntimeAddVariable: "Añadir variable",
        deployRuntimeNoVariables: "No hay variables configuradas.",
        deployRuntimeNoVariablesDescription:
          "Las variables permiten almacenar secretos y constantes que se inyectan automáticamente en las recetas.",
        deployRuntimeCreateVariable: "Crear variable",
        deployRuntimeEditVariable: "Editar variable",
        deployRuntimeDeleteVariable: "Eliminar variable",
        deployRuntimeDeleteVariableDescription:
          "La variable {{name}} se eliminará inmediatamente del Agente.",
        deployRuntimeVariableDialogDescription:
          "Define el nombre, el valor y el scope de esta variable para el Agente.",
        deployRuntimeVariableName: "Nombre",
        deployRuntimeVariableValue: "Valor",
        deployRuntimeVariableValueOptional:
          "Déjalo vacío para conservar el valor existente",
        deployRuntimeVariableSecret: "Ocultar el valor como secreto",
        deployRuntimeVariableDescriptionLabel: "Descripción",
        deployRuntimeVariableRecipeScope: "Scope de recetas",
        deployRuntimeVariableRecipeScopeDescription:
          "Déjalo vacío para compartir la variable con todas las recetas, o selecciona solo las que la necesiten.",
        deployRuntimeVariableAvailableRecipes: "Recetas disponibles",
        deployRuntimeVariableRecipeScopeAll: "Todas las recetas",
        deployRuntimeVariableRecipeScopeEmpty:
          "Todavía no hay recetas desplegadas. La variable seguirá compartida a nivel del Agente.",
        deployRuntimeVariableRecipeScopePlaceholder:
          "recipe_a, recipe_b, recipe_c",
        deployRuntimeVariableNameRequired:
          "El nombre de la variable es obligatorio.",
        deployRuntimeVariableValueRequired:
          "El valor de la variable es obligatorio.",
        deployRuntimeVariableCreated: "Variable creada.",
        deployRuntimeVariableCreateError: "No se pudo crear la variable.",
        deployRuntimeVariableUpdated: "Variable actualizada.",
        deployRuntimeVariableUpdateError: "No se pudo actualizar la variable.",
        deployRuntimeVariableDeleted: "Variable eliminada.",
        deployRuntimeVariableDeleteError: "No se pudo eliminar la variable.",
        deployRuntimeVariableAllRecipes: "Todas las recetas",
        deployRuntimeVariableAllRecipesDescription:
          "Disponible para todas las recetas de este Agente.",
        deployRuntimeVariableScopedRecipes: "Scope limitado",
        deployRuntimeVariableShow: "Mostrar",
        deployRuntimeVariableHide: "Ocultar",
        deployRuntimeVariableSecretBadge: "Secreto",
        deployRuntimeVariableDescription:
          "Explica brevemente para qué sirve esta variable.",
        deployRuntimeVariablesUsageTitle: "Buenas prácticas",
        deployRuntimeVariablesUsage1:
          "Reserva los secretos para valores sensibles como claves API y contraseñas.",
        deployRuntimeVariablesUsage2:
          "Usa el scope de recetas para limitar variables a workflows concretos.",
        deployRuntimeVariablesUsage3:
          "Prefiere nombres explícitos y estables para facilitar el mantenimiento.",
        deployRuntimeVariablesInjectedDescription:
          "Estas variables se inyectarán automáticamente en las ejecuciones del Agente.",
        deployRuntimeVariablesSummary: "{{count}} variable(s) configurada(s)",
        deployRuntimeAccessSummary:
          "{{keys}} clave(s) · {{accounts}} cuenta(s) de mensajería",
        deployRuntimeVariablesDescription:
          "Las variables y secretos del Agente aparecerán aquí para controlar providers LLM, MCP y sidecars.",
        deployRuntimeVariablesPlaceholder:
          "La base API está lista. El editor de variables se conectará en la próxima iteración UI.",
        deployRuntimeVariablesPending: "Editor pendiente",
        deployRuntimeNextStep: "Estado actual",
        deployRuntimeCurrentState: "Estado actual",
        deployRuntimeNextStepDescription:
          "Este panel destaca las acciones más útiles para volver este runtime realmente operativo.",
        deployRuntimeLlmNextStep1:
          "Añadir selección de modelo SaaS y gestión de providers on-prem.",
        deployRuntimeLlmNextStep2:
          "Después conectar embedding providers y proxy de red.",
        deployRuntimeLlmNextStep3:
          "Mantener Candle y las opciones avanzadas dentro de un panel experto.",
        deployRuntimeMcpNextStep1:
          "Añadir listas STDIO/SSE, formularios y tarjetas de servidor.",
        deployRuntimeMcpNextStep2:
          "Conectar OAuth connect/disconnect y el doctor SSE.",
        deployRuntimeMcpNextStep3:
          "Luego separar sidecars del registry y servidores manuales dentro de Build.",
        deployRuntimeInternalNextStep1:
          "Mostrar tarjetas toggle para storage, docstore, company memory y multimodal.",
        deployRuntimeInternalNextStep2:
          "Conectar diálogos S3 y multimodal cuando esas tarjetas se activen.",
        deployRuntimeInternalNextStep3:
          "Mantener shell e inception dentro de un modo experto seguro.",
        deployRuntimeSkillsNextStep1:
          "Adjuntar solo las skills útiles para el Agente actual.",
        deployRuntimeSkillsNextStep2:
          "Revisar las skills que todavía requieren configuración antes del apply.",
        deployRuntimeSkillsNextStep3:
          "Mantener un catálogo enfocado para no sobrecargar a los builders y a Calisto.",
        deployRuntimeAccessNextStep1:
          "Crear claves dedicadas por integración en lugar de compartir una sola clave global.",
        deployRuntimeAccessNextStep2:
          "Añadir cuentas de mensajería antes de conectar webhooks o bots externos.",
        deployRuntimeAccessNextStep3:
          "Validar el auth connector antes de exportar el gateway Next.js.",
        deployRuntimeVariablesNextStep1:
          "Portar la gestión de variables de l’Agente desde el dashboard.",
        deployRuntimeVariablesNextStep2:
          "Luego conectar esas variables con providers LLM y MCP.",
        deployRuntimeVariablesNextStep3:
          "Mantener una separación clara entre variables normales y secretos.",
        pipelineDescription:
          "Gestiona el plan, las pruebas y la promoción para el Agente seleccionado.",
        deployRecipeCoverageDescription:
          "{{synced}} sincronizada(s), {{pending}} todavía por preparar o revisar.",
        deployRecipeListDescription:
          "Elige la meta-receta que vas a impulsar y usa esta página para validar, probar y aplicar.",
        deployPrimaryValidateDescription:
          "Corrige primero la spec local para trabajar desde una base válida antes de planificar o aplicar.",
        deployPrimaryPlanDescription:
          "Prepara un plan ejecutable para ver con claridad qué se aplicará en el Agente objetivo.",
        deployPrimaryTestDescription:
          "Ejecuta las pruebas ahora para confirmar que la receta sigue comportándose bien antes del publish.",
        deployPrimaryPublishDescription:
          "El plan y las pruebas están listos. Ahora puedes aplicar los cambios al Agente.",
        deployPrimaryObserveDescription:
          "Los últimos runs están disponibles. Abre Observe para inspeccionar los detalles de ejecución.",
        selectOrgDeploymentToPublish:
          "Selecciona una organización y un Agente para gestionar la publicación.",
        readyToTest: "Listo para probar {{name}}.",
        readyToPromote: "Listo para promover {{name}}.",
        currentStage: "Etapa actual",
        nextTarget: "Siguiente objetivo",
        readiness: "Preparación",
        health: "Salud",
        environmentLabel: "Entorno: {{environment}}",
        alreadyHighestStage:
          "Ya está en la etapa de promoción más alta declarada.",
        inferredNextStage:
          "Siguiente objetivo de promoción inferido del Agente seleccionado.",
        activeExecutionsLabel: "Ejecuciones activas: {{count}}",
        metaRecettesTitle: "Meta recetas",
        loadingRecipes: "Cargando recetas…",
        noMetaRecetteForDeployment:
          "Todavía no hay meta recetas vinculadas a este Agente.",
        targetLabel: "Objetivo: {{target}}",
        targetDeploymentLabel: "Agente objetivo",
        deploymentTarget: "Objetivo del Agente: {{target}}",
        publicationStages: "Etapas de publicación",
        validate: "Validar",
        planning: "Planificando…",
        plan: "Plan",
        testing: "Probando…",
        dryRun: "Dry-run",
        validation: "Validación",
        latestTest: "Última prueba",
        lastApply: "Último apply",
        issuesCount: "{{count}} incidencia(s)",
        noIssue: "Sin incidencias",
        notRun: "No ejecutado",
        neverApplied: "Nunca aplicado",
        planAndDiff: "Plan y diff",
        inspectChangesBeforePromotion:
          "Genera un plan para inspeccionar los cambios antes de promover.",
        planId: "ID del plan: {{value}}",
        planHash: "Hash del plan: {{value}}",
        generatedAt: "Generado: {{value}}",
        signals: "Señales",
        signalsDescription: "Salidas de validación, prueba y reconcile",
        reconciling: "Reconciliando…",
        reconcile: "Reconciliar",
        validationIssues: "Problemas de validación",
        noLocalValidationIssue:
          "No se detectó ningún problema de validación local.",
        latestTestExecution: "Última ejecución de prueba",
        statusLabel: "Estado: {{status}}",
        testRunLabel: "Test run: {{id}}",
        executionIdsLabel: "IDs de ejecución: {{ids}}",
        inspectInSidePanel: "Inspeccionar en el panel lateral",
        openFullObserve: "Abrir Observe completo",
        lastDryRun: "Último dry-run",
        lastPromotion: "Última promoción",
        syncStatusLabel: "Estado de sincronización: {{status}}",
        inspectApplyInSidePanel: "Inspeccionar apply en el panel lateral",
        inspectTestInSidePanel: "Inspeccionar test en el panel lateral",
        reconcilePayload: "Payload de reconcile",
        observeFocused: "En foco",
        selectMetaRecette:
          "Selecciona una meta receta para ver los detalles de publicación.",
        deploymentHealthTitle: "Salud del Agente",
        readyToPromoteLabel: "Listo para promover",
        readyToPromoteDescription:
          "El plan, las pruebas y la salud del Agente están alineados.",
        partiallyReady: "Parcialmente listo",
        partiallyReadyDescription:
          "Todavía faltan una o más señales antes de la promoción.",
        notPrepared: "No preparado",
        notPreparedDescription:
          "Genera un plan y ejecuta pruebas antes de promover.",
        needsFixes: "Necesita correcciones",
        needsFixesDescription:
          "Resuelve los problemas de validación antes de la promoción.",
        stagePending: "Pendiente",
        stageDeploying: "Desplegando",
        stageActive: "Activo",
        stageError: "Error",
        removedNodesSection: "Nodos eliminados",
        addedNodesSection: "Nodos añadidos",
        modifiedNodesSection: "Nodos modificados",
        removed: "Eliminado",
        added: "Añadido",
        modified: "Modificado",
        configCount: "Config ({{count}})",
        noChangesDetectedShort: "No se detectaron cambios",
        openTasks: "Tareas abiertas",
        timeline: "Cronología",
        artifacts: "Artefactos",
        sourceGraph: "Grafo de fuentes",
        workspaceContextTitle: "Contexto del workspace",
        workspaceContextDescription:
          "Memoria y artefactos de sesión para la ejecución actual.",
        degraded: "Degradado",
        loadingContext: "Cargando contexto…",
        activeBlueprint: "Blueprint activo",
        activeBlueprintDescription:
          "Vista de solo lectura de la receta actualmente en uso.",
        loadingRecipePreview: "Cargando la vista previa de la receta…",
        recipeNotLinked:
          "Esta conversación aún no está vinculada a una receta específica.",
        noOpenWorkspaceTask:
          "No hay tareas abiertas del workspace visibles para esta sesión.",
        noTimelineEvent: "Aún no hay eventos de cronología disponibles.",
        noWorkspaceArtifact: "Aún no hay artefactos del workspace disponibles.",
        artifactPreview: "Vista previa del artefacto",
        artifactPreviewDescription:
          "Vista previa integrada de un artefacto reciente del workspace.",
        openFile: "Abrir archivo",
        noInlinePreviewAvailable: "No hay vista previa integrada disponible.",
        observeContextTitle: "Contexto Observe",
        observeContextDescription:
          "Ejecución de blueprint enfocada, enviada desde Calisto.",
        clear: "Limpiar",
        loadingFocusedContext: "Cargando contexto enfocado…",
        openBlueprintAction: "Abrir blueprint",
        publishAction: "Publicar",
        runAction: "Ejecutar",
        calistoAction: "Calisto",
        applyRun: "Apply run",
        testRun: "Test run",
        started: "Iniciado: {{value}}",
        completed: "Completado: {{value}}",
        recommendation: "Recomendación",
        inspectLinkedTest: "Inspeccionar prueba vinculada",
        regressionDetected: "Regresión detectada",
        regressionDescription:
          "Esta ejecución contiene una carga de regresión en la vista Observe detallada.",
        metaRecettePanelAction: "Meta-receta",
        metaRecettePageDescription:
          "La meta-receta formaliza las especificaciones del Agente y sirve como superficie principal de conversación con Calisto.",
        metaRecetteStatusTitle: "Estado",
        metaRecettePrimaryActionBadge: "Acción principal",
        metaRecettePrimaryPlanLabel: "Preparar plan",
        metaRecettePrimaryPlanDescription:
          "Genera un plan nuevo para ver exactamente qué debe cambiar antes del apply.",
        metaRecettePrimaryAttentionLabel: "Revisar puntos críticos",
        metaRecettePrimaryAttentionDescription:
          "El plan aún contiene cambios que requieren atención antes del apply.",
        metaRecettePrimaryReviewLabel: "Revisar cambios",
        metaRecettePrimaryReviewDescription:
          "El plan es utilizable, pero algunos cambios aún merecen una validación rápida.",
        metaRecettePrimaryApplyLabel: "Abrir Calisto para aplicar",
        metaRecettePrimaryApplyDescription:
          "El plan parece listo. Abre Calisto para lanzar la convergencia o guiar el apply.",
        metaRecettePrimaryObserveLabel: "Revisar últimas ejecuciones",
        metaRecettePrimaryObserveDescription:
          "El Agente está sincronizado. Abre Observe para inspeccionar los últimos apply y tests.",
        metaRecetteSecondaryActions: "Accesos rápidos",
        metaRecetteNextStep: "Siguiente paso recomendado",
        metaRecetteExecutionTitle: "Ejecución",
        metaRecetteArtifactsTitle: "Artefactos",
        metaRecettePipelineTitle: "Flujo de build",
        metaRecettePipelineDescription:
          "Sigue la progresión desde la spec hasta el último apply y las pruebas más recientes.",
        metaRecetteDriftTitle: "Snapshot de drift",
        metaRecetteDriftDescription:
          "Inspecciona el impacto esperado de los cambios entre la spec actual y el Agente objetivo.",
        metaRecetteDriftLoading: "Preparando snapshot de drift…",
        metaRecetteNoDriftDescription:
          "El Agente parece alineado con la spec activa. No se detectó drift accionable.",
        metaRecetteDriftNeedsPlanDescription:
          "La spec aún no está alineada. Prepara un plan para inspeccionar los cambios exactos a aplicar.",
        metaRecetteActionsToApply: "Acciones a aplicar",
        metaRecetteWarningsDetected: "Se detectaron advertencias en el plan.",
        metaRecetteDiscoveryTitle: "Discovery",
        metaRecetteDiscoveryFresh: "Discovery reciente",
        metaRecetteDiscoveryStale: "Discovery antigua",
        metaRecetteDiscoveryTargetOk: "Objetivo validado",
        metaRecetteDiscoveryTargetMismatch: "Objetivo a verificar",
        metaRecetteDriftRecommendationFallback:
          "Prepara un plan para confirmar con precisión los cambios a aplicar.",
        metaRecetteTopChangesTitle: "Cambios principales",
        metaRecetteTopChangesDescription:
          "Resumen de las primeras acciones propuestas por el plan.",
        metaRecetteChecklistTitle: "Checklist de apply",
        metaRecetteChecklistDescription:
          "Prioriza los cambios listos, los que requieren revisión y los que necesitan atención antes del apply.",
        metaRecetteChecklistReadyTitle: "Listo para aplicar",
        metaRecetteChecklistReadyDescription:
          "Cambios de bajo riesgo, utilizables directamente en el plan actual.",
        metaRecetteChecklistReviewTitle: "Revisar",
        metaRecetteChecklistReviewDescription:
          "Cambios válidos que aún merecen una verificación rápida antes del apply.",
        metaRecetteChecklistAttentionTitle: "Atención",
        metaRecetteChecklistAttentionDescription:
          "Posibles bloqueos, cambios no soportados o acciones de alto impacto.",
        metaRecetteChecklistReadinessTitle: "Preparación del apply",
        metaRecetteChecklistReadyReadiness:
          "El plan parece listo para aplicar. La mayoría de los cambios identificados son de bajo riesgo.",
        metaRecetteChecklistReviewReadiness:
          "El plan es utilizable, pero algunos cambios merecen una revisión rápida antes del apply.",
        metaRecetteChecklistAttentionReadiness:
          "Algunos cambios aún requieren atención antes del apply.",
        metaRecetteChecklistReadyBadge: "Listo",
        metaRecetteChecklistReviewBadge: "Revisión",
        metaRecetteChecklistAttentionBadge: "Atención",
        metaRecetteChecklistUnsupported: "No soportado",
        metaRecetteChecklistHumanReview: "Revisión humana",
        metaRecetteChecklistFilterAll: "Todos",
        metaRecetteChecklistEmptyFilter:
          "Todavía no hay cambios que coincidan con este filtro.",
        metaRecetteChecklistMoreCount:
          "Existen {{count}} cambio(s) adicional(es) en el plan completo.",
        metaRecetteImpactedSectionsTitle: "Secciones impactadas",
        metaRecetteImpactedSectionsDescription:
          "Navegación rápida hacia las secciones del markdown probablemente afectadas por el plan.",
        metaRecetteQuickNavTitle: "Navegación rápida",
        metaRecetteQuickNavDescription:
          "Salta rápidamente entre las grandes secciones de la spec y las zonas impactadas.",
        metaRecetteImpactedBadge: "Impactado",
        metaRecetteInspectChange: "Inspeccionar",
        metaRecetteOpenInSpecs: "Abrir en la spec",
        metaRecetteFieldColumn: "Campo",
        metaRecetteBeforeColumn: "Antes",
        metaRecetteAfterColumn: "Después",
        metaRecetteContextColumn: "Contexto",
        metaRecetteChangeSummaryFallback:
          "Todavía no hay un resumen detallado disponible para este cambio.",
        metaRecetteNoChangeDetails:
          "El plan aún no contiene suficiente detalle para resumir los cambios.",
        metaRecetteOpenObserve: "Abrir Observe",
        metaRecetteAdvancedTitle: "Herramientas expertas",
        metaRecetteAdvancedDescription:
          "Herramientas de diagnóstico y acciones avanzadas para usar cuando el flujo principal no es suficiente.",
        metaRecetteExpertPlanDescription:
          "Regenera un plan detallado y su diff sin aplicar cambios.",
        metaRecetteExpertReconcileDescription:
          "Fuerza una reconciliación orientada a validación para comparar la spec y el objetivo.",
        metaRecetteExpertDryRunDescription:
          "Simula el apply sin desplegar, para inspeccionar el resultado esperado.",
        metaRecetteExpertLatestOutputTitle: "Última salida experta",
        metaRecetteExpertLatestOutputDescription:
          "Mostrar la salida bruta producida por {{label}}.",
        metaRecettePreferredView: "Vista recomendada",
        metaRecetteSpecUnavailable:
          "Esta vista todavía no está disponible para esta meta-receta.",
        metaRecetteCanvasReady:
          "El canvas está disponible para inspeccionar la estructura.",
        metaRecetteMarkdownReady:
          "Markdown es la mejor vista disponible para editar la especificación.",
        metaRecetteStructuredFallback:
          "El JSON estructurado sigue disponible hasta que la vista canvas sea usable.",
        metaRecetteNoPreparedPlan: "Todavía no hay un plan preparado.",
        metaRecetteStageSync: "Sincronización",
        metaRecetteContextTitle: "Contexto meta-receta",
        metaRecetteContextDescription:
          "Conversación con Calisto, especificación funcional y señales de sincronización alrededor de la meta-receta activa.",
        metaRecetteOverviewTab: "Resumen",
        metaRecetteSpecTab: "Specs",
        metaRecetteConversationTab: "Calisto",
        metaRecetteLoading: "Cargando meta-receta…",
        metaRecetteNoSelection: "No hay meta-receta seleccionada.",
        metaRecetteNoSelectionDescription:
          "Abre este panel desde Recipes, Deploy u Observe para cargar la meta-receta actual.",
        metaRecetteOpenConversation: "Hablar con Calisto",
        metaRecetteCanvasTab: "Canvas",
        metaRecetteMarkdownTab: "Markdown",
        metaRecetteStructuredTab: "Spec estructurada",
        metaRecetteNoStructuredSpec:
          "No hay spec estructurada disponible para esta meta-receta.",
        metaRecetteNoMarkdownSpec:
          "No hay especificación funcional markdown disponible para esta meta-receta.",
        metaRecetteCalistoSyncing:
          "Sincronizando el contexto de Calisto con la meta-receta activa…",
        metaRecetteCalistoReady:
          "Calisto está listo para hablar sobre cambios, diferencias e intención alrededor de esta meta-receta.",
        metaRecetteCalistoTitle: "Calisto Meta-receta",
        metaRecetteCalistoDescription:
          "Conversación guiada sobre {{name}} y su especificación actual.",
        metaRecetteCalistoContextDescription:
          "Conversación contextual con Calisto sobre las especificaciones del Agente.",
        metaRecetteVariablesLabel: "Variables",
        metaRecetteLastSynced: "Última sincronización: {{value}}",
        metaRecetteEdgesCount: "{{count}} enlace(s)",
        metaRecetteLoadError: "No se pudo cargar la meta-receta.",
        metaRecettePlanError: "No se pudo generar el plan de la meta-receta.",
        metaRecetteReconcileError: "No se pudo reconciliar la meta-receta.",
        metaRecetteDryRunError:
          "No se pudo ejecutar el dry-run de la meta-receta.",
        metaRecetteMiniAppPreviewTitle: "Preview mini-app OpenUI",
        metaRecetteMiniAppPreviewDescription:
          "Este panel renderiza la mini-app realmente generada en structured_spec a partir de las recipe definitions compiladas por la meta-receta.",
        metaRecetteMiniAppPreviewRecipeLabel: "Mini-app generada",
        metaRecetteMiniAppPreviewRefresh: "Actualizar preview",
        metaRecetteMiniAppPreviewError:
          "No se pudo generar el preview mini-app de la meta-receta.",
        metaRecetteMiniAppPreviewRuntimeTitle: "Runtime generado",
        metaRecetteMiniAppPreviewFormatLabel: "Formato UI",
        metaRecetteMiniAppPreviewViewLabel: "Vista",
        metaRecetteMiniAppPreviewStateLabel: "Versión de estado",
        metaRecetteMiniAppPreviewActionsLabel: "Acciones detectadas",
        metaRecetteMiniAppPreviewFormsLabel: "Formularios",
        metaRecetteMiniAppPreviewInteractionsTitle: "Interacciones capturadas",
        metaRecetteMiniAppPreviewInteractionsEmpty:
          "Haz clic dentro de la mini-app para ver los eventos y aperturas de formularios capturados localmente.",
        metaRecetteMiniAppPreviewEmpty:
          "Todavía no hay una mini-app generada que se pueda previsualizar para esta meta-receta.",
        metaRecetteMiniAppPreviewEventError:
          "No se pudo ejecutar este evento de preview de mini-app.",
      },
    },
  },
} as const;

export type SupportedLanguage = keyof typeof resources;
